/** @format */
window.sensors = window["sensorsDataAnalytic201505"];
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(
    "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(receiver);
      }
      return desc.value;
    };
  }
  return _get(target, property, receiver || target);
}
function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function jelenewSectionAppendTemplate(tem_class_name, container, remove_template = true) {
  const class_name = tem_class_name.replace("-template", "-element");
  if ($(class_name, container).length == 0) {
    const dom = $(tem_class_name, container)[0].content.cloneNode(true);
    
    container.appendChild(dom);
    if ($(container).hasClass("jelenew-section-loading")) {
      $(container).removeClass("jelenew-section-loading");
    }
    if (remove_template) {
      $(tem_class_name, container).remove();
    }
   
    return true;
  } else {
    return false;
  }
}
function _getTimeStamp(timeStr, TIME_ZONE = "PDT") {
  /*  EST: 美国东部标准时间 ，GMT-5
   *  EDT: 美国东部夏令时时间 ，GMT-4
   *  CST：美国中部标准时间，GMT-6
   *  CDT：美国中部夏令时时间，GMT-5
   *  PST: （美国）太平洋标准时间，GMT-8
   *  PDT:（美国）太平洋夏令时时间，GMT-7
   *  GMT: 格林威治标准时间，即UTC时间
   *  CCT：北京时间（中国沿海时间），GMT+8 // js不识别, 手动适配
   */
  let t = null;
  if (TIME_ZONE === "CCT") {
    const cctTimeZone = 28800000; // 8hours
    t = new Date(`${timeStr} GMT`).getTime() - cctTimeZone;
  } else {
    t = new Date(`${timeStr} ${TIME_ZONE}`).getTime();
  }
  return t;
}
function jelenewHttpGetContext(context = {}) {
  return Object.assign(context, {
    refer: "shopify",
    userId: jelenewGetCookie("userId"), // 用户id
    accessToken: jelenewGetCookie("accessToken"), // token
    loginSource: jelenewGetCookie("loginSource"), // 需要传进来
    visitorId: window.jelenew_visitor_id, //访客id
    appVersion: "", // app版本号 🐷
    appInternalVersion: "", // app对内版本号 🐷
    appBuildCode: "", // app数字版本号 🐷
    channel: "", // 推广渠道  "如:(1000a)google、AppStore、xiaomi、vivo" 🐷
    appStatus: "", // "网络请求发送时的进程状态，具体定义:active:前台运行;background:后台运行" 🐷
    build: "", // "编译时间，精确到秒，例如:20130706121018(2013年7月6日12点10分18秒);" 🐷
    appKey: "c_jelenew_h5", // 产品维度、账号唯独统一。移动端相关资源 https://jbj9cqvxrg.feishu.cn/wiki/wikcntIVMm5CHp5wAtsBDS8ZCFc
    appId: "com.jelenew.athletics", // 统一或业务App/h5的唯一。移动端相关资源 https://jbj9cqvxrg.feishu.cn/wiki/wikcntIVMm5CHp5wAtsBDS8ZCFc // com.jelenew.athletics
    platform: "", // 平台 "设备平台，例如:iphone,android,ipad,html5,windows8,wp7" 🐷
    brand: "", // 设备厂商信息，例如:Apple, samsung 🐷
    model: "", // 设备型号，手机或终端的机型 AL100、iPhone3 🐷
    screen: window.screen.width + "*" + window.screen.height, // 屏幕。物流像素 1024*2160
    os: "", // 操作系统 """iphone os"" 或 ""ipad os"" 或 ""mac os"" 或 ""Android"" 或 ""aliy'" 🐷
    osVersion: "", // 系统版本 8.1 🐷
    network: "", // "当前网络连接类型:WIFI、4G、3G、2G和UNKNOWN。取值app根据netsubtype转换得来" 🐷
    serialNum: "", // 手机Rom的序列版本 🐷
    deviceId: jelenew.functions.getDistinctId(), // 神策id
    androidId: "", // android独有，android id 标识 // 1a2b3c4d1a2b3c4d 🐷
    idfa: "", // iOS独有，广告追踪 // iOS独有 🐷
    idfv: "", // 取值identifierForVender(统一广告主标识符) 🐷
    currencyType: Shopify.currency.active,
    currencyRate: Shopify.currency.rate,
    rootUrl: Shopify.routes.root,
  });
}
// 接口错误神策上报
function httpSensorsError(error) {
  if (error.message && error.message === "Network Error") return;
  let exception_modle_sub;
  if (error.config && error.config.url && error.config.data) {
    exception_modle_sub = JSON.stringify({ url: error.config.url, params: error.config.data });
  } else {
    exception_modle_sub = JSON.stringify(error, Object.getOwnPropertyNames(error), 2);
  }
  let exception_type_name = "jelenew";
  if (error.config && error.config.baseURL && error.config.baseURL.includes("www.jelenew.com")) {
    exception_type_name = "shopify";
  }
  sensors.track("ServeException", {
    exception_from: "前端",
    exception_type: exception_type_name + "接口异常",
    exception_level: "p0",
    exception_modle: $("body").data("page-type"),
    exception_modle_sub,
    exception_reason: error.message,
  });
}
// axios报错拦截
function axiosResponseError(error, httpFn) {
  // 请求取消
  if (axios.isCancel(error)) return Promise.reject(error);
  // 请求超时、网络错误 => 重新请求
  if (error.code === "ECONNABORTED") {
    const config = error.config;
    if (!config || !config.retry) {
      return Promise.reject(error);
    }
    config.__retryCount = config.__retryCount || 0;
    if (config.__retryCount >= config.retry) {
      // 超时重发的次数已用完
      httpSensorsError(error);
      return Promise.reject(error);
    }
    // 定义一个延迟的方法，也可以单独抽离出来做公共方法
    const backoff = new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, config.retryDelay || 1000);
    });

    // 延迟时间到后重新发起请求
    return backoff.then(() => {
      config.__retryCount++;
      return httpFn(config);
    });
  } else {
    httpSensorsError(error);
    return Promise.reject(error);
  }
}
function axiosRequestSuccess(config) {
  const data = makeForewarnData("jelenew_http_list", { url: config.url, timestamp: new Date().getTime() });
  if (
    data.length >= 3 &&
    data[data.length - 1].url === data[data.length - 2].url &&
    data[data.length - 1].url === data[data.length - 3].url &&
    data[data.length - 1].timestamp - data[data.length - 3].timestamp < (10 * 1000)
  ) {
    // 1min内重复3次相同请求
    sensors.track("ServeException", {
      exception_from: "前端",
      exception_type: "行为异常",
      exception_level: "p0",
      exception_modle: $("body").data("page-type"),
      exception_modle_sub: "接口重复请求",
      exception_reason: JSON.stringify(data),
    });
  }
  return config;
}
// 获取dom选择器
function getDomSelector(el,idFlag=true) {
  if (!(el instanceof Element)) return;
  var currunt_class_name = el.classList[0] ? `.${el.classList[0]}` : null;
  var path = [];
  while (el?.nodeType === Node.ELEMENT_NODE) {
    var selector = el.nodeName.toLowerCase();
    if (el.id && idFlag) {
      selector += "#" + el.id;
      path.unshift(selector);
      break;
    } else {
      var sib = el,
        nth = 1;
      while ((sib = sib.previousElementSibling)) {
        if (sib.nodeName.toLowerCase() == selector) nth++;
      }
      if (currunt_class_name) {
        selector += currunt_class_name;
        currunt_class_name = null;
      }
      if (nth != 1) selector += ":nth-of-type(" + nth + ")";
    }
    path.unshift(selector);
    el = el.parentNode;
  }
  return path.join(">");
}
// 创建预警数据集
function makeForewarnData(key, item) {
  let data = window.localStorage.getItem(key);
  if (!data) {
    data = [];
  } else {
    data = JSON.parse(data);
  }
  if (!(data instanceof Array)) data = [];
  data.push(item);
  while (data.length > 5) {
    data.shift();
  }
  window.localStorage.setItem(key, JSON.stringify(data));
  return data;
}
// 组件精准曝光
// function sectionAccurateExposure(container) {
//   const intersectionObserver = new IntersectionObserver(
//     function (entries) {
//       entries.forEach((e) => {
//         if (e.isIntersecting) {
//           // 在可视区域内
//           $(e.target).attr("time", new Date().getTime());
//         } else {
//           // 不在可视区域内
//           sensorsTrack(e.target);
//         }
//         $(e.target).attr("isIntersecting", e.isIntersecting);
//       });
//     },
//     { rootMargin: window.jelenew.exposureRootMargin, threshold: [0] }
//   );
//   intersectionObserver.observe(container);

//   $(window).on("visibilitychange beforeunload", function (e) {
//     if (e.type == "visibilitychange") {
//       if (document.visibilityState == "hidden") {
//         // 可视区域曝光上报
//         if ($(container).attr("isIntersecting") == true) {
//           sensorsTrack(container);
//         }
//       } else {
//         // 重新计时
//         if ($(container).attr("isIntersecting") == true) {
//           $(container).attr("time", new Date().getTime());
//         }
//       }
//     }
//     if (e.type == "beforeunload") {
//       // 可视区域曝光上报
//       if ($(container).attr("isIntersecting") == true) {
//         sensorsTrack(container);
//       }
//     }
//   });
//   function sensorsTrack(target) {
//     const exposure_area_percent = ((window.innerHeight - target.getBoundingClientRect().top) / target.scrollHeight) * 100;
//     const exposure_time = (new Date().getTime() - $(target).attr("time")) / 1000;
//     // 有效曝光 => 曝光时长>1s, 曝光面积百分比>50%
//     if (exposure_time > 1 && exposure_area_percent > 50) {
//       sensors.track("EpModules", {
//         page_position: theme.jelenew_web_page_name,
//         exposure_time,
//         ep_module: $(target).data("section-type"),
//         module_name: $(target).data("section-type"),
//       });
//     }
//   }
// }
// 滚动至对应新增商品视窗
function addProductScrollTop(lineKey) {
  const dom = $(`[data-line-item-key='${lineKey}']`);
  let scrollTop = 0;
  if (dom.length == 0 || dom.index() == 0) {
    scrollTop = 0;
  } else {
    scrollTop = dom[0].getBoundingClientRect().y - 100;
  }
  setTimeout(() => {
    $("#jelenew-main-cart").animate({ scrollTop });
  }, 0);
}
// 神策购物车内商品上报信息组合
function makeSensorsCartParams() {
  let params = {
    cart_token: $.cookie("cart") || "",
    page_position: window.theme.jelenew_web_page_name || "",
    product_ids: [],
    sku_ids: [],
    skc_ids: [],
    spu_ids: [],
    variant_ids: [],
    product_number: $(".cart-link__count_inner").eq(0).text() * 1,
    is_note: $(".jelenew-main-cart .textareawrapper #note").val() == "" ? false : true,
    note: $(".jelenew-main-cart .textareawrapper #note").val(),
    check_price: theme.jelenew_money_to_number($(".jelenew-main-cart .checkout-subtotal-container__right .total-container .theme-money").text()),
    discount_amount: theme.jelenew_money_to_number($(".jelenew-main-cart .checkout-subtotal-container__right .total-container .discount").text()),
    // trees_donated: $(".donation-section-container .info-box .donation_num").text().trim() * 1,
    is_usecode: $(".jelenew-real-cart .discount-detail-item").length === 0 ? true : false,
    discount_code: $(".discount-detail-code .code").text().trim(),
  };
  $(".cart-item-list__body .cart-item").each(function () {
    params.product_ids.push($(this).data("product_id"));
    params.sku_ids.push($(this).data("sku"));
    params.skc_ids.push($(this).data("skc"));
    params.spu_ids.push($(this).data("spu"));
    params.variant_ids.push($(this).data("variant_id"));
  });
  return params;
  // sensors.track("ClickCheckOut", params);
}

// 快速加购 -- 搭配snipper - jelenew-quick-buy使用
window.jelenew.functions["quickBuy"] = function (container) {
  if ($(".ajax-handler", container).length > 0) {
    $(container).on("click", ".ajax-handler", async function () {
      // let href = $(this).closest("a").attr("href");
      // $(this).closest("a").removeAttr("href");

      const $block = $(this);
      const product_handle = $block.data("handle");
      $block.addClass("jelenew-ajax-variants-selector-show");
      $("body").addClass("jelenew-ajax-variants-selector-show");
      await theme.CartTemplateSection.functions.fetchJelenewVariantsSelector($block, product_handle);
      sensors.track("ClickAddList", {
        page_position: theme.jelenew_web_page_name + "快速加购",
        product_name: $(this).closest(".jelenew_pro_block_wrap_wrap").find(".pro_block_title").text().trim(),
        product_id: $(this).closest(".jelenew_pro_block_wrap_wrap").data("product-id"),
        original_price: theme.jelenew_money_to_number($(this).closest(".jelenew_pro_block_wrap_wrap").find(".theme-money").text()),
      });
      // $(this).closest("a").attr("href", href);
    });
  }
}
// --------------- 上传图片--start ------------------
// num 上传图片素材的个数限制
window.jelenew.functions["uploadImgAction"] = function (container, _this,num=6,isTrigger=false) {
  let mediaUrls = new Map();
  _this.mediaMap = mediaUrls;
  
  let mediaType = null;
  const accessKeyId = "AKIAVIT32FQCHSJF3ME3";
  const secretAccessKey = "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";
  $("#jelenew-upload-input", container).on("change", function (e) {
    const fileList = Array.from(e.target.files || e.dataTransfer.files);
    const itemLength = $(".jelenew-upload-img-container:not(.hidden)", container).length;
    if (fileList.some((file) => !file.size)) {
      return theme.JelenewTips(theme?.jsUse?.tips?.choose_file);
    }
    const mediaType = $(container).data("mediaType") || "";
    if (
      fileList.length + itemLength > num ||
      (mediaType == 1 && (fileList.some((file) => file.type.includes("image") == false) || itemLength + fileList.length > num)) ||
      (mediaType == 2 && (fileList.some((file) => file.type.includes("video") == false) || itemLength + fileList.length > 1))
    ) {
      return theme.JelenewTips("You can only upload up to "+num+" images");
    }
    // if(fileList.length + itemLength == num){
    //   $(".jelenew-upload-input-container", container).hide()
    // }
    let promiseArr = [];
    fileList.forEach((file, i) => {
      let id = `${new Date().getTime()}${i}`;
      promiseArr.push(updateToAws(file, id));
    });
    Promise.all(promiseArr)
      .then((res) => {
        res.forEach(({ id, Key }) => {
          mediaUrls.set(id, `https://cdn.jelenew.com/${Key}`);
        });
        if(isTrigger){
          //触发事件-图片上传结束
          $(document).trigger("theme:imageUpload.end");
        }
      })
      .catch((errMsg) => {
        console.error(errMsg);
        if (errMsg) theme.JelenewTips(errMsg);
      })
      .finally(() => {
        $(this).val("");
      });
  });
  function appendImgToContainer(img_url, id, type = "img") {
    let $item = $(".jelenew-upload-img-container.hidden", container).clone(true);
    $item.removeClass("hidden").addClass(id).find("img").attr("src", img_url);
    $item.find(".jelenew-upload-img-close").addClass(id).attr("id", id);
    if (type == "video") {
      $item.addClass("flie_type_video");
    }
    console.log($item, {img_url, id, type})
    if(isTrigger){
      //触发事件--图片开始上传
      $(document).triggerHandler(imageUploadStart({img_url:img_url}));
    }
    $(container)
      .data("mediaType", type == "img" ? 1 : 2)
      .append($item);
  }
  function updateToAws(file, id) {
    return new Promise(function (resolve, reject) {
      let mediaType = 1;
      if (file.type == "video/mp4") {
        mediaType = 2;
        const videoElem = document.createElement("video");
        const dataUrl = URL.createObjectURL(file);
        // 当前帧的数据是可用的
        videoElem.onloadeddata = function () {
          let fileSize = parseFloat(file.size / Math.pow(1024, 2)).toFixed(2); // 转换为MB
          if (fileSize > 10 || videoElem.duration > 15) {
            return reject("Video file size should be less than 10MB or duration should be less than 15s, thank you."); //视频大小应小于10MB且时长应小于15s，谢谢。
          } else {
            let canvas = document.createElement("canvas");
            canvas.width = videoElem.videoWidth;
            canvas.height = videoElem.videoHeight;
            canvas.getContext("2d").drawImage(videoElem, 0, 0, canvas.width, canvas.height);
            appendImgToContainer(canvas.toDataURL("image/png"), id, "video");
          }
        };
        videoElem.onerror = function () {
          return reject("video file err");
        };
        // 设置 auto 预加载数据， 否则会出现截图为黑色图片的情况
        videoElem.setAttribute("preload", "auto");
        videoElem.src = dataUrl;
      } else {
        let fileSize = parseFloat(file.size / Math.pow(1024, 2)).toFixed(2); // 转换为MB
        if (fileSize > 2) {
          return reject("Image file size should be less than 2M.");
        }
        // 本地加载完成 显示缩略图
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (evt) {
          appendImgToContainer(this.result, id, "img");
        };
      }

      let s3 = new AWS.S3({
        accessKeyId,
        secretAccessKey,
      });
      let time = new Date();
      let Key;
      if (mediaType == 1) {
        let fileType = file.type.replace("image/", ".");
        Key = `h5/img/${time.getFullYear()}/${time.getMonth() + 1}/${time.getDate()}/${uuid()}${new Date().getTime().toString(16)}${fileType}`;
      } else {
        let fileType = file.type.replace("video/", ".");
        Key = `h5/video/${time.getFullYear()}/${time.getMonth() + 1}/${time.getDate()}/${uuid()}${new Date().getTime().toString(16)}${fileType}`;
      }
      let putObjectParams = {
        Bucket: "rehan-img" /* 储存桶名称 */,
        Key /* 储存地址及文件名 */,
        Body: file, //文件流
      };
      $(`.jelenew-upload-img-container.${id}`, container).addClass("show-upload-loading");
      // 上传时禁用提交按钮
      $(".write-review-drawer-button", container).addClass("disabled");
      s3.putObject(putObjectParams, function (err, data) {
        if (mediaType == 1) {
          // 上传完成后取消按钮禁用状态
          $(`.jelenew-upload-img-container.${id}`, container).removeClass("show-upload-loading");
          $(".write-review-drawer-button", container).removeClass("disabled");
        }
        if (err) {
          $(`.jelenew-upload-img-close.${id}`, container).trigger("click");
          return reject("Upload failed, please try again.");
        } else {
          // 上传成功 -- 保存key值
          // mediaUrls = 'https://cdn.jelenew.com/'+ Key;
          if (mediaType == 2) {
            let keyarr = Key.replace("h5/video", "h5/img").split(".");
            keyarr.pop();
            let base64Url = $(`.jelenew-upload-img-container.${id}`, container)
              .find("img")
              .attr("src");
            let newFile = base64ImgtoFile(base64Url, keyarr.join("."));
            s3.putObject(
              {
                Bucket: "rehan-img" /* 储存桶名称 */,
                Key: newFile.name /* 储存地址及文件名 */,
                Body: newFile, //文件流
              },
              function (err, data) {
                // 取消按钮禁用状态
                $(".write-review-drawer-button", container).removeClass("disabled");
                $(`.jelenew-upload-img-container.${id}`, container).removeClass("show-upload-loading");
                if (err) {
                  $(`.jelenew-upload-img-close.${id}`, container).trigger("click");
                  return reject("Upload failed, please try again.");
                } else {
                  resolve({ id, Key });
                }
              }
            );
          } else {
            resolve({ id, Key });
          }
        }
      });
    });
  }
  function uuid() {
    var d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
      d += performance.now();
    }
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx".replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0; // d是随机种子
      d = Math.floor(d / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  }
  function base64ImgtoFile(base64data, filename = "file") {
    let arr = base64data.split(",");
    let mime = arr[0].match(/:(.*?);/)[1];
    let suffix = mime.split("/")[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], `${filename}.png`, {
      type: mime,
    });
  }
  // 删除选中的文件
  $(container).on("click", ".jelenew-upload-img-close", function () {
    const id = $(this).attr("id");
    $(this).closest(`.jelenew-upload-img-container.${id}`).remove();
    mediaUrls.delete(id);
    if (mediaUrls.size == 0) {
      $(container).data("mediaType", "");
    }
    // if($(".jelenew-upload-img-container:not(.hidden)", container).length < num){
    //   $(".jelenew-upload-input-container", container).show()
    // }
  });
};
// --------------- 上传图片--end --------------------
// $("body").on("click", "#shopify-pc__prefs__header-accept, #shopify-pc__prefs__header-save, #shopify-pc__banner__btn-accept", function () {
//   gtag("consent", "update", {
//     ad_storage: "granted",
//     ad_user_data: "granted",
//     ad_personalization: "granted",
//     analytics_storage: "granted",
//   });
// });

// 不存在登录用户是清楚cookie
if (!$("body").data("is_login")) {
  ["accessToken", "userId", "loginSource", "userName", "userInfo"].forEach((cookie) => {
    delCookie(cookie);
  });
}
// 默认超时重复请求两次，间隔1s
axios.defaults.retry = 1;
axios.defaults.retryDelay = 1000;
axios.defaults.timeout = 15 * 1000;
// shopify 接口调用
const shopifyHttp = axios.create({
  baseURL: window.location.origin + Shopify.routes.root,
  headers: { "content-type": "application/json" },
});
shopifyHttp.interceptors.request.use(axiosRequestSuccess);
shopifyHttp.interceptors.response.use(
  (res) => {
    return res.data;
  },
  (error) => {
    if (!axios.isCancel(error) && error.code !== "ECONNABORTED" && (error.response.data.description || error.response.data.message)) {
      theme.JelenewTips(error.response.data.description || error.response.data.message);
    }
    return axiosResponseError(error, shopifyHttp);
  }
);
// jelenew接口调用
const jelenewHttp = axios.create({
  // baseURL: window.location.hostname == "www.jelenew.com" && Shopify.theme.role == "main" ? "https://api.jelenew.com" : "https://dev-api.jelenew.com",
  baseURL: "https://api.jelenew.com",
  headers: {
    "content-type": "application/json",
    lang: Shopify.routes.root.replaceAll("/", ""),
  },
  transformRequest: [
    function (data) {
      // 对发送的 data 进行任意转换处理
      if ((typeof data === "string" && data.includes("appKey")) || (typeof data === "object" && "appKey" in data)) {
        return data;
      } else {
        return JSON.stringify({
          params: data ? data : {},
          context: jelenewHttpGetContext(),
          appKey: "c_jelenew_h5",
        });
      }
    },
  ],
});
jelenewHttp.interceptors.request.use(axiosRequestSuccess);
jelenewHttp.interceptors.response.use(
  (res) => {
    if (res.data.status.code == 0) {
      return res.data;
    } else if (res.data.status.code == -1002) {
      // access_token is null
      jelenewHttp
        .post("/api/user/autoPermissions", {
          username: $("html").data("customer_email"),
          loginSource: "email",
        })
        .then((res) => {
          res.result.cookies.forEach((item, index) => {
            jelenewSetCookie(item.name, item.value, item.maxAge / (24 * 60 * 60), item.path, item.sameSite);
          });
          window.location.href = res.result && res.result.info && res.result.info.multipassUrl;
        });
    } else {
      if (res.data.status.code != -1024 && res.data.status.desc) {
        theme.JelenewTips(res.data.status.desc || "Server busy, please try again later!");
      }
      if (res.data.status.code < 0) {
        const params = JSON.parse(res.config.data).params || "";
        sensors.track("ServeException", {
          exception_from: "前端",
          exception_type: "jelenew接口异常",
          exception_level: "p0",
          exception_modle: $("body").data("page-type"),
          exception_modle_sub: JSON.stringify({ url: res.request._url, params }),
          exception_reason: JSON.stringify(res.data),
        });
      }
      return Promise.reject(res.data);
    }
  },
  (error) => {
    return axiosResponseError(error, jelenewHttp);
  }
);
// 折扣码&订阅 -> 引导
jelenew.functions.discountCodeHave = function () {
  const email = window.jelenew.customer.email;
  if (email) {
    // 存在邮箱-> 展示折扣码列表弹窗按钮 
    $(".more-discount-btn").show();
  } else {
    // 不存在邮箱-> 隐藏折扣码列表弹窗按钮
    $(".more-discount-btn").hide();
  }
  // const discountCode = $("body").data("ajax-code");
  // console.log("是否存在折扣码", $(".jelenew-real-cart .discount-detail-item").length);
  const notUseAutoDiscountCode = $(".jelenew-real-cart .discount-detail-item").length == 0;
  if (notUseAutoDiscountCode) {
    // 当前时间戳小于2026年1月6日0点0分0秒 -> 圣诞活动进行 -> 自动应用XMASGIFT折扣码
    const EndTimeStamp = new Date("2026/01/06 00:00:00 GMT-0700").getTime();
    const NowTimeStamp = new Date().getTime();
    const ChristmasDiscountAvailable = NowTimeStamp < EndTimeStamp;
    if (localStorage.getItem("jelenew_auto_use_discount_type") !== "remove" && ChristmasDiscountAvailable) {
      let christmas_count = 0;
      $(".cart-item-list__body .cart-item:not(.jelenew-cart-item-gift)[data-is_christmas=true]").each(function () {
        christmas_count += $(this).find(".cart-item__quantity-input").val() * 1;
      });
      if (christmas_count >= 3) {
        // 满足圣诞节活动，自动使用折扣码
        shopifyHttp.post("cart/update.js", { discount: "XMASGIFT" }).then(() => {
          $(document).triggerHandler(cartChangedEvent());
        });
        return;
      }
    }
    if (localStorage.getItem("jelenew_auto_use_discount_type") !== "remove" && email) {
      // null || "remove"
      theme.jelenewCartDiscountListPopup.functions.useDefaultDiscount();
      return;
    };
    let checkCodeParams = {
      variantList: [],
      subtotalPrice: `${theme.jelenew_money_to_number($(".total-container .theme-money").text())}`,
      rate: Shopify.currency.rate,
      currency: Shopify.currency.active,
      email,
      loginRequired: $("body").data("customer_email") && $("body").data("registered") ? true : false,
    };
    $(".cart-item-list__body")
      .eq(0)
      .find(".cart-item")
      .each(function () {
        checkCodeParams.variantList.push({
          variantId: $(this).attr("data-line-item-id").trim(),
          quantity: $(this).find(".cart-item__quantity-input").val() * 1,
          price: `${theme.jelenew_money_to_number($(this).find(".theme-money").text())}`,
          isNormalProduct: $(this).data("is_normal_product"),
        });
      });
    jelenewHttp.post("/api/shop/promotion/discountCodeHave", checkCodeParams).then((res) => {
      if (res.status.code == 0) {
        if (res.result.msgHtml) {
          $(".jelenew-real-cart .cd-cart-announcement .code-announcement").replaceWith($(res.result.msgHtml));
          // if(res.result.msgHtml.includes('THERE IS STILL ONE ORDER THAT HAS NOT BEEN PAID')){
          //   sensors.track("EpModules", {
          //     page_position: $("body").data("page-type") == "cart" ? "购物车页" : "购物车弹层页",
          //     module_name: "弃单链接",
          //   });
          // }
          // 开启活动后，jelenew不再自动应用
          if (!$("[data-jelenew_event_open]").data("jelenew_event_open")) {
            const jelenew_use_error_timestamp = localStorage.getItem("jelenew_use_error_timestamp") || 0;
            const DISCOUNT_CODE = "JELENEW";
            if (
              $(".jelenew-real-cart .cd-cart-announcement .code-announcement .code").text().trim() === DISCOUNT_CODE &&
              jelenew_use_error_timestamp + 1000 * 60 * 60 * 24 * 30 < new Date().getTime() &&
              sessionStorage.getItem("remove_discount_code") !== DISCOUNT_CODE
            ) {
              $(".discount-container #checkout_reduction_code").val(DISCOUNT_CODE);
              $(".discount-container #checkout_submit").trigger("click");
            }
          }

          // $(".jelenew-real-cart .cd-cart-announcement").addClass("show");
          // sensors.track("EpModules", {
          //   page_position: $("body").data("page-type") === "cart" ? "购物车" : "购物车弹层页",
          //   ep_module: "可用折扣提醒",
          // });
        } else {
          $(".jelenew-real-cart .cd-cart-announcement").remove(); // 已订阅 -> 删除提示
        }
        $(".jelenew-real-cart .cd-cart-announcement").removeClass("js-hidden");
      }
    });
  } else {
    return;
    if (!$("[data-jelenew_event_open]").data("jelenew_event_open")) {
      return;
    }
    // $(".cd-cart-announcement").addClass("js-hidden");
    // return false;
    //console.log("-----------存在折扣码-")
    // 活动凑单逻辑
    $(".jelenew-real-cart .cd-cart-announcement").addClass("js-hidden");
    const total = theme.jelenew_money_to_number($(".total-container .theme-money").text());
    const discount = theme.jelenew_money_to_number($(".total-container>.discount>span").text());
    const usTotal = (total + discount) / Shopify.currency.rate;
    let levelPrice = 300;
    if (usTotal < levelPrice) {
      // $(".jelenew-real-cart .cd-cart-announcement .code-announcement").empty();
      // $(".jelenew-real-cart .cd-cart-announcement .code-announcement").append(
      //   `<span>Spend <b>$${Math.ceil(400 - usTotal)}</b> more to get a FREE $39 Wool Beanie.</span>`
      // );
      // $(".jelenew-real-cart .cd-cart-announcement").removeClass("js-hidden");
      $(".checkout-subtotal-container .add-on-title").show();
      if (usTotal < 149) {
        levelPrice = 149;
        $(".checkout-subtotal-container .add-on-title span").text("Socks");
        $(".checkout-subtotal-container .add-on-title b").text(`$${Math.ceil(levelPrice - usTotal)}`);
      }
      if (usTotal >= 149 && usTotal < 300) {
        levelPrice = 300;
        $(".checkout-subtotal-container .add-on-title span").text("Bag");
        $(".checkout-subtotal-container .add-on-title b").text(`$${Math.ceil(levelPrice - usTotal)}`);
      }

      // 展示凑单
      let url = "/api/mall/product/recommend/cart";
      let params = {
        recommendType: 1,
        lang: $("html").data("root_url") == "/" ? "" : $("html").data("root_url"),
        currency: Shopify.currency.active,
        currencyRate: Shopify.currency.rate * 1,
        productIds: [`${$(".cart-item-list__body").eq(0).find(".cart-item").data("product_id")}`],
        templateCode: "server-recommends-cart",
        // needFixedPrice: 0,
        needFixedPrice: levelPrice - usTotal,
      };
      jelenewHttp.post(url, params).then((res) => {
        if (res.status.code === 0) {
          res.result.info.products;
          if (res?.result?.info?.products?.length > 0 && $(".checkout-subtotal-container .add-on-container .cart-recommends-block").length === 0) {
            // 价格限制 -> 插入凑单商品
            res.result.info.products.forEach((str, index) => {
              const item = JSON.parse(str)[params.templateCode];
              $(".checkout-subtotal-container .add-on-container").append($(item).children());
            });
            $(".checkout-subtotal-container .add-on-container-fold-btn").removeClass("js-hidden").addClass("active");
            $(".checkout-subtotal-container .add-on-container")
              .addClass("active")
              .slick({
                arrows: true,
                dots: false,
                infinite: false,
                slidesToShow: 3.3,
                slidesToScroll: 1,
                swipeToSlide: true,
                prevArrow:
                  '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
              });
          }
        }
      });
    } else {
      $(".jelenew-real-cart .cd-cart-announcement").addClass("js-hidden");

      return false;
    }
  }
};
// 用户登录 && 已订阅 =》 修正订阅邮箱
if ($("body").data("customer_email") && $("body").data("accepts_marketing")) {
  localStorage.setItem("jelenew_subscription_email", $("body").data("customer_email"));
}
window.shopifyCartApi = {
  // add_params : { items: [{ id: 36110175633573, quantity: 2 }, { id: 36110175633572, quantity: 1 }] }
  add: (add_params) => {
    //app兼容逻辑
    if (isNative() && isVersion()) {
      var itemListArray = [];
      newItemList.forEach(function (item, index) {
        itemListArray.push({
          itemId: 222,
          skuId: item.id,
        });
      });
      window.bridge &&
        window.bridge.call(
          "jnShoppingAddBag",
          {
            list: itemListArray,
          },
          (res) => {
            if (res.rCode == 0) {
              window.bridge && window.bridge.call("jnShoppingBag", {}, (res) => {});
            }
          }
        );
      return;
    }
    return shopifyHttp.post("cart/add.js", add_params).then((res)=>{
      return res;
    });
  },
  // updates: { variant_id_1: quantity_1, variant_id_2: quantity_2 } || [line_1_quantity, line_2_quantity]
  update: (updates) => {
    return shopifyHttp.post("cart/update.js", { updates });
  },
  //param:{ id/line, quantity, properties }
  change: (param) => {
    return shopifyHttp.post("cart/change.js", param);
  },
  clear: () => {
    return shopifyHttp.post("cart/clear.js");
  },
  get: () => {
    return shopifyHttp.get("cart.js");
  },
};
window.jelenewHeaderAnimateArr = [];
var hostname = location.hostname;
var sensors_server_host = "web_test_jelenew";
if ((location.hostname == "www.jelenew.com" || location.hostname == "jelenew.com") && window.Shopify.theme.role == "main") {
  sensors_server_host = "web_jelenew";
}
var ab_tag = sessionStorage.getItem("jelenewABtag");
(async () => {
  // gtag("consent", "default", {
  //   ad_storage: "denied",
  //   ad_user_data: "denied",
  //   ad_personalization: "denied",
  //   analytics_storage: "denied",
  // });
  // gtag("consent", "update", {
  //   ad_storage: "granted",
  //   ad_user_data: "granted",
  //   ad_personalization: "granted",
  //   analytics_storage: "granted",
  // });
  window.fpPromise = await FingerprintJS.load();
  const fpPromiseRes = await fpPromise.get();
  window.jelenew_visitor_id = fpPromiseRes.visitorId;
  localStorage.setItem("jelenew_visitor_id", fpPromiseRes.visitorId);
  // window.jelenew_visitor_id = "test"
  // 设置当前币种汇率, 每次访问更新
  localStorage.setItem("jelenew_rate", JSON.stringify(Shopify.currency));
  if (
    (isNative() && isNativeTest()) ||
    localStorage.getItem("rehan") ||
    $("body").attr("data-customer_email").includes("@jelenew") ||
    location.host != "www.jelenew.com" ||
    Shopify.theme.role != "main"
  ) {
    console.log("神策测试环境开启");
    sensors_server_host = "web_test_jelenew";
  }
  sensors.init({
    // server_url: "https://data.jelenew.com/sa?project=web_jelenew",
    server_url: sensors_server_host === "web_test_jelenew" ? "" : "https://data.jelenew.com/sa?project=" + sensors_server_host,
    // is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    source_channel: ["utm_adid"],
    source_type: {
      search: [".naver.", "duckduckgo.", ".ecosia.org", ".qwant.com"],
    },
    use_client_time: true,
    send_type: "beacon",
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: "default",
      //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: "default",
      collect_tags: {
        div: {
          max_level: 3, // 默认是 1，即只支持叶子 div。可配置范围是 [1, 2, 3],非该范围配置值，会被当作 1 处理。
        },
        li: true,
        img: true,
      },
    },
    max_string_length: 1000,
    max_referrer_string_length: 1000,
    // show_log: false,
    show_log: sensors_server_host.includes("test") && localStorage.getItem("rehan") != "false" ? true : false,
    preset_properties: {
      latest_landing_page: true,
    },
  });
  // shopifyHttp.post("cart/update.js", {
  //   attributes: { __distinct_id: sensors?.quick("getAnonymousID") },
  // });
  if (localStorage.getItem("jelenew_visitor_id")) {
    window.jelenew_visitor_id = localStorage.getItem("jelenew_visitor_id");
    sensors.registerPage({ jelenew_id: window.jelenew_visitor_id });
    // shopifyHttp.post("cart/update.js", {
    //   attributes: { __jelenew_id: window.jelenew_visitor_id },
    // });
  }
  (function setShopifyClientId() {
    if (localStorage.getItem("jelenewShopifyClientId")) {
      setCartAttribues();
    } else {
      const interval = setInterval(() => {
        if (localStorage.getItem("jelenewShopifyClientId")) {
          clearInterval(interval);
          setCartAttribues();
        }
      }, 250);
    }
  })();
  function setCartAttribues() {
    sensors.registerPage({ clientId: localStorage.getItem("jelenewShopifyClientId") });
    shopifyHttp
      .post("cart/update.js", {
        attributes: {
          __client_id: localStorage.getItem("jelenewShopifyClientId"),
          __distinct_id: sensors?.quick("getAnonymousID"),
          __jelenew_id: window?.jelenew_visitor_id || "",
        },
      })
      .then((res) => {
        res.items = res.items.map((item) => {
          return {
            sku: item.sku,
            quantity: item.quantity,
            handle: item.handle,
          };
        });
        sensors.track("SetCartAttribues", {
          result: JSON.stringify(res),
        });
      })
      .catch((err) => {
        sensors.track("SetCartAttribues", {
          result: JSON.stringify(err),
        });
      });
  }
  // url id替换逻辑
  // const jelenew_identify_interval = setInterval(() => {
  //   if (jelenew.functions.getDistinctId() && jelenew.functions.getDistinctId() !== "undefined") {
  //     clearInterval(jelenew_identify_interval);
  //     (function jelenew_identify() {
  //       sensors.registerPage({ jelenew_id: window.jelenew_visitor_id });
  //       sensors.registerPage({ local_distinct_id: jelenew.functions.getDistinctId() });
  //       let jelenewReferrer=getJelenewReferre();
  //       const referrer_distinct_id = getUrlParam("distinct_id", jelenewReferrer);
  //       const referrer_jelenew_id = getUrlParam("jelenew_id", jelenewReferrer);
  //       const url_distinct_id = getUrlParam("distinct_id");
  //       const url_jelenew_id = getUrlParam("jelenew_id");
        
  //       // sensors.track("ServeException", {
  //       //   exception_from: "前端监控",
  //       //   exception_type: "distinctId排查",
  //       //   exception_level: "p1",
  //       //   exception_modle: "distinctId前端覆盖",
  //       //   exception_modle_sub: referrer_distinct_id || "",
  //       //   exception_reason: referrer_jelenew_id || "",
  //       //   exception_cookie: JSON.parse(jelenewGetCookie("sensorsdata2015jssdkcross") || "{}")?.distinct_id, // cookie中distinct_id
  //       // });
  //       if (referrer_distinct_id && referrer_jelenew_id) {
  //         // referrer中存在id, 与本地id比较
  //         if (referrer_jelenew_id === window.jelenew_visitor_id) {
  //           // 相同, 则继续将referrer中的id替换至链接上
  //           sensors.identify(referrer_distinct_id, true);
  //           replaceUrlParamVal("distinct_id", referrer_distinct_id);
  //           replaceUrlParamVal("jelenew_id", referrer_jelenew_id);
  //           // sensors.track("ServeException", {
  //           //   exception_from: "前端监控",
  //           //   exception_type: "distinctId排查",
  //           //   exception_level: "p1",
  //           //   exception_modle: "distinctId前端覆盖--referrer等于本地",
  //           //   exception_modle_sub: referrer_distinct_id,
  //           //   exception_reason: referrer_jelenew_id,
  //           //   exception_cookie: JSON.parse(jelenewGetCookie("sensorsdata2015jssdkcross") || "{}")?.distinct_id, // cookie中distinct_id
  //           // });
  //         } else {
  //           // 不同, 则以本地为准, 将本地id替换至链接上
  //           sensors.identify(jelenew.functions.getDistinctId(), true);
  //           replaceUrlParamVal("distinct_id", jelenew.functions.getDistinctId());
  //           replaceUrlParamVal("jelenew_id", window.jelenew_visitor_id);
  //           // sensors.track("ServeException", {
  //           //   exception_from: "前端监控",
  //           //   exception_type: "distinctId排查",
  //           //   exception_level: "p1",
  //           //   exception_modle: "distinctId前端覆盖--referrer不等于本地",
  //           //   exception_modle_sub: referrer_distinct_id,
  //           //   exception_reason: referrer_jelenew_id,
  //           //   exception_cookie: JSON.parse(jelenewGetCookie("sensorsdata2015jssdkcross") || "{}")?.distinct_id, // cookie中distinct_id
  //           // });
  //         }
  //       } else if (url_distinct_id && url_jelenew_id) {
  //         // referrer中不存在id, 但url中存在id, 进行比对
  //         // jelenew_id 相同，则继续保持url中的id
  //         // jelenew_id 不同，则以本地为准，将本地id替换至url中
  //         if (url_jelenew_id === window.jelenew_visitor_id) {
  //           let exception_modle = "distinctId前端覆盖--url_jelenew_id等于本地";
  //           if (url_distinct_id !== jelenew.functions.getDistinctId()) {
  //             sensors.identify(url_distinct_id, true);
  //             exception_modle += "-distinct_id-替换";
  //           }
  //           // sensors.track("ServeException", {
  //           //   exception_from: "前端监控",
  //           //   exception_type: "distinctId排查",
  //           //   exception_level: "p1",
  //           //   exception_modle,
  //           //   exception_modle_sub: url_distinct_id,
  //           //   exception_reason: url_jelenew_id,
  //           //   exception_cookie: JSON.parse(jelenewGetCookie("sensorsdata2015jssdkcross") || "{}")?.distinct_id, // cookie中distinct_id
  //           // });
  //         } else {
  //           replaceUrlParamVal("distinct_id", jelenew.functions.getDistinctId());
  //           replaceUrlParamVal("jelenew_id", window.jelenew_visitor_id);
  //           // sensors.track("ServeException", {
  //           //   exception_from: "前端监控",
  //           //   exception_type: "distinctId排查",
  //           //   exception_level: "p1",
  //           //   exception_modle: "distinctId前端覆盖--url_jelenew_id不等于本地",
  //           //   exception_modle_sub: url_distinct_id,
  //           //   exception_reason: url_jelenew_id,
  //           //   exception_cookie: JSON.parse(jelenewGetCookie("sensorsdata2015jssdkcross") || "{}")?.distinct_id, // cookie中distinct_id
  //           // });
  //         }
  //       } else {
  //         // referrer、url中均不存在id, 将本地id填入url
  //         replaceUrlParamVal("distinct_id", jelenew.functions.getDistinctId());
  //         replaceUrlParamVal("jelenew_id", window.jelenew_visitor_id);
  //         // sensors.track("ServeException", {
  //         //   exception_from: "前端监控",
  //         //   exception_type: "distinctId排查",
  //         //   exception_level: "p1",
  //         //   exception_modle: "distinctId前端覆盖--referrer、url中不存在id",
  //         //   exception_modle_sub: referrer_distinct_id,
  //         //   exception_reason: referrer_jelenew_id,
  //         //   exception_cookie: JSON.parse(jelenewGetCookie("sensorsdata2015jssdkcross") || "{}")?.distinct_id, // cookie中distinct_id
  //         // });
  //       }
  //     })();
  //   }
  // }, 200);

  (function registerApp (){
    const app = window.jelenew.functions.analyzeUserAgent();
    sensors.registerPage({ is_opened_in_app: app ? true : false });
    if (app) {
      sensors.registerPage({ app_name: app });
      if (app === "Facebook") {
      }
    }
    // (function getFacebookQuickLogin() {
    //   // const { pageType, is_login } = document.getElementsByTagName("body")[0].dataset;
    //   // if (is_login === "true" || pageType.includes("customers")) {
    //   //   return;
    //   // }
    //   const _this = this;
    //   (function (d, s, id) {
    //     var js,
    //       fjs = d.getElementsByTagName(s)[0];
    //     if (d.getElementById(id)) return;
    //     js = d.createElement(s);
    //     js.id = id;
    //     js.src = "https://connect.facebook.net/en_US/sdk.js";
    //     fjs.parentNode.insertBefore(js, fjs);
    //   })(document, "script", "facebook-jssdk");
    //   window.fbAsyncInit = function () {
    //     FB.init({
    //       appId: "1032435545361214",
    //       cookie: true, // 启用cookie
    //       xfbml: true, // 解析此页面上的社交插件
    //       version: "v2.8", // 使用图形api 2.8版本
    //     });
    //     // 检查登录态
    //     FB.getLoginStatus(function (response) {
    //       console.log(response);
    //       if (response.status === "connected" && response.authResponse.accessToken) {
    //         // 插入fb快速登录按钮
    //         const $FbQuickLoginBtn = $(`<div id="fb-quick-box" class="fb-login-container">
    //           <style>
    //             .fb-login-container{
    //               position: fixed;
    //               bottom: 0;
    //               left: 0;
    //               right: 0;
    //               z-index: 9999;
    //               background: rgba(0, 0, 0, 0.5);
    //               display: flex;
    //               justify-content: center;
    //               align-items: center;
    //               height: 100vh;
    //             }
    //             .fb-login-popup{
    //               border-radius: 10px;
    //               background: #fff;
    //             }
    //             .fb-login-title{
    //               font-size: 16px;
    //               height: 32px;
    //               width: 100%;
    //               display: flex;
    //               align-items: center;
    //               justify-content: space-between;
    //               padding-left: 32px;
    //               border-bottom: 1px solid #ccc;
    //             }
    //             .fb-login-close{
    //               float: right;
    //               cursor: pointer;
    //               border-left: 1px solid #ccc;
    //               height: 32px;
    //               width: 32px;
    //               display: flex;
    //               align-items: center;
    //               justify-content: center;
    //             }
    //             .fb-login-btn{
    //               width: 180px;
    //               height: 40px;
    //               background: #4267B2;
    //               color: #fff;
    //               text-align: center;
    //               line-height: 40px;
    //               border-radius: 5px;
    //               cursor: pointer;
    //               margin: 16px 32px;
    //             }
    //           </style>
    //           <div class="fb-login-popup">
    //             <div class="fb-login-title Futuram">
    //               <span>Quick login</span>
    //               <span class="fb-login-close">X</span>
    //             </div>
    //             <div class="fb-login-content">
    //               <div class="fb-login-btn">
    //                 Continue with Facebook
    //               </div>
    //             </div>
    //           </div>
    //           </div>`);
            
    //         $("body").append($FbQuickLoginBtn);
    //         $("body").on("click", "#fb-quick-box .fb-login-close", function () {

    //           $("#fb-quick-box").remove();
    //         });
    //         $("body").on("click", "#fb-quick-box .fb-login-btn", function () {
    //           $("#fb-quick-box").remove();
    //           // _this.functions.userThirdLogin({
    //           //   idToken: "", // 登录为google，apple时，此字段必填
    //           //   accessToken: response.authResponse.accessToken, // 登录为facebook时，此字段必填
    //           //   loginSource: "facebook", // 登陆类型  google、apple、facebook
    //           // });
    //           const _this = this;
    //           const container = _this.container;
    //           let param = {
    //             idToken: "",
    //             accessToken: response.authResponse.accessToken,
    //             loginSource: "facebook",
    //           };
    //           if (window.location.search && window.location.search.indexOf("checkout_url=") >= 0) {
    //             let shopifyReturnTo = decodeURIComponent(window.location.search.split("checkout_url=")[1]);
    //             Object.assign(param, { shopifyReturnTo });
    //           }
    //           jelenewHttp
    //             .post(`/api/user/third/v2/login`, param)
    //             .then((res) => {
    //               if (res?.result?.info?.userId) {
    //                 // 存在用户 跳转登录链接
    //                 res.result.cookies.forEach((item, index) => {
    //                   jelenewSetCookie(item.name, item.value, item.maxAge / (24 * 60 * 60), item.path, item.sameSite);
    //                 });
    //                 window.location.href = res.result && res.result.info && res.result.info.multipassUrl;
    //               } else {
    //                 // 未注册用户 跳转注册页面
    //                 $(container).trigger("third-register");
    //                 const { userInfo, openId } = res.result.info;
    //                 _this.registerParams.openId = openId;
    //                 _this.registerParams.loginSource = params.loginSource;
    //                 $(".register-form input[name='first-name']", container).val(userInfo.firstName);
    //                 $(".register-form input[name='last-name']", container).val(userInfo.lastName);
    //                 $(".register-form input[name='email']", container).val(userInfo.email);
    //                 $("body").removeClass("page-loading");
    //               }
    //             })
    //             .catch((err) => {
    //               theme.JelenewTips(err.status.desc || _this.errorMsg.thirdLoginError);
    //               $("body").removeClass("page-loading");
    //             });
    //         });
    //         // axios.get(`https://graph.facebook.com/v13.0/me?access_token=${response.authResponse.accessToken}&fields=email`).then((res) => {
    //         //   console.log(res);
    //         // });
    //       }
    //       // statusChangeCallback(response);
    //     });
    //   };
    // })();
  })();
  //设置公共属性
  sensors.registerPage({ userAgent: getUA() });
  if (window.jelenew.customer.email) {
    sensors.registerPage({ user_email: window.jelenew.customer.email });
  }
  if ($("body").data("page-type") === "index") {
    sensors.registerPage({ page_path: "/" });
  } else {
    sensors.registerPage({ page_path: "/" + location.pathname.replace(Shopify.routes.root, "") });
  }
  let jelenewReferrer=getJelenewReferre();
  sensors.registerPage({ $referrer: jelenewReferrer });
  if(jelenewReferrer){
    const fre_Url = new URL(jelenewReferrer);
    sensors.registerPage({ forward_page_path: "/" + fre_Url.pathname.replace(Shopify.routes.root, "")});
  }else{
    sensors.registerPage({ forward_page_path: ""});
  }
  sensors.registerPage({ region_language: location.pathname.split("/")[1] });
  sensors.registerPage({ currency_type: Shopify.currency.active });
  sensors.registerPage({ currency_rate: Shopify.currency.rate });
  
  Shopify.currency.rate;

  if (ab_tag) {
    sensors.registerPage({ ab_tag });
  }
  if (isNative() && getAppOwnDeviceId()) {
    sensors.registerPage({
      own_device_id: getAppOwnDeviceId(),
    });
  }
  sensors.quick("autoTrack");
  sensors.use("PageLeave");
  sensors.use("PageLoad");
  if (window.current_template) {
    theme.jelenew_web_page_name = window?.current_template?.web_page_name || "";
    theme.jelenew_event_name = window?.current_template?.event_name || "";
    theme.jelenew_active_name = window?.current_template?.active_name || "";
    switch ($("body").data("page-type")) {
      case "product":
        Object.assign(current_template, {
          skc_id: $(".jelenew-main-product").data("skc"),
          spu_id: $(".jelenew-main-product").data("spu"),
        });
        break;
      case "cart":
        let obj = {
          skc_ids: [],
          sku_ids: [],
          spu_ids: [],
        };
        $(".cart-item-list__body .cart-item").each(function () {
          obj.skc_ids.push($(this).data("skc"));
          obj.sku_ids.push($(this).data("sku"));
          obj.spu_ids.push($(this).data("spu"));
        });
        Object.assign(current_template, obj);
        break;
    }
    // sensors.track("WebPageView", Object.assign(current_template, {}));
  }
  if ($("body").hasClass("template-customers/register")) {
    $("#create-customer")
      .find(".btn")
      .on("click", function () {
        var email = $("input[name='customer[email]']").val();
        emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (email && emailReg.test(email)) {
          sensors.setProfile({ register_email: email });
        }
      });
  }
  (function ($) {
    var $ = (jQuery = $);
    var cc = {
      sections: [],
    };

    theme.cartNoteMonitor = {
      load: function load(className) {
        $("body").on("change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor", className, function () {
          theme.cartNoteMonitor.postUpdate($(this).val());
        });
      },

      unload: function unload(className) {
        $("body").find(className).off(".themeCartNoteMonitor");
        // $notes
      },

      updateThrottleTimeoutId: -1,
      updateThrottleInterval: 500,

      postUpdate: function postUpdate(val) {
        clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId);
        theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(function () {
          $.post(
            theme.routes.cart_url + "/update.js",
            {
              note: val,
            },
            function (data) {},
            "json"
          );
        }, theme.cartNoteMonitor.updateThrottleInterval);
      },
    };

    theme.Shopify = {
      formatMoney: function formatMoney(t, r) {
        function e(t, r) {
          return void 0 === t ? r : t;
        }
        function a(t, r, a, o) {
          if (((r = e(r, 2)), (a = e(a, ",")), (o = e(o, ".")), isNaN(t) || null == t)) return 0;
          t = (t / 100).toFixed(r);
          var n = t.split(".");
          return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? o + n[1] : "");
        }
        "string" == typeof t && (t = t.replace(".", ""));
        var o = "",
          n = /\{\{\s*(\w+)\s*\}\}/,
          i = r || this.money_format;
        switch (i.match(n)[1]) {
          case "amount":
            o = a(t, 2);
            break;
          case "amount_no_decimals":
            o = a(t, 0);
            break;
          case "amount_with_comma_separator":
            o = a(t, 2, ".", ",");
            break;
          case "amount_with_space_separator":
            o = a(t, 2, " ", ",");
            break;
          case "amount_with_period_and_space_separator":
            o = a(t, 2, " ", ".");
            break;
          case "amount_no_decimals_with_comma_separator":
            o = a(t, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            o = a(t, 0, " ", "");
            break;
          case "amount_with_apostrophe_separator":
            o = a(t, 2, "'", ".");
            break;
          case "amount_with_decimal_separator":
            o = a(t, 2, ".", ".");
        }

        return i.replace(n, o);
      },
      formatImage: function formatImage(originalImageUrl, format) {
        return originalImageUrl ? originalImageUrl.replace(/^(.*)\.([^\.]*)$/g, "$1_" + format + ".$2") : "";
      },
      Image: {
        imageSize: function imageSize(t) {
          var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
          return null !== e ? e[1] : null;
        },
        getSizedImageUrl: function getSizedImageUrl(t, e) {
          if (null == e) return t;
          if ("master" == e) return this.removeProtocol(t);
          var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
          if (null != o) {
            var i = t.split(o[0]),
              r = o[0];
            return this.removeProtocol(i[0] + "_" + e + r);
          }
          return null;
        },
        removeProtocol: function removeProtocol(t) {
          return t.replace(/http(s)?:/, "");
        },
      },
    };

    theme.Disclosure = (function () {
      var selectors = {
        disclosureList: "[data-disclosure-list]",
        disclosureToggle: "[data-disclosure-toggle]",
        disclosureInput: "[data-disclosure-input]",
        disclosureOptions: "[data-disclosure-option]",
      };

      var classes = {
        listVisible: "disclosure-list--visible",
      };

      function Disclosure($disclosure) {
        this.$container = $disclosure;
        this.cache = {};
        this._cacheSelectors();
        this._connectOptions();
        this._connectToggle();
        this._onFocusOut();
      }

      Disclosure.prototype = $.extend({}, Disclosure.prototype, {
        _cacheSelectors: function _cacheSelectors() {
          this.cache = {
            $disclosureList: this.$container.find(selectors.disclosureList),
            $disclosureToggle: this.$container.find(selectors.disclosureToggle),
            $disclosureInput: this.$container.find(selectors.disclosureInput),
            $disclosureOptions: this.$container.find(selectors.disclosureOptions),
          };
        },

        _connectToggle: function _connectToggle() {
          this.cache.$disclosureToggle.on(
            "click",
            function (evt) {
              var ariaExpanded = $(evt.currentTarget).attr("aria-expanded") === "true";
              $(evt.currentTarget).attr("aria-expanded", !ariaExpanded);

              this.cache.$disclosureList.toggleClass(classes.listVisible);
            }.bind(this)
          );
        },

        _connectOptions: function _connectOptions() {
          this.cache.$disclosureOptions.on(
            "click",
            function (evt) {
              evt.preventDefault();
              this._submitForm($(evt.currentTarget).data("value"));
            }.bind(this)
          );
        },

        _onFocusOut: function _onFocusOut() {
          this.cache.$disclosureToggle.on(
            "focusout",
            function (evt) {
              var disclosureLostFocus = this.$container.has(evt.relatedTarget).length === 0;

              if (disclosureLostFocus) {
                this._hideList();
              }
            }.bind(this)
          );

          this.cache.$disclosureList.on(
            "focusout",
            function (evt) {
              var childInFocus = $(evt.currentTarget).has(evt.relatedTarget).length > 0;
              var isVisible = this.cache.$disclosureList.hasClass(classes.listVisible);

              if (isVisible && !childInFocus) {
                this._hideList();
              }
            }.bind(this)
          );

          this.$container.on(
            "keyup",
            function (evt) {
              if (evt.which !== 27) return; // escape
              this._hideList();
              this.cache.$disclosureToggle.focus();
            }.bind(this)
          );

          this.bodyOnClick = function (evt) {
            var isOption = this.$container.has(evt.target).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(classes.listVisible);

            if (isVisible && !isOption) {
              this._hideList();
            }
          }.bind(this);

          $("body").on("click", this.bodyOnClick);
        },

        _submitForm: function _submitForm(value) {
          this.cache.$disclosureInput.val(value);
          this.$container.parents("form").submit();
        },

        _hideList: function _hideList() {
          this.cache.$disclosureList.removeClass(classes.listVisible);
          this.cache.$disclosureToggle.attr("aria-expanded", false);
        },

        unload: function unload() {
          $("body").off("click", this.bodyOnClick);
          this.cache.$disclosureOptions.off();
          this.cache.$disclosureToggle.off();
          this.cache.$disclosureList.off();
          this.$container.off();
        },
      });

      return Disclosure;
    })();
    (function () {
      function throttle(callback, threshold) {
        var debounceTimeoutId = -1;
        var tick = false;

        return function () {
          clearTimeout(debounceTimeoutId);
          debounceTimeoutId = setTimeout(callback, threshold);

          if (!tick) {
            callback.call();
            tick = true;
            setTimeout(function () {
              tick = false;
            }, threshold);
          }
        };
      }

      var scrollEvent = document.createEvent("Event");
      scrollEvent.initEvent("throttled-scroll", true, true);

      window.addEventListener(
        "scroll",
        throttle(function () {
          window.dispatchEvent(scrollEvent);
        }, 200)
      );
    })();
    // Source: https://davidwalsh.name/javascript-debounce-function
    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    theme.debounce = function (func) {
      var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 700;
      var immediate = arguments.length > 2 ? arguments[2] : undefined;
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };
    // requires: throttled-scroll, debouncedresize

    /*
    Define a section by creating a new function object and registering it with the section handler.
    The section handler manages:
      Instantiation for all sections on the current page
      Theme editor lifecycle events
      Deferred initialisation
      Event cleanup
  
    There are two ways to register a section.
    In a theme:
      theme.Sections.register('slideshow', theme.SlideshowSection);
      theme.Sections.register('header', theme.HeaderSection, { deferredLoad: false });
      theme.Sections.register('background-video', theme.VideoManager, { deferredLoadViewportExcess: 800 });
  
    As a component:
      cc.sections.push({ name: 'faq', section: theme.Faq });
  
    Assign any of these to receive Shopify section lifecycle events:
      this.onSectionLoad
      this.afterSectionLoadCallback
      this.onSectionSelect
      this.onSectionDeselect
      this.onBlockSelect
      this.onBlockDeselect
      this.onSectionUnload
      this.afterSectionUnloadCallback
      this.onSectionReorder
  
    If you add any events using the manager's registerEventListener,
    e.g. this.registerEventListener(element, 'click', this.functions.handleClick.bind(this)),
    these will be automatically cleaned up after onSectionUnload.
   */

    theme.Sections = new (function () {
      var _ = this;

      _._instances = [];
      _._deferredSectionTargets = [];
      _._sections = [];
      _._deferredLoadViewportExcess = 300; // load defferred sections within this many px of viewport
      _._deferredWatcherRunning = false;

      _.init = function () {
        $(document)
          .on("shopify:section:load", function (e) {
            // load a new section
            var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
            if (target) {
              _.sectionLoad(target);
            }
          })
          .on("shopify:section:unload", function (e) {
            // unload existing section
            var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
            if (target) {
              _.sectionUnload(target);
            }
          })
          .on("shopify:section:reorder", function (e) {
            // unload existing section
            var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
            if (target) {
              _.sectionReorder(target);
            }
          });
        $(window).on("throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader", _._processDeferredSections);
        _._deferredWatcherRunning = true;
      };

      // register a type of section
      _.register = function (type, section, options) {
        _._sections.push({
          type: type,
          section: section,
          afterSectionLoadCallback: options ? options.afterLoad : null,
          afterSectionUnloadCallback: options ? options.afterUnload : null,
        });
        // load now
        $('[data-section-type="' + type + '"]').each(function () {
          if (Shopify.designMode || (options && options.deferredLoad === false) || !_._deferredWatcherRunning) {
            _.sectionLoad(this);
          } else {
            _.sectionDeferredLoad(this, options);
          }
        });
      };

      // prepare a section to load later
      _.sectionDeferredLoad = function (target, options) {
        _._deferredSectionTargets.push({
          target: target,
          deferredLoadViewportExcess:
            options && options.deferredLoadViewportExcess ? options.deferredLoadViewportExcess : _._deferredLoadViewportExcess,
        });

        _._processDeferredSections(true);
      };

      // load deferred sections if in/near viewport
      _._processDeferredSections = function (firstRunCheck) {
        if (_._deferredSectionTargets.length) {
          var viewportTop = $(window).scrollTop(),
            viewportBottom = viewportTop + $(window).height(),
            loopStart = firstRunCheck === true ? _._deferredSectionTargets.length - 1 : 0;
          for (var i = loopStart; i < _._deferredSectionTargets.length; i++) {
            var target = _._deferredSectionTargets[i].target,
              viewportExcess = _._deferredSectionTargets[i].deferredLoadViewportExcess,
              sectionTop = $(target).offset().top - viewportExcess,
              doLoad = sectionTop > viewportTop && sectionTop < viewportBottom;
            if (!doLoad) {
              var sectionBottom = sectionTop + $(target).outerHeight() + viewportExcess * 2;
              doLoad = sectionBottom > viewportTop && sectionBottom < viewportBottom;
            }
            if (doLoad || (sectionTop < viewportTop && sectionBottom > viewportBottom)) {
              // in viewport, load
              _.sectionLoad(target);
              // remove from deferred queue and resume checks
              _._deferredSectionTargets.splice(i, 1);
              i--;
            }
          }
        }

        // remove event if no more deferred targets left, if not on first run
        if (firstRunCheck !== true && _._deferredSectionTargets.length === 0) {
          _._deferredWatcherRunning = false;
          $(window).off(".themeSectionDeferredLoader");
        }
      };

      // load in a section
      _.sectionLoad = function (target) {
        var target = target,
          sectionObj = _._sectionForTarget(target),
          section = false;

        if (sectionObj.section) {
          section = sectionObj.section;
        } else {
          section = sectionObj;
        }

        if (section !== false) {
          var instance = {
            target: target,
            section: section,
            $shopifySectionContainer: $(target).closest(".shopify-section"),
            thisContext: {
              functions: section.functions,
              registeredEventListeners: [],
            },
          };

          instance.thisContext.registerEventListener = _._registerEventListener.bind(instance.thisContext);
          _._instances.push(instance);

          //Initialise any components
          if ($(target).data("components")) {
            //Init each component
            var components = $(target).data("components").split(",");
            components.forEach(function (component) {
              $(document).trigger("cc:component:load", [component, target]);
            });
          }

          _._callSectionWith(section, "onSectionLoad", target, instance.thisContext);
          // sectionAccurateExposure(target);
          _._callSectionWith(section, "afterSectionLoadCallback", target, instance.thisContext);

          // attach additional UI events if defined
          if (section.onSectionSelect) {
            instance.$shopifySectionContainer.on("shopify:section:select", function (e) {
              _._callSectionWith(section, "onSectionSelect", e.target, instance.thisContext);
            });
          }
          if (section.onSectionDeselect) {
            instance.$shopifySectionContainer.on("shopify:section:deselect", function (e) {
              _._callSectionWith(section, "onSectionDeselect", e.target, instance.thisContext);
            });
          }
          if (section.onBlockSelect) {
            $(target).on("shopify:block:select", function (e) {
              _._callSectionWith(section, "onBlockSelect", e.target, instance.thisContext);
            });
          }
          if (section.onBlockDeselect) {
            $(target).on("shopify:block:deselect", function (e) {
              _._callSectionWith(section, "onBlockDeselect", e.target, instance.thisContext);
            });
          }
        }
      };

      // unload a section
      _.sectionUnload = function (target) {
        var sectionObj = _._sectionForTarget(target);
        var instanceIndex = -1;
        for (var i = 0; i < _._instances.length; i++) {
          if (_._instances[i].target == target) {
            instanceIndex = i;
          }
        }
        if (instanceIndex > -1) {
          var instance = _._instances[instanceIndex];
          // remove events and call unload, if loaded
          $(target).off("shopify:block:select shopify:block:deselect");
          instance.$shopifySectionContainer.off("shopify:section:select shopify:section:deselect");
          _._callSectionWith(instance.section, "onSectionUnload", target, instance.thisContext);
          _._unloadRegisteredEventListeners(instance.thisContext.registeredEventListeners);
          _._callSectionWith(sectionObj, "afterSectionUnloadCallback", target, instance.thisContext);
          _._instances.splice(instanceIndex);

          //Destroy any components
          if ($(target).data("components")) {
            //Init each component
            var components = $(target).data("components").split(",");
            components.forEach(function (component) {
              $(document).trigger("cc:component:unload", [component, target]);
            });
          }
        } else {
          // check if it was a deferred section
          for (var i = 0; i < _._deferredSectionTargets.length; i++) {
            if (_._deferredSectionTargets[i].target == target) {
              _._deferredSectionTargets[i].splice(i, 1);
              break;
            }
          }
        }
      };

      _.sectionReorder = function (target) {
        var instanceIndex = -1;
        for (var i = 0; i < _._instances.length; i++) {
          if (_._instances[i].target == target) {
            instanceIndex = i;
          }
        }
        if (instanceIndex > -1) {
          var instance = _._instances[instanceIndex];
          _._callSectionWith(instance.section, "onSectionReorder", target, instance.thisContext);
        }
      };

      // Helpers
      _._registerEventListener = function (element, eventType, callback) {
        element.addEventListener(eventType, callback);
        this.registeredEventListeners.push({
          element: element,
          eventType: eventType,
          callback: callback,
        });
      };

      _._unloadRegisteredEventListeners = function (registeredEventListeners) {
        registeredEventListeners.forEach(function (rel) {
          rel.element.removeEventListener(rel.eventType, rel.callback);
        });
      };

      // _._callSectionWith(section, "afterSectionLoadCallback", target, instance.thisContext);
      _._callSectionWith = function (section, method, container, thisContext) {
        if (typeof section[method] === "function") {
          try {
            if (thisContext) {
              section[method].bind(thisContext)(container);
            } else {
              section[method](container);
            }
            $(container).removeClass("jelenew-section-loading");
          } catch (ex) {
            var sectionType = container.dataset["sectionType"];
            console.warn("Theme warning: '".concat(method, "' failed for section '").concat(sectionType, "'"));
            console.debug(container, ex);
          }
        }
      };

      _._themeSectionTargetFromShopifySectionTarget = function (target) {
        var $target = $("[data-section-type]:first", target);
        if ($target.length > 0) {
          return $target[0];
        } else {
          return false;
        }
      };

      _._sectionForTarget = function (target) {
        var type = $(target).attr("data-section-type");
        for (var i = 0; i < _._sections.length; i++) {
          if (_._sections[i].type == type) {
            return _._sections[i];
          }
        }
        return false;
      };

      _._sectionAlreadyRegistered = function (type) {
        for (var i = 0; i < _._sections.length; i++) {
          if (_._sections[i].type == type) {
            return true;
          }
        }
        return false;
      };
    })();
    // 组件懒加载
    (function () {
      $("[data-section-type]").each(function (i, el) {
        if ($(el).data("section-js") || $(el).data("section-style")) {
          observerSections(el);
        }
      });
      function observerSections(container) {
        const intersectionObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                // 在可视区域内
                if ($(e.target).data("section-style")) {
                  loadCss(e.target);
                } else {
                  loadJs(e.target);
                }
                // 加载完成后取消监听
                intersectionObserver.disconnect();
              }
            });
          },
          // 缓冲区域为上下一屏
          { rootMargin: `${window.outerHeight}px 0px ${window.outerHeight}px 0px`, threshold: [0] }
        );
        intersectionObserver.observe(container);
      }
      function loadCss(el) {
        const styleLink = $(el).data("section-style");
        if ($(`link[href="${styleLink}"]`).length == 0) {
          let link = document.createElement("link");
          link.rel = "stylesheet";
          link.fetchPriority = "high";
          link.type = "text/css";
          link.href = styleLink;
          link.onload = loadJs(el);
          document.head.appendChild(link);
        }
      }
      function loadJs(el) {
        const jsLink = $(el).data("section-js");
        if (jsLink && $(`script[src="${jsLink}"]`).length == 0) {
          let script = document.createElement("script");
          script.src = jsLink;
          script.defer = true;
          script.async = false;
          document.body.appendChild(script);
          // $(`[data-section-type][data-section-js="${jsLink}"]`).removeAttr("data-section-js");
        }
      }
    })();
    // Loading third party scripts
    theme.scriptsLoaded = {};
    theme.loadScriptOnce = function (src, callback, beforeRun, sync) {
      if (typeof theme.scriptsLoaded[src] === "undefined") {
        theme.scriptsLoaded[src] = [];
        var tag = document.createElement("script");
        tag.src = src;

        if (sync || beforeRun) {
          tag.async = false;
        }

        if (beforeRun) {
          beforeRun();
        }

        if (typeof callback === "function") {
          theme.scriptsLoaded[src].push(callback);
          if (tag.readyState) {
            // IE, incl. IE9
            tag.onreadystatechange = function () {
              if (tag.readyState == "loaded" || tag.readyState == "complete") {
                tag.onreadystatechange = null;
                for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {
                  theme.scriptsLoaded[this][i]();
                }
                theme.scriptsLoaded[this] = true;
              }
            }.bind(src);
          } else {
            tag.onload = function () {
              // Other browsers
              for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {
                theme.scriptsLoaded[this][i]();
              }
              theme.scriptsLoaded[this] = true;
            }.bind(src);
          }
        }

        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        return true;
      } else if (_typeof(theme.scriptsLoaded[src]) === "object" && typeof callback === "function") {
        theme.scriptsLoaded[src].push(callback);
      } else {
        if (typeof callback === "function") {
          callback();
        }
        return false;
      }
    };

    theme.loadStyleOnce = function (src) {
      var srcWithoutProtocol = src.replace(/^https?:/, "");
      if (!document.querySelector('link[href="' + encodeURI(srcWithoutProtocol) + '"]')) {
        var tag = document.createElement("link");
        tag.href = srcWithoutProtocol;
        tag.rel = "stylesheet";
        tag.type = "text/css";
        var firstTag = document.getElementsByTagName("link")[0];
        firstTag.parentNode.insertBefore(tag, firstTag);
      }
    }; /// Show a short-lived text popup above an element
    theme.showQuickPopup = function (message, $origin) {
      var $popup = $('<div class="simple-popup"/>');
      var offs = $origin.offset();
      $popup.html(message).css({ left: offs.left, top: offs.top }).hide();
      $("body").append($popup);
      $popup.css({
        marginTop: -$popup.outerHeight() - 10,
        marginLeft: -($popup.outerWidth() - $origin.outerWidth()) / 2,
      });
      $popup
        .fadeIn(200)
        .delay(3500)
        .fadeOut(400, function () {
          $(this).remove();
        });
    };
    var ccComponent = /*#__PURE__*/ (function () {
      "use strict";
      function ccComponent(name) {
        var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);
        _classCallCheck(this, ccComponent);
        var _this = this;
        this.instances = [];

        // Initialise any instance of this component within a section
        $(document).on("cc:component:load", function (event, component, target) {
          if (component === name) {
            $(target)
              .find("".concat(cssSelector, ":not(.cc-initialized)"))
              .each(function () {
                _this.init(this);
              });
          }
        });

        // Destroy any instance of this component within a section
        $(document).on("cc:component:unload", function (event, component, target) {
          if (component === name) {
            $(target)
              .find(cssSelector)
              .each(function () {
                _this.destroy(this);
              });
          }
        });

        // Initialise any instance of this component
        $(cssSelector).each(function () {
          _this.init(this);
        });
      }
      _createClass(ccComponent, [
        {
          key: "init",
          value: function init(container) {
            $(container).addClass("cc-initialized");
          },
        },
        {
          key: "destroy",
          value: function destroy(container) {
            $(container).removeClass("cc-initialized");
          },
        },
        {
          key: "registerInstance",
          value: function registerInstance(container, instance) {
            this.instances.push({
              container: container,
              instance: instance,
            });
          },
        },
        {
          key: "destroyInstance",
          value: function destroyInstance(container) {
            this.instances = this.instances.filter(function (item) {
              if (item.container === container) {
                if (typeof item.instance.destroy === "function") {
                  item.instance.destroy();
                }

                return item.container !== container;
              }
            });
          },
        },
      ]);
      return ccComponent;
    })();

    /**
     * Use with template literals to build HTML with correct escaping.
     *
     * Example:
     *
     * const tve = theme.createTemplateVariableEncoder();
     * tve.add('className', className, 'attribute');
     * tve.add('title', title, 'html');
     * tve.add('richText', richText, 'raw');
     * const template = `
     *   <div class="${tve.values.className}">
     *     <h1>${tve.values.title}</h1>
     *     <div class="rte">${tve.values.richText}</div>
     *   </div>
     * `;
     */
    theme.createTemplateVariableEncoder = function () {
      return {
        utilityElement: document.createElement("div"),
        values: {},
        /**
         * Add a new value to sanitise.
         * @param {String} key - key used to retrieve this value
         * @param {String} value - the value to encode and store
         * @param {String} type - possible values: [attribute, html, raw] - the type of encoding to use
         */
        add: function add(key, value, type) {
          switch (type) {
            case "attribute":
              this.utilityElement.innerHTML = "";
              this.utilityElement.setAttribute("util", value);
              this.values[key] = this.utilityElement.outerHTML.match(/util="([^"]*)"/)[1];
              break;
            case "html":
              this.utilityElement.innerText = value;
              this.values[key] = this.utilityElement.innerHTML;
              break;
            case "raw":
              this.values[key] = value;
              break;
            default:
              throw "Type '".concat(type, "' not handled");
          }
        },
      };
    };
    theme.suffixIds = function (container, suffix) {
      var refAttrs = ["aria-describedby", "aria-controls"];
      suffix = "-" + suffix;
      container.querySelectorAll("[id]").forEach(function (el) {
        var oldId = el.id,
          newId = oldId + suffix;
        el.id = newId;
        refAttrs.forEach(function (attr) {
          container.querySelectorAll("[".concat(attr, '="').concat(oldId, '"]')).forEach(function (refEl) {
            refEl.setAttribute(attr, newId);
          });
        });
      });
    };
    theme.renderUnitPrice = function (unit_price, unit_price_measurement, money_format) {
      if (unit_price && unit_price_measurement) {
        var unitPriceHtml = '<div class="unit-price">';
        unitPriceHtml += '<span class="unit-price__price theme-money">'.concat(theme.Shopify.formatMoney(unit_price, money_format), "</span>");
        unitPriceHtml += '<span class="unit-price__separator">'.concat(theme.strings.products_product_unit_price_separator, "</span>");
        var unit = unit_price_measurement.reference_unit;
        if (unit_price_measurement.reference_value != 1) {
          unit = unit_price_measurement.reference_value + unit;
        }
        unitPriceHtml += '<span class="unit-price__unit">'.concat(unit, "</span>");
        unitPriceHtml += "</div>";
        return unitPriceHtml;
      } else {
        return "";
      }
    };
    var ccPopup = /*#__PURE__*/ (function () {
      "use strict";
      function ccPopup($container, namespace) {
        _classCallCheck(this, ccPopup);
        this.$container = $container;
        this.namespace = namespace;
        this.cssClasses = {
          visible: "cc-popup--visible",
          bodyNoScroll: "cc-popup-no-scroll",
          bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right",
        };
      }

      /**
       * Open popup on timer / local storage - move focus to input ensure you can tab to submit and close
       * Add the cc-popup--visible class
       * Update aria to visible
       */ _createClass(ccPopup, [
        {
          key: "open",
          value: function open(callback) {
            var _this2 = this;
            // Prevent the body from scrolling
            if (this.$container.data("freeze-scroll")) {
              $("body").addClass(this.cssClasses.bodyNoScroll);
              // Add any padding necessary to the body to compensate for the scrollbar that just disappeared
              var scrollDiv = document.createElement("div");
              scrollDiv.className = "popup-scrollbar-measure";
              document.body.appendChild(scrollDiv);
              var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
              document.body.removeChild(scrollDiv);
              if (scrollbarWidth > 0) {
                $("body")
                  .css("padding-right", scrollbarWidth + "px")
                  .addClass(this.cssClasses.bodyNoScrollPadRight);
              }
            }
            if (window.innerWidth > 767) {
              $(".section-popup .popup_img_container").addClass("open");
            } else {
              $(".section-popup .popup_sign_up-submit").addClass("open");
            }

            // Add reveal class
            this.$container.addClass(this.cssClasses.visible);

            // Track previously focused element
            this.previouslyActiveElement = document.activeElement;

            // Focus on the close button after the animation in has completed
            setTimeout(function () {
              _this2.$container.find(".cc-popup-close")[0].focus();
            }, 500);

            // Pressing escape closes the modal
            $(window).on("keydown" + this.namespace, function (event) {
              if (event.keyCode === 27) {
                _this2.close();
              }
            });

            if (callback) {
              callback();
            }
          },
        },
        {
          key: "close",
          value:
            /**
             * Close popup on click of close button or background - where does the focus go back to?
             * Remove the cc-popup--visible class
             */
            function close(callback, popup_name = "订阅弹层") {
              var _this3 = this;
              // Remove reveal class
              this.$container.removeClass(this.cssClasses.visible);

              // 神策埋点
              // sensors.track("ClickClose", {
              //   popup_name: popup_name,
              // });
              // Revert focus
              if (this.previouslyActiveElement) {
                $(this.previouslyActiveElement).focus();
              }

              // Destroy the escape event listener
              $(window).off("keydown" + this.namespace);

              // Allow the body to scroll and remove any scrollbar-compensating padding
              if (this.$container.data("freeze-scroll")) {
                var transitionDuration = 500;

                var $innerModal = this.$container.find(".cc-popup-modal");
                if ($innerModal.length) {
                  transitionDuration = parseFloat(getComputedStyle($innerModal[0])["transitionDuration"]);
                  if (transitionDuration && transitionDuration > 0) {
                    transitionDuration *= 1000;
                  }
                }

                setTimeout(function () {
                  $("body").removeClass(_this3.cssClasses.bodyNoScroll).removeClass(_this3.cssClasses.bodyNoScrollPadRight).css("padding-right", "0");
                }, transitionDuration);
              }

              if (callback) {
                callback();
              }
            },
        },
      ]);
      return ccPopup;
    })();
    (function () {
      theme.initAnimateOnScroll = function () {
        if (document.body.classList.contains("cc-animate-enabled") && window.innerWidth >= 768) {
          var animationTimeout = typeof document.body.dataset.ccAnimateTimeout !== "undefined" ? document.body.dataset.ccAnimateTimeout : 200;

          if ("IntersectionObserver" in window) {
            var intersectionObserver = new IntersectionObserver(function (entries, observer) {
              entries.forEach(function (entry) {
                // In view and hasn't been animated yet
                if (entry.isIntersecting && !entry.target.classList.contains("cc-animate-complete")) {
                  setTimeout(function () {
                    entry.target.classList.add("-in", "cc-animate-complete");
                  }, animationTimeout);

                  setTimeout(function () {
                    //Once the animation is complete (assume 5 seconds), remove the animate attribute to remove all css
                    entry.target.classList.remove("data-cc-animate");
                    entry.target.style.transitionDuration = null;
                    entry.target.style.transitionDelay = null;
                  }, 5000);

                  // Remove observer after animation
                  observer.unobserve(entry.target);
                }
              });
            });

            document.querySelectorAll("[data-cc-animate]:not(.cc-animate-init)").forEach(function (elem) {
              //Set the animation delay
              if (elem.dataset.ccAnimateDelay) {
                elem.style.transitionDelay = elem.dataset.ccAnimateDelay;
              }

              ///Set the animation duration
              if (elem.dataset.ccAnimateDuration) {
                elem.style.transitionDuration = elem.dataset.ccAnimateDuration;
              }

              //Init the animation
              if (elem.dataset.ccAnimate) {
                elem.classList.add(elem.dataset.ccAnimate);
              }

              elem.classList.add("cc-animate-init");

              //Watch for elem
              intersectionObserver.observe(elem);
            });
          } else {
            //Fallback, load all the animations now
            var elems = document.querySelectorAll("[data-cc-animate]:not(.cc-animate-init)");
            for (var i = 0; i < elems.length; i++) {
              elems[i].classList.add("-in", "cc-animate-complete");
            }
          }
        }
      };

      theme.initAnimateOnScroll();

      document.addEventListener("shopify:section:load", function () {
        setTimeout(theme.initAnimateOnScroll, 100);
      });

      //Reload animations when changing from mobile to desktop
      try {
        window.matchMedia("(min-width: 768px)").addEventListener("change", function (event) {
          if (event.matches) {
            setTimeout(theme.initAnimateOnScroll, 100);
          }
        });
      } catch (e) {}
    })();
    var AccordionInstance = /*#__PURE__*/ (function () {
      "use strict";
      function AccordionInstance(container) {
        _classCallCheck(this, AccordionInstance);
        this.accordion = container;
        this.itemClass = ".cc-accordion-item";
        this.titleClass = ".cc-accordion-item__title";
        this.panelClass = ".cc-accordion-item__panel";
        this.allowMultiOpen = this.accordion.dataset.allowMultiOpen === "true";

        // If multiple open items not allowed, set open item as active (if there is one)
        if (!this.allowMultiOpen) {
          this.activeItem = this.accordion.querySelector("".concat(this.itemClass, "[open]"));
        }

        this.bindEvents();
      }

      /**
       * Adds inline 'height' style to a panel, to trigger open transition
       * @param {HTMLDivElement} panel - The accordion item content panel
       */ _createClass(
        AccordionInstance,
        [
          {
            key: "open",
            value:
              /**
               * Opens an accordion item
               * @param {HTMLDetailsElement} item - The accordion item
               * @param {HTMLDivElement} panel - The accordion item content panel
               */
              function open(item, panel) {
                panel.style.height = "0";

                // Set item to open. Blocking the default click action and opening it this way prevents a
                // slight delay which causes the panel height to be set to '0' (because item's not open yet)
                item.open = true;

                AccordionInstance.addPanelHeight(panel);

                // Slight delay required before starting transitions
                setTimeout(function () {
                  item.classList.add("is-open");
                }, 10);

                if (!this.allowMultiOpen) {
                  // If there's an active item and it's not the opened item, close it
                  if (this.activeItem && this.activeItem !== item) {
                    var activePanel = this.activeItem.querySelector(this.panelClass);
                    this.close(this.activeItem, activePanel);
                  }

                  this.activeItem = item;
                }
              },

            /**
             * Closes an accordion item
             * @param {HTMLDetailsElement} item - The accordion item
             * @param {HTMLDivElement} panel - The accordion item content panel
             */
          },
          {
            key: "close",
            value: function close(item, panel) {
              AccordionInstance.addPanelHeight(panel);

              item.classList.remove("is-open");
              item.classList.add("is-closing");

              if (this.activeItem === item) {
                this.activeItem = null;
              }

              // Slight delay required to allow scroll height to be applied before changing to '0'
              setTimeout(function () {
                panel.style.height = "0";
              }, 10);
            },

            /**
             * Handles 'click' event on the accordion
             * @param {Object} e - The event object
             */
          },
          {
            key: "handleClick",
            value: function handleClick(e) {
              // Ignore clicks outside a toggle (<summary> element)
              var toggle = e.target.closest(this.titleClass);
              if (!toggle) return;

              // Prevent the default action
              // We'll trigger it manually after open transition initiated or close transition complete
              e.preventDefault();

              var item = toggle.parentNode;
              var panel = toggle.nextElementSibling;

              if (item.open) {
                this.close(item, panel);
              } else {
                this.open(item, panel);
              }
            },

            /**
             * Handles 'transitionend' event in the accordion
             * @param {Object} e - The event object
             */
          },
          {
            key: "handleTransition",
            value: function handleTransition(e) {
              // Ignore transitions not on a panel element
              if (!e.target.matches(this.panelClass)) return;

              var panel = e.target;
              var item = panel.parentNode;

              if (item.classList.contains("is-closing")) {
                item.classList.remove("is-closing");
                item.open = false;
              }

              AccordionInstance.removePanelHeight(panel);
            },
          },
          {
            key: "bindEvents",
            value: function bindEvents() {
              // Need to assign the function calls to variables because bind creates a new function,
              // which means the event listeners can't be removed in the usual way
              this.clickHandler = this.handleClick.bind(this);
              this.transitionHandler = this.handleTransition.bind(this);

              this.accordion.addEventListener("click", this.clickHandler);
              this.accordion.addEventListener("transitionend", this.transitionHandler);
            },
          },
          {
            key: "destroy",
            value: function destroy() {
              this.accordion.removeEventListener("click", this.clickHandler);
              this.accordion.removeEventListener("transitionend", this.transitionHandler);
            },
          },
        ],
        [
          {
            key: "addPanelHeight",
            value: function addPanelHeight(panel) {
              panel.style.height = "".concat(panel.scrollHeight, "px");
            },
            /**
             * Removes inline 'height' style from a panel, to trigger close transition
             * @param {HTMLDivElement} panel - The accordion item content panel
             */
          },
          {
            key: "removePanelHeight",
            value: function removePanelHeight(panel) {
              panel.getAttribute("style"); // Fix Safari bug (doesn't remove attribute without this first!)
              panel.removeAttribute("style");
            },
          },
        ]
      );
      return AccordionInstance;
    })();
    var Accordion = /*#__PURE__*/ (function (_ccComponent) {
      "use strict";
      _inherits(Accordion, _ccComponent);
      var _super = _createSuper(Accordion);
      function Accordion() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "accordion";
        var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);
        _classCallCheck(this, Accordion);
        return _super.call(this, name, cssSelector);
      }
      _createClass(Accordion, [
        {
          key: "init",
          value: function init(container) {
            _get(_getPrototypeOf(Accordion.prototype), "init", this).call(this, container);
            this.registerInstance(container, new AccordionInstance(container));
          },
        },
        {
          key: "destroy",
          value: function destroy(container) {
            this.destroyInstance(container);
            _get(_getPrototypeOf(Accordion.prototype), "destroy", this).call(this, container);
          },
        },
      ]);
      return Accordion;
    })(ccComponent);

    new Accordion();
    var CustomSelectInstance = /*#__PURE__*/ (function () {
      "use strict";
      function CustomSelectInstance(el) {
        _classCallCheck(this, CustomSelectInstance);
        this.el = el;
        this.button = el.querySelector(".cc-select__btn");
        this.listbox = el.querySelector(".cc-select__listbox");
        this.options = el.querySelectorAll(".cc-select__option");
        this.selectedOption = el.querySelector('[aria-selected="true"]');
        this.nativeSelect = document.getElementById("".concat(el.id, "-native"));
        this.swatches = "swatch" in this.options[0].dataset;
        this.focusedClass = "is-focused";
        this.searchString = "";
        this.listboxOpen = false;

        // Set the selected option
        if (!this.selectedOption) {
          this.selectedOption = this.listbox.firstElementChild;
        }

        this.bindEvents();
        this.setButtonWidth();
      }
      _createClass(CustomSelectInstance, [
        {
          key: "bindEvents",
          value: function bindEvents() {
            this.el.addEventListener("keydown", this.handleKeydown.bind(this));
            this.button.addEventListener("mousedown", this.handleMousedown.bind(this));
          },

          /**
           * Adds event listeners when the options list is visible
           */
        },
        {
          key: "addListboxOpenEvents",
          value: function addListboxOpenEvents() {
            this.mouseoverHandler = this.handleMouseover.bind(this);
            this.mouseleaveHandler = this.handleMouseleave.bind(this);
            this.clickHandler = this.handleClick.bind(this);
            this.blurHandler = this.handleBlur.bind(this);

            this.listbox.addEventListener("mouseover", this.mouseoverHandler);
            this.listbox.addEventListener("mouseleave", this.mouseleaveHandler);
            this.listbox.addEventListener("click", this.clickHandler);
            this.listbox.addEventListener("blur", this.blurHandler);
          },

          /**
           * Removes event listeners added when the options list was visible
           */
        },
        {
          key: "removeListboxOpenEvents",
          value: function removeListboxOpenEvents() {
            this.listbox.removeEventListener("mouseover", this.mouseoverHandler);
            this.listbox.removeEventListener("mouseleave", this.mouseleaveHandler);
            this.listbox.removeEventListener("click", this.clickHandler);
            this.listbox.removeEventListener("blur", this.blurHandler);
          },

          /**
           * Handles a 'keydown' event on the custom select element
           * @param {Object} e - The event object
           */
        },
        {
          key: "handleKeydown",
          value: function handleKeydown(e) {
            if (this.listboxOpen) {
              this.handleKeyboardNav(e);
            } else if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === " ") {
              e.preventDefault();
              this.showListbox();
            }
          },

          /**
           * Handles a 'mousedown' event on the button element
           * @param {Object} e - The event object
           */
        },
        {
          key: "handleMousedown",
          value: function handleMousedown(e) {
            if (!this.listboxOpen && e.button === 0) {
              this.showListbox();
            }
          },

          /**
           * Handles a 'mouseover' event on the options list
           * @param {Object} e - The event object
           */
        },
        {
          key: "handleMouseover",
          value: function handleMouseover(e) {
            if (e.target.matches("li")) {
              this.focusOption(e.target);
            }
          },

          /**
           * Handles a 'mouseleave' event on the options list
           */
        },
        {
          key: "handleMouseleave",
          value: function handleMouseleave() {
            this.focusOption(this.selectedOption);
          },

          /**
           * Handles a 'click' event on the options list
           * @param {Object} e - The event object
           */
        },
        {
          key: "handleClick",
          value: function handleClick(e) {
            if (e.target.matches(".js-option")) {
              this.selectOption(e.target);
            }
          },

          /**
           * Handles a 'blur' event on the options list
           */
        },
        {
          key: "handleBlur",
          value: function handleBlur() {
            if (this.listboxOpen) {
              this.hideListbox();
            }
          },

          /**
           * Handles a 'keydown' event on the options list
           * @param {Object} e - The event object
           */
        },
        {
          key: "handleKeyboardNav",
          value: function handleKeyboardNav(e) {
            var optionToFocus;

            // Disable tabbing if options list is open (as per native select element)
            if (e.key === "Tab") {
              e.preventDefault();
            }

            switch (e.key) {
              // Focus an option
              case "ArrowUp":
              case "ArrowDown":
                e.preventDefault();

                if (e.key === "ArrowUp") {
                  optionToFocus = this.focusedOption.previousElementSibling;
                } else {
                  optionToFocus = this.focusedOption.nextElementSibling;
                }

                if (optionToFocus && !optionToFocus.classList.contains("is-disabled")) {
                  this.focusOption(optionToFocus);
                }
                break;

              // Select an option
              case "Enter":
              case " ":
                e.preventDefault();
                this.selectOption(this.focusedOption);
                break;

              // Cancel and close the options list
              case "Escape":
                e.preventDefault();
                this.hideListbox();
                break;

              // Search for an option and focus the first match (if one exists)
              default:
                optionToFocus = this.findOption(e.key);

                if (optionToFocus) {
                  this.focusOption(optionToFocus);
                }
                break;
            }
          },

          /**
           * Sets the button width to the same as the longest option, to prevent
           * the button width from changing depending on the option selected
           */
        },
        {
          key: "setButtonWidth",
          value: function setButtonWidth() {
            // Get the width of an element without side padding
            var getUnpaddedWidth = function getUnpaddedWidth(el) {
              var elStyle = getComputedStyle(el);
              return parseFloat(elStyle.paddingLeft) + parseFloat(elStyle.paddingRight);
            };

            var buttonPadding = getUnpaddedWidth(this.button);
            var optionPadding = getUnpaddedWidth(this.selectedOption);
            var buttonBorder = this.button.offsetWidth - this.button.clientWidth;
            var optionWidth = Math.ceil(this.selectedOption.getBoundingClientRect().width);

            this.button.style.width = "".concat(optionWidth - optionPadding + buttonPadding + buttonBorder, "px");
          },

          /**
           * Shows the options list
           */
        },
        {
          key: "showListbox",
          value: function showListbox() {
            var _this4 = this;
            this.listbox.hidden = false;
            this.listboxOpen = true;

            this.el.classList.add("is-open");
            this.button.setAttribute("aria-expanded", "true");
            this.listbox.setAttribute("aria-hidden", "false");

            // Slight delay required to prevent blur event being fired immediately
            setTimeout(function () {
              _this4.focusOption(_this4.selectedOption);
              _this4.listbox.focus();

              _this4.addListboxOpenEvents();
            }, 10);
          },

          /**
           * Hides the options list
           */
        },
        {
          key: "hideListbox",
          value: function hideListbox() {
            if (!this.listboxOpen) return;

            this.listbox.hidden = true;
            this.listboxOpen = false;

            this.el.classList.remove("is-open");
            this.button.setAttribute("aria-expanded", "false");
            this.listbox.setAttribute("aria-hidden", "true");

            if (this.focusedOption) {
              this.focusedOption.classList.remove(this.focusedClass);
              this.focusedOption = null;
            }

            this.button.focus();
            this.removeListboxOpenEvents();
          },

          /**
           * Finds a matching option from a typed string
           * @param {string} key - The key pressed
           * @returns {?HTMLElement}
           */
        },
        {
          key: "findOption",
          value: function findOption(key) {
            var _this5 = this;
            this.searchString += key;

            // If there's a timer already running, clear it
            if (this.searchTimer) {
              clearTimeout(this.searchTimer);
            }

            // Wait 500ms to see if another key is pressed, if not then clear the search string
            this.searchTimer = setTimeout(function () {
              _this5.searchString = "";
            }, 500);

            // Find an option that contains the search string (if there is one)
            var matchingOption = _toConsumableArray(this.options).find(function (option) {
              var label = option.innerText.toLowerCase();
              return label.includes(_this5.searchString) && !option.classList.contains("is-disabled");
            });

            return matchingOption;
          },

          /**
           * Focuses an option
           * @param {HTMLElement} option - The <li> element of the option to focus
           */
        },
        {
          key: "focusOption",
          value: function focusOption(option) {
            // Remove focus on currently focused option (if there is one)
            if (this.focusedOption) {
              this.focusedOption.classList.remove(this.focusedClass);
            }

            // Set focus on the option
            this.focusedOption = option;
            this.focusedOption.classList.add(this.focusedClass);

            // If option is out of view, scroll the list
            if (this.listbox.scrollHeight > this.listbox.clientHeight) {
              var scrollBottom = this.listbox.clientHeight + this.listbox.scrollTop;
              var optionBottom = option.offsetTop + option.offsetHeight;

              if (optionBottom > scrollBottom) {
                this.listbox.scrollTop = optionBottom - this.listbox.clientHeight;
              } else if (option.offsetTop < this.listbox.scrollTop) {
                this.listbox.scrollTop = option.offsetTop;
              }
            }
          },

          /**
           * Selects an option
           * @param {HTMLElement} option - The option <li> element
           */
        },
        {
          key: "selectOption",
          value: function selectOption(option) {
            if (option !== this.selectedOption) {
              // Switch aria-selected attribute to selected option
              option.setAttribute("aria-selected", "true");
              this.selectedOption.setAttribute("aria-selected", "false");

              // Update swatch colour in the button
              if (this.swatches) {
                this.button.dataset.swatch = option.dataset.swatch;
              }

              // Update the button text and set the option as active
              this.button.firstChild.textContent = option.firstElementChild.textContent;
              this.listbox.setAttribute("aria-activedescendant", option.id);
              this.selectedOption = document.getElementById(option.id);

              // If a native select element exists, update its selected value and trigger a 'change' event
              if (this.nativeSelect) {
                this.nativeSelect.value = option.dataset.value;
                this.nativeSelect.dispatchEvent(new Event("change"));
              } else {
                // Trigger a 'change' event on the custom select element
                var detail = { selectedValue: option.dataset.value };
                this.el.dispatchEvent(new CustomEvent("change", { bubbles: true, detail: detail }));
              }
            }

            this.hideListbox();
          },
        },
      ]);
      return CustomSelectInstance;
    })();
    var CustomSelect = /*#__PURE__*/ (function (_ccComponent2) {
      "use strict";
      _inherits(CustomSelect, _ccComponent2);
      var _super2 = _createSuper(CustomSelect);
      function CustomSelect() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "custom-select";
        var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-select";
        _classCallCheck(this, CustomSelect);
        return _super2.call(this, name, cssSelector);
      }
      _createClass(CustomSelect, [
        {
          key: "init",
          value: function init(container) {
            _get(_getPrototypeOf(CustomSelect.prototype), "init", this).call(this, container);
            this.registerInstance(container, new CustomSelectInstance(container));
          },
        },
        {
          key: "destroy",
          value: function destroy(container) {
            this.destroyInstance(container);
            _get(_getPrototypeOf(CustomSelect.prototype), "destroy", this).call(this, container);
          },
        },
      ]);
      return CustomSelect;
    })(ccComponent);

    new CustomSelect();
    /**
     * Display a modal window on-click. It's a lightbox.
     * To use:
     * Add 'cc-modal' class to a clickable element.
     *
     * Configure with:
     * - data-cc-modal-contentelement - selector for element containing content to show, innerHTML of element is copied into the modal
     * - data-cc-modal-size (optional) - 'small' or 'medium', defaults to 'medium'
     * - data-cc-modal-launch (optional) - 'true' if we want to open the modal immediately
     *
     * Example:
     * <a href="#password-login" class="cc-modal" data-cc-modal-contentelement="#password-login" data-cc-modal-size="small">
     * <div id="password-login" class="js-hidden">
     */ var ModalInstance = /*#__PURE__*/ (function () {
      "use strict";
      function ModalInstance(container) {
        _classCallCheck(this, ModalInstance);
        this.container = container;
        this.size = container.dataset.ccModalSize || "medium";
        this.contentElement = document.querySelector(container.dataset.ccModalContentelement);

        this.container.addEventListener("click", this.handleClick.bind(this));

        if (container.dataset.ccModalLaunch === "true") {
          setTimeout(this.open.bind(this), 10);
        }
      }

      /**
       * Handles 'click' event on the container
       * @param {Object} e - The event object
       */ _createClass(ModalInstance, [
        {
          key: "handleClick",
          value: function handleClick(e) {
            e.preventDefault();
            this.open();
            this.opener = e.target;
          },

          /**
           * Create the modal and add it to the page.
           */
        },
        {
          key: "open",
          value: function open() {
            var _this6 = this;
            var tve = theme.createTemplateVariableEncoder();
            tve.add("size", this.size, "attribute");
            tve.add("content", this.contentElement.innerHTML, "raw");
            tve.add("button_close_label", theme.strings.general_accessibility_labels_close, "attribute");
            tve.add("button_close_icon", theme.icons.close, "raw");

            var html = '\n      <div class="cc-modal-window cc-modal-window--pre-reveal cc-modal-window--size-'
              .concat(
                tve.values.size,
                '">\n        <div class="cc-modal-window__background"></div>\n        <div class="cc-modal-window__foreground" role="dialog" aria-modal="true">\n          <div class="cc-modal-window__content-container">\n            <button class="cc-modal-window__close" aria-label="'
              )
              .concat(tve.values.button_close_label, '">')
              .concat(tve.values.button_close_icon, '</button>\n            <div class="cc-modal-window__content">')
              .concat(tve.values.content, "</div>\n          </div>\n        </div>\n      </div>\n    ");

            var modalElementFragment = document.createRange().createContextualFragment(html);
            document.body.appendChild(modalElementFragment);

            document.body.classList.add("cc-modal-visible");
            this.modalElement = document.body.lastElementChild;

            this.modalElement.querySelector(".cc-modal-window__background").addEventListener("click", this.close.bind(this));
            this.modalElement.querySelector(".cc-modal-window__close").addEventListener("click", this.close.bind(this));

            setTimeout(function () {
              _this6.modalElement.classList.remove("cc-modal-window--pre-reveal");
              _this6.modalElement.querySelector(".cc-modal-window__close").focus();
            }, 10);
          },
        },
        {
          key: "close",
          value: function close() {
            var _this7 = this;
            this.modalElement.classList.add("cc-modal-window--closing");
            if (!document.querySelector(".cc-modal-window:not(.cc-modal-window--closing)")) {
              document.body.classList.remove("cc-modal-visible");
            }

            if (this.opener) {
              setTimeout(function () {
                _this7.opener.focus();
              }, 10);
            }

            // give transitions 5s to do their thing before we tidy up (note: this.modalElement may be reassigned during this timeout)
            setTimeout(
              function () {
                this.remove();
              }.bind(this.modalElement),
              5000
            );
          },
        },
      ]);
      return ModalInstance;
    })();
    var Modal = /*#__PURE__*/ (function (_ccComponent3) {
      "use strict";
      _inherits(Modal, _ccComponent3);
      var _super3 = _createSuper(Modal);
      function Modal() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "modal";
        var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);
        _classCallCheck(this, Modal);
        return _super3.call(this, name, cssSelector);
      }
      _createClass(Modal, [
        {
          key: "init",
          value: function init(container) {
            _get(_getPrototypeOf(Modal.prototype), "init", this).call(this, container);
            this.registerInstance(container, new ModalInstance(container));
          },
        },
        {
          key: "destroy",
          value: function destroy(container) {
            this.destroyInstance(container);
            _get(_getPrototypeOf(Modal.prototype), "destroy", this).call(this, container);
          },
        },
      ]);
      return Modal;
    })(ccComponent);

    new Modal();
    var PriceRangeInstance = /*#__PURE__*/ (function () {
      "use strict";
      function PriceRangeInstance(container) {
        var _this8 = this;
        _classCallCheck(this, PriceRangeInstance);
        this.container = container;
        this.selectors = {
          inputMin: ".cc-price-range__input--min",
          inputMax: ".cc-price-range__input--max",
          control: ".cc-price-range__control",
          controlMin: ".cc-price-range__control--min",
          controlMax: ".cc-price-range__control--max",
          bar: ".cc-price-range__bar",
          activeBar: ".cc-price-range__bar-active",
        };

        this.controls = {
          min: {
            barControl: container.querySelector(this.selectors.controlMin),
            input: container.querySelector(this.selectors.inputMin),
          },

          max: {
            barControl: container.querySelector(this.selectors.controlMax),
            input: container.querySelector(this.selectors.inputMax),
          },
        };

        this.controls.min.value = parseInt(
          this.controls.min.input.value === "" ? this.controls.min.input.placeholder : this.controls.min.input.value
        );
        this.controls.max.value = parseInt(
          this.controls.max.input.value === "" ? this.controls.max.input.placeholder : this.controls.max.input.value
        );
        this.valueMin = this.controls.min.input.min;
        this.valueMax = this.controls.min.input.max;
        this.valueRange = this.valueMax - this.valueMin;

        [this.controls.min, this.controls.max].forEach(function (item) {
          item.barControl.setAttribute("aria-valuemin", _this8.valueMin);
          item.barControl.setAttribute("aria-valuemax", _this8.valueMax);
          item.barControl.setAttribute("tabindex", 0);
        });
        this.controls.min.barControl.setAttribute("aria-valuenow", this.controls.min.value);
        this.controls.max.barControl.setAttribute("aria-valuenow", this.controls.max.value);

        this.bar = container.querySelector(this.selectors.bar);
        this.activeBar = container.querySelector(this.selectors.activeBar);
        this.inDrag = false;

        this.bindEvents();
        this.render();
      }
      _createClass(PriceRangeInstance, [
        {
          key: "getPxToValueRatio",
          value: function getPxToValueRatio() {
            return this.bar.clientWidth / (this.valueMax - this.valueMin);
          },
        },
        {
          key: "getPcToValueRatio",
          value: function getPcToValueRatio() {
            return 100.0 / (this.valueMax - this.valueMin);
          },
        },
        {
          key: "setActiveControlValue",
          value: function setActiveControlValue(value) {
            // only accept valid numbers
            if (isNaN(parseInt(value))) return;

            // clamp & default
            if (this.activeControl === this.controls.min) {
              if (value === "") {
                value = this.valueMin;
              }
              value = Math.max(this.valueMin, value);
              value = Math.min(value, this.controls.max.value);
            } else {
              if (value === "") {
                value = this.valueMax;
              }
              value = Math.min(this.valueMax, value);
              value = Math.max(value, this.controls.min.value);
            }

            // round
            this.activeControl.value = Math.round(value);

            // update input
            if (this.activeControl.input.value != this.activeControl.value) {
              if (this.activeControl.value == this.activeControl.input.placeholder) {
                this.activeControl.input.value = "";
              } else {
                this.activeControl.input.value = this.activeControl.value;
              }
              this.activeControl.input.dispatchEvent(
                new CustomEvent("change", {
                  bubbles: true,
                  cancelable: false,
                  detail: { sender: "theme:component:price_range" },
                })
              );
            }

            // a11y
            this.activeControl.barControl.setAttribute("aria-valuenow", this.activeControl.value);
          },
        },
        {
          key: "render",
          value: function render() {
            this.drawControl(this.controls.min);
            this.drawControl(this.controls.max);
            this.drawActiveBar();
          },
        },
        {
          key: "drawControl",
          value: function drawControl(control) {
            control.barControl.style.left = (control.value - this.valueMin) * this.getPcToValueRatio() + "%";
          },
        },
        {
          key: "drawActiveBar",
          value: function drawActiveBar() {
            this.activeBar.style.left = (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() + "%";
            this.activeBar.style.right = (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() + "%";
          },
        },
        {
          key: "handleControlTouchStart",
          value: function handleControlTouchStart(e) {
            e.preventDefault();
            this.startDrag(e.target, e.touches[0].clientX);
            this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this);
            this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this);
            window.addEventListener("touchmove", this.boundControlTouchMoveEvent);
            window.addEventListener("touchend", this.boundControlTouchEndEvent);
          },
        },
        {
          key: "handleControlTouchMove",
          value: function handleControlTouchMove(e) {
            this.moveDrag(e.touches[0].clientX);
          },
        },
        {
          key: "handleControlTouchEnd",
          value: function handleControlTouchEnd(e) {
            e.preventDefault();
            window.removeEventListener("touchmove", this.boundControlTouchMoveEvent);
            window.removeEventListener("touchend", this.boundControlTouchEndEvent);
            this.stopDrag();
          },
        },
        {
          key: "handleControlMouseDown",
          value: function handleControlMouseDown(e) {
            e.preventDefault();
            this.startDrag(e.target, e.clientX);
            this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this);
            this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this);
            window.addEventListener("mousemove", this.boundControlMouseMoveEvent);
            window.addEventListener("mouseup", this.boundControlMouseUpEvent);
          },
        },
        {
          key: "handleControlMouseMove",
          value: function handleControlMouseMove(e) {
            this.moveDrag(e.clientX);
          },
        },
        {
          key: "handleControlMouseUp",
          value: function handleControlMouseUp(e) {
            e.preventDefault();
            window.removeEventListener("mousemove", this.boundControlMouseMoveEvent);
            window.removeEventListener("mouseup", this.boundControlMouseUpEvent);
            this.stopDrag();
          },
        },
        {
          key: "startDrag",
          value: function startDrag(target, startX) {
            if (this.controls.min.barControl === target) {
              this.activeControl = this.controls.min;
            } else {
              this.activeControl = this.controls.max;
            }
            this.dragStartX = startX;
            this.dragStartValue = this.activeControl.value;
            this.inDrag = true;
          },
        },
        {
          key: "moveDrag",
          value: function moveDrag(moveX) {
            if (this.inDrag) {
              var value = this.dragStartValue + (moveX - this.dragStartX) / this.getPxToValueRatio();
              this.setActiveControlValue(value);
              this.render();
            }
          },
        },
        {
          key: "stopDrag",
          value: function stopDrag() {
            this.inDrag = false;
          },
        },
        {
          key: "handleControlKeyDown",
          value: function handleControlKeyDown(e) {
            if (e.key === "ArrowRight") {
              this.incrementControlFromKeypress(e.target, 10.0);
            } else if (e.key === "ArrowLeft") {
              this.incrementControlFromKeypress(e.target, -10.0);
            }
          },
        },
        {
          key: "incrementControlFromKeypress",
          value: function incrementControlFromKeypress(control, pxAmount) {
            if (this.controls.min.barControl === control) {
              this.activeControl = this.controls.min;
            } else {
              this.activeControl = this.controls.max;
            }
            this.setActiveControlValue(this.activeControl.value + pxAmount / this.getPxToValueRatio());
            this.render();
          },
        },
        {
          key: "handleInputChange",
          value: function handleInputChange(e) {
            // strip out non numeric values
            e.target.value = e.target.value.replace(/\D/g, "");

            if (!e.detail || e.detail.sender != "theme:component:price_range") {
              if (this.controls.min.input === e.target) {
                this.activeControl = this.controls.min;
              } else {
                this.activeControl = this.controls.max;
              }
              this.setActiveControlValue(e.target.value);
              this.render();
            }
          },
        },
        {
          key: "handleInputKeyup",
          value: function handleInputKeyup(e) {
            // enforce numeric chars in the input
            setTimeout(
              function () {
                this.value = this.value.replace(/\D/g, "");
              }.bind(e.target),
              10
            );
          },
        },
        {
          key: "bindEvents",
          value: function bindEvents() {
            var _this9 = this;
            [this.controls.min, this.controls.max].forEach(function (item) {
              item.barControl.addEventListener("touchstart", _this9.handleControlTouchStart.bind(_this9));
              item.barControl.addEventListener("mousedown", _this9.handleControlMouseDown.bind(_this9));
              item.barControl.addEventListener("keydown", _this9.handleControlKeyDown.bind(_this9));
              item.input.addEventListener("change", _this9.handleInputChange.bind(_this9));
              item.input.addEventListener("keyup", _this9.handleInputKeyup.bind(_this9));
            });
          },
        },
        { key: "destroy", value: function destroy() {} },
      ]);
      return PriceRangeInstance;
    })();
    var PriceRange = /*#__PURE__*/ (function (_ccComponent4) {
      "use strict";
      _inherits(PriceRange, _ccComponent4);
      var _super4 = _createSuper(PriceRange);
      function PriceRange() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "price-range";
        var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);
        _classCallCheck(this, PriceRange);
        return _super4.call(this, name, cssSelector);
      }
      _createClass(PriceRange, [
        {
          key: "init",
          value: function init(container) {
            _get(_getPrototypeOf(PriceRange.prototype), "init", this).call(this, container);
            this.registerInstance(container, new PriceRangeInstance(container));
          },
        },
        {
          key: "destroy",
          value: function destroy(container) {
            this.destroyInstance(container);
            _get(_getPrototypeOf(PriceRange.prototype), "destroy", this).call(this, container);
          },
        },
      ]);
      return PriceRange;
    })(ccComponent);

    new PriceRange();
    // Manage videos
    theme.VideoManager = new (function () {
      var _ = this;

      _._permitPlayback = function (container) {
        return !($(container).hasClass("video-container--background") && $(window).outerWidth() < 768);
      };

      // Youtube
      _.youtubeVars = {
        incrementor: 0,
        apiReady: false,
        videoData: {},
        toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)',
      };

      _.youtubeApiReady = function () {
        _.youtubeVars.apiReady = true;
        _._loadYoutubeVideos();
      };

      _._loadYoutubeVideos = function (container) {
        if ($(_.youtubeVars.toProcessSelector, container).length) {
          if (_.youtubeVars.apiReady) {
            // play those videos
            $(_.youtubeVars.toProcessSelector, container).each(function () {
              // Don't init background videos on mobile
              if (_._permitPlayback($(this))) {
                $(this).addClass("video--init");
                _.youtubeVars.incrementor++;
                var containerId = "theme-yt-video-" + _.youtubeVars.incrementor;
                $(this).data("video-container-id", containerId);
                var videoElement = $('<div class="video-container__video-element">')
                  .attr("id", containerId)
                  .appendTo($(".video-container__video", this));
                var autoplay = $(this).data("video-autoplay");
                var loop = $(this).data("video-loop");
                var player = new YT.Player(containerId, {
                  height: "360",
                  width: "640",
                  videoId: $(this).data("video-id"),
                  playerVars: {
                    iv_load_policy: 3,
                    modestbranding: 1,
                    autoplay: 0,
                    loop: loop ? 1 : 0,
                    playlist: $(this).data("video-id"),
                    rel: 0,
                    showinfo: 0,
                  },

                  events: {
                    onReady: _._onYoutubePlayerReady.bind({
                      autoplay: autoplay,
                      loop: loop,
                      $container: $(this),
                    }),
                    onStateChange: _._onYoutubePlayerStateChange.bind({
                      autoplay: autoplay,
                      loop: loop,
                      $container: $(this),
                    }),
                  },
                });

                _.youtubeVars.videoData[containerId] = {
                  id: containerId,
                  container: this,
                  videoElement: videoElement,
                  player: player,
                };
              }
            });
          } else {
            // load api
            theme.loadScriptOnce("https://www.youtube.com/iframe_api");
          }
        }
      };

      _._onYoutubePlayerReady = function (event) {
        event.target.setPlaybackQuality("hd1080");
        if (this.autoplay) {
          event.target.mute();
          event.target.playVideo();
        }

        _._initBackgroundVideo(this.$container);
      };

      _._onYoutubePlayerStateChange = function (event) {
        if (event.data == YT.PlayerState.PLAYING) {
          this.$container.addClass("video--play-started");

          if (this.autoplay) {
            event.target.mute();
          }

          if (this.loop) {
            // 4 times a second, check if we're in the final second of the video. If so, loop it for a more seamless loop
            var finalSecond = event.target.getDuration() - 1;
            if (finalSecond > 2) {
              var loopTheVideo = function loopTheVideo() {
                if (event.target.getCurrentTime() > finalSecond) {
                  event.target.seekTo(0);
                }
                setTimeout(loopTheVideo, 250);
              };
              loopTheVideo();
            }
          }
        }
      };

      _._unloadYoutubeVideos = function (container) {
        for (var dataKey in _.youtubeVars.videoData) {
          var data = _.youtubeVars.videoData[dataKey];
          if ($(container).find(data.container).length) {
            data.player.destroy();
            delete _.youtubeVars.videoData[dataKey];
            return;
          }
        }
      };

      // Vimeo
      _.vimeoVars = {
        incrementor: 0,
        apiReady: false,
        videoData: {},
        toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)',
      };

      _.vimeoApiReady = function () {
        _.vimeoVars.apiReady = true;
        _._loadVimeoVideos();
      };

      _._loadVimeoVideos = function (container) {
        if ($(_.vimeoVars.toProcessSelector, container).length) {
          if (_.vimeoVars.apiReady) {
            // play those videos

            $(_.vimeoVars.toProcessSelector, container).each(function () {
              // Don't init background videos on mobile
              if (_._permitPlayback($(this))) {
                $(this).addClass("video--init");
                _.vimeoVars.incrementor++;
                var $this = $(this);
                var containerId = "theme-vi-video-" + _.vimeoVars.incrementor;
                $(this).data("video-container-id", containerId);
                var videoElement = $('<div class="video-container__video-element">')
                  .attr("id", containerId)
                  .appendTo($(".video-container__video", this));
                var autoplay = !!$(this).data("video-autoplay");
                var player = new Vimeo.Player(containerId, {
                  url: $(this).data("video-url"),
                  width: 640,
                  loop: $(this).data("video-autoplay"),
                  autoplay: autoplay,
                  muted: $this.hasClass("video-container--background") || autoplay,
                });

                player.on(
                  "playing",
                  function () {
                    $(this).addClass("video--play-started");
                  }.bind(this)
                );
                player.ready().then(function () {
                  if (autoplay) {
                    player.setVolume(0);
                    player.play();
                  }
                  if (player.element && player.element.width && player.element.height) {
                    var ratio = parseInt(player.element.height) / parseInt(player.element.width);
                    $this.find(".video-container__video").css("padding-bottom", ratio * 100 + "%");
                  }
                  _._initBackgroundVideo($this);
                });
                _.vimeoVars.videoData[containerId] = {
                  id: containerId,
                  container: this,
                  videoElement: videoElement,
                  player: player,
                  autoPlay: autoplay,
                };
              }
            });
          } else {
            // load api
            if (window.define) {
              // workaround for third parties using RequireJS
              theme.loadScriptOnce(
                "https://player.vimeo.com/api/player.js",
                function () {
                  _.vimeoVars.apiReady = true;
                  _._loadVimeoVideos();
                  window.define = window.tempDefine;
                },
                function () {
                  window.tempDefine = window.define;
                  window.define = null;
                }
              );
            } else {
              theme.loadScriptOnce("https://player.vimeo.com/api/player.js", function () {
                _.vimeoVars.apiReady = true;
                _._loadVimeoVideos();
              });
            }
          }
        }
      };

      _._unloadVimeoVideos = function (container) {
        for (var dataKey in _.vimeoVars.videoData) {
          var data = _.vimeoVars.videoData[dataKey];
          if ($(container).find(data.container).length) {
            data.player.unload();
            delete _.vimeoVars.videoData[dataKey];
            return;
          }
        }
      };

      // Init third party apis - Youtube and Vimeo
      _._loadThirdPartyApis = function (container) {
        //Don't init youtube or vimeo background videos on mobile
        if (_._permitPlayback($(".video-container", container))) {
          _._loadYoutubeVideos(container);
          _._loadVimeoVideos(container);
        }
      };

      // Mp4
      _.mp4Vars = {
        incrementor: 0,
        videoData: {},
        toProcessSelector: '.video-container[data-video-type="mp4"]:not(.video--init)',
      };

      _._loadMp4Videos = function (container) {
        if ($(_.mp4Vars.toProcessSelector, container).length) {
          // play those videos
          $(_.mp4Vars.toProcessSelector, container)
            .addClass("video--init")
            .each(function () {
              _.mp4Vars.incrementor++;
              var $this = $(this);
              var containerId = "theme-mp-video-" + _.mp4Vars.incrementor;
              $(this).data("video-container-id", containerId);
              var videoElement = $('<div class="video-container__video-element">')
                .attr("id", containerId)
                .appendTo($(".video-container__video", this));

              var $video = $("<video playsinline>");
              if ($(this).data("video-loop")) {
                $video.attr("loop", "loop");
              }
              if (!$(this).hasClass("video-container--background")) {
                $video.attr("controls", "controls");
              }
              if ($(this).data("video-autoplay")) {
                $video.attr({ autoplay: "autoplay", muted: "muted" });
                $video[0].muted = true; // required by Chrome - ignores attribute
                $video.one("loadeddata", function () {
                  this.play();
                });
              }
              $video.on(
                "playing",
                function () {
                  $(this).addClass("video--play-started");
                }.bind(this)
              );
              $video.attr("src", $(this).data("video-url")).appendTo(videoElement);
              _.mp4Vars.videoData[containerId] = {
                element: $video[0],
              };
            });
        }
      };

      _._unloadMp4Videos = function (container) {};

      // background video placement for iframes
      _._initBackgroundVideo = function ($container) {
        if ($container.hasClass("video-container--background") && $container.find(".video-container__video iframe").length) {
          var assessBackgroundVideo = function assessBackgroundVideo() {
            var $container = this,
              cw = $container.width(),
              ch = $container.height(),
              cr = cw / ch,
              $frame = $(".video-container__video iframe", this),
              vr = $frame.attr("width") / $frame.attr("height"),
              $pan = $(".video-container__video", this),
              vCrop = 75; // pushes video outside container to hide controls
            if (cr > vr) {
              var vh = cw / vr + vCrop * 2;
              $pan.css({
                marginTop: (ch - vh) / 2 - vCrop,
                marginLeft: "",
                height: vh + vCrop * 2,
                width: "",
              });
            } else {
              var vw = cw * vr + vCrop * 2 * vr;
              $pan.css({
                marginTop: -vCrop,
                marginLeft: (cw - vw) / 2,
                height: ch + vCrop * 2,
                width: vw,
              });
            }
          };
          assessBackgroundVideo.bind($container)();
          $(window).on("debouncedresize." + $container.data("video-container-id"), assessBackgroundVideo.bind($container));
        }
      };

      // Compatibility with Sections
      this.onSectionLoad = function (container) {
        // url only - infer type
        $(".video-container[data-video-url]:not([data-video-type])").each(function () {
          var url = $(this).data("video-url");

          if (url.indexOf(".mp4") > -1) {
            $(this).attr("data-video-type", "mp4");
          }

          if (url.indexOf("vimeo.com") > -1) {
            $(this).attr("data-video-type", "vimeo");
            $(this).attr("data-video-id", url.split("?")[0].split("/").pop());
          }

          if (url.indexOf("youtu.be") > -1 || url.indexOf("youtube.com") > -1) {
            $(this).attr("data-video-type", "youtube");
            if (url.indexOf("v=") > -1) {
              $(this).attr("data-video-id", url.split("v=").pop().split("&")[0]);
            } else {
              $(this).attr("data-video-id", url.split("?")[0].split("/").pop());
            }
          }
        });

        _._loadThirdPartyApis(container);
        _._loadMp4Videos(container);

        $(window).on("debouncedresize.video-manager-resize", function () {
          _._loadThirdPartyApis(container);
        });

        // play button
        $(".video-container__play", container).on("click", function (evt) {
          evt.preventDefault();
          var $container = $(this).closest(".video-container");
          // reveal
          $container.addClass("video-container--playing");

          // broadcast a play event on the section container
          $(container).trigger("cc:video:play");

          // play
          var id = $container.data("video-container-id");
          if (id.indexOf("theme-yt-video") === 0) {
            _.youtubeVars.videoData[id].player.playVideo();
          } else if (id.indexOf("theme-vi-video") === 0) {
            _.vimeoVars.videoData[id].player.play();
          } else if (id.indexOf("theme-mp-video") === 0) {
            _.mp4Vars.videoData[id].element.play();
          }
          // sensors.track("ClickVideoPlaying", {
          //   page_position: window.theme.jelenew_web_page_name || "",
          //   video_url: $("video", container).attr("src"),
          //   video_title: $(".overlay-text__inner", container).text().trim(),
          // });
        });

        // modal close button
        $(".video-container__stop", container).on("click", function (evt) {
          evt.preventDefault();
          var $container = $(this).closest(".video-container");
          // hide
          $container.removeClass("video-container--playing");

          // broadcast a stop event on the section container
          $(container).trigger("cc:video:stop");

          // play
          var id = $container.data("video-container-id");
          if (id.indexOf("theme-yt-video") === 0) {
            _.youtubeVars.videoData[id].player.stopVideo();
          } else if (id.indexOf("theme-vi-video") === 0) {
            _.vimeoVars.videoData[id].player.pause();
            _.vimeoVars.videoData[id].player.setCurrentTime(0);
          } else if (id.indexOf("theme-mp-video") === 0) {
            _.mp4Vars.videoData[id].element.pause();
          }
        });

        // 埋点
        $(".overlay-text__button", container).on("click", function () {
          sensors.track("ClickHomeElement", {
            page_position: theme.jelenew_web_page_name,
            button_name: $(this).text().trim(),
            element_name: "PicResource",
            jump_link: window.origin + $(this).attr("href"),
          });
        });
      };

      this.onSectionUnload = function (container) {
        $(".video-container__play, .video-container__stop", container).off("click");
        $(window).off("." + $(".video-container").data("video-container-id"));
        $(window).off("debouncedresize.video-manager-resize");
        _._unloadYoutubeVideos(container);
        _._unloadVimeoVideos(container);
        _._unloadMp4Videos(container);
        $(container).trigger("cc:video:stop");
      };
    })();
    theme.jelenewIndexVideo = new (function () {
      var _ = this;
      // Mp4
      _.mp4Vars = {
        incrementor: 0,
        videoData: {},
        toProcessSelector: '.video-container[data-video-type="mp4"]:not(.video--init)',
      };

      _._loadMp4Videos = function (container, toProcessSelector) {
        if ($(toProcessSelector, container).length) {
          // play those videos
          var windowWidth = $(window).width();
          $(toProcessSelector, container)
            .addClass("video--init")
            .each(function () {
              _.mp4Vars.incrementor++;
              var $this = $(this);
              // 播放
              function videoPlay() {
                $(container).find("video").trigger("play");
                $(container).find(".video_play_wrap").css({
                  display: "none",
                });
                $(container).find(".video_suspend_wrap").css({
                  display: "block",
                });
              }
              // 暂停
              function videoSuspend() {
                $(container).find("video").trigger("pause");
                $(container).find(".video_suspend_wrap").css({
                  display: "none",
                });
                $(container).find(".video_play_wrap").css({
                  display: "block",
                });
              }
              // 关闭声音
              function videoVoiceClose() {
                $(container).find("video").prop("muted", true);
                $(container).find(".video_voice_open_wrap").css({
                  display: "none",
                });
                $(container).find(".video_voice_close_wrap").css({
                  display: "block",
                });
              }
              // 打开声音
              function videoVoiceOpen() {
                if ($(window).width() > 767) {
                  $(container).find(".index_video_pc video").prop("muted", false);
                } else {
                  $(container).find(".index_video_h5 video").prop("muted", false);
                }
                $(container).find(".one_url video").prop("muted", false);
                $(container).find(".video_voice_close_wrap").css({
                  display: "none",
                });
                $(container).find(".video_voice_open_wrap").css({
                  display: "block",
                });
              }
              // 点击播放事件
              function clickVideoPlay() {
                $(".video_play_wrap", container).on("click", function (e) {
                  videoPlay();
                });
              }
              // 点击暂停事件
              function clickVideoSuspend() {
                $(".video_suspend_wrap", container).on("click", function (e) {
                  videoSuspend();
                });
              }
              // 点击关闭声音事件
              function clickVideoVoiceClose() {
                $(".video_voice_close_wrap", container).on("click", function (e) {
                  videoVoiceOpen();
                });
              }
              // 点击打开声音事件
              function clickVideoVoiceOpen() {
                $(".video_voice_open_wrap", container).on("click", function (e) {
                  videoVoiceClose();
                });
              }
              var loadPcVideo = () => {
                var containerIdPc = "pc_theme-mp-video-" + _.mp4Vars.incrementor;
                $(this).data("video-container-id", containerIdPc);
                var videoElementPc = $('<div class="index_video_pc video-container__video-element">')
                  .attr("id", containerIdPc)
                  .appendTo($(".video-container__video", this));
                var $videoPc = $("<video playsinline>");
                if ($(this).data("video-loop")) {
                  $videoPc.attr("loop", "loop");
                }
                if (!$(this).hasClass("video-container--background")) {
                  $videoPc.attr("controls", "controls");
                }
                if ($(this).data("video-autoplay")) {
                  $videoPc.attr({ autoplay: "autoplay", muted: "muted" });
                  $videoPc[0].muted = true;
                  $videoPc.one("loadeddata", function () {
                    this.play();
                  });
                }
                $videoPc.on(
                  "playing",
                  function () {
                    $(this).addClass("video--play-started");
                  }.bind(this)
                );
                $videoPc.attr("src", $(this).data("video_pc_url")).appendTo(videoElementPc);
                _.mp4Vars.videoData[containerIdPc] = {
                  element: $videoPc[0],
                };
                clickVideoPlay();
                clickVideoSuspend();
                clickVideoVoiceClose();
                clickVideoVoiceOpen();
                window.addEventListener("throttled-scroll", () => {
                  if (
                    $(window).scrollTop() > $(container).offset().top + $(container).height() ||
                    $(window).scrollTop() < $(container).offset().top - $(window).height()
                  ) {
                    $(container).find("video").prop("muted", true);
                    videoVoiceClose();
                  }
                });
              };
              var loadH5Video = (videoClass) => {
                var containerId = "theme-mp-video-" + _.mp4Vars.incrementor;
                $(this).data("video-container-id", containerId);
                var videoElement = $('<div class="' + videoClass + ' video-container__video-element">')
                  .attr("id", containerId)
                  .appendTo($(".video-container__video", this));

                var $video = $("<video playsinline>");
                if ($(this).data("video-loop")) {
                  $video.attr("loop", "loop");
                }
                if (!$(this).hasClass("video-container--background")) {
                  $video.attr("controls", "controls");
                }
                if ($(this).data("video-autoplay")) {
                  $video.attr({ autoplay: "autoplay", muted: "muted" });
                  $video[0].muted = true; // required by Chrome - ignores attribute
                  $video.one("loadeddata", function () {
                    this.play();
                  });
                }
                $video.on(
                  "playing",
                  function () {
                    $(this).addClass("video--play-started");
                  }.bind(this)
                );
                $video.attr("src", $(this).data("video-url")).appendTo(videoElement);
                _.mp4Vars.videoData[containerId] = {
                  element: $video[0],
                };
                clickVideoPlay();
                clickVideoSuspend();
                clickVideoVoiceClose();
                clickVideoVoiceOpen();
                window.addEventListener("throttled-scroll", () => {
                  if (
                    $(window).scrollTop() > $(container).offset().top + $(container).height() ||
                    $(window).scrollTop() < $(container).offset().top - $(window).height()
                  ) {
                    $(container).find("video").prop("muted", true);
                    videoVoiceClose();
                  }
                });
              };
              if ($(this).data("video_pc_url")) {
                // h5和pc两个url
                if (windowWidth > 767) {
                  // 初始化是pc
                  loadPcVideo();
                  window.addEventListener("resize", () => {
                    // 切到h5时，加载h5视频
                    if ($(window).width() <= 767 && $(container).find(".video-container__video-element").length <= 1) {
                      loadH5Video("index_video_h5");
                      videoVoiceClose();
                      videoPlay();
                    }
                  });
                } else {
                  // 初始化是h5
                  loadH5Video("index_video_h5");
                  window.addEventListener("resize", () => {
                    // 切到pc时，加载pc视频
                    if ($(window).width() > 767 && $(container).find(".video-container__video-element").length <= 1) {
                      loadPcVideo();
                      videoVoiceClose();
                      videoPlay();
                    }
                  });
                }
              } else {
                // h5和pc一个url
                loadH5Video("one_url");
              }
            });
        }
      };

      _._unloadMp4Videos = function (container) {};

      // Compatibility with Sections
      this.onSectionLoad = function (container) {
        // url only - infer type
        $(".video-container[data-video-url]:not([data-video-type])", container).each(function () {
          var url = $(this).data("video-url");

          if (url.indexOf(".mp4") > -1) {
            $(this).attr("data-video-type", "mp4");
            _._loadMp4Videos(container, '.video-container[data-video-type="mp4"]:not(.video--init)');
          }
          if (url.indexOf(".webm") > -1) {
            $(this).attr("data-video-type", "webm");
            _._loadMp4Videos(container, '.video-container[data-video-type="webm"]:not(.video--init)');
          }
        });
        // 埋点
        $(".video_main_btn_wrap", container).on("click", function () {
          sensors.track("ClickHomeElement", {
            button_name: $(this).text().trim(),
            element_name: "PicResource",
            jump_link: "https://www.jelenew.com" + $(this).attr("href"),
            page_position: window.theme.jelenew_web_page_name || "",
          });
        });
        $(".video_url_wrap", container).on("click", function () {
          sensors.track("ClickHomeElement", {
            button_name: "pic",
            element_name: "PicResource",
            jump_link: "https://www.jelenew.com" + $(this).attr("href"),
            page_position: window.theme.jelenew_web_page_name || "",
          });
        });
      };

      this.onSectionUnload = function (container) {
        $(window).off("." + $(".video-container").data("video-container-id"));
        _._unloadMp4Videos(container);
        $(container).trigger("cc:video:stop");
      };
    })();

    // Youtube API callback
    window.onYouTubeIframeAPIReady = function () {
      theme.VideoManager.youtubeApiReady();
    };

    // Register the section
    cc.sections.push({
      name: "video",
      section: theme.VideoManager,
    });
    cc.sections.push({
      name: "jelenew-half-layout-video",
      section: theme.VideoManager,
    });

    theme.MapSection = new (function () {
      var _ = this;
      _.config = {
        zoom: 14,
        styles: {
          default: [],
          silver: [
            { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f5f5" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#ffffff" }],
            },
            {
              featureType: "road.arterial",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#dadada" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#c9c9c9" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
          ],
          retro: [
            { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
            { elementType: "labels.text.fill", stylers: [{ color: "#523735" }] },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry.stroke",
              stylers: [{ color: "#c9b2a6" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "geometry.stroke",
              stylers: [{ color: "#dcd2be" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#ae9e90" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#93817c" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#a5b076" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#447530" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#fdfcf8" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#f8c967" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#e9bc62" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#e98d58" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry.stroke",
              stylers: [{ color: "#db8555" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#806b63" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8f7d77" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#ebe3cd" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [{ color: "#b9d3c2" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#92998d" }],
            },
          ],
          dark: [
            { elementType: "geometry", stylers: [{ color: "#212121" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#212121" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "administrative.country",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "administrative.land_parcel",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#181818" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1b1b1b" }],
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: [{ color: "#2c2c2c" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8a8a8a" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#373737" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#3c3c3c" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#4e4e4e" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#000000" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3d3d3d" }],
            },
          ],
          night: [
            { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
            { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#242f3e" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#263c3f" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6b9a76" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#38414e" }],
            },
            {
              featureType: "road",
              elementType: "geometry.stroke",
              stylers: [{ color: "#212a37" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9ca5b3" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#746855" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#1f2835" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#f3d19c" }],
            },
            {
              featureType: "transit",
              elementType: "geometry",
              stylers: [{ color: "#2f3948" }],
            },
            {
              featureType: "transit.station",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#17263c" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#515c6d" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#17263c" }],
            },
          ],
          aubergine: [
            { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
            { elementType: "labels.text.fill", stylers: [{ color: "#8ec3b9" }] },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1a3646" }],
            },
            {
              featureType: "administrative.country",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#64779e" }],
            },
            {
              featureType: "administrative.province",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "landscape.man_made",
              elementType: "geometry.stroke",
              stylers: [{ color: "#334e87" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6f9ba5" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3C7680" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#304a7d" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#2c6675" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#255763" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#b0d5ce" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry.fill",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#3a4762" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#0e1626" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#4e6d70" }],
            },
          ],
        },
      };

      _.apiStatus = null;

      this.geolocate = function ($map) {
        var deferred = $.Deferred();
        var geocoder = new google.maps.Geocoder();
        var address = $map.data("address-setting");

        geocoder.geocode({ address: address }, function (results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            deferred.reject(status);
          }

          deferred.resolve(results);
        });

        return deferred;
      };

      this.createMap = function (container) {
        var $map = $(".map-section__map-container", container);

        return _.geolocate($map)
          .then(
            function (results) {
              var mapOptions = {
                zoom: _.config.zoom,
                styles: _.config.styles[$(container).data("map-style")],
                center: results[0].geometry.location,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true,
                zoomControl: true,
              };

              _.map = new google.maps.Map($map[0], mapOptions);
              _.center = _.map.getCenter();

              var marker = new google.maps.Marker({
                map: _.map,
                position: _.center,
                clickable: false,
              });

              google.maps.event.addDomListener(window, "resize", function () {
                google.maps.event.trigger(_.map, "resize");
                _.map.setCenter(_.center);
              });
            }.bind(this)
          )
          .fail(function () {
            var errorMessage;

            switch (status) {
              case "ZERO_RESULTS":
                errorMessage = theme.strings.addressNoResults;
                break;
              case "OVER_QUERY_LIMIT":
                errorMessage = theme.strings.addressQueryLimit;
                break;
              default:
                errorMessage = theme.strings.addressError;
                break;
            }

            // Only show error in the theme editor
            if (Shopify.designMode) {
              var $mapContainer = $map.parents(".map-section");

              $mapContainer.addClass("page-width map-section--load-error");
              $mapContainer.find(".map-section__wrapper").html('<div class="errors text-center">' + errorMessage + "</div>");
            }
          });
      };

      this.onSectionLoad = function (target) {
        var $container = $(target);
        // Global function called by Google on auth errors
        window.gm_authFailure = function () {
          if (!Shopify.designMode) return;

          $container.addClass("page-width map-section--load-error");
          $container.find(".map-section__wrapper").html('<div class="errors text-center">' + theme.strings.authError + "</div>");
        };

        // create maps
        var key = $container.data("api-key");

        if (typeof key !== "string" || key === "") {
          return;
        }

        // load map
        theme.loadScriptOnce("https://maps.googleapis.com/maps/api/js?key=" + key, function () {
          _.createMap($container);
        });
      };

      this.onSectionUnload = function (target) {
        if (typeof window.google !== "undefined" && typeof google.maps !== "undefined") {
          google.maps.event.clearListeners(_.map, "resize");
        }
      };
    })();

    // Register the section
    cc.sections.push({
      name: "map",
      section: theme.MapSection,
    });

    theme.FaqHeader = new (function () {
      this.onSectionLoad = function (container) {
        this.namespace = theme.namespaceFromSection(container);
        this.container = container;

        this.classNames = {
          questionContainerInactive: "faq-search-item-inactive",
          sectionWithIndexStatus: "section-faq-header--with-index",
        };

        this.searchInput = this.container.querySelector(".faq-search__input");
        if (this.searchInput) {
          this.registerEventListener(this.searchInput, "change", this.functions.performSearch.bind(this));
          this.registerEventListener(this.searchInput, "keyup", this.functions.performSearch.bind(this));
          this.registerEventListener(this.searchInput, "paste", this.functions.performSearch.bind(this));
        }

        this.functions.debouncedBuildIndex = theme.debounce(this.functions.buildIndex.bind(this), 50);
        this.registerEventListener(document, "theme:faq-header-update", this.functions.debouncedBuildIndex);
        this.functions.debouncedBuildIndex();

        if (this.container.querySelector(".faq-index")) {
          this.registerEventListener(this.container, "click", this.functions.handleIndexClick.bind(this));
          this.container.closest(".section-faq-header").classList.add(this.classNames.sectionWithIndexStatus);
          this.functions.resizeIndex.call(this);
          this.registerEventListener(window, "resize", theme.debounce(this.functions.resizeIndex.bind(this), 250));
        }
      };

      this.onSectionReorder = function (container) {
        this.functions.debouncedBuildIndex();
      };

      this.functions = {
        buildIndex: function buildIndex() {
          var _this10 = this;
          var faqHeaderSection = this.container.closest(".section-faq-header"),
            indexContainer = this.container.querySelector(".faq-index__item-container");

          if (indexContainer) {
            indexContainer.querySelectorAll(".faq-index-item").forEach(function (element) {
              element.parentNode.removeChild(element);
            });
          }

          this.linkedCollapsibleTabs = [];
          this.linkedQuestionContainers = [];
          this.linkedContent = [];

          var currentElement = faqHeaderSection;
          while (currentElement.nextElementSibling && currentElement.nextElementSibling.classList.contains("section-collapsible-tabs")) {
            currentElement = currentElement.nextElementSibling;
            this.linkedCollapsibleTabs.push(currentElement);
            currentElement.querySelectorAll(".collapsible-tabs__tab").forEach(function (element) {
              return _this10.linkedQuestionContainers.push(element);
            });
            currentElement.querySelectorAll(".collapsible-tabs__content").forEach(function (element) {
              return _this10.linkedContent.push(element);
            });

            var currentElementHeading = currentElement.querySelector(".collapsible-tabs__heading");
            var tve = theme.createTemplateVariableEncoder();
            tve.add("title_id", currentElementHeading.id, "attribute");
            tve.add("title", currentElementHeading.innerHTML, "raw");

            var html = '\n          <div class="faq-index-item">\n            <a class="faq-index-item__link" href="#'
              .concat(tve.values.title_id, '">')
              .concat(tve.values.title, "</a>\n          </div>");

            var htmlFragment = document.createRange().createContextualFragment(html);
            if (indexContainer) {
              indexContainer.appendChild(htmlFragment);
            }
          }

          if (indexContainer) {
            this.functions.resizeIndex.call(this);
          }
        },

        resizeIndex: function resizeIndex() {
          var stickyContainer = this.container.querySelector(".faq-index__sticky-container"),
            faqHeaderSection = this.container.closest(".section-faq-header");

          var currentElement = faqHeaderSection;
          while (currentElement.nextElementSibling && currentElement.nextElementSibling.classList.contains("section-collapsible-tabs")) {
            currentElement = currentElement.nextElementSibling;
          }

          var stickyContainerRect = stickyContainer.getBoundingClientRect(),
            currentElementRect = currentElement.getBoundingClientRect();

          stickyContainer.style.height = currentElementRect.bottom - stickyContainerRect.top + "px";
        },

        performSearch: function performSearch() {
          var _this11 = this;
          // defer to avoid input lag
          setTimeout(function () {
            var splitValue = _this11.searchInput.value.split(" ");

            // sanitise terms
            var terms = [];
            splitValue.forEach(function (t) {
              if (t.length > 0) {
                terms.push(t.toLowerCase());
              }
            });

            // search
            _this11.linkedQuestionContainers.forEach(function (element) {
              if (terms.length) {
                var termFound = false;
                var matchContent = element.textContent.toLowerCase();
                terms.forEach(function (term) {
                  if (matchContent.indexOf(term) >= 0) {
                    termFound = true;
                  }
                });
                if (termFound) {
                  element.classList.remove(_this11.classNames.questionContainerInactive);
                } else {
                  element.classList.add(_this11.classNames.questionContainerInactive);
                }
              } else {
                element.classList.remove(_this11.classNames.questionContainerInactive);
              }
            });

            // hide non-question content if doing a search
            _this11.linkedContent.forEach(function (element) {
              if (terms.length) {
                element.classList.add(_this11.classNames.questionContainerInactive);
              } else {
                element.classList.remove(_this11.classNames.questionContainerInactive);
              }
            });
          }, 10);
        },

        handleIndexClick: function handleIndexClick(evt) {
          if (evt.target.classList.contains("faq-index-item__link")) {
            evt.preventDefault();
            var id = evt.target.href.split("#")[1];
            var scrollTarget = document.getElementById(id);
            var scrollTargetY = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 50;

            // sticky header offset
            var stickyHeight = getComputedStyle(document.documentElement).getPropertyValue("--theme-sticky-header-height");
            if (stickyHeight) {
              scrollTargetY -= parseInt(stickyHeight);
            }

            window.scrollTo({
              top: scrollTargetY,
              behavior: "smooth",
            });
          }
        },
      };
    })();

    // Register section
    cc.sections.push({
      name: "faq-header",
      section: theme.FaqHeader,
      deferredLoad: false,
    });

    theme.CollapsibleTabs = new (function () {
      this.onSectionLoad = function (container) {
        this.functions.notifyFaqHeaderOfChange();
      };

      this.onSectionReorder = function (container) {
        this.functions.notifyFaqHeaderOfChange();
      };

      this.onSectionUnload = function (container) {
        this.functions.notifyFaqHeaderOfChange();
      };

      this.functions = {
        notifyFaqHeaderOfChange: function notifyFaqHeaderOfChange() {
          document.dispatchEvent(
            new CustomEvent("theme:faq-header-update", {
              bubbles: true,
              cancelable: false,
            })
          );
        },
      };
    })();

    // Register section
    cc.sections.push({
      name: "collapsible-tabs",
      section: theme.CollapsibleTabs,
      deferredLoad: false,
    });

    /**
     * StoreAvailability Section Script
     * ------------------------------------------------------------------------------
     *
     * @namespace StoreAvailability
     */

    theme.StoreAvailability = function (container) {
      var loadingClass = "store-availability-loading";
      var initClass = "store-availability-initialized";
      var storageKey = "cc-location";

      this.onSectionLoad = function (container) {
        var _this12 = this;
        this.namespace = theme.namespaceFromSection(container);
        this.$container = $(container);
        this.productId = this.$container.data("store-availability-container");
        this.sectionUrl = this.$container.data("section-url");
        this.$modal;

        var firstRun = true;

        // Handle when a variant is selected
        $(window).on("cc-variant-updated".concat(this.namespace).concat(this.productId), function (e, args) {
          if (args.product.id === _this12.productId) {
            _this12.functions.updateContent.bind(_this12)(
              args.variant.id,
              args.product.title,
              firstRun,
              _this12.$container.data("has-only-default-variant"),
              typeof args.variant.available !== "undefined"
            );

            firstRun = false;
          }
        });

        // Handle single variant products
        if (this.$container.data("single-variant-id")) {
          this.functions.updateContent.bind(this)(
            this.$container.data("single-variant-id"),
            this.$container.data("single-variant-product-title"),
            firstRun,
            this.$container.data("has-only-default-variant"),
            this.$container.data("single-variant-product-available")
          );

          firstRun = false;
        }
      };

      this.onSectionUnload = function () {
        $(window).off("cc-variant-updated".concat(this.namespace).concat(this.productId));
        this.$container.off("click");
        if (this.$modal) {
          this.$modal.off("click");
        }
      };

      this.functions = {
        // Returns the users location data (if allowed)
        getUserLocation: function getUserLocation() {
          return new Promise(function (resolve, reject) {
            var storedCoords;

            if (sessionStorage[storageKey]) {
              storedCoords = JSON.parse(sessionStorage[storageKey]);
            }

            if (storedCoords) {
              resolve(storedCoords);
            } else {
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                  function (position) {
                    var coords = {
                      latitude: position.coords.latitude,
                      longitude: position.coords.longitude,
                    };

                    //Set the localization api
                    fetch("/localization.json", {
                      method: "PUT",
                      headers: {
                        "Content-Type": "application/json",
                      },

                      body: JSON.stringify(coords),
                    });

                    //Write to a session storage
                    sessionStorage[storageKey] = JSON.stringify(coords);

                    resolve(coords);
                  },
                  function () {
                    resolve(false);
                  },
                  {
                    maximumAge: 3600000, // 1 hour
                    timeout: 5000,
                  }
                );
              } else {
                resolve(false);
              }
            }
          });
        },

        // Requests the available stores and calls the callback
        getAvailableStores: function getAvailableStores(variantId, cb) {
          return $.get(this.sectionUrl.replace("VARIANT_ID", variantId), cb);
        },

        // Haversine Distance
        // The haversine formula is an equation giving great-circle distances between
        // two points on a sphere from their longitudes and latitudes
        calculateDistance: function calculateDistance(coords1, coords2, unitSystem) {
          var dtor = Math.PI / 180;
          var radius = unitSystem === "metric" ? 6378.14 : 3959;

          var rlat1 = coords1.latitude * dtor;
          var rlong1 = coords1.longitude * dtor;
          var rlat2 = coords2.latitude * dtor;
          var rlong2 = coords2.longitude * dtor;

          var dlon = rlong1 - rlong2;
          var dlat = rlat1 - rlat2;

          var a = Math.pow(Math.sin(dlat / 2), 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2);
          var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          return radius * c;
        },

        // Updates the existing modal pickup with locations with distances from the user
        updateLocationDistances: function updateLocationDistances(coords) {
          var unitSystem = this.$modal.find("[data-unit-system]").data("unit-system");
          var self = this;

          this.$modal.find('[data-distance="false"]').each(function () {
            var _this13 = this;
            var thisCoords = {
              latitude: parseFloat($(this).data("latitude")),
              longitude: parseFloat($(this).data("longitude")),
            };

            if (thisCoords.latitude && thisCoords.longitude) {
              var distance = self.functions.calculateDistance(coords, thisCoords, unitSystem).toFixed(1);

              $(this).html(distance);

              //Timeout to trigger animation
              setTimeout(function () {
                $(_this13).closest(".store-availability-list__location__distance").addClass("-in");
              }, 0);
            }

            $(this).attr("data-distance", "true");
          });
        },

        // Requests the available stores and updates the page with info below Add to Basket, and append the modal to the page
        updateContent: function updateContent(variantId, productTitle, firstRun, isSingleDefaultVariant, isVariantAvailable) {
          var _this14 = this;
          this.$container.off("click", "[data-store-availability-modal-open]");
          this.$container.off("click" + this.namespace, ".cc-popup-close, .cc-popup-background");
          $(".store-availabilities-modal").remove();

          if (firstRun) {
            this.$container.hide();
          } else if (!isVariantAvailable) {
            //If the variant is Unavailable (not the same as Out of Stock) - hide the store pickup completely
            this.$container.addClass(loadingClass).addClass(initClass);
            this.$container.css("height", "0px");
          } else {
            this.$container.addClass(loadingClass).addClass(initClass);
            this.$container.css("height", this.$container.outerHeight() > 0 ? this.$container.outerHeight() + "px" : "auto");
          }

          if (isVariantAvailable) {
            this.functions.getAvailableStores.call(this, variantId, function (response) {
              if (response.trim().length > 0 && !response.includes("NO_PICKUP")) {
                _this14.$container.html(response);
                _this14.$container.html(_this14.$container.children().first().html()); // editor bug workaround

                _this14.$container.find("[data-store-availability-modal-product-title]").html(productTitle);

                if (isSingleDefaultVariant) {
                  _this14.$container.find(".store-availabilities-modal__variant-title").remove();
                }

                _this14.$container.find(".cc-popup").appendTo("body");

                _this14.$modal = $("body").find(".store-availabilities-modal");
                var popup = new ccPopup(_this14.$modal, _this14.namespace);

                _this14.$container.on("click", "[data-store-availability-modal-open]", function () {
                  popup.open();

                  //When the modal is opened, try and get the users location
                  _this14.functions.getUserLocation().then(function (coords) {
                    if (coords && _this14.$modal.find('[data-distance="false"]').length) {
                      //Re-retrieve the available stores location modal contents
                      _this14.functions.getAvailableStores.call(_this14, variantId, function (response) {
                        _this14.$modal.find(".store-availabilities-list").html($(response).find(".store-availabilities-list").html());
                        _this14.functions.updateLocationDistances.bind(_this14)(coords);
                      });
                    }
                  });

                  return false;
                });

                _this14.$modal.on("click" + _this14.namespace, ".cc-popup-close, .cc-popup-background", function () {
                  popup.close();
                });

                if (firstRun) {
                  _this14.$container.slideDown(300);
                } else {
                  _this14.$container.removeClass(loadingClass);

                  var newHeight = _this14.$container.find(".store-availability-container").outerHeight();

                  _this14.$container.css("height", newHeight > 0 ? newHeight + "px" : "auto");
                }
              }
            });
          }
        },
      };

      // Initialise the section when it's instantiated
      this.onSectionLoad(container);
    };

    // Register section
    cc.sections.push({
      name: "store-availability",
      section: theme.StoreAvailability,
    });

    /**
     * 隐私政策弹窗埋点
     */
    window.jelenew.hasPrivtePopup = false;
    if ($("#shopify-pc__banner").length > 0) {
      window.jelenew.hasPrivtePopup = true;
      sensors.track("EpLayerOpen", {
        popup_type: "Popup",
        popup_strategy: "自动触发",
        popub_name: "隐私政策弹层",
      });
    } else {
      const privteOberver = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type == "childList" && mutation.addedNodes.length > 0 && $(mutation.addedNodes[0]).attr("id") === "shopify-pc__banner") {
            window.jelenew.hasPrivtePopup = true;
            sensors.track("EpLayerOpen", {
              popup_type: "Popup",
              popup_strategy: "自动触发",
              popub_name: "隐私政策弹层",
            });
            observer.disconnect();
          }
        }
      });
      privteOberver.observe(document.querySelector("body"), { childList: true });
    }
    // 隐私详情按钮
    $("body").on("click", "#shopify-pc__banner__body-policy-link", function () {
      // sensors.track("ClickLayerButton", {
      //   element_name: "详细政策",
      //   popup_type: "Popup",
      //   popup_strategy: "自动触发",
      //   popub_name: "隐私政策弹层",
      // });
    });
    // 管理隐私按钮
    $("body").on("click", "#shopify-pc__banner__btn-manage-prefs", function () {
      // sensors.track("ClickLayerButton", {
      //   popup_type: "Popup",
      //   element_name: "管理",
      //   popup_strategy: "自动触发",
      //   popub_name: "隐私政策弹层",
      // });
      // sensors.track("EpLayerOpen", {
      //   popup_type: "Popup",
      //   popup_strategy: "自动触发",
      //   popub_name: "隐私政策管理弹层",
      // });
    });
    // 点击同意按钮
    $("body").on("click", "#shopify-pc__banner__btn-accept", function () {
      // sensors.track("ClickLayerButton", {
      //   popup_type: "Popup",
      //   element_name: "同意",
      //   popup_strategy: "自动触发",
      //   popub_name: "隐私政策弹层",
      // });
    });
    // 点击保存按钮
    $("body").on("click", "#shopify-pc__prefs__header-save", function () {
      // sensors.track("ClickLayerButton", {
      //   popup_type: "Popup",
      //   element_name: "保存",
      //   popup_strategy: "自动触发",
      //   popub_name: "隐私政策管理弹层",
      // });
    });
    /**
     * Popup Section Script
     * ------------------------------------------------------------------------------
     *
     * @namespace Popup
     */

    theme.Popup = new (function () {
      /**
       * Popup section constructor. Runs on page load as well as Theme Editor
       * `section:load` events.
       * @param {string} container - selector for the section container DOM element
       */

      var dismissedStorageKey = "cc-theme-popup-dismissed";

      var is_second_popup = false;
      this.onSectionLoad = function (container) {
        const _this = this;
        this.namespace = theme.namespaceFromSection(container);
        this.$container = $(container);
        this.popup = new ccPopup(this.$container, this.namespace);

        var dismissForDays = this.$container.data("dismiss-for-days"), // 间隔几天后弹窗再次出现
          delaySeconds = this.$container.data("delay-seconds") * 1000, // 延迟多少秒后弹窗出现
          showPopup = true, // 是否显示弹窗
          lastDismissed = window.localStorage.getItem(dismissedStorageKey), // 上次弹窗关闭时间
          realDelaySeconds = this.$container.data("delay-seconds") * 1000; // 实际延迟时间
        scendDelaySeconds = $(container).data("scend-delay-seconds") * 1000; // 二次弹窗延迟时间

        // Should we show it during this page view?
        // Check when it was last dismissed
        if (lastDismissed) {
          var dismissedDaysAgo = (new Date().getTime() - lastDismissed) / (1000 * 60 * 60 * 24);
          if (dismissedDaysAgo < dismissForDays) {
            showPopup = false;
          } else {
            // 禁用时间过期
            localStorage.removeItem(dismissedStorageKey);
            // localStorage.removeItem("second_popup_dismissed");
          }
          // 第二次弹限制条件
          let jelenewReferrer = getJelenewReferre();
          // if (scendDelaySeconds != 0 && !localStorage.getItem("second_popup_dismissed") && jelenewReferrer.includes("https://www.jelenew.com")) {
          //   showPopup = true;
          //   is_second_popup = true;
          //   realDelaySeconds = scendDelaySeconds - (new Date().getTime() - lastDismissed);
          //   if (realDelaySeconds < 0) {
          //     realDelaySeconds = 0;
          //   }
          // }
        }
        // klaviyo来源不触发自动弹窗
        let utm_source = getUrlParam("utm_source", location.href);
        if (utm_source && utm_source == "Klaviyo") {
          localStorage.setItem("jelenew_utm_source", utm_source);
        }

        // Prevent popup on Shopify robot challenge page 、已订阅、 klaviyo来源、政策页 -> 不自动弹出
        if (
          document.querySelector(".shopify-challenge__container") || // shopify机器人认证
          localStorage.getItem("jelenew_subscription_email") || // 已订阅
          localStorage.getItem("jelenew_utm_source") == "Klaviyo" // klaviyo来源
        ) {
          showPopup = false;
        }

        if (showPopup) {
          const inter = setInterval(() => {
            if (!checkPrivetPopup()) {
              clearInterval(inter);
              timeoutOpenPopup();
            }
          }, 1000);
          function checkPrivetPopup() {
            if ($("#shopify-pc__banner").length > 0 && $("#shopify-pc__banner").css("display") === "block") {
              return true;
            } else if ($("#shopify-pc__prefs").length > 0 && $("#shopify-pc__prefs").css("display") === "block") {
              return true;
            } else {
              return false;
            }
          }
          function timeoutOpenPopup() {
            setTimeout(function () {
              if ($("body").data("accepts_marketing")) {
                return;
              }
              container.popup_strategy = "自动触发";
              container.popup_times = is_second_popup ? 2 : 1;
              container.subscription_method = "自动弹窗";
              if (is_second_popup) {
                localStorage.setItem("second_popup_dismissed", new Date().getTime());
              }
              $(document).triggerHandler(popupOpenEvent());
            }, realDelaySeconds);
          }
        }

        // 注册全局弹窗事件
        // 打开注册弹窗
        window.popupOpenEvent = function (options = {}) {
          console.log("options=>", options, _this.namespace, this.namespace);
          return $.Event(`theme:popupOpen${_this.namespace}`, Object.assign({ bubbles: true, cancelable: false }, options));
        };
        $(document).on(`theme:popupOpen${_this.namespace}`, function (e) {
          // console.log("event=>", e);
          const param = {
            popup_type: "Popup",
            popub_name: "订阅弹层",
            popup_strategy: container.popup_strategy,
          };
          if (is_second_popup) {
            Object.assign(param, { popup_times: container.popup_times });
          }
          sensors.track("EpLayerOpen", param);
          _this.popup.open();
        });
        // 关闭注册弹窗
        // Click on close button or modal background --> .cc-popup-background
        window.popupCloseEvent = function () {
          $(".cc-popup-close", container).trigger("click");
        };
        this.$container.on("click" + this.namespace, ".cc-popup-close", function () {
          _this.popup.close(function () {
            if (!lastDismissed) {
              _this.functions.popupSetAsDismissed.call(_this);
            }
          });
        });

        // 点击订阅邮箱输入框
        $(container).on("click", "#cc-popup-mailinglist_email", function () {
          sensors.track("ClickLayerInput", {
            element_name: "EnterEmail",
            popup_type: "Popup",
            popup_strategy: container.popup_strategy,
            popup_name: "订阅弹层",
            popup_times: container.popup_times,
          });
        });
        // 订阅接口调用
        $(container).on("click", ".popup_sign_up_wrap .cc-popup-form-submit", function () {
          const $btn = $(this);
          var email = $(this).parents(".cc-popup-form__inputs").find("#cc-popup-mailinglist_email").val();
          emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          if (email && emailReg.test(email)) {
            let subParams = {
              subscribeCode: email,
              country: Shopify.country,
              ridingOther: $(this).parents(".cc-popup-form__inputs").find("#riding-other-input").val(),
            };
            let ridingStyle_arr = [];
            $(".section-popup[data-section-type=newsletter-popup] .ridingcheck").each(function () {
              if (this.checked) {
                ridingStyle_arr.push(this.value);
              }
            });
            Object.assign(subParams, {
              ridingStyle: ridingStyle_arr.join(","),
            });
            localStorage.setItem("jelenew_subscription_email", email);
            //异步提交订阅
            $btn.addClass("lazyload--placeholder");
            jelenewHttp
              .post("/api/shop/customer/subscribe", subParams)
              .then((res) => {
                jelenew.functions.discountCodeHave();
                gtag("event", "jelenew_subscribe", { email });
                _this.popup.open(function () {
                  _this.$container.find(".cc-popup-form__response--success").show();
                  _this.$container.find(".popup_sign_up-submit").hide();
                });
                sensors.setProfile({ subscribe_email: email });
                fbq("track", "Subscribe");
                let sensorsParam = {
                  element_name: "Submit",
                  email_input: email,
                  popup_type: "Popup",
                  popup_name: "订阅弹层",
                  popup_strategy: container.popup_strategy,
                  subscription_method: container.subscription_method,
                };
                sensorsParam.riding_style = [];
                $(".section-popup[data-section-type=newsletter-popup] .ridingcheck").each(function () {
                  if (this.checked) {
                    sensorsParam.riding_style.push(this.value);
                  }
                });
                if (is_second_popup) {
                  sensorsParam.popup_times = 2;
                }
                sensors.track("ClickLayerSubmit", sensorsParam);
              })
              .catch((err) => {
                _this.$container.find(".cc-popup-close").trigger("click");
                theme.JelenewTips(err?.status?.desc);
              })
              .finally(() => {
                $btn.removeClass("lazyload--placeholder");
              });
          } else {
            theme.JelenewTips(theme?.jsUse?.tips?.check_email);
          }
        });
        // 订阅后点击复制
        $(container).on("click", ".cc-popup-form__discount--btn", function () {
          // $("#discount-code-textarea").text($("#discount-code-textarea").data("discount-code")).show();
          // var ele = document.getElementById("discount-code-textarea");
          // ele.select();
          // document.execCommand("copy", false, null);
          // $("#discount-code-textarea").hide();

          const code = $("#discount-code-textarea").data("discount-code").trim().toUpperCase();
          jelenew.functions.copyText(code);
          //关闭弹框
          $(".cc_popup_close_only", container).trigger("click");
          //埋点
          sensors.track("ClickCopy", {
            page_position: theme.jelenew_web_page_name,
            business_name: "code码",
            popup_strategy: container.popup_strategy,
            copy_content: code,
          });
        });

        //a标签打开订阅popup a标签加特定锚点 subscriptionPop
        $("body").on("click", "a[href*='subscriptionPop']", function () {
          const subscription_method = $(this).data("subscription_method");
          $("[data-section-type=newsletter-popup]")[0].popup_strategy = "点击触发";
          $("[data-section-type=newsletter-popup]")[0].subscription_method = subscription_method;
          $(document).triggerHandler(popupOpenEvent());
        });

        // // 折扣码使用
        // this.$container.on("click" + this.namespace, ".cc-popup-form__discount-use-btn", function () {
        //   if ($(".checkout-container-item .discount-container").length > 0) {
        //     $(".checkout-container-item .discount-container #checkout_reduction_code").val($("#discount-code-textarea").data("discount-code"));
        //     $(".checkout-container-item .discount-container .order-summary__section--discount #checkout_submit").trigger("click");
        //   }
        //   $(".cc_popup_close_only").trigger("click");
        // });
      };

      this.onSectionSelect = function () {
        this.popup.open();
      };

      this.functions = {
        /**
         * Use localStorage to set as dismissed
         */
        popupSetAsDismissed: function popupSetAsDismissed() {
          window.localStorage.setItem(dismissedStorageKey, new Date().getTime());
        },
      };

      /**
       * Event callback for Theme Editor `section:unload` event
       */
      this.onSectionUnload = function () {
        this.$container.off(this.namespace);
      };
    })();

    // Register Popup section
    (function () {
      cc.sections.push({
        name: "newsletter-popup",
        section: theme.Popup,
      });
    })();

    /*================ General =================*/
    theme.owlCarouselEventList = ["to", "next", "prev", "destroy", "initialized", "resized", "refreshed"].join(".owl.carousel ") + ".owl.carousel";
    theme.beforeCarouselLoadEventBlockFix = function (carouselEls) {
      $(carouselEls).on(theme.owlCarouselEventList, function (evt) {
        evt.stopPropagation();
      });
    };

    theme.beforeCarouselUnloadEventBlockFix = function (carouselEls) {
      $(carouselEls).off(theme.owlCarouselEventList);
    };

    theme.loadCarousels = function (container) {
      return $(".carousel", container).each(function () {
        var $this = $(this);

        function getTotalProductBlockWidth() {
          var productBlockTotalWidth = 0;
          $this.find($this.hasClass("owl-loaded") ? ".owl-item:not(.cloned)" : ".product-block").each(function () {
            productBlockTotalWidth += $(this).outerWidth(true);
          });
          return productBlockTotalWidth;
        }

        // next & prev arrows
        // $this.closest(".collection-slider").on("click.themeCarousel", ".prev, .next", function (e) {
        //   e.preventDefault();
        //   var carousel = $(this).closest(".collection-slider").find(".owl-carousel").data("owl.carousel");
        //   if ($(this).hasClass("prev")) {
        //     carousel.prev();
        //   } else {
        //     carousel.next();
        //   }
        // });

        // create options
        var carouselOptions, isLooping;
        var fixedMode = !$(this).closest(".container--no-max").length;
        $this.toggleClass("carousel--fixed-grid-mode", fixedMode);
        if (fixedMode) {
          var desktopNumPerRow = parseInt($(this)[0].className.match(/per-row-(.)/)[1]);
          carouselOptions = {
            margin: 0,
            loop: false,
            autoWidth: false,
            items: 5,
            center: false,
            nav: false,
            dots: false,
            responsive: {
              0: {
                items: desktopNumPerRow < 4 ? 1 : 2,
              },

              480: {
                items: Math.min(2, desktopNumPerRow - 2),
              },

              767: {
                items: desktopNumPerRow - 1,
              },

              1000: {
                items: desktopNumPerRow,
              },
            },
          };
        } else {
          isLooping = getTotalProductBlockWidth() > $this.width();
          carouselOptions = {
            margin: 0,
            loop: isLooping,
            autoWidth: true,
            items: Math.min($this.children().length, 8),
            center: true,
            nav: false,
            dots: false,
          };
        }

        // init carousel
        var loadCarousel = function loadCarousel() {
          // remove data-src as not in correct format for Owl to parse
          $this.find("[data-src]").each(function () {
            $(this).attr("data-src-temp", $(this).attr("data-src")).removeAttr("data-src");
          });

          // fix for event propagation in nested owl carousels
          theme.beforeCarouselLoadEventBlockFix($this);

          // run after carousel is initialised
          $this.on("initialized.owl.carousel", function () {
            // restore data-src
            $this.find("[data-src-temp]").each(function () {
              $(this).attr("data-src", $(this).attr("data-src-temp")).removeAttr("data-src-temp");
            });
            // lazysizes on primary images
            $this
              .find('.product-block__image--primary .lazyload--manual, .product-block__image--secondary[data-image-index="1"] .lazyload--manual')
              .removeClass("lazyload--manual")
              .addClass("lazyload");
            // ensure clones are processed from scratch
            theme.ProductBlockManager.loadImages($this.closest("[data-section-type]"));
            // recalculate widths, after the above's async calls
            setTimeout(function () {
              $this.data("owl.carousel").invalidate("width");
              $this.trigger("refresh.owl.carousel");
            }, 10);
          });

          // run after carousel is initialised or resized
          $this.on("initialized.owl.carousel resized.owl.carousel", function (evt) {
            // only loop if items do not all fit on screen, in non-fixed mode
            if (!fixedMode && evt.type == "resized") {
              var shouldLoop = getTotalProductBlockWidth() > $this.width();
              if (shouldLoop != isLooping) {
                // destroy and rebuild carousel with appropriate loop setting
                carouselOptions.loop = shouldLoop;
                isLooping = shouldLoop;

                // destroy function
                $(evt.target).data("owl.carousel").destroy();

                // build again
                $(evt.target).owlCarousel(carouselOptions);

                // do no more in this callback
                return;
              }
            }

            // layout fixes
            setTimeout(function () {
              // fixes
              var currentWidth = $this.find(".owl-stage").width();
              var stageIsPartiallyOffScreen = currentWidth > $this.width();
              if (stageIsPartiallyOffScreen) {
                // more elements than fit in viewport
                // resize stage to avoid rounding-error wrapping
                var newWidth = 0;
                $this.find(".owl-item").each(function () {
                  newWidth += $(this).outerWidth(true) + 1;
                });
                $this.find(".owl-stage").css({}).removeClass("owl-stage--items-fit");
              } else {
                // all elements fit inside viewport
                // centre-align using css, if not full
                $this.find(".owl-stage").addClass("owl-stage--items-fit").css({});
              }
              // previous/next button visibility
              //   $this.closest(".collection-slider").find(".prev, .next").toggleClass("owl-btn-disabled", !stageIsPartiallyOffScreen);
            }, 10);
          });

          // run when the contents change, for any reason
          theme.carouselInputIncrementer = theme.carouselInputIncrementer || 0;
          $this
            .on("refreshed.owl.carousel", function () {
              // set a11y attrs to avoid clone items giving duplication errors
              $(".owl-item", this).removeAttr("aria-hidden");
              $(".owl-item.cloned", this)
                .attr("aria-hidden", "true")
                .each(function () {
                  theme.carouselInputIncrementer++;
                  var uniquenessSuffix = "_" + theme.carouselInputIncrementer;
                  $(this)
                    .find("form[id]:not([data-id-altered]), :input[id]:not([data-id-altered])")
                    .each(function () {
                      $(this).attr("id", $(this).attr("id") + uniquenessSuffix);
                    })
                    .attr("data-id-altered", true);

                  $(this)
                    .find("label[for]:not([data-id-altered])")
                    .each(function () {
                      $(this).attr("for", $(this).attr("for") + uniquenessSuffix);
                    })
                    .attr("data-id-altered", true);
                });
            })
            .addClass("owl-carousel")
            .owlCarousel(carouselOptions);
        };
        loadCarousel();
      });
    };

    theme.unloadCarousels = function (container) {
      // $(".collection-slider", container).off(".themeCarousel");
      $(".slick-slider", container).slick("unslick");
      theme.beforeCarouselUnloadEventBlockFix($(".owl-carousel", container));
      $(".owl-carousel", container).each(function () {
        $(this).data("owl.carousel").destroy();
      });
    };

    theme.icons = {
      left:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_left +
        '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
      right:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_right +
        '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
      close:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><title>' +
        theme.strings.icon_labels_close +
        '</title><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
      chevronLeft:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><title>' +
        theme.strings.icon_labels_left +
        '</title><polyline points="15 18 9 12 15 6"></polyline></svg>',
      chevronRight:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>' +
        theme.strings.icon_labels_right +
        '</title><polyline points="9 18 15 12 9 6"></polyline></svg>',
      chevronDown:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_down +
        '</title><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
      tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>',
      label:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tag"><title>Label</title><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7" y2="7"></line></svg>',
    };

    // Get Shopify feature support
    try {
      theme.Shopify.features = JSON.parse(document.documentElement.querySelector("#shopify-features").textContent);
    } catch (e) {
      theme.Shopify.features = {};
    }

    theme.namespaceFromSection = function (container) {
      return [".", $(container).data("section-type"), $(container).data("section-id")].join("");
    };

    theme.toggleLinkDropdownButton = function (evt) {
      evt.stopPropagation();
      var $btn = $(evt.currentTarget),
        doExpand = $btn.attr("aria-expanded") == "false";
      $btn.attr("aria-expanded", doExpand);
      $(".jelenew_utility_bar").show();
      $btn.css("width", $btn.outerWidth() + "px");
      var newWidth = null,
        $optsBox = $btn.next(),
        isLeftAligned = $btn.closest(".link-dropdown").hasClass("link-dropdown--left-aligned");
      if (!isLeftAligned) {
        if (doExpand) {
          newWidth = $optsBox.outerWidth();
          newWidth += parseInt($optsBox.css("right"));
          newWidth -= parseInt($optsBox.find(".link-dropdown__link:first").css("padding-left"));
        } else {
          newWidth = parseInt($btn.css("padding-right")) + $btn.find(".link-dropdown__button-text").width() + 1;
        }
        setTimeout(function () {
          $btn.css("width", newWidth + "px");
        }, 10);
      }
      if (!$(".jelenew_collection_filter_list_back").hasClass("jelenew_collection_filter_list_back_show")) {
        sensors.track(theme.jelenew_event_name, {
          element_name: "SORT BY",
          category_name: location.pathname.split("/").pop(),
          page_position: theme.jelenew_web_page_name,
        });
      }
      $(".jelenew_collection_filter_list_back").addClass("jelenew_collection_filter_list_back_show");
    };

    // Enables any images inside a container
    theme.awakenImagesFromSlumber = function ($cont) {
      $cont.find(".lazyload--manual:not(.lazyload)").addClass("lazyload");
    };

    theme.measureTextInsideElement = function (text, element) {
      theme.measureTextInsideElementCanvas = theme.measureTextInsideElementCanvas || document.createElement("canvas");
      var context = theme.measureTextInsideElementCanvas.getContext("2d");
      var font = getComputedStyle(element).font;
      context.font = font;
      return context.measureText(text);
    };

    // Use non-breaking space to attempt to avoid orphans
    theme.avoidUnecessaryOrphans = function (element) {
      if (theme.settings.avoid_orphans) {
        var innerTextSplit = element.innerText.split(" ");
        if (
          innerTextSplit.length >= 4 && // 4 or more words
          innerTextSplit[innerTextSplit.length - 1].length + innerTextSplit[innerTextSplit.length - 2].length < 20 // last two words aren't particularly long together
        ) {
          var html = element.innerHTML;
          if (html.indexOf("&nbsp;") < 0) {
            html = html.replace(/<[^>]*?>/g, function (match) {
              return match.replace(/ /g, "ΩΩ");
            });
            var splitHtml = html.split(" "),
              lastItem = splitHtml.pop();

            if (theme.measureTextInsideElement(splitHtml[splitHtml.length - 1] + " " + lastItem, element).width > element.clientWidth) {
              return;
            }

            html = splitHtml.join(" ") + "&nbsp;" + lastItem;
            html = html.replace(/ΩΩ/g, " ");
            element.innerHTML = html;
          }
        }
      }
    };

    // bg-set snippet in JS
    theme.lazyBGSetWidths = [180, 360, 540, 750, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2260, 2450, 2700, 3000, 3350, 3750, 4100];
    theme.loadLazyBGSet = function (container) {
      $("[data-lazy-bgset-src]", container).each(function () {
        var srcset = "",
          masterSrc = $(this).data("lazy-bgset-src"),
          aspectRatio = $(this).data("lazy-bgset-aspect-ratio"),
          masterWidth = $(this).data("lazy-bgset-width"),
          masterHeight = Math.round(masterWidth / aspectRatio);

        for (var i = 0; i < theme.lazyBGSetWidths.length; i++) {
          var thisWidth = theme.lazyBGSetWidths[i];
          if (masterWidth >= thisWidth) {
            srcset += ""
              .concat(theme.Shopify.formatImage(masterSrc, thisWidth + "x"), " ")
              .concat(thisWidth, "w ")
              .concat(Math.round(thisWidth / aspectRatio), "h, ");
          }
        }
        srcset += "".concat(masterSrc, " ").concat(masterWidth, "w ").concat(masterHeight, "h");
        $(this).attr("data-bgset", srcset).removeClass("lazyload--manual").addClass("lazyload");
      });
    };

    /*=============== Components ===============*/
    theme.applyAjaxToProductForm = function ($formContainer) {
      $formContainer
        .filter('[data-ajax-add-to-cart="true"]')
        .find("form.product-purchase-form")
        .each(function () {
          $(this).on("submit", function (evt) {
            evt.preventDefault();
            var $form = $(this);
            var selected_variant_id = $form.find(".original-selector").val();
            if (!selected_variant_id) {
              $(".size-selector-container").addClass("size-warning");
              return;
            }
            //Disable add button
            $form
              .find('button[type="submit"]')
              .attr("disabled", "disabled")
              .each(function () {
                $(this).data("previous-value", $(this).val());
              })
              .val(theme.strings.products_product_adding_to_cart);

            //Hide any existing notifications
            // $("#cart-summary-overlay #shop-more").triggerHandler("click");
            let addProduct = {
              id: $(".original-selector").val(),
              quantity: 1,
              properties: {},
            };
            // add - sort
            shopifyCartApi
              .add({ items: [addProduct], sections: "cart-drawer" })
              .then((data) => {
                const addedDataJSON = data.items[0];
                function removeBtnAttr() {
                  //Enable add button
                  $form
                    .find('button[type="submit"]')
                    .removeAttr("disabled")
                    .each(function () {
                      $btn = $(this);
                      //Set to 'DONE', alter button style, wait a few secs, revert to normal
                      $btn.val(theme.strings.products_product_added_to_cart).addClass("inverted");
                      window.setTimeout(function () {
                        $btn.removeClass("inverted").val($btn.data("previous-value"));
                      }, 3000);
                    });
                  addProductScrollTop(addedDataJSON?.key);
                }

                $(document).triggerHandler(cartChangedEvent({ detail: { jelenewCustomCallBack: removeBtnAttr } }));

                // waterfall组件的加购提示
                const jelenewAddPrice = theme.Shopify.formatMoney(addedDataJSON.final_price, theme.money_format_with_cart_code_preference);
                if (theme.jelenewImgWaterfallShowAddToBagPrompt) {
                  theme.jelenewImgWaterfallShowAddToBagPrompt(addedDataJSON.title, addedDataJSON.image, jelenewAddPrice);
                }
                //关闭h5 sku选择器
                $("body").removeClass("enable-mobile-shop-now-transition");
              })
              .catch(() => {
                $form
                  .find('button[type="submit"]')
                  .removeAttr("disabled")
                  .each(function () {
                    $(this).val($(this).data("previous-value"));
                  });
              });
          });
        });
    };

    /**
     * @use theme.addedToCartHandler.call(this, data)
     * @param {Element} - 包含提交按钮的form
     * @param {CartData} - 包含购物车数据
     */
    // theme.addedToCartHandler = function (response) {
    //   $(this)
    //     .find('button[type="submit"]')
    //     .removeAttr("disabled")
    //     .each(function () {
    //       $btn = $(this);
    //       //Set to 'DONE', alter button style, wait a few secs, revert to normal
    //       $btn.val(theme.strings.products_product_added_to_cart).addClass("inverted");
    //       window.setTimeout(function () {
    //         $btn.removeClass("inverted").val($btn.data("previous-value"));
    //       }, 3000);
    //     });

    //   var $cartDrawerContainer = $(response.sections["cart-drawer"]);
    //   var cartDrawer = $cartDrawerContainer.find(".cart-summary-overlay")[0];
    //   cartDrawer.classList.add("cart-summary-overlay--off-screen");

    //   // show only added item
    //   // $cartDrawerContainer.find('.cart-summary-overlay__row-body:not([data-item-key="'.concat(response.key, '"])')).remove();
    //   $cartDrawerContainer.find(".cart-summary-overlay__row-body").each(function () {
    //     if (response.items.every((item) => item.key != $(this).data("item-key"))) {
    //       $(this).addClass("need_remove");
    //     }
    //   });
    //   if ($cartDrawerContainer.find(".cart-summary-overlay__row-body:not(.need_remove)").length == response.items.length) {
    //     $cartDrawerContainer.find(".cart-summary-overlay__row-body.need_remove").remove();
    //   } else {
    //     $cartDrawerContainer.find(".cart-summary-overlay__row-body").each(function (i) {
    //       if (i > response.items.length - 1) {
    //         $(this).remove();
    //       }
    //     });
    //   }
    //   $(cartDrawer).on("click", ".to-cart, .shop-more", function (evt) {
    //     let params = {
    //       page_position: theme.jelenew_web_page_name,
    //       element_name: $(this).hasClass("shop-more") ? "x" : "View your Shopping Bag",
    //       product_id: $cartDrawerContainer
    //         .find(".cart-summary-overlay__row-body")
    //         .map(function () {
    //           return this?.dataset?.productId;
    //         })
    //         .get()
    //         .join(","),
    //       original_price: 0,
    //     };
    //     $cartDrawerContainer.find(".cart-summary-overlay__row-body").each(function () {
    //       params.original_price += $(this).data("price") / 100;
    //     });
    //     if ($(this).hasClass("shop-more")) {
    //       evt.preventDefault();
    //     }
    //     sensors.track("ClickDetailsElement", params);
    //     theme.removeAddedCartDrawer();
    //   });
    //   $(cartDrawer).on("click", ".to-checkout", function () {
    //     sensors.track("ClickCheckOut", makeSensorsCartParams());
    //   });
    //   if (window.innerWidth >= 768 && $("#pageheader").css("top") == "0px") {
    //     // pc端 && header展示情况
    //     $("#pageheader").addClass("jelenewheader-fixed-style");
    //     $cartDrawerContainer.css("top", `${$("#pageheader").height()}px`);
    //   }
    //   $cartDrawerContainer.prependTo("body");
    //   $("body").addClass("cc-popup-no-scroll");
    //   setTimeout(function () {
    //     cartDrawer.classList.remove("cart-summary-overlay--off-screen");
    //   }, 50);
    // };

    // theme.removeAddedCartDrawer = function () {
    //   document.querySelectorAll(".cart-summary-overlay").forEach((drawer) => {
    //     drawer.classList.add("cart-summary-overlay--off-screen");
    //     // var duration = parseFloat(getComputedStyle(drawer).transitionDuration) * 1000;
    //     setTimeout(() => {
    //       if ($("#pageheader").css("top") == "0px") {
    //         $("#pageheader").removeClass("jelenewheader-fixed-style");
    //       }
    //       $(drawer.parentElement).remove();
    //       $("body").removeClass("cc-popup-no-scroll");
    //     }, 0);
    //   });
    // };

    theme.removeAjaxFromProductForm = function ($formContainer) {
      $formContainer.find("form.product-purchase-form").off("submit");
    };

    theme.LoadFilterer = function (section) {
      this.$container = section.$container;
      this.namespace = section.namespace;
      this.registerEventListener = section.registerEventListener;

      this.functions = {
        initFiltersEtc: function initFiltersEtc() {
          $(".filter-container", this.$container).addClass("filter-container--mobile-initialised");

          // append query vars onto sort urls (e.g. filters, vendor collection)
          if (location.href.indexOf("?") >= 0) {
            $("#sort-dropdown-options .link-dropdown__link", this.$container).each(function () {
              var queryTerms = location.href.split("?")[1].split("&");
              var newHref = $(this).attr("href");
              queryTerms.forEach(function (term) {
                if (term.indexOf("sort_by=") === -1) {
                  newHref += "&" + term;
                }
              });
              $(this).attr("href", newHref);
            });
          }

          theme.ProductBlockManager.loadImages(this.$container);
        },

        switchGridLayout: function switchGridLayout(evt) {
          evt.preventDefault();
          if ($(evt.currentTarget).hasClass("layout-switch--one-column")) {
            this.$container.find(".product-list").addClass("product-list--one-column-mobile");
          } else {
            this.$container.find(".product-list").removeClass("product-list--one-column-mobile");
          }
          $(evt.currentTarget).addClass("layout-switch--active").siblings().removeClass("layout-switch--active");
        },

        checkStickyScroll: function checkStickyScroll() {
          var utilityBarOffsetY = $(".utility-bar").offset().top;
          if ($(window).width() < 768 && this.previousScrollTop > window.scrollY && window.scrollY > utilityBarOffsetY) {
            $("body").addClass("utility-bar-sticky-mobile-copy-reveal");
          } else {
            $("body.utility-bar-sticky-mobile-copy-reveal").removeClass("utility-bar-sticky-mobile-copy-reveal");
          }
          this.previousScrollTop = window.scrollY;
        },

        ajaxLoadLink: function ajaxLoadLink(evt) {
          evt.preventDefault();
          this.functions.ajaxLoadUrl.call(this, $(evt.currentTarget).attr("href"));
        },

        ajaxLoadForm: function ajaxLoadForm(evt) {
          if (evt.type === "submit") {
            evt.preventDefault();
          }
          var queryVals = [];
          evt.currentTarget.querySelectorAll("input, select").forEach(function (input) {
            if (
              ((input.type !== "checkbox" && input.type !== "radio") || input.checked) && // is an active input value
              input.value !== "" // has a value
            ) {
              queryVals.push([input.name, encodeURIComponent(input.value)]);
            }
          });
          // new url
          var newUrl = location.pathname;
          queryVals.forEach(function (value) {
            newUrl += "&".concat(value[0], "=").concat(value[1]);
          });
          newUrl = newUrl.replace("&", "?");
          // load
          this.functions.ajaxLoadUrl.call(this, newUrl);
        },

        ajaxPopState: function ajaxPopState(event) {
          this.functions.ajaxLoadUrl.call(this, document.location.href);
        },

        ajaxLoadUrl: function ajaxLoadUrl(url) {
          // update url history
          var fullUrl = url;
          if (fullUrl.slice(0, 1) === "/") {
            fullUrl = window.location.protocol + "//" + window.location.host + fullUrl;
          }
          window.history.pushState({ path: fullUrl }, "", fullUrl);

          // start fetching URL
          var refreshContainerSelector = "[data-ajax-container]",
            $ajaxContainers = this.$container.find(refreshContainerSelector);

          // loading state
          $ajaxContainers.addClass("ajax-loading");

          // fetch content
          if (this.currentAjaxLoadUrlFetch) {
            this.currentAjaxLoadUrlFetch.abort();
          }
          this.currentAjaxLoadUrlFetch = $.get(
            url,
            function (data) {
              this.currentAjaxLoadUrlFetch = null;

              // save active element
              if (document.activeElement) {
                this.activeElementId = document.activeElement.id;
              }

              // unload content
              theme.ProductBlockManager.unloadImages(this.$container);

              // replace contents
              var $newAjaxContainers = $("<div>".concat(data, "</div>")).find(refreshContainerSelector);
              $newAjaxContainers.each(function (index) {
                $($ajaxContainers[index]).html($(this).html());
              });

              // init js
              this.functions.initFiltersEtc.call(this);

              // init theme components
              var $componentHaver = this.$container.closest("[data-components]");
              if ($componentHaver.length) {
                var components = $componentHaver.data("components").split(",");
                components.forEach(
                  function (component) {
                    $(document).trigger("cc:component:load", [component, $componentHaver[0]]);
                  }.bind(this)
                );
              }

              // remove loading state
              $ajaxContainers.removeClass("ajax-loading");

              // init scroll animations
              theme.initAnimateOnScroll();

              // restore active element
              if (this.activeElementId) {
                var el = document.getElementById(this.activeElementId);
                if (el) {
                  el.focus();
                }
              }

              // scroll viewport (must be done after any page size changes)
              var scrollToY = $("[data-ajax-scroll-to]:first", this.$container).offset().top - $(".section-header").height();
              window.scrollTo({
                top: scrollToY,
                behavior: "smooth",
              });
            }.bind(this)
          );
        },
      };

      // ajax filter & sort
      if (this.$container.data("ajax-filtering")) {
        // ajax load on link click
        this.$container.on(
          "click" + this.namespace,
          ".link-dropdown__link, .filter-group__applied-item, .filter-group__clear-link, .pagination a",
          this.functions.ajaxLoadLink.bind(this)
        );
        // ajax load form submission
        this.$container.on(
          "change" + this.namespace + " submit" + this.namespace,
          "#CollectionFilterForm",
          theme.debounce(this.functions.ajaxLoadForm.bind(this), 700)
        );
        // handle back button
        this.registerEventListener(window, "popstate", this.functions.ajaxPopState.bind(this));
      } else {
        this.$container.on("change" + this.namespace, "#CollectionFilterForm", function () {
          $(this).submit();
        });
      }

      // sort dropdown: open
      this.$container.on("click" + this.namespace, ".link-dropdown__button", theme.toggleLinkDropdownButton.bind(this));

      // sort dropdown: click anywhere else in page to close
      $(document).on("click" + this.namespace, function () {
        $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
      });

      if (document.querySelector(".utility-bar")) {
        // duplicate utility bar for mobile
        var $utilBarClone = $(".utility-bar")
          .clone()
          .addClass("utility-bar--sticky-mobile-copy")
          .removeAttr("data-ajax-container")
          .insertAfter(".utility-bar");
        // ensure unique ids
        theme.suffixIds($utilBarClone[0], "dupe");

        this.previousScrollTop = window.scrollY;
        $(window).on("throttled-scroll" + this.namespace, this.functions.checkStickyScroll.bind(this));

        // filter visibility
        this.$container.on(
          "click" + this.namespace,
          "[data-toggle-filters]",
          function (evt) {
            var isNowVisible = $(".filter-container", this.$container)
              .toggleClass("filter-container--show-filters-desktop filter-container--show-filters-mobile")
              .hasClass("filter-container--show-filters-desktop");
            $(".toggle-btn[data-toggle-filters]", this.$container).toggleClass("toggle-btn--revealed-desktop", isNowVisible);
            // handle resized collection grid
            theme.ProductBlockManager.afterImagesResized();
            $(".slick-slider", this.$container).each(function () {
              $(this).slick("setPosition");
            });
            return false;
          }.bind(this)
        );

        // layout switcher
        this.$container.on("click" + this.namespace, ".layout-switch", this.functions.switchGridLayout.bind(this));
      }

      // init things that may need re-initialising on ajax load
      this.functions.initFiltersEtc.call(this);

      this.destroy = function () {
        theme.ProductBlockManager.unloadImages(this.$container);
        theme.destroyProductGallery(this.$container);
        this.$container.off(this.namespace);
        $(window).off(this.namespace);
        $(document).off(this.namespace);
      }.bind(this);
    };

    theme.buildGalleryViewer = function (config) {
      // create viewer
      var $allContainer = $('<div class="gallery-viewer gallery-viewer--pre-reveal">'),
        $zoomContainer = $('<div class="gallery-viewer__zoom-container">').appendTo($allContainer),
        $thumbContainer = $('<div class="gallery-viewer__thumbs">').appendTo($allContainer),
        $controlsContainer = $('<div class="gallery-viewer__controls">').appendTo($allContainer),
        $close = $('<a class="gallery-viewer__button gallery-viewer__close" href="#">').html(config.close).appendTo($controlsContainer),
        $right = $('<a class="gallery-viewer__button gallery-viewer__prev" href="#">').html(config.prev).appendTo($controlsContainer),
        $left = $('<a class="gallery-viewer__button gallery-viewer__next" href="#">').html(config.next).appendTo($controlsContainer),
        $currentZoomImage = null,
        wheelZoomMultiplier = -0.001,
        pinchZoomMultiplier = 0.003,
        touchPanModifier = 1.0,
        currentTransform = {
          panX: 0,
          panY: 0,
          zoom: 1,
        };

      // add images
      for (var i = 0; i < config.images.length; i++) {
        var img = config.images[i];
        $('<a class="gallery-viewer__thumb" href="#">').data("zoom-url", img.zoomUrl).html(img.thumbTag).appendTo($thumbContainer);
      }

      if (config.images.length === 1) {
        $allContainer.addClass("gallery-viewer--single-image");
      }

      // helper function for panning an image
      var panZoomImageFromCoordinate = function panZoomImageFromCoordinate(inputX, inputY) {
        // do nothing if the image fits, pan if not
        var doPanX = $currentZoomImage.width() > $allContainer.width();
        var doPanY = $currentZoomImage.height() > $allContainer.height();
        if (doPanX || doPanY) {
          var midX = $allContainer.width() / 2;
          var midY = $allContainer.height() / 2;

          var offsetFromCentreX = inputX - midX,
            offsetFromCentreY = inputY - midY;

          // the offsetMultipler ensures it can only pan to the edge of the image, no further
          var finalOffsetX = 0;
          var finalOffsetY = 0;
          if (doPanX) {
            var offsetMultiplierX = ($currentZoomImage.width() - $allContainer.width()) / 2 / midX;
            finalOffsetX = Math.round(-offsetFromCentreX * offsetMultiplierX);
          }
          if (doPanY) {
            var offsetMultiplierY = ($currentZoomImage.height() - $allContainer.height()) / 2 / midY;
            finalOffsetY = Math.round(-offsetFromCentreY * offsetMultiplierY);
          }

          currentTransform.panX = finalOffsetX;
          currentTransform.panY = finalOffsetY;
          alterCurrentPanBy(0, 0); // sanitise
          updateImagePosition();
        }
      };

      var alterCurrentPanBy = function alterCurrentPanBy(x, y) {
        currentTransform.panX += x;
        // limit offset to keep most of image on screen
        var panXMax = ($currentZoomImage[0].naturalWidth * currentTransform.zoom - $allContainer.width()) / 2.0;
        panXMax = Math.max(panXMax, 0);
        currentTransform.panX = Math.min(currentTransform.panX, panXMax);
        currentTransform.panX = Math.max(currentTransform.panX, -panXMax);

        currentTransform.panY += y;
        var panYMax = ($currentZoomImage[0].naturalHeight * currentTransform.zoom - $allContainer.height()) / 2.0;
        panYMax = Math.max(panYMax, 0);
        currentTransform.panY = Math.min(currentTransform.panY, panYMax);
        currentTransform.panY = Math.max(currentTransform.panY, -panYMax);
        updateImagePosition();
      };

      var setCurrentTransform = function setCurrentTransform(panX, panY, zoom) {
        currentTransform.panX = panX;
        currentTransform.panY = panY;
        currentTransform.zoom = zoom;
        alterCurrentTransformZoomBy(0);
      };

      var alterCurrentTransformZoomBy = function alterCurrentTransformZoomBy(delta) {
        currentTransform.zoom += delta;
        // do not zoom in further than native size
        currentTransform.zoom = Math.min(currentTransform.zoom, 1.0);
        // do not zoom out further than fit
        var maxZoomX = $allContainer.width() / $currentZoomImage[0].naturalWidth,
          maxZoomY = $allContainer.height() / ($currentZoomImage[0].naturalHeight + 800);
        currentTransform.zoom = Math.max(currentTransform.zoom, Math.min(maxZoomX, maxZoomY));

        // reasses pan bounds
        alterCurrentPanBy(0, 0);
        updateImagePosition();
      };

      var updateImagePosition = function updateImagePosition() {
        $currentZoomImage.css(
          "transform",
          "translate3d(".concat(currentTransform.panX, "px, ").concat(currentTransform.panY, "px, 0) scale(").concat(currentTransform.zoom, ")")
        );
      };

      // set up events
      // event: select thumbnail - zoom it
      $allContainer.on("click.galleryViewer select.galleryViewer", ".gallery-viewer__thumb", function (evt) {
        evt.preventDefault();

        // set active
        $(this).addClass("gallery-viewer__thumb--active").siblings(".gallery-viewer__thumb--active").removeClass("gallery-viewer__thumb--active");
        // 放大后标记同步到localstorage
        localStorage.setItem("thumbnailIndex", $(this).index());
        // replace zoom image
        $currentZoomImage = $('<img class="gallery-viewer__zoom-image" alt="" style="visibility: hidden">');
        $currentZoomImage
          .on("load", function () {
            $(this).off("load");
            $(this).css({
              visibility: "",
              top: ($allContainer.height() / 2 - $(this).height() / 2) * 1.6,
              left: $allContainer.width() / 2 - $(this).width() / 2,
            });

            setCurrentTransform(0, 0, 0.3); // centre, zoomed in
          })
          .attr("src", $(this).data("zoom-url"));

        $zoomContainer.html($currentZoomImage);
      });

      // event: pan
      var pinchTracking = {
        isTracking: false,
        lastPinchDistance: 0,
      };

      var touchTracking = {
        isTracking: false,
        lastTouchX: 0,
        lastTouchY: 0,
      };

      $allContainer.on("touchend.galleryViewer", function (evt) {
        pinchTracking.isTracking = false;
        touchTracking.isTracking = false;
      });

      $allContainer.on("mousemove.galleryViewer touchmove.galleryViewer", function (evt) {
        evt.preventDefault();
        if (evt.type === "touchmove" && evt.touches.length > 0) {
          // pan
          var touch1 = evt.touches[0];
          if (!touchTracking.isTracking) {
            touchTracking.isTracking = true;
            touchTracking.lastTouchX = touch1.clientX;
            touchTracking.lastTouchY = touch1.clientY;
          } else {
            alterCurrentPanBy(
              (touch1.clientX - touchTracking.lastTouchX) * touchPanModifier,
              (touch1.clientY - touchTracking.lastTouchY) * touchPanModifier
            );

            touchTracking.lastTouchX = touch1.clientX;
            touchTracking.lastTouchY = touch1.clientY;
          }

          if (evt.touches.length === 2) {
            // pinch
            var touch2 = evt.touches[1],
              pinchDistance = Math.sqrt(Math.pow(touch1.clientX - touch2.clientX, 2) + Math.pow(touch1.clientY - touch2.clientY, 2));
            if (!pinchTracking.isTracking) {
              pinchTracking.lastPinchDistance = pinchDistance;
              pinchTracking.isTracking = true;
            } else {
              var pinchDelta = pinchDistance - pinchTracking.lastPinchDistance;
              alterCurrentTransformZoomBy(pinchDelta * pinchZoomMultiplier);
              pinchTracking.lastPinchDistance = pinchDistance;
            }
          } else {
            pinchTracking.isTracking = false;
          }
        } else {
          // mousemove
          panZoomImageFromCoordinate(evt.clientX, evt.clientY);
        }
      });

      // event: mousewheel
      $allContainer.on("wheel.galleryViewer", function (evt) {
        evt.preventDefault();
        if (evt.originalEvent.deltaY != 0) {
          alterCurrentTransformZoomBy(evt.originalEvent.deltaY * wheelZoomMultiplier);
        }
      });

      // event: prevent pan while swiping thumbnails
      $allContainer.on("touchmove.galleryViewer", ".gallery-viewer__thumbs", function (evt) {
        evt.stopPropagation();
      });

      // event: next thumbnail
      $allContainer.on("click.galleryViewer", ".gallery-viewer__next", function (evt) {
        evt.preventDefault();
        var $next = $thumbContainer.find(".gallery-viewer__thumb--active").next();
        if ($next.length === 0) {
          $next = $thumbContainer.find(".gallery-viewer__thumb:first");
        }
        $next.trigger("select");
      });

      // event: previous thumbnail
      $allContainer.on("click.galleryViewer", ".gallery-viewer__prev", function (evt) {
        evt.preventDefault();
        var $prev = $thumbContainer.find(".gallery-viewer__thumb--active").prev();
        if ($prev.length === 0) {
          $prev = $thumbContainer.find(".gallery-viewer__thumb:last");
        }
        $prev.trigger("select");
      });

      // event: close
      $allContainer.on("click.galleryViewer", ".gallery-viewer__close", function (evt) {
        const selectedId = localStorage.getItem("thumbnailIndex");
        $(".gallery").find(".slideshow").slick("slickGoTo", selectedId);
        evt.preventDefault();
        // destroy events
        $allContainer.off(".galleryViewer");
        // begin exit transition
        $allContainer.addClass("gallery-viewer--transition-out");
        // remove after transition
        var transitionDelay = $allContainer.css("transition-duration");
        transitionDelay = transitionDelay.indexOf("ms") > -1 ? parseFloat(transitionDelay) : parseFloat(transitionDelay) * 1000;
        setTimeout(function () {
          $allContainer.remove();
          $("html").removeClass("gallery-viewer-open");
        }, transitionDelay);
      });

      // event: zoom
      $allContainer.on("click.galleryViewer", ".gallery-viewer__zoom-container", function (evt) {
        evt.preventDefault();
        if (currentTransform.zoom == 1.0) {
          currentTransform.zoom = 0;
          alterCurrentTransformZoomBy(0);
        } else {
          currentTransform.zoom = 1;
          alterCurrentTransformZoomBy(0);
        }
      });

      // initialise

      // - clear any remnants of failed previous closure
      $("html").removeClass("gallery-viewer-open");
      $(".gallery-viewer").remove();

      // - insert into page
      $("html").addClass("gallery-viewer-open");
      $allContainer.appendTo("body");

      // - select first thumbnail
      $thumbContainer
        .find(".gallery-viewer__thumb:eq(" + (config.current > 0 ? config.current : 0) + ")")
        .trigger("select")
        .focus();

      // - reveal
      setTimeout(function () {
        $allContainer.removeClass("gallery-viewer--pre-reveal");
      }, 10);
    };
    theme.Navigation = {
      init: function init(options) {
        if (options.nav.length == 0) {
          return;
        }

        var $nav = options.nav,
          navHoverDelay = 250,
          $navLastOpenDropdown = $(),
          navOpenTimeoutId = -1;

        /// Mobile nav

        // create it
        var $mobileDrawer = $('<div class="mobile-navigation-drawer">');

        // add nav links
        $mobileDrawer.append($nav.clone());

        // add announcement bar items
        var $mobileDrawerFooter = $('<div class="mobile-navigation-drawer__footer">').appendTo($mobileDrawer);
        $mobileDrawerFooter.append($(".announcement-bar .inline-menu").clone().removeClass("desktop-only"));
        $mobileDrawerFooter.append($(".announcement-bar .header-disclosures").clone().removeClass("desktop-only"));
        $mobileDrawerFooter.append($(".announcement-bar .social-links").clone().removeClass("desktop-only"));

        // ensure unique ids
        theme.suffixIds($mobileDrawer[0], "mob");

        // insert into page
        $mobileDrawer.insertAfter($("#shopify-section-header"));
        $mobileDrawer.on("click", ".navigation__tier-1 > .navigation__item .black-friday-title", function (e) {
          e.stopPropagation();
          sensors.track("ClickFirstTab", {
            first_tab_name: $(this).text().trim(),
          });
        });
        $mobileDrawer.on("click", ".navigation__tier-1 > .navigation__item .navigation-wish-list__link", function (e) {
          e.stopPropagation();
          sensors.track("ClickFirstTab", {
            first_tab_name: $(this).text().trim(),
          });
        });

        // event: open second tier
        $mobileDrawer.on("click", ".navigation__tier-1 > .navigation__item > .navigation__children-toggle", function (evt) {
          evt.preventDefault();
          var doOpen = !$(this).parent().hasClass("navigation__item--open");
          if (doOpen) {
            sensors.track("ClickFirstTab", {
              first_tab_name: $($(this).parents(".navigation__item_1").find(".navigation__link")[0]).text().trim().replace("Toggle menu", "").trim(),
            });
            // 打开
            // 舍弃二级导航的top定位
            // $(this)
            // 	.siblings(".navigation__tier-2-container")
            // 	.css({
            // 		top: Math.ceil($(".navigation__mobile-header:last").height() + 26) + "px",
            // 	});

            $(this).parent().addClass("navigation__item--open").closest(".mobile-navigation-drawer").addClass("mobile-navigation-drawer--child-open");
            // .find(".mobile-nav-title")
            // .text($(this).siblings(".navigation__link").text());

            var $childContainer = $(this).siblings(".navigation__tier-2-container");
            $childContainer.css("height", $childContainer.children().outerHeight());
          } else {
            // 关闭
            $(this)
              .parent()
              .removeClass("navigation__item--open")
              .closest(".mobile-navigation-drawer")
              .removeClass("mobile-navigation-drawer--child-open");
            $(this).siblings(".navigation__tier-2-container").css("height", "");
          }
        });

        if ($nav.data("mobile-expand-with-entire-link")) {
          $mobileDrawer.on("click", ".navigation__item--with-children > .navigation__link", function (evt) {
            evt.preventDefault();
            $(this).siblings(".navigation__children-toggle").trigger("click");
          });
        }

        // event: close second tier
        $mobileDrawer.on("click", ".mobile-nav-back", function (evt) {
          evt.preventDefault();
          $(this)
            .closest(".mobile-navigation-drawer")
            .removeClass("mobile-navigation-drawer--child-open")
            .find(".navigation__tier-1 > .navigation__item--open")
            .removeClass("navigation__item--open");
        });

        // event: toggle third tier
        $mobileDrawer.on("click", ".navigation__tier-2 > .navigation__item > .navigation__children-toggle", function (evt) {
          evt.preventDefault();
          var doOpen = !$(this).parent().hasClass("navigation__item--open");
          if (doOpen) {
            setTimeout(() => {
              $(this).parent().addClass("navigation__item--open");
              var $childContainer = $(this).siblings(".navigation__tier-3-container");
              $childContainer.css("height", $childContainer.children().outerHeight());
              // 新增逻辑-->增加的高度要再给二级导航加上，防止内部滚动条出现
              var $parentContainer = $childContainer.closest(".navigation__tier-2-container");
              $parentContainer.css(
                "height",
                parseInt($parentContainer.css("height").replace("px", "")) + parseInt($childContainer.children().outerHeight()) + "px"
              );
            });
          } else {
            // 新增逻辑-->减少的高度要再给二级导航减去
            var $childContainer = $(this).siblings(".navigation__tier-3-container");
            var $parentContainer = $childContainer.closest(".navigation__tier-2-container");
            $parentContainer.css(
              "height",
              parseInt($parentContainer.css("height").replace("px", "")) - parseInt($childContainer.css("height").replace("px", "")) + "px"
            );
            // 原有逻辑
            setTimeout(() => {
              $(this).parent().removeClass("navigation__item--open");
              $(this).siblings(".navigation__tier-3-container").css("height", "");
            });
          }
        });

        // H5菜单栏中--地区切换
        $mobileDrawer.on("click", ".jelenew-select-show input, .jelenew-select-option", function (evt) {
          if ($(this).hasClass("jelenew-select-show")) {
            $(this).closest(".jelenew-select").addClass("jelenew-show-options");
          } else {
            if ($(this).hasClass("jelenew-selected")) return;
            $(this).closest(".jelenew-select-options").find(".jelenew-selected").removeClass("jelenew-selected");
            $(this).addClass("jelenew-selected");
            $(this).closest(".jelenew-select").removeClass("jelenew-show-options");
            $(this)
              .closest(".jelenew-select")
              .find(".jelenew-select-show input")
              .val($(this).closest(".jelenew-select").find(".jelenew-selected").text());
            var root_url = $(this).closest(".jelenew-select-options").find(".jelenew-selected").attr("root_url");
            var old_root_url = Shopify.routes.root;
            var href = location.href
              .replace(location.hostname + old_root_url.slice(0, old_root_url.length - 1), location.hostname + root_url)
              .replaceAll(",", "%2C");
            if(href.includes("/fr-eu/collections/") || old_root_url.includes("fr-eu")){
              window.location.href = href.split('?')[0];
            }else{
              window.location.href = href;
            }  
          }
        });
        $(".jelenew-select-show input", $mobileDrawer[0]).val($(".jelenew-selected", $mobileDrawer[0]).text());
        $(".jelenew-select-show input", $mobileDrawer[0]).on("blur", function () {
          setTimeout(() => {
            $(".jelenew-select", $mobileDrawer[0]).removeClass("jelenew-show-options");
          }, 200);
        });

        /// Desktop nav
        var $dropdownContainer = null;
        $nav.on("click", ".navigation__tier-1 > .navigation__item--with-children", function (evt) {
          // $dropdownContainer = $(this);

          if ($("body").hasClass("jelenew-navigation-container-show") && $dropdownContainer && $dropdownContainer[0] == $(this)[0]) {
            closeNavigationDrawer();
          } else {
            // delay on hover-out
            $dropdownContainer = $(this);
            $("body").addClass("jelenew-navigation-container-show");
            $(".jelenew-navigation-container").children().remove();
            $(".jelenew-navigation-container").css("top", $("#pageheader")[0].getBoundingClientRect().top + $("#pageheader").height());
            $dropdownContainer.find(".navigation__tier-2-container").clone().appendTo($(".jelenew-navigation-container"));

            var offsetValue = 40;
            var offsetLeft = $dropdownContainer.parents(".navigation__tier-1").offset().left + offsetValue;
            $(".jelenew-navigation-container")
              .find(".navigation__tier-2-container")
              .find(".navigation__tier-2")
              .css("padding-left", offsetLeft + "px");
            $(window).resize(function () {
              var offsetLeft = $dropdownContainer.parents(".navigation__tier-1").offset().left + offsetValue;
              $(".jelenew-navigation-container")
                .find(".navigation__tier-2-container")
                .find(".navigation__tier-2")
                .css("padding-left", offsetLeft + "px");
            });

            var $openSiblings = $dropdownContainer.siblings(".navigation__item--show-children");
            // close all menus but last opened
            $openSiblings.not($navLastOpenDropdown).removeClass("navigation__item--show-children");
            $navLastOpenDropdown = $dropdownContainer;

            // show after a delay, based on first-open or not
            $dropdownContainer
              .addClass("navigation__item--show-children navigation__item--active")
              .siblings(".navigation__item--show-children")
              .removeClass("navigation__item--show-children navigation__item--active");
          }
        });
        $(".jelenew-navigation-container").on("click", ".PC_nav_close", closeNavigationDrawer);

        function closeNavigationDrawer() {
          $("body").removeClass("jelenew-navigation-container-show");
          $(".jelenew-navigation-container").children().remove();
          $dropdownContainer.removeClass("navigation__item--show-children navigation__item--active");
          $dropdownContainer = null;
        }

        // proxy for desktop nav interaction events
        if (options.proxyTier1Nav) {
          $(options.proxyTier1Nav)
            .on("mouseenter mouseleave", ".navigation__tier-1 > .navigation__item--with-children", function (evt) {
              $($(".navigation__tier-1 > .navigation__item", $nav)[$(this).index()]).trigger(evt.type);
            })
            .on("touchstart touchend click", ".navigation__tier-1 > .navigation__item--with-children > .navigation__link", function (evt) {
              var response = touchHandler.bind(
                $($(".navigation__tier-1 > .navigation__item", $nav)[$(this).parent().index()]).children(".navigation__link")[0]
              )(evt);
              if (response === false) {
                return false;
              }
            })
            .on("keydown", ".navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle", function (evt) {
              if (evt.which == 13) {
                keydownHandler.bind(
                  $($(".navigation__tier-1 > .navigation__item", $nav)[$(this).parent().index()]).children(".navigation__children-toggle")[0]
                )(evt);
                return false;
              }
            });
        }

        $nav.on("click", '.navigation__link[href="#"][aria-haspopup="true"]', function () {
          $(this).siblings(".navigation__children-toggle").trigger("click");
          return false;
        });
      },
      destroy: function destroy($nav, $proxyTier1Nav) {
        $nav.add($proxyTier1Nav).off("click mouseenter mouseleave touchstart touchend keydown");
        theme.ProductBlockManager.unloadImages($(".mobile-navigation-drawer .product-list"));
        $(".mobile-navigation-drawer").off("click").remove();
      },
    };

    // Process product block layout
    theme.ProductBlockManager = new (function () {
      var _ = this;

      _.isDesktop = function () {
        return $(window).width() >= 768;
      };

      _.loadImages = function (container) {
        var container = container;
        if (typeof container === "undefined") {
          container = $("body");
        }

        // lazy bg-set - faster in JS
        theme.loadLazyBGSet(container);

        if (_.isDesktop()) {
          // preload hover images after short delay
          setTimeout(function () {
            $(".product-block__image--show-on-hover.product-block__image--inactivated", container).each(function () {
              _.lazyloadImage($(this));
              lazySizes.loader.unveil($(this).find(".lazyload")[0]);
            });
          }, 250);
          // preload first carousel image after a delay
          setTimeout(function () {
            $(".product-block__image--show-on-hover + .product-block__image--inactivated", container).each(function () {
              _.lazyloadImage($(this));
            });
          }, 1000);
        }

        _.monitorImagePagination(container);
        _.monitorSwatchSelection(container);
        _.afterImagesResized(container);
      };

      _.unloadImages = function (container) {
        $(container).off(".productBlockManager");
      };

      // get image at index, safely wraps index
      _.getImageAt = function ($images, index) {
        // positive modulo, like it should be, JS does not do *maths* correctly
        return $images[((index % $images.length) + $images.length) % $images.length];
      };

      _.lazyloadImage = function ($image, onLoadCB) {
        var _this16 = this;
        var $toLoad = $image.filter(".product-block__image--inactivated");
        if ($toLoad.length) {
          if (onLoadCB) {
            $toLoad.on("lazyloaded.themeBlockManager", function (evt) {
              if (evt.target === $toLoad.find(".lazyloaded")[0]) {
                onLoadCB();
              }
              $(_this16).off("lazyloaded.themeBlockManager");
            });
          }
          $toLoad.removeClass("product-block__image--inactivated");
        } else if (onLoadCB) {
          onLoadCB();
        }
      };

      _.incrementActiveImage = function ($images, increment) {
        var index = Math.max($images.filter(".product-block__image--active:first").index(), 0);
        _.setActiveImage($images, index + increment);
      };

      _.setActiveImage = function ($images, index) {
        var $newActive = $(_.getImageAt($images, index));

        _.lazyloadImage($newActive, function () {
          // set new active image visibility
          $newActive.addClass("product-block__image--active");
          $newActive.siblings().removeClass("product-block__image--active");
          // set new hover image
          var $hoverImage = $(_.getImageAt($images, index + 1)).addClass("product-block__image--show-on-hover");
          $hoverImage.siblings().removeClass("product-block__image--show-on-hover");
          _.lazyloadImage($hoverImage);
        });

        // dots
        var $dots = $images.closest(".image-cont").find(".product-block__image-dot");
        $dots.removeClass("product-block__image-dot--active").eq($newActive.index()).addClass("product-block__image-dot--active");
      };

      _.monitorImagePagination = function (container) {
        if ($(".image-cont--with-secondary-image", container).length) {
          // next/prev button selection
          $(container).on("click.productBlockManager", ".image-page-button", function (evt) {
            var $images = $(this).closest(".product-block").find(".product-block__image");
            _.incrementActiveImage($images, $(evt.currentTarget).hasClass("image-page-button--next") ? 1 : -1);
            // preload the rest
            $images.each(function () {
              _.lazyloadImage($(this));
            });
            return false;
          });

          // swipe (when not in a carousel)
          if ($(".image-cont--with-secondary-image:first", container).closest(".carousel, .product-list--scrollarea").length === 0) {
            // preload all images after swipe
            $(container).on("imageSwiped", ".product-block", function () {
              if ($(".product-block__image--inactivated", this).length) {
                setTimeout(
                  function () {
                    $(this)
                      .find(".product-block__image")
                      .each(function () {
                        _.lazyloadImage($(this));
                      });
                  }.bind(this),
                  500
                );
              }
            });

            $(container).on("touchstart.productBlockManager", ".image-cont--with-secondary-image", function (evt) {
              theme.productBlockTouchTracking = true;
              theme.productBlockTouchStartX = evt.touches[0].clientX;
              theme.productBlockTouchStartY = evt.touches[0].clientY;
              // preload next image on touchstart
              var nextImage = evt.currentTarget.querySelector(".product-block__image--active + .product-block__image--inactivated");
              if (nextImage) {
                _.lazyloadImage($(nextImage));
              }
            });

            $(container).on("touchmove.productBlockManager", ".image-cont--with-secondary-image", function (evt) {
              if (theme.productBlockTouchTracking) {
                if (Math.abs(evt.touches[0].clientY - theme.productBlockTouchStartY) < 30) {
                  var deltaX = evt.touches[0].clientX - theme.productBlockTouchStartX;
                  if (deltaX > 25) {
                    var $images = $(this).closest(".product-block").trigger("imageSwiped").find(".product-block__image");
                    _.incrementActiveImage($images, -1);
                    theme.productBlockTouchTracking = false;
                  } else if (deltaX < -25) {
                    var $images = $(this).closest(".product-block").trigger("imageSwiped").find(".product-block__image");
                    _.incrementActiveImage($images, 1);
                    theme.productBlockTouchTracking = false;
                  }
                }
              }
            });
            $(container).on("touchend.productBlockManager", ".image-cont--with-secondary-image", function (evt) {
              theme.productBlockTouchTracking = false;
            });
          }
        }
      };

      _.monitorSwatchSelection = function (container) {
        if ($("[data-media].product-block-options__item", container).length) {
          $(container).on("mouseenter.productBlockManager click.productBlockManager", "[data-media].product-block-options__item", function () {
            var $images = $(this).closest(".product-block").find(".product-block__image");
            var index = $images.filter('[data-media-id="' + $(this).data("media") + '"].product-block__image').index();
            _.setActiveImage($images, index);
          });
        }
      };

      _.afterImagesResized = function (container) {
        var container = container;
        if (typeof container === "undefined") {
          container = $("body");
        }

        _.alignProductBlockHeights(container);
      };

      _.alignProductBlockHeights = function (container) {
        var container = container;
        if (typeof container === "undefined") {
          container = $("body");
        }

        // All product blocks must be the same height, for quick-buy alignment
        $(".collection-listing .product-list", container).each(function () {
          if ($(window).width() >= 768 || $(this).closest(".carousel").length > 0) {
            var tallest = 0;
            $(this)
              .find(".product-block .block-inner .block-inner-inner")
              .each(function () {
                if ($(this).height() > tallest) tallest = $(this).height();
              });
            $(this).find(".product-block .block-inner").css("min-height", tallest);
          } else {
            $(this).find(".product-block .block-inner").css("min-height", "");
          }
        });
      };
    })();

    // container must be an element higher up the tree than the gallery
    theme.initProductGallery = function (container) {
      var $gallery = $(".gallery", container);

      var $thumbnails = $(".thumbnails", container);
      function loadThumbnails() {
        if ($thumbnails.length && !$thumbnails.find(".selected").length) {
          return setTimeout(loadThumbnails, 500);
        }
        var carouselVisibleItemCount = 6,
          isCarousel = false;

        /// Screen-width based initialisation of thumbnail carousels
        var assessCarousel = function assessCarousel() {
          if ($thumbnails.parent().css("display") == "flex") {
            // thumbnail container is in column beside main image - destroy carousel
            if (isCarousel) {
              isCarousel = false;

              theme.beforeCarouselUnloadEventBlockFix($thumbnails);
              $thumbnails.removeClass("owl-carousel").data("owl.carousel").destroy();
            }
          } else {
            // thumbnails underneath - init carousel
            if (!isCarousel) {
              isCarousel = true;

              // fix for event propagation in nested owl carousels
              theme.beforeCarouselLoadEventBlockFix($thumbnails);

              $thumbnails
                .addClass("owl-carousel")
                .on("initialized.owl.carousel", function () {
                  $(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload");
                })
                .owlCarousel({
                  items: carouselVisibleItemCount,
                  dots: false,
                  margin: 7,
                });
            }
          }
        };

        $(window).on("debouncedresize.productGallery", assessCarousel);
        assessCarousel();
        $(container).data("assessCarouselCallback", assessCarousel);

        $(".gallery__inner", container).on("click select selectFromSlick", ".thumbnails .thumbnail", function (e) {
          e.preventDefault();
          let clickIndex = $(this).index();
          // 判断是否是PC环境
          let isPC = true;
          if ($(".owl-carousel").length) isPC = false;

          if (!isPC) {
            clickIndex = $(this).parent().index();
            // h5适配
            $(this).addClass("selected");
            $(this)
              .parent()
              .siblings()
              .each((i, node) => {
                node.childNodes[0].classList.remove("selected");
              });
          } else {
            $(this).addClass("selected").siblings(".selected").removeClass("selected");
          }
          if (e.type === "selectFromSlick") {
            // if (!isPC) {
            //   // h5适配
            //   $(this).addClass("selected");
            //   $(this)
            //     .parent()
            //     .siblings()
            //     .each((i, node) => {
            //       node.childNodes[0].classList.remove("selected");
            //     });
            // } else {
            //   $(this).addClass("selected").siblings(".selected").removeClass("selected");
            // }
          } else {
            $(this).closest(".gallery").find(".slideshow").slick("slickGoTo", clickIndex);
          }
        });
      }
      // 		loadThumbnails();

      if ($gallery.hasClass("gallery-initialised")) {
        return;
      }

      $gallery.addClass("gallery-initialised");

      /// Init main image slideshow
      function loadSlick() {
        $(".main-image", container).each(function () {
          var $slideshow = $(this)
            .on("init", function (evt, slick) {
              localStorage.setItem("thumbnailIndex", 0);
              $(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload");
            })
            .on("beforeChange", function (evt, slick, current, next) {
              localStorage.setItem("thumbnailIndex", next);
              $($(this).closest(".gallery").find(".thumbnails .thumbnail")[next]).trigger("selectFromSlick");
            });
          //         .slick({
          //         autoplay: false,
          //         fade: true,
          //         infinite: false,
          //         useTransform: true,
          //         dots: false,
          //         arrows: true,
          //         appendArrows: $(this).siblings('.slideshow-controls').find('.slideshow-controls__arrows'),
          //         prevArrow: '<button type="button" class="slick-product-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + '</button>',
          //         nextArrow: '<button type="button" class="slick-product-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + '</button>',
          //         responsive: [
          //         {
          //           breakpoint: 768,
          //           settings: {
          //             fade: false,
          //             arrows: false } }] });

          // media initialisation
          theme.ProductMedia.init($gallery, {
            onPlyrInit: function onPlyrInit(playerObj) {
              theme.productGallerySlideshowTabFix($slideshow.slick("getSlick").$slides, $slideshow.slick("getSlick").currentSlide);
            },
            onYoutubeInit: function onYoutubeInit(playerObj) {
              theme.productGallerySlideshowTabFix($slideshow.slick("getSlick").$slides, $slideshow.slick("getSlick").currentSlide);
            },
            onModelViewerInit: function onModelViewerInit(element) {
              theme.productGallerySlideshowTabFix($slideshow.slick("getSlick").$slides, $slideshow.slick("getSlick").currentSlide);
            },
            onVideoVisible: function onVideoVisible(e) {
              if ($(window).width() >= 768) {
                $(e.target).closest(".slick-slider").slick("slickSetOption", "swipe", false);
              }
            },
            onVideoHidden: function onVideoHidden(e) {
              if ($(window).width() >= 768) {
                $(e.target).closest(".slick-slider").slick("slickSetOption", "swipe", true);
              }
            },
            onPlyrPlay: function onPlyrPlay(e) {
              $(e.target).closest(".slick-slider").slick("slickSetOption", "swipe", false);
            },
            onPlyrPause: function onPlyrPause(e) {
              $(e.target).closest(".slick-slider").slick("slickSetOption", "swipe", true);
            },
            onModelViewerPlay: function onModelViewerPlay(e) {
              // prevent swiping
              $(e.target).closest(".slick-slider").slick("slickSetOption", "swipe", false);
              // prevent left/right key control
              $(e.target).closest(".slick-slider").slick("slickSetOption", "accessibility", false);
            },
            onModelViewerPause: function onModelViewerPause(e) {
              $(e.target).closest(".slick-slider").slick("slickSetOption", "swipe", true);
              $(e.target).closest(".slick-slider").slick("slickSetOption", "accessibility", true);
            },
          });
          // fix tabindex for first slide
          //         theme.productGallerySlideshowTabFix($slideshow.slick('getSlick').$slides, $slideshow.slick('getSlick').currentSlide);

          $slideshow.on("afterChange", function (evt, slick, current) {
            // 神策埋点 ---- luzeqi -- 2022.05.22
            let params = {
              element_name: "主图",
              page_position: "商品详情页",
              position: current,
              product_name: $(".product-form .title-row .title").text(),
              product_id: $(".product-form").data("product-id"),
              original_price: Number(
                $(".price-container .current-price")
                  .text()
                  .trim()
                  .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                  .replace(",", ".")
              ),
            };
            // sensors.track("ClickDetailsElement", params);
            // 神策埋点 ---- luzeqi -- 2022.05.22 -- end

            // notify media of visibility
            $(".product-media--activated").removeClass("product-media--activated").trigger("mediaHidden");
            $(".product-media", slick.$slides[current]).addClass("product-media--activated").trigger("mediaVisible");
            // fix tabbing
            theme.productGallerySlideshowTabFix(slick.$slides, current);
            // resize quickbuy
            $(this).closest(".quickbuy-container").trigger("changedsize");
          });

          // if in quickbuy, trigger resize after slideshow change
          if ($(container).closest(".collection-listing").length > 0) {
            $slideshow.on("afterChange", function () {
              $(this).closest(".quickbuy-container").trigger("changedsize");
            });
          }
        });
      }
      loadSlick();
    };

    theme.destroyProductGallery = function (container) {
      $(window).off(".productGallery");
      var $gallery = $(".gallery", container).off("click select selectFromSlick");
      theme.ProductMedia.destroy($gallery);
      $(".slick-slider", container).slick("unslick").off("init beforeChange afterChange");
      $(".owl-carousel", container).each(function () {
        theme.beforeCarouselUnloadEventBlockFix(this);
        $(this).data("owl.carousel").destroy();
      });
    };

    /* Product Media
     *
     * Load and destroy:
     * theme.ProductMedia.init(galleryContainer, {
     *   onModelViewerPlay: function(e){
     *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', false);
     *   },
     *   onModelViewerPause: function(e){
     *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', true);
     *   },
     *   onPlyrPlay: function(e){
     *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', false);
     *   },
     *   onPlyrPause: function(e){
     *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', true);
     *   },
     * });
     *
     * theme.ProductMedia.destroy(galleryContainer);
     *
     * Trigger mediaVisible and mediaHidden events based on UI
     * $slickSlideshow.on('afterChange', function(evt, slick, current){
     *   $('.product-media--activated').removeClass('product-media--activated').trigger('mediaHidden');
     *   $('.product-media', slick.$slides[current]).addClass('product-media--activated').trigger('mediaVisible');
     * });
     */
    theme.ProductMedia = new (function () {
      var _ = this;

      _._setupShopifyXr = function () {
        if (!window.ShopifyXR) {
          document.addEventListener("shopify_xr_initialized", _._setupShopifyXr.bind(this));
          return;
        }

        window.ShopifyXR.addModels(JSON.parse($(this).html()));
        window.ShopifyXR.setupXRElements();
      };

      this.init = function (container, callbacks) {
        var callbacks = callbacks || {},
          _container = container;

        // set up video media elements with a controller
        $(container)
          .find(".product-media--video")
          .each(function (index) {
            var enableLooping = $(this).data("enable-video-looping"),
              element = $(this).find("iframe, video")[0];
            if (element.tagName === "VIDEO") {
              // set up a controller for Plyr video
              window.Shopify.loadFeatures([
                {
                  name: "video-ui",
                  version: "1.0",
                  onLoad: function () {
                    var playerObj = { playerType: "html5", element: element };

                    playerObj.play = function () {
                      this.plyr.play();
                    }.bind(playerObj);

                    playerObj.pause = function () {
                      this.plyr.pause();
                    }.bind(playerObj);

                    playerObj.destroy = function () {
                      this.plyr.destroy();
                    }.bind(playerObj);

                    playerObj.plyr = new Shopify.Plyr(element, {
                      controls: ["play", "progress", "mute", "volume", "play-large", "fullscreen"],

                      loop: { active: enableLooping },
                      hideControlsOnPause: true,
                      iconUrl: "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                      tooltips: { controls: false, seek: true },
                    });

                    $(this).data("player", playerObj).addClass("product-media--video-loaded");

                    // callbacks for Plyr playback
                    if (callbacks.onPlyrPlay) {
                      $(element).on("playing", callbacks.onPlyrPlay);
                    }
                    if (callbacks.onPlyrPause) {
                      $(element).on("pause ended", callbacks.onPlyrPause);
                    }
                    if (callbacks.onPlyrInit) {
                      callbacks.onPlyrInit(playerObj);
                    }
                  }.bind(this),
                },
              ]);

              theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css");
            } else if (element.tagName === "IFRAME") {
              if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(element.src)) {
                // set up a controller for YouTube video
                var temp = window.onYouTubeIframeAPIReady;
                var loadYoutubeVideo = function () {
                  var playerObj = { playerType: "youtube", element: element };
                  var videoId = $(this).data("video-id");

                  playerObj.player = new YT.Player(element, {
                    videoId: videoId,
                    events: {
                      onStateChange: function onStateChange(event) {
                        if (event.data === YT.PlayerState.ENDED && enableLooping) {
                          event.target.seekTo(0);
                        }
                      },
                    },
                  });

                  playerObj.play = function () {
                    this.player.playVideo();
                  }.bind(playerObj);

                  playerObj.pause = function () {
                    this.player.pauseVideo();
                  }.bind(playerObj);

                  playerObj.destroy = function () {
                    this.player.destroy();
                  }.bind(playerObj);

                  $(this).data("player", playerObj).addClass("product-media--video-loaded");

                  if (callbacks.onYouTubeInit) {
                    callbacks.onYouTubeInit(playerObj);
                  }
                }.bind(this);
                window.onYouTubeIframeAPIReady = function () {
                  temp();
                  loadYoutubeVideo();
                };
                theme.loadScriptOnce("https://www.youtube.com/iframe_api");
              } else if (/vimeo\.com/.test(element.src)) {
                theme.loadScriptOnce("https://player.vimeo.com/api/player.js", function () {
                  if (enableLooping) {
                    element.src = element.src + "&loop=1";
                  }

                  playerObj = {
                    playerType: "vimeo",
                    element: element,
                    player: new Vimeo.Player(element),
                    play: function play() {
                      this.player.play();
                    },
                    pause: function pause() {
                      this.player.pause();
                    },
                    destroy: function destroy() {
                      this.player.destroy();
                    },
                  };

                  $(this).data("player", playerObj).addClass("product-media--video-loaded");
                });
              }
            }
          });

        // when any media appears
        $(container).on("mediaVisible", ".product-media--video-loaded, .product-media--model-loaded", function () {
          // autoplay all media on larger screens
          if ($(window).width() >= 768) {
            $(this).data("player").play();
          }
          // update view-in-space
          if ($(this).hasClass("product-media--model")) {
            $(".view-in-space", _container).attr("data-shopify-model3d-id", $(this).data("model-id"));
          }
        });

        // when any media is hidden
        $(container).on("mediaHidden", ".product-media--video-loaded, .product-media--model-loaded", function () {
          // pause all media
          $(this).data("player").pause();
        });

        // necessary callbacks
        if (callbacks.onVideoVisible) {
          $(container).on("mediaVisible", ".product-media--video-loaded", callbacks.onVideoVisible);
        }

        if (callbacks.onVideoHidden) {
          $(container).on("mediaHidden", ".product-media--video-loaded", callbacks.onVideoHidden);
        }

        $("model-viewer", container).each(function () {
          if (callbacks.onModelViewerPlay) {
            $(this).on("shopify_model_viewer_ui_toggle_play", callbacks.onModelViewerPlay);
          }
          if (callbacks.onModelViewerPause) {
            $(this).on("shopify_model_viewer_ui_toggle_pause", callbacks.onModelViewerPause);
          }
        });

        // set up a 3d model when it first appears
        $(container).on("mediaVisible mediaVisibleInitial", ".product-media--model:not(.product-media--model-loaded)", function (e) {
          var element = $(this).find("model-viewer")[0],
            autoplay = e.type != "mediaVisibleInitial";
          // load viewer
          theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css");
          window.Shopify.loadFeatures([
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: function () {
                $(this).data("player", new Shopify.ModelViewerUI(element));
                // set class and re-trigger visible event now loaded
                $(this).addClass("product-media--model-loaded");
                if (callbacks.onModelViewerInit) {
                  callbacks.onModelViewerInit(element);
                }
                if (autoplay) {
                  $(this).trigger("mediaVisible");
                }
              }.bind(this),
            },
          ]);
        });

        // load AR viewer
        if ($(".model-json", container).length) {
          window.Shopify.loadFeatures([
            {
              name: "shopify-xr",
              version: "1.0",
              onLoad: _._setupShopifyXr.bind($(".model-json", container)),
            },
          ]);
        }

        // pause video when a 3d model is launched in AR
        $(document).on("shopify_xr_launch", function () {
          $(".product-media--video-loaded").each(function () {
            $(this).data("player").pause();
          });
        });

        // 3d model in first place - start in paused mode
        setTimeout(
          function () {
            $(".product-media:first", this).filter(".product-media--model").trigger("mediaVisibleInitial");
          }.bind(container),
          50
        );
      };

      this.destroy = function (container) {
        $(document).off("shopify_xr_launch");
        $(container).off("mediaVisible mediaVisibleInitial mediaHidden");
        $(".product-media--video-loaded, .product-media--model-loaded", container).each(function () {
          $(this).data("player").destroy();
        });
        $(".product-media--video video", container).off("playing pause ended");
        $("model-viewer", container).off("shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause");
      };
    })();

    theme.productGallerySlideshowTabFix = function (slides, current) {
      // tabindex everything to prevent tabbing into hidden slides
      $(slides[current])
        .find("a, input, button, select, iframe, video, model-viewer, [tabindex]")
        .each(function () {
          if (typeof $(this).data("theme-slideshow-original-tabindex") !== "undefined") {
            if ($(this).data("theme-slideshow-original-tabindex") === false) {
              $(this).removeAttr("tabindex");
            } else {
              $(this).attr("tabindex", $(this).data("theme-slideshow-original-tabindex"));
            }
          } else {
            $(this).removeAttr("tabindex");
          }
        });
      $(slides)
        .not(slides[current])
        .find("a, input, button, select, iframe, video, model-viewer, [tabindex]")
        .each(function () {
          if (typeof $(this).data("theme-slideshow-original-tabindex") === "undefined") {
            $(this).data("theme-slideshow-original-tabindex", typeof $(this).attr("tabindex") !== "undefined" ? $(this).attr("tabindex") : false);

            $(this).attr("tabindex", "-1");
          }
        });
    };

    // Manage option dropdowns
    theme.productData = {};
    theme.OptionManager = new (function () {
      var _ = this;

      _._getVariantOptionElement = function (variant, $container) {
        return $container.find('select[name="id"] option[value="' + variant.id + '"]');
      };

      _.selectors = {
        container: ".product-detail",
        gallery: ".gallery",
        priceArea: ".price-area",
        variantIdInputs: '[name="id"]',
        submitButton: 'input[type="submit"], button[type="submit"]',
        multiOption: ".option-selectors",
        installmentsFormSuffix: "-installments",
      };

      _.strings = {
        priceNonExistent: theme.strings.products_variant_non_existent,
        buttonDefault: theme.strings.products_product_add_to_cart,
        buttonNoStock: theme.strings.products_variant_no_stock,
        buttonNoVariant: theme.strings.products_variant_non_existent,
        unitPriceSeparator: theme.strings.products_product_unit_price_separator,
      };

      _._getString = function (key, variant) {
        var string = _.strings[key];
        if (variant) {
          string = string.replace(
            "[PRICE]",
            '<span class="theme-money">' + theme.Shopify.formatMoney(variant.price, theme.money_format_with_cart_code_preference) + "</span>"
          );
        }
        return string;
      };

      _.getProductData = function ($form) {
        var productId = $form.data("product-id");
        var data = null;
        if (!theme.productData[productId]) {
          theme.productData[productId] = JSON.parse(document.getElementById("ProductJson-" + productId).innerHTML);
        }
        data = theme.productData[productId];
        if (!data) {
          console.log("Product data missing (id: " + $form.data("product-id") + ")");
        }
        return data;
      };

      (_.getBaseUnit = function (variant) {
        return variant.unit_price_measurement.reference_value === 1
          ? variant.unit_price_measurement.reference_unit
          : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
      }),
        (_.addVariantUrlToHistory = function (variant) {
          if (variant) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
            window.history.replaceState({ path: newurl }, "", newurl);
          }
        });

      _.updateSku = function (variant, $container) {
        $container.find(".sku .sku__value").html(variant ? variant.sku : "");
        $container.find(".sku").toggleClass("sku--no-sku", !variant || !variant.sku);
      };

      _.updateTitle = function ($container) {
        var custom_variant = $container.find(".jelenew-custom-variant-style");
        custom_variant.find("input").each(function (index, item) {
          if ($(item).is(":checked")) {
            var next_element = $(item).next();
            var sku_title = next_element.text().trim();
            var product_sku_title = next_element.data("product-sku-title");
            $container.find(".title").html(product_sku_title[sku_title]);
          }
        });
      };

      _.updateSkuDetail = function (variant, $container) {
        $container.find(".sku-detail").map(function (index, item) {
          $(item).text(variant["option" + (index + 1)].split("-")[0]);
        });
      };

      _.updateBarcode = function (variant, $container) {
        $container.find(".barcode .barcode__value").html(variant ? variant.barcode : "");
        $container.find(".barcode").toggleClass("barcode--no-barcode", !variant || !variant.barcode);
      };

      _.updateTransferNotice = function (variant, $container) {
        var transferData = _._getVariantOptionElement(variant, $container).data("inventory-transfer");
        if (transferData) {
          $container.find(".product-inventory-transfer").removeClass("product-inventory-transfer--none").html(transferData);
        } else {
          $container.find(".product-inventory-transfer").addClass("product-inventory-transfer--none").empty();
        }
      };

      _.updateVariantDeterminedVisibilityAreas = function (variant, $container) {
        $container.find(".variant-visibility-area").each(function () {
          $(this).children(":not(script)").remove();
          $(this).append(
            $(this)
              .children('script[data-variant-id="' + variant.id + '"]')
              .html()
          );
        });
      };

      _.updateBackorder = function (variant, $container) {
        var $backorder = $container.find(".backorder");
        if ($backorder.length) {
          if (variant && variant.available) {
            if (variant.inventory_management && _._getVariantOptionElement(variant, $container).data("stock") == "out") {
              var productData = _.getProductData($backorder.closest(".product-form"));
              $backorder.find(".backorder__variant").html(productData.title + (variant.title.indexOf("Default") >= 0 ? "" : " - " + variant.title));
              $backorder.show();
            } else {
              $backorder.hide();
            }
          } else {
            $backorder.hide();
          }
        }
      };

      _.updatePrice = function (variant, $container) {
        var $priceArea = $container.find(_.selectors.priceArea);
        $priceArea.removeClass("on-sale");

        if (variant) {
          var $newPriceArea = $("<div>");
          var $price = $('<div class="price h4-style">').appendTo($newPriceArea);
          $('<span class="current-price theme-money">')
            .html(theme.Shopify.formatMoney(variant.price, theme.money_format_with_cart_code_preference))
            .appendTo($price);
          if (variant.compare_at_price > variant.price) {
            $price.append(" ");
            $('<span class="was-price theme-money">')
              .html(theme.Shopify.formatMoney(variant.compare_at_price, theme.money_format_with_cart_code_preference))
              .appendTo($price);
            var discount = (variant.compare_at_price - variant.price) / variant.compare_at_price;
            discount = discount.toFixed(2) * 100;
            $price.append(" ");
            $('<span class="discount-ratio">')
              .html("-" + parseInt(discount) + "%")
              .appendTo($price);
            $price.addClass("on-sale");
          }
          if (variant.unit_price_measurement) {
            var $newUnitPriceArea = $('<div class="unit-price">').appendTo($newPriceArea);
            $('<span class="unit-price__price theme-money">')
              .html(theme.Shopify.formatMoney(variant.unit_price, theme.money_format_with_cart_code_preference))
              .appendTo($newUnitPriceArea);
            $('<span class="unit-price__separator">').html(_._getString("unitPriceSeparator")).appendTo($newUnitPriceArea);
            $('<span class="unit-price__unit">').html(_.getBaseUnit(variant)).appendTo($newUnitPriceArea);
          }
          $priceArea.html($newPriceArea.html());
        } else {
          $priceArea.html(_._getString("priceNonExistent", variant));
        }
      };

      _._updateButtonText = function ($button, string, variant) {
        $button.each(function () {
          var newVal;
          newVal = _._getString("button" + string, variant);
          if (newVal !== false) {
            if ($(this).is("input")) {
              $(this).val(newVal);
            } else {
              $(this).html(newVal);
            }
          }
        });
      };

      _.updateButtons = function (variant, $container) {
        var $button = $container.find(_.selectors.submitButton);

        if (variant && variant.available == true) {
          $button.removeAttr("disabled");
          _._updateButtonText($button, "Default", variant);
        } else {
          $button.attr("disabled", "disabled");
          if (variant) {
            _._updateButtonText($button, "NoStock", variant);
          } else {
            _._updateButtonText($button, "NoVariant", variant);
          }
        }
      };

      _.updateContainerStatusClasses = function (variant, $container) {
        $container.toggleClass("variant-status--unavailable", variant && !variant.available);
        $container.toggleClass(
          "variant-status--backorder",
          variant && variant.available && variant.inventory_management && _._getVariantOptionElement(variant, $container).data("stock") == "out"
        );
        $container.toggleClass("variant-status--on-sale", variant && variant.available && variant.compare_at_price > variant.price);
      };

      _.initProductOptions = function ($productForm) {
        if ($productForm.hasClass("theme-init")) return;

        var productData = _.getProductData($productForm);
        $productForm.addClass("theme-init");

        // init option selectors
        $productForm.find(_.selectors.multiOption).on("change.themeProductOptions", function () {
          var selectedOptions = [];
          $(this)
            .find(".option-selector")
            .each(function () {
              if ($(this).data("selector-type") === "listed") {
                selectedOptions.push($(this).find(".js-option:checked").val());
              } else {
                selectedOptions.push($(this).find('.js-option[aria-selected="true"]').data("value"));
              }
            });
          // find variant
          var variant = false;
          for (var i = 0; i < productData.variants.length; i++) {
            var v = productData.variants[i];
            var matchCount = 0;
            for (var j = 0; j < selectedOptions.length; j++) {
              if (v.options[j] == selectedOptions[j]) {
                matchCount++;
              }
            }
            if (matchCount == selectedOptions.length) {
              variant = v;
              break;
            }
          }
          // trigger change
          if (variant) {
            $productForm.find(_.selectors.variantIdInputs).val(variant.id);
          }
          // a jQuery event may not be picked up by all listeners
          $productForm.find(_.selectors.variantIdInputs).each(function () {
            this.dispatchEvent(
              new CustomEvent("change", {
                bubbles: true,
                cancelable: false,
                detail: variant,
              })
            );
          });
        });

        // init variant ids
        $productForm.find(_.selectors.variantIdInputs).each(function () {
          // change state for original dropdown
          $(this).on("change.themeProductOptions firstrun.themeProductOptions", function (e) {
            if ($(this).is("input[type=radio]:not(:checked)")) {
              return; // handle radios - only update for checked
            }
            var variant = e.detail;
            if (!variant && variant !== false) {
              for (var i = 0; i < productData.variants.length; i++) {
                if (productData.variants[i].id == $(this).val()) {
                  variant = productData.variants[i];
                }
              }
            }
            var $container = $(this).closest(_.selectors.container);

            // string overrides
            var $addToCart = $container.find(_.selectors.submitButton).filter("[data-add-to-cart-text]");
            if ($addToCart.length) {
              _.strings.buttonDefault = $addToCart.data("add-to-cart-text");
            }

            // update price
            _.updatePrice(variant, $container);

            // update buttons
            _.updateButtons(variant, $container);

            // emit an event to broadcast the variant update
            $(window).trigger("cc-variant-updated", {
              variant: variant,
              product: productData,
            });

            // variant images
            if (variant && variant.featured_media) {
              $container.find(_.selectors.gallery).trigger("variantImageSelected", variant);
            }

            // extra details
            _.updateTitle($container);
            _.updateBarcode(variant, $container);
            _.updateSku(variant, $container);
            _.updateSkuDetail(variant, $container);
            _.updateTransferNotice(variant, $container);
            _.updateVariantDeterminedVisibilityAreas(variant, $container);
            _.updateBackorder(variant, $container);
            _.updateContainerStatusClasses(variant, $container);

            // variant urls
            if ($productForm.data("enable-history-state") && e.type == "change") {
              _.addVariantUrlToHistory(variant);
            }

            // allow other things to hook on
            $productForm.trigger("variantChanged", variant);
          });

          // first-run
          $(this).trigger("firstrun");
        });

        //           	$('.jelenew-product-sku-color').on("change.themeProductOptions", function () {
        // 				var selectedSkuColor = $(this).find(".js-option:checked").val();
        //               	// find variant
        // 				var variant = false;
        //               	var selectedvariant;
        // 				for (var i = 0; i < productData.variants.length; i++) {
        // 					var v = productData.variants[i];
        //                     if(v.option1 == theme.selected_variant.option1 && v.options.indexOf(selectedSkuColor) != -1){
        // 						theme.selected_variant = selectedvariant = v;
        //                     }
        // 				}

        //               	$('.jelenew-shop-now-sku-popup').find('.option-selector-1').find('input').each(function(){
        //                 	var sku = $(this).next().text().trim();
        //                   	$(this).prop('checked', false)
        //                     if(theme.selected_variant.title.indexOf(sku) != -1){
        // 						$(this).prop('checked', true);
        //                     }
        //                 })

        //               	// trigger change
        // 				if (selectedvariant) {
        // 					$productForm.find(_.selectors.variantIdInputs).val(selectedvariant.id);
        // 				}
        // 				// a jQuery event may not be picked up by all listeners
        // 				$productForm.find(_.selectors.variantIdInputs).each(function () {
        // 					this.dispatchEvent(new CustomEvent("change", { bubbles: true, cancelable: false, detail: selectedvariant }));
        // 				});
        // 			});

        // ajax
        theme.applyAjaxToProductForm($productForm);
      };

      _.unloadProductOptions = function ($productForm) {
        $productForm.removeClass("theme-init").each(function () {
          $(this).trigger("unloading").off(".themeProductOptions");
          $(this).find(_.selectors.multiOption).off(".themeProductOptions");
          theme.removeAjaxFromProductForm($productForm);
        });
      };
    })();

    theme.loadQuickbuy = function () {
      // utility function for quickbuy (closes all quickbuys in passed blocks, in a collection grid)
      function contractDetail($blocks, speed) {
        if ($blocks.length > 0) {
          $blocks.removeClass("expanded");
          $blocks
            .find(".quickbuy-container")
            .stop()
            .animate({ height: 0 }, speed, function () {
              $(this).find(".inner").empty();
            });
          $blocks.stop().each(function () {
            $(this).animate({ paddingBottom: 0 }, speed);
          });
        }
      }

      // handle components
      function loadComponents(componentContainer) {
        $(componentContainer)
          .closest("[data-components]")
          .each(function () {
            $(this)
              .data("components")
              .split(",")
              .forEach(function (component) {
                $(document).trigger("cc:component:load", [component, componentContainer]);
              });
          });
        $(componentContainer)
          .find(".cc-accordion")
          .on("transitionend.qbLoadComponents", function () {
            $(this).closest(".quickbuy-container").trigger("changedsize");
          });

        $(document).trigger("cc:component:load", ["custom-select", ".quickbuy-container"]);
      }

      function unloadComponents(componentContainer) {
        $(componentContainer).find(".cc-accordion").off(".qbLoadComponents");
        $(componentContainer)
          .closest("[data-components]")
          .each(function () {
            $(this)
              .data("components")
              .split(",")
              .forEach(function (component) {
                $(document).trigger("cc:component:unload", [component, componentContainer]);
              });
          });
      }

      // quick buy - managing slide-down quickbuy in both grids and carousels
      var droppyDownAnimSpeed = 500;
      $(document).on("click", ".product-list .product-block:not(.collection-block):not(.main-search-result) .quickbuy-toggle", function () {
        var pageWidth = $(window).width(),
          productUrl = $(this).attr("href");

        //Only show dropdown if screen is large enough for it to be useful
        if (pageWidth > 767) {
          // cancel current request if one exists
          if (theme.currentQuickbuyRequest) {
            theme.currentQuickbuyRequest.abort();
          }

          var $block = $(this).closest(".product-block"),
            $detailCont = null;
          // $quickbuyCont = null,
          // $slider = $(this).closest(".collection-slider"),
          // $sliderRow = null;

          // do different things if it's inside a slideshow
          // if ($slider.length > 0) {
          //   $sliderRow = $slider.closest(".collection-slider-row");
          //   // slider without detail
          //   if ($sliderRow.find(".quickbuy-container").length === 0) {
          //     return;
          //   }
          //   $quickbuyCont = $sliderRow.find(".quickbuy-container");
          // } else {
          //   $quickbuyCont = $block.find(".quickbuy-container");
          // }
          // $detailCont = $quickbuyCont.find(".inner");

          // toggle active class on block
          if ($block.toggleClass("expanded").hasClass("expanded")) {
            // expanding
            if ($slider.length > 0) {
              // if another block is expanded, remove its expanded class
              var noneExpanded = $slider.find(".product-block.expanded").not($block).removeClass("expanded").length === 0;

              // if expanding from empty, set initial detail container height to 0
              if (noneExpanded) {
                $quickbuyCont.height(0);
              } else {
                // unload existing quickbuy
                theme.OptionManager.unloadProductOptions($('[name="id"].original-selector', $quickbuyCont));
                $(".gallery", $quickbuyCont).off(this.namespace);
                $(".slideshow", $quickbuyCont).slick("unslick");
                // unload components
                unloadComponents($quickbuyCont);
              }

              // what to adjust when details change size
              $quickbuyCont.off("changedsize").on("changedsize", function () {
                $quickbuyCont.stop().animate(
                  {
                    // height: $detailCont.outerHeight(),
                  },
                  droppyDownAnimSpeed
                );
              });
            } else {
              // close expanded siblings
              var $expandedSiblings = $block.siblings(".expanded");

              $expandedSiblings.each(function () {
                contractDetail($(this), 0);

                // unload existing quickbuy
                theme.OptionManager.unloadProductOptions($('[name="id"].original-selector', this));
                theme.destroyProductGallery(this);
                // unload components
                unloadComponents(this);
              });

              // what do adjust when details change size
              $quickbuyCont.off("changedsize").on("changedsize", function () {
                // check expanded class in case it's mid close transition
                if ($block.hasClass("expanded")) {
                  var targetHeight = 0;
                  // slide down instantly if a neighbour is expanded
                  var speed = $expandedSiblings.length > 0 ? 0 : droppyDownAnimSpeed;
                  $block.stop().animate(
                    {
                      paddingBottom: targetHeight + 20,
                    },
                    speed
                  ); // extra for gap underneath
                  $quickbuyCont.stop().animate({ height: targetHeight }, speed);
                }
              });
            }

            // add spinner
            // $detailCont.html('<div class="loading-spinner"></div>');
            $quickbuyCont.trigger("changedsize");

            // load in content
            var url = $(this).attr("href");
            theme.currentQuickbuyRequest = $.get(url, function (response) {
              var $newDetail = $("<div>" + response + "</div>").find(".quickbuy-content");

              // convert to quickbuy content
              $newDetail.find(".more").attr("href", productUrl);
              $newDetail.find(".detail .title").wrapInner($("<a>").attr("href", productUrl));
              $newDetail.find(".show-gallery").removeClass("show-gallery").attr("href", productUrl);
              $newDetail.find(".not-in-quickbuy").remove();
              $newDetail.find(".only-in-quickbuy").removeClass("only-in-quickbuy");
              $newDetail.find(".sticky-content-container").removeClass("sticky-content-container");
              $newDetail.find(".store-availability-container").remove();
              $newDetail.find('[data-enable-history-state="true"]').attr("data-enable-history-state", "false");

              // resize after images load, if present
              $newDetail.find(".rte img").on("load", function () {
                $quickbuyCont.trigger("changedsize");
                $(this).off("load");
              });

              // $detailCont.html($newDetail);
              // dpb if present
              if (Shopify.PaymentButton && $quickbuyCont.find(".shopify-payment-button").length) {
                // resize after loading extra payment buttons
                var _f = null;
                _f = function f() {
                  document.removeEventListener("shopify:payment_button:loaded", _f);
                  $quickbuyCont.trigger("changedsize");
                };
                document.addEventListener("shopify:payment_button:loaded", _f);

                Shopify.PaymentButton.init();
              }
              // the order of these is important:
              theme.initProductGallery($quickbuyCont); // 1
              $quickbuyCont
                .find(".product-form")
                .trigger("load-product-form") // 2
                .on("variantChanged", function () {
                  $quickbuyCont.trigger("changedsize"); // (5)
                });
              loadComponents($quickbuyCont); // 3
              theme.initAnimateOnScroll(); // 4
              $quickbuyCont.trigger("changedsize"); // 5
            }).always(function () {
              theme.currentQuickbuyRequest = false;
            });

            // enable close button
            $quickbuyCont.find(".close-detail").removeAttr("tabindex");

            // scroll to appropriate position
            // qb: top of quick buy
            // bl: top of product block
            var scrollMode = "qb";
            var scrollOffset = -120;

            if ($(".section-header").css("position") == "sticky") {
              scrollOffset -= $(".section-header").height();
            }

            if (scrollMode == "qb") {
              $("html:not(:animated),body:not(:animated)").animate({ scrollTop: $quickbuyCont.offset().top + scrollOffset }, 500);
            } else {
              if ($slider.length > 0) {
                // simple for slider
                $("html:not(:animated),body:not(:animated)").animate({ scrollTop: $block.offset().top }, 500);
              } else {
                // need to use top of block when no quickbuys are visible
                saveCollectionPageData();
                var offsetTop = typeof $block.data("offsetTop") != "undefined" ? $block.data("offsetTop") : $block.offset().top;
                $("html:not(:animated),body:not(:animated)").animate({ scrollTop: offsetTop + scrollOffset }, 500);
              }
            }
          } else {
            // close
            unloadComponents($quickbuyCont);
            if ($slider.length > 0) {
              // collapse detail container
              $quickbuyCont.stop().animate({ height: 0 }, droppyDownAnimSpeed, function () {
                // remove details
                // $detailCont.empty();
              });
            } else {
              contractDetail($block, droppyDownAnimSpeed);
            }

            // scroll to top of closing block
            var scrollUpOffset = -140;
            $("html:not(:animated),body:not(:animated)").animate({ scrollTop: $block.offset().top + scrollUpOffset }, 500);

            // disable close button
            $quickbuyCont.find(".close-detail").attr("tabindex", "-1");
          }

          return false;
        }
      });

      //Close button event
      // $(document).on("click", ".quickbuy-container .close-detail", function () {
      //   var $slider = $(this).closest(".collection-slider-row");
      //   if ($slider.length) {
      //     $slider.find(".product-block.expanded .quickbuy-toggle:first").trigger("click");
      //   } else {
      //     $(this).closest(".product-block").find(".quickbuy-toggle:first").trigger("click");
      //   }
      //   return false;
      // });

      //You also need to know where to scroll to
      function saveCollectionPageData() {
        $(".collection-listing").each(function () {
          var $blocks = $(this).find(".product-block");
          if ($blocks.length <= 1) return true; // Skip for empty colls
          var row = 0;
          var currTop = 0;
          //Heights are fixed. Check two in case somebody has expanded one...
          var blockHeight = Math.min($blocks.first().outerHeight(), $($blocks[1]).outerHeight());
          var blockPageOffset = $blocks.first().offset().top;
          $blocks.each(function (index) {
            var currOffsetTop = $(this).offset().top;
            if (index == 0) {
              currTop = currOffsetTop;
            } else {
              if (currOffsetTop > currTop) {
                row++;
                currTop = currOffsetTop;
              }
            }
            $(this).data({
              offsetTop: blockPageOffset + row * blockHeight,
            });
          });
        });
      }
    };

    $(function () {
      $(document).on("click", ".sharing a", function (e) {
        var $parent = $(this).parent();
        if ($parent.hasClass("twitter")) {
          e.preventDefault();
          var url = $(this).attr("href");
          var width = 575,
            height = 450,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0" +
              ",width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Twitter", opts);
        } else if ($parent.hasClass("facebook")) {
          e.preventDefault();
          var url = $(this).attr("href");
          var width = 626,
            height = 256,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0" +
              ",width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Facebook", opts);
        } else if ($parent.hasClass("pinterest")) {
          e.preventDefault();
          var url = $(this).attr("href");
          var width = 700,
            height = 550,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0" +
              ",width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Pinterest", opts);
        } else if ($parent.hasClass("google")) {
          e.preventDefault();
          var url = $(this).attr("href");
          var width = 550,
            height = 450,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0" +
              ",width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Google+", opts);
        }
      });
    });

    /*================ Sections ================*/
    theme.AnnouncementBarSection = new (function () {
      this.onSectionLoad = function (container) {
        $(".disclosure", container).each(function () {
          $(this).data("disclosure", new theme.Disclosure($(this)));
        });
        $(".announcement-bar__inner_wrap", container).slick({
          vertical: true,
          autoplay: true,
          draggable: false,
          infinite: true,
          autoplaySpeed: 3000,
          accessibility: false,
        });
      };

      this.onSectionUnload = function (container) {
        $(".disclosure", container).each(function () {
          $(this).data("disclosure").unload();
        });
      };
    })();

    theme.BlogTemplateSection = new (function () {
      this.onSectionLoad = function (container) {
        this.namespace = theme.namespaceFromSection(container);
        this.$container = $(container);

        // filter dropdown
        this.$container.on("click" + this.namespace, ".link-dropdown__button", theme.toggleLinkDropdownButton.bind(this));

        // click anywhere else in page to close
        $(document).on("click" + this.namespace, function () {
          $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
        });
      };

      this.onSectionUnload = function (container) {
        this.$container.off(this.namespace);
        $(document).off(this.namespace);
      };
    })();

    theme.CartTemplateSection = new (function () {
      this.onSectionLoad = function (container) {
        this.$container = $(container);
        var _this = this;
        // listen to cart changes
        window.cartChangedEvent = function (options = {}) {
          return $.Event("theme:cartchanged.cartTemplateSection", Object.assign({ bubbles: true, cancelable: false }, options));
          // return new CustomEvent("theme:cartchanged", Object.assign({ bubbles: true, cancelable: false }, options));
        };
        $(document).on("theme:cartchanged.cartTemplateSection", this.functions.refreshCartDependentContent.bind(this));
        window.cartRecommendUpdateEvent = function (options = {}) {
          return $.Event("theme:cartrecomendupdate.cartTemplateSection", Object.assign({ bubbles: true, cancelable: false }, options));
          // return new CustomEvent("theme:cartchanged", Object.assign({ bubbles: true, cancelable: false }, options));
        };
        $(document).on("theme:cartrecomendupdate.cartTemplateSection", this.functions.getCartRecommendList.bind(this));
        // terms and conditions checkbox
        if ($("#cartform input#terms", container).length > 0) {
          $(document).on(
            "click.cartTemplateSection",
            '#cartform [name="checkout"], .additional-checkout-buttons input, a[href*="/checkout"]',
            function () {
              if ($("#cartform input#terms:checked").length == 0) {
                alert(theme.strings.cart_terms_confirmation);
                return false;
              }
            }
          );
        }

        if ($(container).data("ajax-update")) {
          var _timer = null,
            _timer2 = null;
          $(container).on(
            "keyup.cartTemplateSection change.cartTemplateSection changeFromButton.cartTemplateSection",
            ".cart-item__quantity-input",
            function (evt) {
              if (this.replacingContent) {
                return;
              }
              if ($(evt.currentTarget).data("initial-value") && $(evt.currentTarget).data("initial-value") == $(evt.currentTarget).val()) {
                return;
              }
              if ($(evt.currentTarget).val().length == 0 || $(evt.currentTarget).val() == "0") {
                return;
              }
              const $quantity = $(evt.currentTarget).parent();
              $quantity.find(".notabutton").addClass("unusable");
              $quantity.find(".cart-item__quantity-input").before($("<div class='lazyload--placeholder'></div>"));
              $quantity.addClass("loading");
              // focus on -/+ button or input, depending on source of event
              var toFocusId;
              // if (evt.type === "changeFromButton") {
              //   toFocusId = $(evt.data).attr("id");
              //   // 判断是否是在购物车页面
              //   // 购物车浮层加减按钮逻辑
              //   return this.functions.updateCart.call(
              //     this,
              //     {
              //       id: $(evt.currentTarget).closest(".cart-item").data("line-item-key"),
              //       quantity: $(evt.currentTarget).val(),
              //     },
              //     function (res) {}
              //   );
              // } else {
              //   toFocusId = $(evt.currentTarget).attr("id");
              // }
              this.functions.updateCart.call(
                this,
                {
                  id: $(evt.currentTarget).closest(".cart-item").data("line-item-key"),
                  quantity: $(evt.currentTarget).val(),
                },
                evt.type === "changeFromButton"
                  ? function () {}
                  : function () {
                      // after update, set focus
                      $("#" + toFocusId).focus();
                    }
              );
            }.bind(this)
          );

          $(container).on("click.cartTemplateSection", ".quantity-down, .quantity-up", function (evt) {
            var $input = $(this).closest(".quantity").find("input"),
              step = $input.attr("step") ? parseInt($input.attr("step")) : 1;

            const lastClassName = "." + $input[0].classList[$input[0].classList.length - 1];

            // ----------- 原有逻辑 ------------------
            if ($(this).hasClass("quantity-down")) {
              $input.val(parseInt($input.val()) - step).trigger("changeFromButton", { data: this });
            } else {
              $input.val(parseInt($input.val()) + step).trigger("changeFromButton", { data: this });
            }
            // if (!$input.hasClass("num")) {
            // 	$(lastClassName).each(function () {
            // 		$(this).val($input.val());
            // 	});
            // }
            return false;
          });
        }

        theme.cartNoteMonitor.load('.checkout-note [name="note"]');

        // $(container).on("click.cartTemplateSection", "button[data-toggle-shipping]", function () {
        //   $("#shipping-calculator").toggle();
        //   var alt = $(this).data("toggle-html");
        //   $(this).data("toggle-html", $(this).html());
        //   $(this).html(alt);
        //   return false;
        // });
        // 折扣码点击自动应用
        $(container).on("click", ".cd-cart-announcement .code-announcement", function () {
          // jelenew?.functions?.copyText($(this).text().trim());
          sensors.track("ClickCartElement", {
            page_position: $("body").data("page-type") === "cart" ? "购物车" : "购物车弹层页",
            ep_module: "可用折扣提醒",
          });
          $("#checkout_reduction_code", container).val($(".code", this).text().trim());
          $(".order-summary__section--discount #checkout_submit", container).trigger("click");
        });
        // 购物车展开收起项模块
        $(container).on("click", ".collapse-container", function () {
          if (!$(this).hasClass("show-collapse")) {
            $(this).addClass("show-collapse");
            let module_name = "";
            if ($(this).find(".gift-container").length > 0) {
              module_name = "礼物CODE";
            }
            if ($(this).find(".checkout-note").length > 0) {
              module_name = "NOTE";
            }
            sensors.track("ClickDrawer", {
              page_position: $("body").data("page-type") == "cart" ? "购物车页" : "购物车弹层页",
              module_name,
              product_number: $(".cart-link__count_inner").eq(0).text() * 1,
              original_price: theme.jelenew_money_to_number($(".checkout-subtotal-container__right .total .theme-money").text()),
              choose_type: "展开",
            });
          }
          return false;
        });
        // 打开折扣码列表弹层
        $(container).on("click", ".collapse-container .more-discount-btn", function (e) {
          theme.jelenewCartDiscountListPopup.functions.openPopup();
          return false;
        });
        // 不存在邮箱时隐藏折扣码列表
        if (!$("body").data("customer_email")) {
          $(".collapse-container .more-discount-btn", container).hide();
        }
        $(container).on("click", ".collapse-container .collapse-handler", function () {
          if ($(this).closest(".collapse-container").hasClass("show-collapse")) {
            $(this).closest(".collapse-container").removeClass("show-collapse");
            let module_name = "";
            if ($(this).closest(".collapse-container").find(".gift-container").length > 0) {
              module_name = "礼物CODE";
            }
            if ($(this).closest(".collapse-container").find(".checkout-note").length > 0) {
              module_name = "NOTE";
            }
            sensors.track("ClickDrawer", {
              page_position: $("body").data("page-type") == "cart" ? "购物车页" : "购物车弹层页",
              module_name,
              product_number: $(".cart-link__count_inner").eq(0).text() * 1,
              original_price: theme.jelenew_money_to_number($(".checkout-subtotal-container__right .total .theme-money").text()),
              choose_type: "折叠",
            });
            return false;
          }
        });

        /* 折扣码 */
        const auto_add_gift = $(container).data("auto_add_gift");

        // input框回车触发接口调用，点击埋点
        $(container).on(
          "keyup click",
          ".discount-container #checkout_reduction_code",
          theme.debounce(function (e) {
            if (e.keyCode == 13 && e.type == "keyup") {
              e.stopPropagation();
              e.preventDefault();
              // $(this).closest(".discount-container").find("#checkout_submit").trigger("click");
              return false;
            }
            if (e.type == "click") {
              sensors.track("ClickInput", {
                page_position: $("body").data("page-type") == "cart" ? "购物车页" : "购物车弹层页",
                product_number: $(".cart-link__count_inner").eq(0).text() * 1,
                original_price: theme.jelenew_money_to_number($(".checkout-subtotal-container__right .total .theme-money").text()),
                input_type: "优惠券CODE输入框",
              });
            }
          }, 500)
        );
        // 折扣码APPLY按钮触发
        $(container).on("click", ".discount-container .field__message--error a", function () {
          const href = $(this).attr("href");
          window.location.href = $("html").data("root_url") == "/" ? href : $("html").data("root_url") + href;
        });

        // 折扣码APPLY按钮触发
        $(container).on("click", ".discount-container #checkout_submit", async function (e) {
          // click 应用
          e.stopPropagation();
          e.preventDefault();
          const $btn = $(this);
          const code_val = $(".discount-container #checkout_reduction_code").val().trim().toUpperCase();
          if (code_val === "") {
            return false;
          }
          $(this).addClass("btn--loading");
          // 正常商品为零时，返回提示文案
          if ($(".cart-item-list__body>.cart-item:not(.is_gift_card)").length === 0) {
            $btn.removeClass("btn--loading");
            return theme.JelenewTips(`${code_val} discount code isn't valid for the items in your cart`);
          }
          // 自动加车函数
          await _this.functions.checkAutoAddGift.call(_this, code_val);

          _this.functions.discountCodeFeature.apply(_this, [code_val]).finally(() => {
            // $btn.removeClass("btn--loading");
            // $(".discount-container #checkout_reduction_code").val("");
          });
          return false;
        });
        // 删除折扣码
        $(container).on("click", ".tag__button", function (e) {
          e.stopPropagation();
          e.preventDefault();
          $(this).closest(".discount-detail").addClass("tag-loading");
          $(this).closest(".tag").addClass("tag-loading");
          $(".discount-container #checkout_submit").addClass("btn--loading");
          // 删除折扣码自动应用列表的选中态
          $(".jelenew-cart-discount-list-popup-list .jelenew-cart-discount-list-popup-check-box.active").removeClass("active");
          // 删除折扣码时，进行标记。 让折扣码自动应用函数读取标记后跳过执行
          localStorage.setItem("jelenew_auto_use_discount_type", "remove");
          sessionStorage.setItem("remove_discount_code", $(".discount-detail-code .code").text().trim().toUpperCase());
          _this.functions.discountCodeFeature.apply(_this).finally(() => {
            $(".discount-container #checkout_submit").removeClass("btn--loading");
          });
          return false;
        });
        // 删除报错信息
        $(container).on("click", ".notice__controls", function (e) {
          $(this).closest("form").css("display", "none");
          e.stopPropagation();
          e.preventDefault();
          return false;
        });

        // 政策曝光埋点
        $(container).on("click", ".cart-tips-item", function () {
          // sensors.track("ClickDetailsElement", {
          //   page_position: $("body").data("page-type") == "cart" ? "购物车页" : "购物车弹层页",
          //   element_name: "learn more",
          //   module_name: $(this).index() == 0 ? "维修服务政策" : "物流&退换货政策",
          // });
        });
        $(container).on("click", ".section-footer__payment-icons .section-footer__payment-icon", function () {
          // sensors.track("ClickDetailsElement", {
          //   page_position: $("body").data("page-type") == "cart" ? "购物车页" : "购物车弹层页",
          //   element_name: $(this).find("title").text().trim(),
          //   module_name: "付款方式",
          // });
        });

        // 点击凑单引导
        $(container).on("click", "a[href='#cart-recommend']", function () {
          let params = {
            cart_token: $.cookie("cart") || "",
            element_name: "满赠凑单引导",
            page_position: theme.jelenew_web_page_name,
            product_ids: [],
            sku_name: [],
            skc_ids: [],
            spu_ids: [],
            variant_ids: [],
            product_number: $(".cart-link__count").length > 0 ? $(".cart-link__count").eq(0).text() * 1 : 0,
            is_note: $(".jelenew-main-cart .textareawrapper #note").val() == "" ? false : true,
            note: $(".jelenew-main-cart .textareawrapper #note").val(),
            check_price: theme.jelenew_money_to_number(
              $(".jelenew-main-cart .checkout-subtotal-container__right .total-container .theme-money").text()
            ),
            discount_amount: theme.jelenew_money_to_number(
              $(".jelenew-main-cart .checkout-subtotal-container__right .total-container .discount").text()
            ),
            trees_donated: $(".donation-section-container .info-box .donation_num").text().trim() * 1,
            is_usecode: $(".jelenew-real-cart .discount-detail-item").length === 0 ? true : false,
            discount_code: $(".discount-detail-code .code").text().trim(),
          };
          $(".cart-item-list__body .cart-item").each(function () {
            params.product_ids.push($(this).data("product_id"));
            params.sku_name.push($(this).data("sku"));
            params.skc_ids.push($(this).data("skc"));
            params.spu_ids.push($(this).data("spu"));
            params.variant_ids.push($(this).data("variant_id"));
          });
          // sensors.track("ClickDetailsElement", params);
        });
        $(container).on("keyup", ".textareawrapper>#note", function (e) {
          $(this).closest(".textareawrapper").find(".note-num").text($(this).val().length);
        });

        // 购物车提示文案打开
        $(container).on("click", ".jelenew-real-cart .noraml-announcement", function () {
          // document.dispatchEvent(new CustomEvent("jelenewCartDrawerHidden"));
          $("[data-section-type=newsletter-popup]")[0].popup_strategy = "点击触发";
          $(document).triggerHandler(popupOpenEvent());
        });

        $(container).on("click", ".cart-recommends-block .ajax-handler", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const $block = $(this).closest(".cart-recommends-block");
          const product_handle = $block.data("product_handle");
          $block.addClass("jelenew-ajax-variants-selector-show");
          $("body").addClass("jelenew-ajax-variants-selector-show");
          if ($(".cart-recommends-block-" + product_handle).length == 0) {
            _this.functions.fetchJelenewVariantsSelector($block, product_handle);
          }
          return false;
        });

        // 凑单展开 / 收起
        $(container).on("click", ".add-on-container-fold-btn", function () {
          $(this).toggleClass("active");
          $(this).siblings(".add-on-container").toggleClass("active");
          if($(this).hasClass("active")){
            $("#error-for-reduction_code").show();
          }else{
            $("#error-for-reduction_code").hide();
          }
        });

        // 推荐快速加购
        $(container).on("click", ".product-quick-buy-block .product-quick-buy-block-add-to-cart-btn", async function (e) {
          e.preventDefault();
          e.stopPropagation();
          const _this = this;
          const variant_id = $(this).parent().find(".product-quick-buy-block-variant-select").val();
          // console.log("quick buy variant_id:", variant_id, $(this).closest(".product-quick-buy-block"));
          $(this).closest(".product-quick-buy-block").append($("<div class='block-shade'></div>"));
          sensors.track("ClickAddList", {
            page_position: "购物车快速加购",
            product_name: $(this).closest(".product-quick-buy-block").find(".title").text().trim(),
            product_id: $(this).closest(".product-quick-buy-block").data("product_id"),
            original_price: theme.jelenew_money_to_number($(this).closest(".product-quick-buy-block").find(".theme-money").text()),
          });
          await shopifyHttp.post("cart/add.js", { items: [{ id: variant_id, quantity: 1 }] }).finally(() => {
            $(document).triggerHandler(
              cartChangedEvent({ detail: { open_drawer: true } })
            );
            $(_this).closest(".product-quick-buy-block").find(".block-shade").remove();
          });
          return false;
        });
        $(container).on("click", ".product-quick-buy-block>a", function () {
          const $block = $(this).closest(".product-quick-buy-block");
          sensors.track("ClickProductList", {
            page_position: theme.jelenew_web_page_name,
            list_type: "购物车快速加购推荐商品列表",
            list_name: "购物车快速加购推荐商品列表",
            current_product_name: $block.find(".title").text().trim(),
            current_product_id: $block.data("product_id"),
            product_name: $block.find(".title").text().trim(),
            product_id: $block.data("product_id"),
            original_price: theme.jelenew_money_to_number($block.find(".theme-money").text()),
            ep_module_id: $block.data("slick-index") + "",
          });
        });
        // $(container).on("click", ".cart-recommend-title .custom-arrow", function () {
        //   if (condition) {
            
        //   }
        // });
        $(".page-shade").on("click", function () {
          if ($(".jelenew-ajax-variants-selector-show .close-variants-selector").length > 0) {
            $(".jelenew-ajax-variants-selector-show .close-variants-selector").trigger("click");
          }
        });

        // 购物车页面时，初始化购物车推荐
        if ($("body").data("page-type") == "cart") {
          $(document).triggerHandler(cartRecommendUpdateEvent());
          jelenew.functions.discountCodeHave();
        }
        if ($("[data-jelenew_event_open]").data("jelenew_event_open")) {
          // 购物车页面时，初始化折扣码引导
          if ($("body").data("page-type") == "cart") {
            jelenew.functions.discountCodeHave();
            let bf_2024_total = 0;
            // 活动折扣自动应用
            $(`.jelenew-real-cart .cart-item[data-is_bf_2024=true]`).each(function () {
              bf_2024_total += Number($(this).data("original-line-price"));
            });
            // 满足金额条件 && 未使用折扣码
            if (bf_2024_total / Shopify.currency.rate < 75) {
              // 未满足金额条件 -> 展示凑单商品
              this.functions.cartddOnload();
            }
          }
          // this.functions.checkAppGift();
        }
      }.bind(this);

      this.functions = {
        checkAutoAddGift: async function (code_val) {
          const need_add_gift = this.functions.checkCodeType(code_val, "add");
          if (!need_add_gift) {
            return;
          }
          // // 查询折扣码是否可用
          let checkCodeParams = {
            variantList: [],
            subtotalPrice: `${theme.jelenew_money_to_number($(".total-container .theme-money").text())}`,
            rate: Shopify.currency.rate,
            currency: Shopify.currency.active,
            discountCode: code_val,
            email: $("body").attr("data-customer_email").trim(),
          };
          $(".cart-item-list__body")
            .eq(0)
            .find(".cart-item:not(.jelenew-cart-item-gift)")
            .each(function () {
              checkCodeParams.variantList.push({
                variantId: $(this).attr("data-line-item-id").trim(),
                quantity: $(this).find(".cart-item__quantity-input").val() * 1,
                price: `${theme.jelenew_money_to_number($(this).find(".theme-money").text())}`,
              });
            });
          let gift_product = null;
          // 开启了赠品自动加车 && 输入为赠品码时
          // 根据是否登录选择不同接口
          try {
            const { result } = await jelenewHttp.post("/api/shop/promotion/verify", checkCodeParams);
            if (result && result.gift) {
              gift_product = {
                variant: result.productList[0].skuIdList[0],
                quantity: result.productList[0].quantity ? result.productList[0].quantity : 1,
              };
              // 检查购物车中是否存在符合条件的商品
              let has_gift = false;
              $(".cart-item-list__body .cart-item:not(.jelenew-cart-item-gift)").each(function () {
                const variant_id = $(this).data("variant_id");
                const find_gift = result.productList[0].skuIdList.some((sku_id) => {
                  return sku_id == variant_id;
                });
                if (find_gift) {
                  has_gift = true;
                }
              });
              // 赠品不存在 =》 加车
              if (!has_gift) {
                await shopifyCartApi.add({
                  items: [
                    {
                      id: gift_product.variant,
                      quantity: 1,
                    },
                  ],
                });
              }
            }
          } catch (err) {
            gift_product = null;
          }
        },
        refreshCartDependentContent: async (e) => {
          // cart页面中不执行cart-drawer的初始化
          if (this.refreshAbortController) {
            this.refreshAbortController.abort();
          }
          this.refreshAbortController = new AbortController();
          // fetch new html for the page
          if (e === undefined) {
            e = {};
          }
          var cartSectionName = "jelenew-main-cart";
          // var url = e.detail
          //   ? e.detail.url || theme.routes.cart_url + "?sections=" + cartSectionName
          //   : theme.routes.cart_url + "?sections=" + cartSectionName;
          const url = `cart?sections=${cartSectionName}`;
          var jelenewCustomCallBack = e.detail ? e.detail.jelenewCustomCallBack || null : null;
          const open_drawer = e?.detail?.open_drawer === false ? false : true;
          // 购物车发生变化，删除检查完成标记
          $("#jelenew-main-cart").removeClass("cart-over-check");

          // 是否有数据传入， 有则不请求接口
          let result = e.detail && e.detail.data && e.detail.data.sections ? e.detail.data.sections || null : null;
          if (!result) {
            try {
              result = await shopifyHttp.get(url, { signal: this.refreshAbortController.signal });
            } catch (error) {
              if (!axios.isCancel(error) && error.code !== "ECONNABORTED") {
                theme.JelenewTips("Network Error, Please refersh the page.");
                location.reload();
              }
            }
          }
          const data = result[cartSectionName];
          var _timer, _timer2;
          // DOM 替换
          var $newDom = $("<div>" + data + "</div>");
          // 是否使用了折扣码 && 折扣码使用失败 => 打开折扣码折叠
          const use_discount_code = e?.detail?.use_discount_code || false;
          if (use_discount_code && $newDom.find(".discount-detail-item").length === 0) {
            $newDom.find(".discount-container #checkout_submit").addClass("btn--loading");
            $newDom.find(".discount-container .field").addClass("field--error");
            $newDom
              .find(".checkout-subtotal-container .discount-container")
              .closest(".checkout-container-item.collapse-container")
              .addClass("show-collapse");
          }

          // change header count
          var is_cart_drawer = $("body").attr("data-page-type") != "cart";
          var newCount = $newDom.find(".main-cart-header-totalNum").text() * 1;
          if (is_cart_drawer) {
            // 浮层页保存当前滚动值
            this.cart_drawer_scrolltop = e.detail
              ? e.detail.scrollTopNum || $(".jelenew-main-cart-drawer-container").scrollTop()
              : $(".jelenew-main-cart-drawer-container").scrollTop();
          }
          if (newCount == 0) {
            $("#pageheader .cart-link__count").remove();
          } else if ($("#pageheader .cart-link__count").length == 0) {
            $("#pageheader .cart-link__icon").append(
              "<span class='cart-link__count'><span class='cart-link__count_inner' style='top: 0px;'>" + newCount + "</span></span>"
            );
          } else {
            var oldCount = Number($("#pageheader .cart-link__count_inner").eq(0).text());
            if (oldCount > newCount) {
              $("#pageheader .cart-link__icon .cart-link__count").append(
                "<span class='cart-link__count_inner' style='top: 17px;'>" + newCount + "</span>"
              );
              $("#pageheader .cart-link__count_inner").eq(0).css({
                top: "-17px",
              });
              _timer = setTimeout(() => {
                $("#pageheader .cart-link__count_inner").eq(1).css({
                  top: "0px",
                });
                clearTimeout(_timer);
              }, 10);
              _timer2 = setTimeout(() => {
                $("#pageheader .cart-link__count_inner").eq(0).remove();
                clearTimeout(_timer2);
              }, 500);
            } else {
              $("#pageheader .cart-link__icon .cart-link__count").prepend(
                "<span class='cart-link__count_inner' style='top: -17px;'>" + newCount + "</span>"
              );
              $("#pageheader .cart-link__count_inner").eq(1).css({
                top: "17px",
              });
              _timer = setTimeout(() => {
                $("#pageheader .cart-link__count_inner").eq(0).css({
                  top: "0px",
                });
                clearTimeout(_timer);
              }, 10);
              _timer2 = setTimeout(() => {
                $("#pageheader .cart-link__count_inner").eq(1).remove();
                clearTimeout(_timer2);
              }, 500);
            }
          }
          // config for cart DOM & cart-drawer DOM need to replace
          var toReplace = [
            ".jelenew-real-cart>.jelenew-cartform .page-header",
            ".jelenew-real-cart>.jelenew-cartform .cd-cart-announcement",
            ".jelenew-real-cart>.jelenew-cartform .cart-item-list__body",
            ".jelenew-real-cart>.jelenew-cartform .checkout-subtotal-container",
            ".cart-recommend>.cart-recommend-title",
          ];
          if ($(".jelenew-real-cart>.jelenew-cartform .cart-item-list__body").length === 0 || $newDom.find(".cart-item-list__body").length === 0) {
            toReplace = [".jelenew-real-cart>.jelenew-cartform", ".cart-recommend>.cart-recommend-title"];
          }

          // remove any transitions
          $newDom.find(".fade-in").removeClass("fade-in");
          $newDom.find("[data-cc-animate]").removeAttr("data-cc-animate");

          // replace car DOM
          var emptyStr = $newDom.find(".jelenew-real-cart .cart-item-list p").text();
          if (emptyStr === "Your cart is currently empty.") {
            $(".jelenew-real-cart").replaceWith($newDom.find(".jelenew-real-cart").clone());
            $(".cart-recommend>.cart-recommend-title").text($newDom.find(".jelenew-real-cart").attr("data-recommend-title"));
          } else {
            for (var i = 0; i < toReplace.length; i++) {
              this.replacingContent = true; // to avoid triggering change events when focus is lifted before DOM replacement
              // var $toReplace = this.$container.find(toReplace[i]),
              // 	$replaceWith = $newDom.find(toReplace[i]);
              var $toReplace = $("body").find(toReplace[i]),
                $replaceWith = $newDom.find(toReplace[i]).clone();
              // preserve loaded images
              $replaceWith.find(".cart-item__image").each(function () {
                var $match = $toReplace.find("#" + this.id);
                if ($match.length) {
                  $(this).replaceWith($match.clone());
                }
              });
              $toReplace.replaceWith($replaceWith);
              this.replacingContent = false;
            }
          }
          // open cart-drawer without cart-page
          if (is_cart_drawer && open_drawer) {
            // 打开弹窗，更新variant-id
            document.dispatchEvent(
              new CustomEvent("jelenewCartDrawerShow", {
                detail: { dataReInit: true },
              })
            );
            $(".jelenew-main-cart-drawer-container").scrollTop(this.cart_drawer_scrolltop);
          }

          // complete逻辑迁移至success。因为请求被终止时complete依然执行
          if (jelenewCustomCallBack) {
            jelenewCustomCallBack();
          }
          var exception_reason = [];
          let gift_num = 0;
          $(".jelenew-real-cart .cart-item").each(function () {
            if ($(this).hasClass("jelenew-cart-item-gift")) {
              gift_num++;
            }
            exception_reason.push({
              variant_id: $(this).data("variant_id"),
              quantity: $(".cart-item__quantity-input", this).val() * 1,
              is_gift: $(this).hasClass("jelenew-cart-item-gift"),
            });
          });
          // 只剩赠品时清空购物车
          if (gift_num === $(".jelenew-real-cart .cart-item").length && gift_num != 0) {
            shopifyCartApi.clear().then(() => {
              $(document).triggerHandler(cartChangedEvent({}));
            });
          }
          sensors.track("ServeException", {
            exception_type: "前端监控",
            exception_level: "p2",
            exception_modle: "购物车选择的实际结果",
            exception_from: "前端",
            exception_reason: JSON.stringify(exception_reason),
            exception_modle_sub: "购物车监控",
            $url: window.location.href,
          });
          window?.jelenew?.functions?.discountCodeHave();
          localStorage.removeItem("jelenew_auto_use_discount_type");

          $(document).triggerHandler(cartRecommendUpdateEvent());
          // 活动折扣自动应用
          if ($("[data-jelenew_event_open]").data("jelenew_event_open")) {
            let bf_2024_total = 0;
            $(`.jelenew-real-cart .cart-item[data-is_bf_2024=true]`).each(function () {
              bf_2024_total += Number($(this).data("original-line-price"));
            });
            // 满足金额条件 && 未使用折扣码
            if (bf_2024_total / Shopify.currency.rate >= 75) {
              $(".checkout-subtotal-container .add-on-container").empty();
              $(".checkout-subtotal-container .add-on-container-fold-btn").addClass("js-hidden").removeClass("active");
              // 折扣码自动应用次数
              const autoDiscountCount = sessionStorage.getItem("autoDiscountCount") || 0;
              if (
                autoDiscountCount < 3 &&
                $(".jelenew-real-cart .discount-detail-code .code").length == 0 &&
                sessionStorage.getItem("remove_discount_code") !== "SEASONEND"
              ) {
                // 自动应用黑五折扣码
                $(".jelenew-real-cart .discount-container #checkout_reduction_code").val("SEASONEND");
                $(".jelenew-real-cart .discount-container #checkout_submit").trigger("click");
                sessionStorage.setItem("autoDiscountCount", autoDiscountCount++);
              }
            } else {
              // 未满足金额条件 -> 展示凑单商品
              theme.CartTemplateSection.functions.cartddOnload();
            }
            // 赠品检查
            // theme.CartTemplateSection.functions.checkAppGift();
          }
        },
        updateCart: (params, successCallback, errCallback) => {
          if (this.updateCartAbortController) {
            this.updateCartAbortController.abort();
          }
          this.updateCartAbortController = new AbortController();
          return shopifyHttp
            .post("cart/change.js", params, {
              signal: this.updateCartAbortController.signal,
            })
            .then(async (res) => {
              await this.functions.refreshCartDependentContent.call(this);
              successCallback(res);
            })
            .catch(async (data) => {
              errCallback(data);
              // 不是主动取消 && 不是网络问题
              if (!axios.isCancel(data) && data.code !== "ECONNABORTED") {
                await this.functions.refreshCartDependentContent.call(this);
              }
            });
        },
        // 折扣码功能整合
        discountCodeFeature: (discount_code = "", deleteCodeText = "", gift_product = null) => {
          $(".discount-container .field").removeClass("field--error");
          discount_code = discount_code.replaceAll(" ", "");
          return shopifyHttp
            .post("cart/update.js", {
              discount: discount_code,
            }).then((res) => {
              // 应用折扣码失败后 -> 发起错误提示请求
              if (res && discount_code && res?.discount_codes?.some((t) => t.applicable === false)) {
                if (discount_code === "JELENEW") {
                  localStorage.setItem("jelenew_use_error_timestamp", new Date().getTime());
                }
                $(".discount-container .field").addClass("field--error");
                const user_email = $("body").attr("data-customer_email").trim();
                const templateCode = "server-product-quick-buy"; // "server-product-quick-buy", "server-recommends-cart"
                let checkCodeParams = {
                  variantList: [],
                  subtotalPrice: `${theme.jelenew_money_to_number($(".total-container .theme-money").text())}`,
                  rate: Shopify.currency.rate,
                  currency: Shopify.currency.active,
                  discountCode: discount_code,
                  email: user_email,
                  templateCode: templateCode,
                  lang: $("html").data("root_url") == "/" ? "" : $("html").data("root_url"),
                  warning: true,
                  cartTip: $(".jelenew-main-cart .cd-cart-announcement").hasClass("js-hidden")
                    ? ""
                    : $(".jelenew-main-cart .cd-cart-announcement").text().trim(),
                };
                $(".cart-item-list__body")
                  .eq(0)
                  .find(".cart-item")
                  .each(function () {
                    checkCodeParams.variantList.push({
                      variantId: $(this).attr("data-line-item-id").trim(),
                      quantity: $(this).find(".cart-item__quantity-input").val() * 1,
                      price: $(this).data("final-price"),
                      isNormalProduct: $(this).data("is_normal_product"),
                    });
                  });
                const url = jelenewGetCookie("accessToken")
                  ? "/api/shop/member/promotion/discountCodeMiss"
                  : "/api/shop/promotion/discountCodeMiss";
                var codeUrlNum = 0;
                jelenewHttp
                  .post(url, checkCodeParams)
                  .then(({ result }) => {
                    if (
                      result?.code?.startsWith("DISCOUNT_CODE_PRICE_LIMIT") &&
                      result?.hotProductList?.length > 0 &&
                      $(".add-on-container", this.$container[0]).children().length === 0
                    ) {
                      // 价格限制 -> 插入凑单商品
                      result.hotProductList.forEach((str, index) => {
                        const item = JSON.parse(str)[checkCodeParams.templateCode];
                        $(".add-on-container", this.$container[0]).append($(item).children());
                      });
                      $(".checkout-subtotal-container .add-on-container-fold-btn", this.$container[0])
                        .removeClass("js-hidden")
                        .addClass("active");
                      $(".add-on-container", this.$container[0])
                        .addClass("active")
                        .slick({
                          arrows: true,
                          dots: false,
                          infinite: false,
                          slidesToShow: 3.3,
                          slidesToScroll: 1,
                          swipeToSlide: true,
                          prevArrow:
                            '<button type="button" class="slick-prev" aria-label="' +
                            theme.strings.previous +
                            '">' +
                            theme.icons.chevronLeft +
                            "</button>",
                          nextArrow:
                            '<button type="button" class="slick-next" aria-label="' +
                            theme.strings.next +
                            '">' +
                            theme.icons.chevronRight +
                            "</button>",
                        });

                      if (result?.notCamparedList?.length > 0) {
                        // 价格限制 -> 未匹配商品
                        result.notCamparedList.forEach((variantId) => {
                          $(`.cart-item-list__body .cart-item[data-line-item-id=${variantId}]`).addClass("shake");
                        });
                        setTimeout(() => {
                          $(".cart-item-list__body .cart-item.shake").removeClass("shake");
                        }, 3000);
                      }
                    }
                    $("#error-for-reduction_code").empty().html(result.message);
                    sensors.track("ClickInputConfirm", {
                      page_position: $("body").data("page-type") == "cart" ? "购物车页" : "购物车弹层页",
                      product_number: $(".cart-link__count_inner").eq(0).text() * 1,
                      original_price: theme.jelenew_money_to_number($(".checkout-subtotal-container__right .total .theme-money").text()),
                      input_type: "优惠券CODE输入框",
                      discount_code: discount_code,
                      is_success: false,
                      message: result.message,
                    });
                  })
                  .catch(() => {
                    $("#error-for-reduction_code").text($("#error-for-reduction_code").data("error_text"));
                    //错误多次调用 刷新页面
                    codeUrlNum++;
                    if (codeUrlNum >= 2) {
                      codeUrlNum = 0;
                      location.reload();
                      return;
                    }
                  })
                  .finally(() => {
                    $(".checkout-subtotal-container .discount-container")
                      .closest(".checkout-container-item.collapse-container")
                      .addClass("show-collapse");
                    $(".discount-container #checkout_submit").removeClass("btn--loading");
                  });
                // jelenew.functions.discountCodeHave();

              } else {
                // 应用折扣码成功
                $(document).triggerHandler(
                  cartChangedEvent({
                    detail: {
                      use_discount_code: discount_code.trim() && discount_code !== "" ? true : false,
                      jelenewCustomCallBack: () => {
                        setTimeout(() => {
                          sensors.track("ClickInputConfirm", {
                            page_position: $("body").data("page-type") == "cart" ? "购物车页" : "购物车弹层页",
                            product_number: $(".cart-link__count_inner").eq(0).text() * 1,
                            original_price: theme.jelenew_money_to_number($(".checkout-subtotal-container__right .total .theme-money").text()),
                            input_type: "优惠券CODE输入框",
                            discount_code: discount_code,
                            is_success: discount_code === "" ? false : true,
                          });
                          $(".discount-container #checkout_submit").removeClass("btn--loading");
                        }, 0);
                      },
                    },
                  })
                );
              }
            });
        },
        // 商详浮层
        fetchJelenewVariantsSelector: ($block, product_handle, variant_id, namespace = "cart-recommends-block-") => {
          return new Promise((resolve, reject) => {
            $block.append($("<div class='block-shade'></div>"));
            const _this = this;
            let url = "products/" + product_handle + "?view=ajax-variants-selector&sections=jelenew-ajax-variants-selector";
            if (variant_id) {
              url = url + "&variant=" + variant_id;
            }
            const slickParams = {
              prevArrow: ".jelenew-main-product-slideshow-dots-controls .slick-prev",
              nextArrow: ".jelenew-main-product-slideshow-dots-controls .slick-next",
              infinite: false,
              appendDots: ".jelenew-ajax-variants-selector .jelenew-main-product-slideshow-dots",
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true,
              dots: true,
              arrows: true,
              customPaging: function (slider, i) {
                return i + 1 + "/" + slider.slideCount;
              },
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                    dots: true,
                    arrows: true,
                    appendDots: ".jelenew-ajax-variants-selector .jelenew-main-product-slideshow-dots",
                    customPaging: function (slider, i) {
                      return i + 1 + "/" + slider.slideCount;
                    },
                  },
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                    dots: false,
                    arrows: false,
                  },
                },
              ],
            };
            shopifyHttp
              .get(url)
              .then((html) => {
                const $dom = $(html["jelenew-ajax-variants-selector"])
                  .find("div[data-section-type=jelenew-ajax-variants-selector]")
                  .addClass(namespace + product_handle);
                $("body").append($dom);
                $block.find(".block-shade").remove();
                $("body .jelenew-ajax-variants-selector .product-imags").slick(slickParams);

                theme.jelenewSizeGuide.onSectionLoad($("body").find("div[data-section-type=jelenew-ajax-variants-selector]"));

                // Actions
                // 关闭popup 销毁dom
                $("body").off("click", "div[data-section-type=jelenew-ajax-variants-selector] .close-variants-selector");
                $("body").on("click", "div[data-section-type=jelenew-ajax-variants-selector] .close-variants-selector", function () {
                  $("body").removeClass("jelenew-ajax-variants-selector-show");
                  $("[data-section-type=jelenew-filter-collection] .jelenew_col_filter").css("z-index", "");
                  $(this).closest(".cart-recommends-block").removeClass("jelenew-ajax-variants-selector-show");
                  // $("body").find(".jelenew-main-product-size-guide-drawer").remove();
                  $(".jelenew-main-product-size-guide-drawer .header-close").trigger("click");
                  $("body").find(".jelenew-ajax-variants-selector").remove();
                  return false;
                });
                // 颜色选择
                $("body").off(
                  "click",
                  "div[data-section-type=jelenew-ajax-variants-selector] [data-option-name=Color] .jelenew-product-option-values .color-item"
                );
                $("body").on(
                  "click",
                  "div[data-section-type=jelenew-ajax-variants-selector] [data-option-name=Color] .jelenew-product-option-values .color-item",
                  function () {
                    if ($(this).hasClass("active")) {
                      return false;
                    }
                    const $ajaxBlock = $(this).closest("div[data-section-type=jelenew-ajax-variants-selector]");

                    $ajaxBlock
                      .css("overflow", "hidden")
                      .append($(`<div class='block-shade' style="height: 100%;bottom: auto;top: ${$ajaxBlock.scrollTop()}px;"></div>`));

                    shopifyHttp
                      .get($(this).data("url"))
                      .then((newHtml) => {
                        $ajaxBlock.find(".replace-element").replaceWith($(newHtml[Object.keys(newHtml)[0]]).find(".replace-element"));
                        $ajaxBlock.find(".product-imags").slick(slickParams);
                        $ajaxBlock.find("[data-option-name=Color]").css("display", "block");
                        $ajaxBlock.find(".add-to-cart").text("update");
                      })
                      .finally(() => {
                        $ajaxBlock.css("overflow", "scroll");
                        $ajaxBlock.find(".jelenew-main-product-size-guide-drawer").remove();
                        $ajaxBlock.find(".block-shade").remove();
                      });
                    // sensors.track("ClickDetailsElement", {
                    //   element_name: "COLOUR",
                    //   page_position: $(".jelenew-product-option").css("display") == "block" ? "赠品规格切换弹层页" : theme.jelenew_web_page_name,
                    //   colour: $(this).data("swatch") || "",
                    //   product_name: $(this).closest(".replace-element").find(".jelenew-product-name").text().trim(),
                    //   product_id: $(this).closest(".replace-element").find(".jelenew-product-options").data("product_id"),
                    //   original_price: theme.jelenew_money_to_number(
                    //     $(this).closest(".replace-element").find(".jelenew-product-price .theme-money").text()
                    //   ),
                    // });
                  }
                );
                // 尺码选择
                $("body").off("click", "div[data-section-type=jelenew-ajax-variants-selector] .size-item");
                $("body").on("click", "div[data-section-type=jelenew-ajax-variants-selector] .size-item", function () {
                  if ($(this).hasClass("sku_unavailable")) {
                    return;
                  }
                  $(this).siblings().removeClass("active");
                  $(this).addClass("active");
                  $(this).closest(".replace-element").find(".original-selector").val($(this).data("variant-id"));
                  if (
                    $(this)
                      .closest(".replace-element")
                      .find(`.original-selector [value=${$(this).data("variant-id")}]`)
                      .data("stock") == "out"
                  ) {
                    $(this).closest(".replace-element").find(".add-to-cart").addClass("out-of-stock");
                  } else {
                    $(this).closest(".replace-element").find(".add-to-cart").removeClass("out-of-stock");
                  }
                  // sensors.track("ClickDetailsElement", {
                  //   element_name: "SIZE",
                  //   page_position: $(".jelenew-product-option").css("display") == "block" ? "赠品规格切换弹层页" : theme.jelenew_web_page_name,
                  //   size: $(this).text().trim(),
                  //   product_name: $(this).closest(".replace-element").find(".jelenew-product-name").text().trim(),
                  //   product_id: $(this).closest(".replace-element").find(".jelenew-product-options").data("product_id"),
                  //   original_price: theme.jelenew_money_to_number(
                  //     $(this).closest(".replace-element").find(".jelenew-product-price .theme-money").text()
                  //   ),
                  // });
                });
                // 加车
                $("body").off("click", "div[data-section-type=jelenew-ajax-variants-selector] .add-to-cart");
                $("body").on("click", "div[data-section-type=jelenew-ajax-variants-selector] .add-to-cart", function () {
                  $(this).addClass("disabled");
                  sensors.track("ClickAddToBag", {
                    page_position: theme.jelenew_web_page_name,
                    colour: $(this).closest(".replace-element").find(".jelenew-product-option-selected").eq(0).text().trim(),
                    size: $(this).closest(".replace-element").find(".jelenew-product-option-values .size-item.active").text().trim(),
                    sku_id: $(this).closest(".replace-element").find(".original-selector option:selected").attr("sku-value"),
                    skc_id: $(this).closest(".replace-element").find(".original-selector option:selected").data("skc"),
                    spu_id: $(this).closest(".replace-element").find(".original-selector option:selected").data("spu"),
                    variant_id_string: $(this).closest(".replace-element").find(".original-selector").val() + "",
                    product_name: $(this).closest(".replace-element").find(".jelenew-product-name").text().trim(),
                    product_id: $(this).closest(".replace-element").find(".jelenew-product-options").data("product_id"),
                    original_price: theme.jelenew_money_to_number(
                      $(this).closest(".replace-element").find(".jelenew-product-price .theme-money").text()
                    ),
                  });
                  let addProduct = {
                    id: $("div[data-section-type=jelenew-ajax-variants-selector] .original-selector").val(),
                    quantity: 1,
                  };
                  shopifyCartApi
                    .add({ items: [addProduct] })
                    .then((data) => {
                      $(document).triggerHandler(cartChangedEvent());
                    })
                    .finally(() => {
                      $(".jelenew-ajax-variants-selector").each(function () {
                        $(this).remove();
                      });
                    });
                });

                // View Full Details
                $("body").on(
                  "click",
                  "div[data-section-type=jelenew-ajax-variants-selector] .jelenew-product-head .jelenew_product_view.Futuran",
                  function () {
                    sensors.track("ClickCartElement", {
                      element_name: "View Full Details",
                      product_id: $(this).closest(".jelenew-ajax-variants-selector").find(".jelenew-product-form-container").data("product-id"),
                      page_position: $("body").data("page-type") == "cart" ? "购物车页" : "购物车弹层页",
                    });
                  }
                );
                resolve(true);
              })
              .catch((err) => {
                $block.find(".block-shade").remove();
                reject(err);
              });
          });
        },
        // 折扣码类型判断
        checkCodeType: (code, type) => {
          // 是否需要邮箱验证
          if (type === "email") {
            if (code.startsWith("BDAYGIFT") || code.startsWith("MEMBER") || code === "EXPRESS20") {
              return true;
            } else {
              return false;
            }
          }
          // 是否需要自动加车
          if (type === "add") {
            if (code.toUpperCase().endsWith("GIFT") || code === "LUZEQI_TEST_GIFT") {
              return true;
            } else {
              return false;
            }
          }
        },
        // 购物车凑单
        cartddOnload: function () {
          // 未满足金额条件 -> 展示凑单商品
          const user_email = $("body").attr("data-customer_email").trim();
          let checkCodeParams = {
            variantList: [],
            subtotalPrice: `${theme.jelenew_money_to_number($(".total-container .theme-money").text())}`,
            rate: Shopify.currency.rate,
            currency: Shopify.currency.active,
            discountCode: "SEASONEND",
            email: user_email,
            templateCode: "server-product-quick-buy",
            lang: $("html").data("root_url") == "/" ? "" : $("html").data("root_url"),
            warning: false,
          };
          $(".cart-item-list__body")
            .eq(0)
            .find(".cart-item")
            .each(function () {
              checkCodeParams.variantList.push({
                variantId: $(this).attr("data-line-item-id").trim(),
                quantity: $(this).find(".cart-item__quantity-input").val() * 1,
                price: $(this).data("final-price"),
                isNormalProduct: $(this).data("is_normal_product"),
              });
            });
          const url = jelenewGetCookie("accessToken") ? "/api/shop/member/promotion/discountCodeMiss" : "/api/shop/promotion/discountCodeMiss";
          var cartddOnloadNum=0;
          jelenewHttp.post(url, checkCodeParams).then(({ result }) => {
            if (
              result?.code?.startsWith("DISCOUNT_CODE_PRICE_LIMIT") &&
              result?.hotProductList?.length > 0 &&
              $(".checkout-subtotal-container .add-on-container .cart-recommends-block").length === 0
            ) {
              // 价格限制 -> 插入凑单商品
              result.hotProductList.forEach((str, index) => {
                const item = JSON.parse(str)[checkCodeParams.templateCode];
                $(".checkout-subtotal-container .add-on-container").append($(item).children());
              });
              $(".checkout-subtotal-container .add-on-container-fold-btn").removeClass("js-hidden").addClass("active");
              $(".checkout-subtotal-container .add-on-container")
                .addClass("active")
                .slick({
                  arrows: true,
                  dots: false,
                  infinite: false,
                  slidesToShow: 3.3,
                  slidesToScroll: 1,
                  swipeToSlide: true,
                  prevArrow:
                    '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                  nextArrow:
                    '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                });
            }else{
              // 如果

            }

          }).catch(() => {
            //错误多次调用 刷新页面
            cartddOnloadNum++;
            if(cartddOnloadNum>=2){
              cartddOnloadNum=0;
              location.reload();
              return
            }
          });
        },
        // 赠品检查
        checkAppGift: function () { 
          const total = theme.jelenew_money_to_number($(".total-container .theme-money").text());
          const discount = theme.jelenew_money_to_number($(".total-container>.discount>span").text());
          const usTotal = (total + discount) / Shopify.currency.rate;
          if ($(".jelenew-cart-item-gift.cart-item").length > 0 && usTotal < 149) {
            let updates = {};
            updates[$(".jelenew-cart-item-gift.cart-item").data("line-item-key")] = 0;
            shopifyCartApi.update(updates).finally(() => {
              $(document).triggerHandler(cartChangedEvent());
            });
          }
          const inventory_quantity = $(".jelenew-cart-item-gift.cart-item").data("inventory_quantity") || 999;
          if (inventory_quantity < 5) {
            sensors.track("ServeException", {
              exception_from: "前端监控",
              exception_type: "赠品库存数量预警",
              exception_level: "p1",
              exception_modle: $("body").data("page-type"),
              exception_modle_sub: `赠品库存资源异常`,
              exception_reason: `赠品库存数量为${inventory_quantity}件，请及时更换`,
            });
          }
        },
        // 商品推荐
        getCartRecommendList: function (container) {
          // function loseHashCode(key) {
          //   var hash = 0;
          //   for (var i = 0; i < key.length; i++) {
          //     hash += key[i].charCodeAt();
          //   }
          //   return hash;
          // }
          // const distinct_id = sensors?.quick("getAnonymousID");
          // const NUM = loseHashCode(distinct_id) % 100;
          // // 只展示10%的用户
          // if (NUM > 50) {
          //   console.log(`%c 隐藏购物车推荐商品:${NUM}`, "background: #ff5722; color: #fff; font-size: 12px; padding: 6px; border-radius: 4px;");
          //   return sensors.registerPage({ ab_tag: "jelenew_cart_recommend_hide" });
          // } else {
          //   console.log(`%c 展示购物车推荐商品:${NUM}`, "background: #8664E2; color: #fff; font-size: 12px; padding: 6px; border-radius: 4px;");
          //   sensors.registerPage({ ab_tag: "jelenew_cart_recommend_show" });
          // };
          $(".jelenew-real-cart .cart-recommend-container").show();
          const templateCode = "server-product-quick-buy"; // "server-product-quick-buy", "server-recommends-cart"
          // 购物车浮层推荐商品
          const params = {
            recommendType: 1,
            lang: $("html").data("root_url") == "/" ? "" : $("html").data("root_url"),
            currency: Shopify.currency.active,
            currencyRate: Shopify.currency.rate * 1,
            productIds: [],
            templateCode: templateCode,
            needFixedPrice: "0",
          };
          let firstSize = null;
          $(".cart-item-list__body>.cart-item:not(.is_gift_card)").each(function (i, el) {
            const variantName = $(".cart-item_variant_title", el).text().trim();
            // console.log("variantName", variantName, firstSize);
            if (variantName.includes("/") && firstSize == null) {
              // 只取第一个尺码
              firstSize = variantName.split("/")[1].trim();
            }
            params.productIds.push($(".cart-item_title a.name", el).data("product_id") + "");
          });
          // 默认M尺码
          if (!firstSize) {
            firstSize = "M";
          }
          jelenewHttp.post("/api/mall/product/recommend/cartV2", params).then(({ result }) => {
            // 价格限制 -> 插入凑单商品
            try {
              $(".jelenew-real-cart .cart-recommend-slick").slick("unslick");
            } catch (error) {
              
            }
            $(".jelenew-real-cart .cart-recommend-slick").empty();
            result.info.products.forEach((str, index) => {
              const $item = $(JSON.parse(str)[templateCode]).children();
              $item.find(".product-quick-buy-block-variant-select option").each(function () {
                if ($(this).text().trim() === firstSize) {
                  $(this).prop("selected", true);
                }
              });
              $(".jelenew-real-cart .cart-recommend-slick").append($item);
            });
            let slick_config = {
              arrows: true,
              dots: true,
              dotsClass: "slick-dots-line-grey",
              infinite: false,
              slidesToShow: 3.3,
              slidesToScroll: 1,
              swipeToSlide: true,
              prevArrow: $(".jelenew-real-cart .cart-recommend-title .custom-prev"),
              nextArrow: $(".jelenew-real-cart .cart-recommend-title .custom-next"),
            };
            if ($("body").data("page-type") == "cart") {
              slick_config = {
                arrows: true,
                dots: true,
                dotsClass: "slick-dots-line-grey",
                infinite: false,
                slidesToShow: 3.3,
                slidesToScroll: 1,
                swipeToSlide: true,
                prevArrow: $(".jelenew-real-cart .cart-recommend-title .custom-prev"),
                nextArrow: $(".jelenew-real-cart .cart-recommend-title .custom-next"),
                responsive: [
                  {
                    breakpoint: 9999,
                    settings: {
                      slidesToShow: 4.5,
                      arrows: true,
                      dots: true,
                      dotsClass: "slick-dots-line-grey",
                      infinite: false,
                      slidesToScroll: 1,
                      swipeToSlide: true,
                      prevArrow: $(".jelenew-real-cart .cart-recommend-title .custom-prev"),
                      nextArrow: $(".jelenew-real-cart .cart-recommend-title .custom-next"),
                    },
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 4.5,
                      arrows: true,
                      dots: true,
                      dotsClass: "slick-dots-line-grey",
                      infinite: false,
                      slidesToScroll: 1,
                      swipeToSlide: true,
                      prevArrow: $(".jelenew-real-cart .cart-recommend-title .custom-prev"),
                      nextArrow: $(".jelenew-real-cart .cart-recommend-title .custom-next"),
                    },
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: true,
                      dots: true,
                      dotsClass: "slick-dots-line-grey",
                      infinite: false,
                      slidesToShow: 3.3,
                      slidesToScroll: 1,
                      swipeToSlide: true,
                      prevArrow: $(".jelenew-real-cart .cart-recommend-title .custom-prev"),
                      nextArrow: $(".jelenew-real-cart .cart-recommend-title .custom-next"),
                    },
                  },
                ],
              };
            }
            // console.log(slick_config);
            $(".jelenew-real-cart .cart-recommend-slick").slick(slick_config);
          });
        }
      };
      this.onSectionUnload = function (container) {
        $(document).off(".cartTemplateSection");
        $(container).off(".cartTemplateSection");
        theme.cartNoteMonitor.unload('.checkout-note [name="note"]');
      };
    })();

    theme.jelenewCartDiscountListPopup = new (function () {
      this.onSectionLoad = function (container) {
        const _this = this;
        // 关闭弹窗
        $(container).on("click", ".jelenew-cart-discount-list-popup-close", function () {
          $(container).removeClass("active");
          $("body").removeClass("cc-popup-no-scroll");
        });
        // 使用其他折扣吗
        $(container).on("click", ".jelenew-cart-discount-list-popup-list .coupons-active-item", async function () {
          if ($(this).find(".jelenew-cart-discount-list-popup-check-box").hasClass("active")) {
            return;
          }
          $(".coupons-active-item .jelenew-cart-discount-list-popup-check-box", container).removeClass("active");
          $(this).find(".jelenew-cart-discount-list-popup-check-box").addClass("active");
          $(".discount-container #checkout_submit").addClass("btn--loading");
          $(".checkout-container-item .discount-container .discount-detail").addClass("tag-loading");
          $(".jelenew-cart-discount-list-popup-close", container).trigger("click");
          await shopifyHttp.post("cart/update.js", { discount: $("[data-code]", this).data("code") });
          $(document).triggerHandler(cartChangedEvent());
        });
      };
      this.functions = {
        getCartDiscountList: async function (c) {
          const container = c || $("[data-section-type='jelenew-cart-discount-list-popup']")[0];
          let params = {
            currencyRate: Shopify.currency.rate,
            currency: Shopify.currency.active,
            lang: $("html").data("root_url") == "/" ? "" : $("html").data("root_url"), // 语言
            cartItemList: [],
            email: window.jelenew.customer.email,
          };
          $(".cart-item-list__body")
            .eq(0)
            .find(".cart-item:not(.is_gift_card,.jelenew-cart-item-gift)")
            .each(function () {
              params.cartItemList.push({
                productId: $(this).data("product_id"),
                variantId: $(this).data("data-line-item-id"),
                quantity: $(this).find(".cart-item__quantity-input").val() * 1,
                price: ($(this).data("original-line-price") / $(this).find(".cart-item__quantity-input").val()) * 100,
                totalPrice: $(this).data("original-line-price") * 100,
              });
            });
          const { result } = await jelenewHttp.post("/api/shop/promotion/discountList", params);
          return result.info;
        },
        openPopup: async function (c) {
          const container = c || $("[data-section-type='jelenew-cart-discount-list-popup']")[0];
          $(container).addClass("active");
          $("body").addClass("cc-popup-no-scroll");
          if ($(".coupons-active-item", container).length == 0) {
            const result = await this.getCartDiscountList(container);
            if (result && result.discountList && result.discountList.length > 0) {
              result.discountList.forEach((item) => {
                const code = $(".checkout-subtotal-container .discount-detail-code .code").text().trim();
                const useingCode = item.discountCode === code;
                const $item = $(`
              <div class="coupons-active-item">
                <div class="coupon-action">
                  <div class="coupon-off">
                  </div>
                </div>
                <div class="coupon-info">
                  <div class="coupon-code-container">
                    <div class="coupon-code" data-code="${item.discountCode}">
                      ${item.discountCode}
                    </div>
                  </div>
                  <ul class="coupon-content">
                  </ul>
                </div>
                <div class="jelenew-cart-discount-list-popup-check-box ${useingCode ? "active" : ""}"></div>
              </div> 
            `);
                let $couponOff = null;
                if (item.type === "Percentage") {
                  $couponOff = $(`
                    <div class="coupon-off-percent">
                      <div class="coupon-off-percent-num">${item.value * 1}</div>
                      <div class="coupon-off-percent-unit">%</div>
                      <div class="coupon-off-percent-text">OFF</div>
                    </div> 
                  `);
                  $item.find(`.coupon-code-container .coupon-off`).text(`${item.value * 1}% OFF`);
                } else if (item.type === "BuyXGetY") {
                  $couponOff = $(`
                    <div class="coupon-off-item">
                      <div class="coupon-off-item-num">${item.value}</div>
                      <div class="coupon-off-item-text">FREE</div>
                    </div>
                  `);
                  $item.find(`.coupon-code-container .coupon-off`).text(`GET ${item.value} ITEM FREE`);
                } else if (item.type === "Fixed Amount") {
                  $couponOff = $(`
                    <div class="coupon-off-price">$${item.value * 1}</div> 
                  `);
                  $item.find(`.coupon-code-container .coupon-off`).text(`$${item.value} OFF`);
                }
                $item.find(".coupon-action>.coupon-off").append($couponOff);
                item?.lines?.forEach((line, index) => {
                  const $line = $(`
                    <li class="coupon-content-item ${line.type === "0" ? "bold" : ""} ${item?.lines.length - 1 === index ? "color" : ""}">${
                    line.desc
                  }</li>
                  `);
                  $item.find(".coupon-content").append($line);
                });
                $(".jelenew-cart-discount-list-popup-list", container).append($item);
              });
            }
          }
          $(container).addClass("active");
        },
        useDefaultDiscount: async function (c) {
          const container = c || $("[data-section-type='jelenew-cart-discount-list-popup']")[0];
          const { defaultDiscount } = await this.getCartDiscountList(container);
          if (!defaultDiscount) {
            return;
          }
          shopifyHttp.post("cart/update.js", { discount: defaultDiscount.discountCode }).then(() => {
            $(document).triggerHandler(cartChangedEvent());
          });
        },
      };
    })();
    /** @format */

    theme.jelenewProductReview = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-product-review-template", container);
        const sectionId = $('div[data-section-type="jelenew-product-review"]').attr("id");
        const customerEmail = $('div[data-section-type="jelenew-product-review"]').attr("data-customer-email");
        const customerFirstName = $('div[data-section-type="jelenew-product-review"]').attr("data-customer-first-name");
        const customerLastName = $('div[data-section-type="jelenew-product-review"]').attr("data-customer-last-name");
        let rating_check_list = [];
        let sort = null;
        let havePic = false; //默认所有
        let timestamp = null;
        let pageCount = 1;
        let $reviewCount = 0; // 总评论数，用于区分是否有评论
        let overallRatingArr = [];
        let pageType = null;
        let hasMore = true; // 是否有下一页
        const listDom = $(".review-list-drawer .reviews-container", container);

        // -------------- 加载更多 -- start ------------------
        function getReviews(type = "list") {
          // $(".review-list-drawer .load_page").hide();
          if (type == "first" && pageCount == 1) {
            $(".review-list-drawer .reviews-container .review-item").show();
            if (!hasMore) {
              $(".review-list-drawer .load_page").hide();
            } else {
              $(".review-list-drawer .load_page").show();
            }
            return;
          }
          listDom.addClass("get-reviews-loading");
          let params = {
            productId: $(container).data("product-id"),
            page: pageCount,
          };
          if (sort != null) {
            params.sort = sort;
          }
          if (havePic) {
            params.havePic = havePic;
          }
          if (overallRatingArr.length) {
            params.filters = [
              {
                field: "overallRating",
                value: JSON.stringify(overallRatingArr),
              },
            ];
          }

          return jelenewHttp.post("/api/mall/review/list/v3", params).then(function (res) {
            const reviewList = res.result.info.reviews;
            hasMore = res.result.info.hasMore; //是否有下一页
            timestamp = res.result.info.timestamp;
            $(".review-list-drawer .drawer-header .drawer-title .count", container).html(res.result.info.total);
            $(".jelenew_review_filter_con .reviews-count-btn span", container).html(res.result.info.total);
            listDom.removeClass("get-reviews-loading");
            if (pageCount == 1) {
              $(".review-list-drawer .review-item", container).remove();
            }
            if (reviewList.length == 0 && pageCount == 1) {
              //查询如果为空
              $(".review-list-drawer .drawer-header .drawer-title .tips", container).hide();
              $(".review-list-drawer .load_page").hide();
              $(".review-list-drawer .jelenew-this-filter-no-reviews").show();
              return;
            } else {
              $(".review-list-drawer .jelenew-this-filter-no-reviews").hide();
            }

            // 评论数据插入
            const $baseDom = $($(".reviews-container-mobile #review-item-template", container).html())
              .clone()
              .removeClass("jelenew-product-base-review jelenew-hidden");

            for (let i = 0; i < reviewList.length; i++) {
              const data = reviewList[i];
              let $currentDom = $baseDom.clone();
              const {
                reply,
                replyUser,
                replyTimestamp,
                reviewId,
                userNickname,
                likes,
                mediaType,
                mediaUrls,
                review,
                createTimestamp,
                pastSeconds,
                userInfo,
                overallRating,
                latestDayStr,
              } = data;
              if (!reply) {
                // 没有回复，删除回复模块
                $currentDom.find(".official-reply").remove();
              } else {
                // 存在回复，修改数据
                $currentDom.find(".official-reply .reply-text").text(reply);
              }
              // 替换回复时间
              if (replyTimestamp) {
                $currentDom.find(".official-reply .reply-time").text(jelenew.functions.formatDateToUs(replyTimestamp));
              }
              // 点赞数
              if (likes) {
                $currentDom.find(".like-count").removeClass("opacity-0").text(likes);
              }
              // 评论id
              $currentDom.attr("data-review-id", reviewId);
              // 用户名称
              $currentDom.find(".review-name").text(userNickname);
              // 用户评论内容
              $currentDom.find(".review-textarea").text(review);
              // 评论时间
              $currentDom.find(".review-time").text(jelenew.functions.formatDateToUs(createTimestamp));
              // $currentDom.find(".review-time").text(latestDayStr);
              // 评论星级
              $currentDom
                .find(".review-satrs .star")
                .eq(overallRating - 1)
                .prevAll()
                .css("fill", "#000000");
              $currentDom
                .find(".review-satrs .star")
                .eq(overallRating - 1)
                .css("fill", "#000000");
              // 评论图片
              if (data.mediaUrls) {
                data?.mediaUrls?.forEach((imgSrc, index) => {
                  $currentDom.find(".media-container").append(`<img src="${imgSrc}"data-index=` + index + `>`);
                });
              } else {
                $currentDom.find(".media-container").addClass("hidden");
              }
              // 用户评论info
              $currentDom.find(".review-detail-item-quality span").text(["Poor", "Average", "Excellent"][data.quality]);
              $currentDom.find(".review-detail-item-fits span").text(["Runs Small", "True to Size", "Runs Large"][data.fits]);
              // 推特分享文案修改
              const t_share_link = $currentDom.find(".share-item.twitter").attr("href").replace("?text=&", `?text=${encodeURIComponent(review)}&`);
              const r_share_link = $currentDom.find(".share-item.reddit").attr("href").replace("?title=&", `?title=${encodeURIComponent(review)}&`);
              $currentDom.find(".share-item.reddit").attr("href", r_share_link);
              $currentDom.find(".share-item.twitter").attr("href", t_share_link);

              $(".review-list-drawer .reviews-container", container).append($currentDom.clone());
            }

            // 第一页 小于3个
            if (pageCount == 1 && reviewList.length <= 3) {
              $(".review-list-drawer .drawer-header .drawer-title .tips", container).hide();
              $(".review-list-drawer .load_page").hide();
              return;
            }
            //第一页 大于3个
            if (pageCount == 1 && reviewList.length > 3) {
              pageType = "first";
              // 第一次评论只能显示三个 后面隐藏
              $(".review-list-drawer .drawer-header .drawer-title .tips", container).show();
              $(".review-list-drawer .reviews-container .review-item:gt(2)").hide();
              // 显示更多按钮
              $(".review-list-drawer .load_page").show();
              return;
            }
            // 是否有下一页 显示还在更多
            if (hasMore) {
              // 显示更多按钮
              $(".review-list-drawer .drawer-header .drawer-title .tips", container).show();
              $(".review-list-drawer .load_page").show();
            } else {
              // 隐藏更多按钮
              $(".review-list-drawer .load_page").hide();
            }
          });
        }

        // 分享按钮点击
        $(container).on("click", ".review-share-btn", function (e) {
          const $this = $(this);
          $(container).find(".review-share-btn").removeClass("active");
          $this.addClass("active");
          setTimeout(() => {
            $this.removeClass("active");
          }, 5000)
        });
        // 关闭分享弹窗
        $(container).on("click", ".review-share-btn .share-box-close", function (e) {
          e.stopPropagation();
          $(this).closest(".review-share-btn").removeClass("active");
        });
        // 点击复制链接分享按钮
        $(container).on("click", ".review-share-btn .copy-link-btn", function () {
          window?.jelenew?.functions?.copyText(window.location.href);
        });
        

        // 商详顶部 品论点击
        $("[data-page-type=product] .jelenew-product-review-summary .jelenew-product-review-count").on("click", function (e) {
          e.stopPropagation(), e.preventDefault();
          // $(".reviews-footer-button.load-more", container).trigger("click");
          var element = document.getElementById("jelenew-product-review");
          element.scrollIntoView({ behavior: "smooth" });
        });

        // 老模版的加载更多
        // $(container).on("click", ".reviews-footer-button.load-more", function (e) {
        //   // sensors.track("ClickDetailsElement", {
        //   //   element_name: "LOAD MORE",
        //   //   module_name: "商品评价",
        //   //   page_position: theme.jelenew_web_page_name,
        //   //   product_name: $(container).data("product-title"),
        //   //   product_id: $(container).data("product-id"),
        //   //   original_price: $(container).data("product-price") / 100,
        //   // });
        //   $("body").addClass("show-review-list-drawer cc-popup-no-scroll");
        //   getReviews("list");
        // });

        // 新版-点击加在更多按钮
        $(container).on("click", ".review-list-drawer .load_page", function (e) {
          if (!listDom.hasClass("get-reviews-loading")) {
            if (pageType == "first") {
              pageType = "list";
              getReviews("first");
            } else {
              pageCount++;
              getReviews("list");
            }
          }
        });
        // 新版-点击选择排序
        $(container).on("click", ".review-list-drawer .drawer-header-sort-content-item", function () {
          $(".review-list-drawer .drawer-header-sort-title", container).removeClass("active");
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            sort = null;
            $(".review-list-drawer .drawer-header-sort-title span", container).html("");
          } else {
            let index = $(this).data("index");
            let value = $(this).data("value");
            sort = { field: index, value: value };
            var name = $(this).data("name");
            $(".review-list-drawer .drawer-header-sort-title span", container).html(name);
            $(".review-list-drawer .drawer-header-sort-content-item", container).removeClass("active");
            $(this).addClass("active");
          }
          if (!listDom.hasClass("get-reviews-loading")) {
            $(".review-list-drawer .drawer-header-sort-content", container).removeClass("active");
            pageCount = 1;
            getReviews("list");
          }
        });

        // 新版-点击选择有无图片
        $(container).on("click", ".jelenew-product-review-body .reviews-img-btn", function () {
          // 点击取消选中
          if ($(this).hasClass("active")) {
            havePic = false;
            $(".jelenew-product-review-body .reviews-img-btn", container).removeClass("active");
            $('.review-filters .review-filter-option[data-star="img"]', container).remove();
            if ($(".review-filter-option", container).length == 0) {
              $(".review-filters", container).removeClass("active");
            }
            pageCount = 1;
            getReviews("list");
            return;
          }
          //点击选中
          $(".review-filters", container).addClass("active");
          $(".review-filters", container).prepend(
            $(`<div class="review-filter-option" data-star="img">
            <span>REVIEWS WITH IMAGES ONLY</span>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#iconfont-guanbianniu"></use>
            </svg>
            </div>`)
          );

          if (!listDom.hasClass("get-reviews-loading")) {
            $(this).addClass("active");
            havePic = true;
            pageCount = 1;
            getReviews("list");
          }
        });
        if (window.innerWidth < 768) {
          // h5 排序div 展开收起
          $(container).on("click", ".review-list-drawer .drawer-header-sort-title", function () {
            $(this).toggleClass("active");
            $(".review-list-drawer .drawer-header-sort-content", container).toggleClass("active");
          });
          // 点击h5-FILTER 已外区域 隐藏
          $(container).on("click", ".review-shade", function () {
            $(".review-list-drawer .drawer-header-filter", container).removeClass("active");
            $(".review-shade", container).removeClass("active");
            $(".jelenew_review_filter_con", container).removeClass("show_col_filter");
          });
        }
        // h5-FILTER 展开
        $(container).on("click", ".review-list-drawer .drawer-header-filter", function () {
          $(this).addClass("active");
          $(".review-shade", container).addClass("active");
          $(".jelenew_review_filter_con", container).addClass("show_col_filter");
        });
        // h5-FILTER 收起
        $(container).on(
          "click",
          ".jelenew-product-review-body  .jelenew_review_filter_con_close svg,.jelenew_review_filter_con .reviews-count-btn",
          function () {
            $(".review-list-drawer .drawer-header-filter", container).removeClass("active");
            $(".review-shade", container).removeClass("active");
            $(".jelenew_review_filter_con", container).removeClass("show_col_filter");
          }
        );

        //滚动加载
        // $(".review-list-drawer .reviews-container", container).on("scroll", async function (e) {
        //   if (
        //     $(this).scrollTop() + $(this).innerHeight() + 100 >= $(this)[0].scrollHeight &&
        //     !$(this).hasClass("get-reviews-loading") &&
        //     !$(this).hasClass("no-more-reviews")
        //   ) {
        //     $(this).addClass("get-reviews-loading");
        //     await getReviews("list");
        //     $(this).removeClass("get-reviews-loading");
        //   }
        // });

        $(container).on("click", ".review-item .like-btn", function () {
          if ($(this).hasClass("active")) {
            return false;
          }
          $(this).addClass("active");
          $(this)
            .closest(".review-actions")
            .find(".like-count")
            .removeClass("opacity-0")
            .text($(this).closest(".review-actions").find(".like-count").text().trim() * 1 + 1);
          jelenewHttp.post("/api/mall/review/likes", { reviewId: $(this).closest(".review-item").data("review-id") });
        });
        // -------------- 加载更多 -- end --------------------

        // 筛选
        // $(document).on("click", function () {
        //   $(".drawer-summary-item .star-line", container).removeClass("active");
        // });

        // 星级筛选
        $(container).on("click", ".jelenew-product-review-body .start-main .star-line", function () {
          // 取消选中
          if ($(this).hasClass("active")) {
            const star = $(this).data("star");
            $(this).removeClass("active");
            $(`.review-filters .review-filter-option[data-star="${star}"]`, container).remove();
            if ($(".review-filter-option", container).length == 0) {
              $(".review-filters", container).removeClass("active");
            }
            overallRatingArr = [];
            if ($(".review-filter-option", container).length > 0) {
              $(`.review-filters .review-filter-option`, container).each(function () {
                if ($(this).data("star") != "img") {
                  overallRatingArr.push($(this).data("star"));
                }
              });
            }
            pageCount = 1;
            getReviews("list");
            return;
          }
          //点击选中
          setTimeout(() => {
            const star = $(this).data("star");
            $(".review-filters", container).addClass("active");
            if ($(`.review-filters .review-filter-option[data-star="${star}"]`, container).length > 0) {
              return false;
            }
            $(".review-filters", container).prepend(
              $(`<div class="review-filter-option" data-star="${star}">
          <span>${star} STARS</span>
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#iconfont-guanbianniu"></use>
          </svg>
          </div>`)
            );
            $(".review-list-drawer .review-item", container).remove();
            $(this).toggleClass("active");
            overallRatingArr = [];
            $(`.review-filters .review-filter-option`, container).each(function () {
              if ($(this).data("star") != "img") {
                overallRatingArr.push($(this).data("star"));
              }
            });
            pageCount = 1;
            getReviews("list");
          }, 0);
        });

        // 清除单个筛选项
        $(container).on("click", ".review-filter-option", function () {
          $(this).remove();
          const star = $(this).data("star");
          $(".review-list-drawer .review-item", container).remove();
          if ($(".review-filter-option", container).length == 0) {
            $(".review-filters", container).removeClass("active");
          }
          overallRatingArr = [];
          $(".review-filters .review-filter-option", container).each(function () {
            if ($(this).data("star") != "img") {
              overallRatingArr.push($(this).data("star"));
            }
          });
          if (star != "img") {
            $('.jelenew-product-review-body .start-main .star-line[data-star="' + star + '"]', container).toggleClass("active");
          } else {
            havePic = false;
            $(".jelenew-product-review-body .reviews-img-btn", container).toggleClass("active");
          }
          pageCount = 1;
          getReviews("list");
        });
        // 清除所有筛选项
        $(container).on("click", ".review-filters .clear", function () {
          $(".review-filters .review-filter-option", container).remove();
          $(".review-list-drawer .review-item", container).remove();
          $(".review-filters", container).removeClass("active");
          $(".jelenew-product-review-body  .start-main .star-line", container).removeClass("active");
          $(".jelenew-product-review-body .reviews-img-btn", container).removeClass("active");
          pageCount = 1;
          sort = null;
          havePic = false;
          overallRatingArr = [];
          getReviews("list");
        });
        // -------------- write a review浮层相关--start -------------
        // window.visualViewport.addEventListener("resize", function () {
        //   const height = window.visualViewport.height;
        //   const maxHeight = height - 100;
        //   const bottom = window.innerHeight - height;
        //   // if (Math.abs(height - window.innerHeight) < 50) {
        //   //   $(".write-review-drawer", container).css({
        //   //     "max-height": "100%",
        //   //     top: "unset",
        //   //     bottom: "0",
        //   //   });
        //   // } else {
        //   //   // 软键盘弹出
        //   //   $(".write-review-drawer", container).css({
        //   //     "max-height": height + "px",
        //   //     top: 0,
        //   //     bottom: "unset",
        //   //   });
        //   // }
        //   console.log("resize", { 视窗高度: height, 屏幕高度: window.innerHeight, 底部距离: bottom });
        // });
        // 打开浮层
        $(container).on("click", ".write-review-button .button", function () {
          $(".write-review-drawer", container)[0].show();
          if ($("#jelenew-aws-sdk").length == 0) {
            let aws_sdk_url = $("div[data-section-type=jelenew-product-review]").attr("data-aws-sdk");
            let aws_script = document.createElement("script");
            aws_script.id = "jelenew-aws-sdk";
            aws_script.src = aws_sdk_url;
            document.body.appendChild(aws_script);
          }
          $("body").addClass("jelenew-show-write-review-drawer");
          if (customerEmail) {
            // 用户已登录
            $('.write-review-drawer input[name="email"]').val(customerEmail);
            $('.write-review-drawer input[name="email"]').attr("disabled", "disabled");
            if (customerFirstName || customerLastName) {
              // 有一个名称存在
              let customerFullName = "";
              if (customerLastName) {
                customerFullName = customerLastName;
              } else {
                customerFullName = customerFirstName;
              }
              $('.write-review-drawer input[name="nickname"]').val(customerFullName);
              $('.write-review-drawer input[name="nickname"]').attr("disabled", "disabled");
            }
          }
          // 神策埋点
          // sensors.track("WebPageView", {
          //   web_page_name: "商品评论页",
          //   forward_page_url:document.referrer,
          //   forward_page_path:document.referrer.split('?')[0]
          // });
          // sensors.track("ClickDetailsElement", {
          //   element_name: "评论入口",
          //   page_position: theme.jelenew_web_page_name,
          //   product_name: $(container).data("product-title"),
          //   product_id: $(container).data("product-id"),
          //   original_price: $(container).data("product-price") / 100,
          // });
        });

        $(container).on("click", ".jelenew-check-box-container .jelenew-check-box", function () {
          $(this).siblings().removeClass("active");
          $(this).addClass("active");
        });

        $(".to-write-first-review", container).on("click", function () {
          $(".write-review-button .button", container).trigger("click");
        });

        // 关闭浮层
        $(container).on("click", ".drawer-header-close, .review-shade, .write-review-drawer-button.cancel", function () {
          //判断是否有评论图片放大
          if ($(".review-image-list", container).is(":visible")) {
            return;
            // $(".review-image-list .review-image-list-main",container).slick("unslick");
            // $(".review-image-list .review-image-list-main",container).html("");
            // $(".review-image-list",container).hide();
          }
          $("body").removeClass("show-review-list-drawer cc-popup-no-scroll jelenew-show-write-review-drawer");
          setTimeout(function () {
            $(".write-review-drawer", container)[0].close();
          }, 300);
        });
        // 图片放大-商品点击关闭浮层
        $(container).on("click", ".review-produc-btn", function () {
          $(".review-image-list .review-image-list-main", container).slick("unslick");
          $(".review-image-list .review-image-list-main", container).html("");
          $(".review-image-list .review-content-main", container).html("");
          $(".review-image-list", container).hide();
          $("body").removeClass("show-review-list-drawer cc-popup-no-scroll jelenew-show-write-review-drawer");
          setTimeout(function () {
            $(".write-review-drawer", container)[0].close();
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }, 300);
        });

        //用户评论输入
        $(container).on("change keyup click", ".feedback-textarea, .info-item input", function (e) {
          if (e.type == "click") {
            //神策埋点
            sensors.track("ClickCommentElement", {
              element_name: "CommentInput",
              page_position: "商品评论页",
              product_name: $(container).data("product-title"),
              product_id: $(container).data("product-id"),
              original_price: $(container).data("product-price") / 100,
            });
          } else {
            let str = $(this).val() + "";
            // 限制字数
            if ($(this).attr("minlength") && $(this).attr("maxlength")) {
              if (str.length >= $(this).attr("minlength") && $(this).attr("maxlength") >= str.length) {
                $(this).parent().removeClass("show-jelenew-input-warnning");
              }
            }
            // 是否存在文字
            if (str.length > 0) {
              $(this).parent().addClass("has_value");
            } else {
              $(this).parent().removeClass("has_value");
            }
            // email格式验证
            if ($(this).attr("type") == "email") {
              if (isRealEmail(str)) {
                $(this).parent().removeClass("show-jelenew-input-warnning");
              }
            }
            // 字数提示
            if ($(this).hasClass("feedback-textarea")) {
              let str_tishi = str.length + "/" + "500";
              $(this).parent().find(".feedback-textarea-tips").text(str_tishi);
            }
          }
        });

        // 提交 按钮
        $(container).on("click", ".write-review-drawer-button.submit", function () {
          // 提交 -- 进行校验
          let has_error = false;
          if (
            !$("input[name=nickname]", container).val() ||
            $("input[name=nickname]", container).val().length < $("input[name=nickname]", container).attr("minlength") ||
            $("input[name=nickname]", container).val().length > $("input[name=nickname]", container).attr("maxlength")
          ) {
            has_error = true;
            $("input[name=nickname]", container).parent().addClass("show-jelenew-input-warnning");
          } else {
            $("input[name=nickname]", container).parent().removeClass("show-jelenew-input-warnning");
          }
          if (!isRealEmail($("input[name=email]", container).val())) {
            has_error = true;
            $("input[name=email]", container).parent().addClass("show-jelenew-input-warnning");
          } else {
            $("input[name=email]", container).parent().removeClass("show-jelenew-input-warnning");
          }
          const $textarea = $("textarea[name=feedback-textarea]", container);
          if ($textarea.val().length < $textarea.attr("minlength") * 1 || $textarea.val().length > $textarea.attr("maxlength") * 1) {
            has_error = true;
            $textarea.parent().addClass("show-jelenew-input-warnning");
          } else {
            $textarea.parent().removeClass("show-jelenew-input-warnning");
          }
          if (has_error) {
            return;
          }
          // 神策埋点
          sensors.track("ClickCommentElement", {
            element_name: "CommentInfoSubmit",
            comment_content: $(".feedback-textarea").val().trim(),
            page_position: "商品评论页",
            product_name: $(container).data("product-title"),
            product_id: $(container).data("product-id"),
            original_price: $(container).data("product-price") / 100,
          });
          // 组装数据 --> 调用接口 --> 关闭弹窗
          let params = makeReviewParmas(container);
          // 调用接口，添加蒙层
          $(".write-review-drawer").append(
            '<div class="jelenew-ajax-mask"><svg t="1658750319020" class="icon jelenew-upload-loading" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4848" width="200" height="200"><path d="M256 529.066667H85.333333a17.066667 17.066667 0 1 1 0-34.133334h170.666667a17.066667 17.066667 0 0 1 0 34.133334z" opacity=".278" p-id="4849"></path><path d="M99.84 640a17.066667 17.066667 0 0 1-4.437333-33.553067l164.693333-44.373333a17.066667 17.066667 0 1 1 8.891733 32.9728l-164.693333 44.373333a17.544533 17.544533 0 0 1-4.4544 0.580267z" opacity=".322" p-id="4850"></path><path d="M264.533333 462.523733a16.896 16.896 0 0 1-4.369066-0.580266l-164.693334-43.52a17.0496 17.0496 0 1 1 8.721067-32.989867l164.693333 43.52a17.066667 17.066667 0 1 1-4.352 33.570133z" opacity=".239" p-id="4851"></path><path d="M384.017067 307.2a17.032533 17.032533 0 0 1-14.7968-8.533333l-85.333334-147.626667a17.066667 17.066667 0 0 1 29.559467-17.083733l85.333333 147.626666A17.066667 17.066667 0 0 1 384.017067 307.2z" opacity=".122" p-id="4852"></path><path d="M639.982933 307.2a17.0496 17.0496 0 0 1-14.762666-25.6l85.333333-147.626667a17.066667 17.066667 0 1 1 29.559467 17.066667l-85.333334 147.626667a17.032533 17.032533 0 0 1-14.7968 8.533333z" opacity=".922" p-id="4853"></path><path d="M692.906667 347.306667a17.066667 17.066667 0 0 1-12.117334-29.098667l120.337067-121.173333a17.066667 17.066667 0 1 1 24.234667 24.046933l-120.337067 121.173333a17.1008 17.1008 0 0 1-12.117333 5.051734z" opacity=".878" p-id="4854"></path><path d="M733.883733 401.066667a17.066667 17.066667 0 0 1-8.5504-31.8464l147.626667-85.333334a17.0496 17.0496 0 1 1 17.066667 29.5424l-147.626667 85.333334a16.776533 16.776533 0 0 1-8.516267 2.304z" opacity=".839" p-id="4855"></path><path d="M512 273.066667a17.066667 17.066667 0 0 1-17.066667-17.066667V85.333333a17.066667 17.066667 0 0 1 34.133334 0v170.666667a17.066667 17.066667 0 0 1-17.066667 17.066667z" p-id="4856"></path><path d="M578.577067 281.6a17.066667 17.066667 0 0 1-16.520534-21.418667l43.52-164.693333a17.066667 17.066667 0 0 1 33.006934 8.721067l-43.52 164.693333a17.066667 17.066667 0 0 1-16.4864 12.6976z" opacity=".961" p-id="4857"></path><path d="M445.44 282.453333a17.066667 17.066667 0 0 1-16.469333-12.629333l-44.373334-164.693333a17.066667 17.066667 0 0 1 32.955734-8.891734l44.373333 164.693334a17.066667 17.066667 0 0 1-16.4864 21.521066z" opacity=".078" p-id="4858"></path><path d="M924.177067 640c-1.4848 0-2.9696-0.187733-4.4544-0.580267l-164.693334-44.373333a17.066667 17.066667 0 0 1 8.874667-32.9728l164.693333 44.373333a17.066667 17.066667 0 0 1-4.420266 33.553067z" opacity=".722" p-id="4859"></path><path d="M881.476267 742.4a17.015467 17.015467 0 0 1-8.482134-2.269867l-148.48-85.333333a17.0496 17.0496 0 1 1 16.9984-29.5936l148.48 85.333333a17.0496 17.0496 0 0 1-8.516266 31.863467z" opacity=".678" p-id="4860"></path><path d="M813.226667 830.293333a17.015467 17.015467 0 0 1-12.066134-5.000533l-120.337066-120.337067a17.0496 17.0496 0 1 1 24.132266-24.132266l120.337067 120.337066a17.0496 17.0496 0 0 1-12.066133 29.1328z" opacity=".639" p-id="4861"></path><path d="M938.666667 529.066667H768a17.066667 17.066667 0 1 1 0-34.133334h170.666667a17.066667 17.066667 0 1 1 0 34.133334z" opacity=".761" p-id="4862"></path><path d="M401.066667 941.226667a17.066667 17.066667 0 0 1-16.4864-21.504l44.373333-164.693334a17.066667 17.066667 0 1 1 32.955733 8.874667l-44.373333 164.693333a17.066667 17.066667 0 0 1-16.469333 12.629334z" opacity=".478" p-id="4863"></path><path d="M298.6496 898.56a17.066667 17.066667 0 0 1-14.779733-25.565867l85.333333-148.48a17.083733 17.083733 0 0 1 29.5936 16.9984l-85.333333 148.48a17.032533 17.032533 0 0 1-14.813867 8.567467z" opacity=".439" p-id="4864"></path><path d="M512 955.733333a17.066667 17.066667 0 0 1-17.066667-17.066666V768a17.066667 17.066667 0 1 1 34.133334 0v170.666667a17.066667 17.066667 0 0 1-17.066667 17.066666z" opacity=".522" p-id="4865"></path><path d="M725.3504 898.56a17.032533 17.032533 0 0 1-14.7968-8.533333l-85.333333-147.626667a17.066667 17.066667 0 0 1 29.559466-17.066667l85.333334 147.626667a17.066667 17.066667 0 0 1-14.762667 25.6z" opacity=".6" p-id="4866"></path><path d="M622.062933 942.08c-7.509333 0-14.421333-5.0176-16.469333-12.629333l-44.3904-164.693334a17.066667 17.066667 0 1 1 32.9728-8.874666l44.3904 164.693333a17.066667 17.066667 0 0 1-16.503467 21.504z" opacity=".561" p-id="4867"></path><path d="M759.4496 463.36a17.083733 17.083733 0 0 1-4.420267-33.553067l164.693334-44.373333a17.066667 17.066667 0 0 1 8.874666 32.955733l-164.693333 44.373334a16.657067 16.657067 0 0 1-4.4544 0.597333z" opacity=".702" p-id="4868"></path><path d="M330.24 347.306667a17.015467 17.015467 0 0 1-12.066133-5.000534l-120.32-120.32a17.0496 17.0496 0 1 1 24.132266-24.132266l120.32 120.32a17.0496 17.0496 0 0 1-12.066133 29.1328z" opacity=".161" p-id="4869"></path><path d="M290.116267 401.066667a17.032533 17.032533 0 0 1-8.533334-2.286934l-147.626666-85.333333a17.066667 17.066667 0 1 1 17.083733-29.5424l147.626667 85.333333a17.066667 17.066667 0 0 1-8.5504 31.829334z" opacity=".2" p-id="4870"></path><path d="M142.523733 742.4a17.066667 17.066667 0 0 1-8.567466-31.8464l147.626666-85.333333a17.066667 17.066667 0 1 1 17.083734 29.559466l-147.626667 85.333334a16.930133 16.930133 0 0 1-8.516267 2.286933z" opacity=".361" p-id="4871"></path><path d="M209.92 830.293333a17.066667 17.066667 0 0 1-12.117333-29.098666l120.32-121.173334a17.066667 17.066667 0 0 1 24.2176 24.029867l-120.32 121.1904a16.896 16.896 0 0 1-12.100267 5.051733z" opacity=".4" p-id="4872"></path></svg></div>'
          );
          jelenewHttp
            .post("/api/mall/review/create", params)
            .then(function (res) {
              resetDomData();
              theme.JelenewTips(
                {
                  title: theme?.jsUse?.tips?.review_title,
                  text: theme?.jsUse?.tips?.review_thx,
                },
                "success"
              );
              document.dispatchEvent(
                new CustomEvent("jelenew:review-create", {
                  bubbles: true,
                  cancelable: false,
                  detail: res,
                })
              );
            })
            .catch(function (err) {
              theme.JelenewTips(theme?.jsUse?.tips?.comment_failed);
              document.dispatchEvent(
                new CustomEvent("jelenew:review-create", {
                  bubbles: true,
                  cancelable: false,
                  detail: err,
                })
              );
            })
            .finally(() => {
              $(".write-review-drawer .jelenew-ajax-mask").remove();
              $("body").removeClass("jelenew-show-write-review-drawer");
            });
        });
        // 邮箱验证函数
        function isRealEmail(str) {
          let reg = new RegExp(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/);
          return reg.test(str.trim());
        }
        // review入参组装
        function makeReviewParmas(container) {
          let params = {
            identifyTicket: $(container).data("order-id"),
            identifyCode: $("input[name=email]", container).val().trim(),
            productId: $(container).data("product-id"),
            userNickname: $("input[name=nickname]", container).val().trim(),
            userEmail: $("input[name=email]", container).val().trim(),
            overallRating: 5,
            // mediaUrls: Array.from(mediaUrls.values()).join(" "),
            // mediaType: $(".upload-container").data("mediaType") * 1,
            userInfo: [
              // 尺码
              // {
              //   field: "size",
              //   value: $("input[name=size]").val().trim(),
              // },
              // // 身高
              // {
              //   field: "height",
              //   value: $("input[name=height]").val().trim(),
              // },
              // 是否合身
              {
                field: "fits",
                value: $(".jelenew-check-box-container.fits .active", container).data("value"),
              },
              {
                field: "quality",
                value: $(".jelenew-check-box-container.quality .active", container).data("value"),
              },
            ],
            review: $("textarea[name=feedback-textarea]").val().trim(),
            userTimeZone: -new Date().getTimezoneOffset() / 60,
          };
          return params;
        }
        // 重置dom数据
        function resetDomData() {
          $("input, textarea", container).each(function () {
            $(this).val("");
          });
        }
        // -------------- write a review浮层相关--end ---------------

        // -------------- input 清除按钮展示与隐藏 -- start ---------
        $(container).on("change keyup customBlur", "input[name=nickname], input[name=email]", showOrhiddenCloseIcon);
        $(container).on("click", "input[name=nickname], input[name=email]", function () {
          let element_name = "EmailInput";
          if ($(this).attr("name") == "nickname") {
            element_name = "NicknameInput";
          }
          // 神策埋点
          sensors.track("ClickCommentElement", {
            element_name,
            page_position: "商品评论页",
            product_name: $(container).data("product-title"),
            product_id: $(container).data("product-id"),
            original_price: $(container).data("product-price") / 100,
          });
        });
        // 失去焦点后去除首尾空格
        $(container).on("blur", "input[name=nickname], input[name=email]", function () {
          $(this).val($(this).val().trim());
          $(this).trigger("customBlur");
        });
        function showOrhiddenCloseIcon(e) {
          let $this = $(e.target);
          let s = $this.val();
          if (s.length > 0) {
            $this.parent().addClass("has_value");
          } else {
            $this.parent().removeClass("has_value");
          }
          // 进行校验，删除警告
          //if($this.attr("name") === "nickname"){
          //    if($this.val().length >= 4){
          //        $this.parent().removeClass("show-jelenew-input-warnning");
          //    }
          //} else {
          //    if(isRealEmail($this.val())) $this.parent().removeClass("show-jelenew-input-warnning");
          //}
        }

        $(container).on("click", ".info-nickname-close, .info-email-close, .feedback-textarea-close", function () {
          $(this).parent().find("input").val("");
          $(this).parent().find("input").trigger("change");
          $(this).parent().find("textarea").val("");
          $(this).parent().find("textarea").trigger("change");
        });

        // -------------- input 清除按钮展示与隐藏 -- end -----------

        // -------------- 评论图片放大 轮播 -- start ---------
        $(container).on("click", ".review-list-drawer .media-container img", function () {
          if ($(".review-image-list", container).is(":visible")) {
            return;
          }
          //获取图片内容
          var $images = $(this).closest(".media-container").find("img");
          var index = $(this).data("index"); //获取点击的第几张图片
          //将图片写入图片碳层
          $images.each(function () {
            // 对每个img元素执行操作
            $(".review-image-list .review-image-list-main", container).append(
              `<div class="img-item"><img src="${this.src}" data-index=` + index + `></div>`
            );
          });
          //获取评论星级和内容
          var stars = $(this).closest(".review-item").find(".review-header").html();
          var con = $(this).closest(".review-item").find(".review-textarea").html();
          $(".review-image-list .review-content-main", container).append(`<div class="review-line"></div>`);
          $(".review-image-list .review-content-main", container).append(`<div class="review-header">${stars}</div>`);
          $(".review-image-list .review-content-main", container).append(`<div class="review-textarea">${con}</div>`);
          //现实图片碳层
          $(".review-image-list", container).show();
          //使用slick
          const slickCfg = {
            lazyLoad: "ondemand",
            arrows: true,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            touchThreshold: 5,
            swipe: true,
            speed: 0,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          };
          $(".review-image-list .review-image-list-main", container).slick(slickCfg);
          $(".review-image-list .review-image-list-main", container).slick("slickGoTo", index);
        });
        //关闭评论图片放大
        $(container).on("click", ".review-image-list .review-image-list-header", function () {
          $(".review-image-list .review-image-list-main", container).slick("unslick");
          $(".review-image-list .review-image-list-main", container).html("");
          $(".review-image-list .review-content-main", container).html("");
          $(".review-image-list", container).hide();
        });
        // -------------- 评论图片放大 轮播 -- end ---------
        // -------------- 初始化 -------------------------
        // 解决页面初始加载时，浮层有时会突然闪现
        if ($("body").data("page-type") == "product") {
          $(function ($) {
            // 初始加载基本信息
            jelenewHttp.post("/api/mall/review/summary/v3", { productId: $(container).data("product-id") }).then(function (res) {
              const { info } = res.result;
              const avgFits = info.avgFits / 2;
              const avgQuality = info.avgQuality / 2;
              $(".line-container.fits .line", container).css({
                // background: `linear-gradient(to right, #fff 0%, #000 ${avgFits * 100}%, #fff 100%)`,
                background: `linear-gradient( 90deg, #E6E6E6 22%, #000000 51%, rgba(0,0,0,0.96) 51%, #E6E6E6 80%)`,
              });
              $(".line-container.quality .line", container).css({
                // background: `linear-gradient(to right, #fff 0%, #000 ${avgQuality * 100}%, #fff 100%)`,
                background: `linear-gradient( 90deg, #E6E6E6 0%, #E6E6E6 0%, #E6E6E6 49%, #000000 99%, #000000 99%)`,
              });
              info.overallRatingList.forEach((arr, i) => {
                const val = arr[1].value;
                $(".reviews-header-title-mid", container).each(function () {
                  $(".count", this)
                    .eq(i)
                    .text("(" + val + ")");
                });
                $(".jelenew_review_filter_con", container).each(function () {
                  $(".count", this)
                    .eq(i)
                    .text("(" + val + ")");
                });
              });
              $(".reviews-img-btn .count", container).html("(" + info.haveMediaCount + ")");
              // $reviewCount = reviewCount;
              // if (reviewCount == 0) {
              //   $(".title-count", container).css("display", "none");
              // } else {
              //   // 更新总评论数
              //   $(".title-count", container).text("(" + reviewCount.toLocaleString() + ")");
              // }
            });
            getReviews("list");
          });
        }
        // -------------- 初始化 -------------------------
      };
    })();
    
    theme.jelenew_money_to_number = function (str) {
      str += "";
      let original_price = "0";
      str
        .trim()
        .split("")
        .forEach((n) => {
          if (parseFloat(n).toString() != "NaN") {
            original_price += n;
          }
        });
      return original_price / 100;
    };

    // theme.CollectionTemplateSection = new (function () {
    //   this.onSectionLoad = function (container) {
    //     this.namespace = theme.namespaceFromSection(container);
    //     this.$container = $(container);

    //     this.filterer = new theme.LoadFilterer(this);

    //     // button subcollection link hide/reveal
    //     $(window).on("debouncedresize" + this.namespace, this.functions.truncateButtonSubcollections.bind(this));
    //     this.functions.truncateButtonSubcollections.call(this);

    //     // gallery subcollection carousel
    //     var $subcollectionGallery = $(".subcollection-links--gallery .gallery", container);
    //     $subcollectionGallery
    //       .on("init", function () {
    //         $(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload");
    //       })
    //       .slick({
    //         autoplay: false,
    //         fade: false,
    //         infinite: false,
    //         swipeToSlide: true,
    //         slidesToShow: Math.min(4, $(".subcollection-links--gallery .gallery__item", container).length),
    //         slidesToScroll: 1,
    //         useTransform: true,
    //         arrows: true,
    //         dots: false,
    //         prevArrow:
    //           '<button type="button" class="image-page-button image-page-button--previous" aria-label="' +
    //           theme.strings.previous +
    //           '">' +
    //           theme.icons.chevronLeft +
    //           "</button>",
    //         nextArrow:
    //           '<button type="button" class="image-page-button image-page-button--next" aria-label="' +
    //           theme.strings.next +
    //           '">' +
    //           theme.icons.chevronRight +
    //           "</button>",
    //         responsive: [
    //           {
    //             breakpoint: 1000,
    //             settings: {
    //               slidesToShow: Math.min(3, $(".subcollection-links--gallery .gallery__item", container).length),
    //             },
    //           },

    //           {
    //             breakpoint: 768,
    //             settings:
    //               $subcollectionGallery.data("mobile-item-count") == "hide"
    //                 ? "unslick"
    //                 : {
    //                     slidesToShow: $subcollectionGallery.data("mobile-item-count"),
    //                   },
    //           },
    //         ],
    //       });

    //     if (theme.jelenew_web_page_name == "分类列表页") {
    //       // collection页面
    //       $(".product-block").on("click", ".product-link", function () {
    //         sensors.track("ClickProductList", {
    //           page_position: "分类列表页",
    //           list_type: "分类列表",
    //           list_name: location.pathname.split("/").pop(),
    //           product_name: $(this).parents(".product-block").find(".product-block__title").text().trim(),
    //           product_id: $(this).parents(".product-block").attr("data-product-id"),
    //           original_price: Number(
    //             (
    //               $(this).parents(".product-block").find(".product-price__compare").text().trim() ||
    //               $(this).parents(".product-block").find(".product-price__amount").text().trim()
    //             )
    //               .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
    //               .replace(",", ".")
    //           ),
    //         });
    //       });
    //     }
    //   };

    //   this.onSectionUnload = function (container) {
    //     this.filterer.destroy();
    //     $(".subcollection-links__expander", this.$container).off("click");
    //     $(".slick-slider", container).slick("unslick").off("init");
    //     $(window).off(this.namespace);
    //   };

    //   this.functions = {
    //     truncateButtonSubcollections: function truncateButtonSubcollections() {
    //       var $subcollections = $(".subcollection-links--buttons", this.$container);
    //       if ($subcollections.css("display") == "flex") {
    //         var limit = 4;
    //         var $btns = $subcollections.find(".btn");
    //         if ($btns.length > limit && $subcollections.find(".subcollection-links__expander").length === 0) {
    //           $btns.slice(limit - 1).hide();
    //           $('<a href="#" class="btn btn--tertiary subcollection-links__expander">')
    //             .text(theme.strings.collections_general_see_all_subcollections)
    //             .appendTo($subcollections)
    //             .on("click", function (evt) {
    //               evt.preventDefault();
    //               $(this).siblings().show();
    //               $(this).remove();
    //             });
    //         }
    //       } else if ($subcollections.find(".subcollection-links__expander").length) {
    //         $subcollections.find(".subcollection-links__expander").siblings().show();
    //         $subcollections.find(".subcollection-links__expander").remove();
    //       }
    //     },
    //   };
    // })();

    theme.CustomRowSection = new (function () {
      this.onSectionLoad = function (container) {
        theme.VideoManager.onSectionLoad(container);
      };

      this.onSectionUnload = function (container) {
        theme.VideoManager.onSectionUnload(container);
      };
    })();

    // theme.FeaturedProductSection = new (function () {
    //   this.onSectionLoad = function (container) {
    //     $(".product-form", container).trigger("load-product-form");
    //     theme.initProductGallery(container);
    //   };

    //   this.onSectionUnload = function (container) {
    //     theme.destroyProductGallery(container);
    //     theme.OptionManager.unloadProductOptions($(".product-form", container));
    //     $(".slideshow", container).slick("unslick");
    //   };
    // })();

    theme.FooterSection = new (function () {
      this.onSectionLoad = function (container) {
        this.container = container;
        this.functions.appendTemplate(".jelenew-footer-section-template", container);
        this.functions.footerInit(container);
      };

      this.onSectionUnload = function (container) {
        $(".disclosure", container).each(function () {
          $(this).data("disclosure").unload();
        });
      };
      this.functions = {
        appendTemplate: (tem_class_name, box = this.container) => {
          const class_name = tem_class_name.replace("-template", "");
          if ($(class_name, box).length == 0) {
            const dom = $(tem_class_name)[0].content.cloneNode(true);
            box.appendChild(dom);
            return true;
          } else {
            return false;
          }
        },
        footerInit: (container) => {
          $(container).removeClass("jelenew-section-loading");
          $(".disclosure", container).each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          });

          $(".jelenew-signup-form__email .signup-form__button")
            .off("click")
            .on("click", function () {
              var email = $(this).siblings().val();
              emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
              if (email && emailReg.test(email)) {
                //异步提交订阅
                $(this).attr("disabled", "true");
                sensors.setProfile({ subscribe_email: email });
                localStorage.setItem("jelenew_subscription_email", email);
                jelenewHttp
                  .post("/api/shop/customer/subscribe", {
                    subscribeCode: email,
                    country: Shopify.country,
                  })
                  .then(function () {
                    $("[data-section-type=newsletter-popup]")[0].popup_strategy = "点击触发";
                    jelenew.functions.discountCodeHave();
                    var shopify_section_popup = $(".section-popup");
                    shopify_section_popup.addClass("cc-popup--visible");
                    shopify_section_popup.find(".cc-popup-form__response--success").show();
                    shopify_section_popup.find(".cc-popup-form__response--success").siblings().hide();
                    gtag("event", "jelenew_subscribe", { email });
                    sensors.track("ClickLayerSubmit", {
                      element_name: "Submit",
                      email_input: email,
                      popup_type: "Popup",
                      popup_strategy: $("[data-section-type=newsletter-popup]")[0].popup_strategy,
                      popup_name: "订阅弹层",
                      subscription_method: "底部订阅"
                    });
                    // 点击复制
                    $(".cc-popup-form__discount--btn")
                      .off("click")
                      .on("click", function () {
                        const code = $("#discount-code-textarea").data("discount-code");
                        jelenew.functions.copyText(code);
                        $("#discount-code-textarea").hide();
                        //关闭弹框
                        $(".cc_popup_close_only").trigger("click");
                        //埋点
                        var openPopupType = sessionStorage.getItem("openPopupType");
                        sensors.track("ClickCopy", {
                          page_position: theme.jelenew_web_page_name,
                          business_name: "code码",
                          popup_strategy: $("[data-section-type=newsletter-popup]")[0].popup_strategy,
                          copy_content: code,
                        });
                      });
                  })
                  .catch((err) => {
                    let desc = "Network Error";
                    if (err.status && err.status.desc) {
                      desc = err.status.desc;
                    }
                    theme.JelenewTips(desc);
                  })
                  .finally(() => {
                    $(this).removeAttr("disabled");
                  });
              } else {
                theme.JelenewTips(theme?.jsUse?.tips?.check_email);
              }
            });
        },
      };
    })();

    theme.GallerySection = new (function () {
      this.onSectionLoad = function (container) {
        var $carouselGallery = $(".gallery--mobile-carousel", container);
        if ($carouselGallery.length) {
          var assessCarouselFunction = function assessCarouselFunction() {
            var isCarousel = $carouselGallery.hasClass("slick-slider"),
              shouldShowCarousel = $(window).width() < 768;

            if (!shouldShowCarousel) {
              $(".lazyload--manual", $carouselGallery).removeClass("lazyload--manual").addClass("lazyload");
            }

            if (isCarousel && !shouldShowCarousel) {
              // Destroy carousel

              // - unload slick
              $carouselGallery.slick("unslick").off("init");
              $carouselGallery.find("a, .gallery__item").removeAttr("tabindex").removeAttr("role");

              // - re-row items
              var rowLimit = $carouselGallery.data("grid");
              var $currentRow = null;
              $carouselGallery.find(".gallery__item").each(function (index) {
                if (index % rowLimit === 0) {
                  $currentRow = $('<div class="gallery__row">').appendTo($carouselGallery);
                }
                $(this).appendTo($currentRow);
              });
            } else if (!isCarousel && shouldShowCarousel) {
              // Create carousel

              // - de-row items
              $carouselGallery.find(".gallery__item").appendTo($carouselGallery);
              $carouselGallery.find(".gallery__row").remove();

              // - init carousel
              $carouselGallery
                .on("init", function () {
                  $(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload");
                })
                .slick({
                  autoplay: false,
                  fade: false,
                  infinite: true,
                  useTransform: true,
                  arrows: false,
                  dots: true,
                  customPaging: function customPaging(slider, i) {
                    return (
                      '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0">' +
                      '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve">' +
                      '<circle class="circle-one" cx="15" cy="15" r="13" />' +
                      '<circle class="circle-two" cx="15" cy="15" r="13" />' +
                      "</svg>" +
                      "</button>"
                    );
                  },
                });
            }
          };

          assessCarouselFunction();
          $(window).on("debouncedresize.themeSection" + container.id, assessCarouselFunction);
        }

        // Tidier typography
        $(".overlay-text__title, .overlay-text__rte", container).each(function () {
          theme.avoidUnecessaryOrphans(this);
        });
      };

      this.onSectionUnload = function (container) {
        $(window).off(".themeSection" + container.id);
        $(".slick-slider", container).each(function () {
          $(this).slick("unslick").off("init");
        });
      };

      this.onBlockSelect = function (block) {
        var blockSlideIndex = $(block).data("slick-index");
        $(block)
          .closest(".slick-slider")
          .each(function () {
            $(this).slick("slickGoTo", blockSlideIndex);
          });
      };
    })();

    theme.JelenewHeaderSection = new (function () {
      this.onSectionLoad = function (container) {
        const _this = this;
        _this.container = container;
        _this.HeaderMenuTemplateNode = document.getElementById("header-menu-template").content.cloneNode(true);
        if (!localStorage.getItem("jelenew_hide_sign_in_logo")) {
          $("#pageheader").addClass("jelenew_sign_in_logo_tips_show");
        }
        let closeNavTimer = null; // 保存滑出收起的演示器id
        // 桌面一级导航点击
        $(".desktop-only.nav-container", container).on(
          "click mouseenter",
          ".navigation__link",
          theme.debounce(function (e) {
            if (closeNavTimer) {
              clearTimeout(closeNavTimer);
            }
            if ($(container).hasClass("show-search") || !$(this).hasClass("has_dropdown")) {
              $(container).removeClass("show-search");
              $(".header-search-layer-jelenew .jelenew_search_layer_wrap", container).removeClass("layer_has_show jelenew_search_layer_show");
            }
            // 再低点击后->关闭当前导航
            if ($(this).hasClass("active")) {
              if (e.type === "click") {
                $(".header-menu-popup-jelenew .PC_nav_close", container).trigger("click");
                $(this).removeClass("active");
              }
              return false;
            }
            $("body").addClass("cc-popup-no-scroll");
            $(".main-header  .navigation__link.active", container).removeClass("active");
            $(this).addClass("active");
            // 埋点
            sensors.track("ClickFirstTab", {
              first_tab_name: $(".link_title", this).text().trim(),
            });
            if (!$(this).hasClass("has_dropdown")) {
              $(container).removeClass("show-menu");
              $("body").removeClass("show-nav-shade cc-popup-no-scroll");
              return false;
            }
            _this.functions.headerTemplateInit(container);
            $(container).addClass("show-menu");
            $("body").addClass("show-nav-shade cc-popup-no-scroll");
            const link_title = $(this).find(".link_title").text().trim();
            $(".header-menu-popup-jelenew .nav_popup-container", container).empty();
            // 导航菜单插入
            const nav = _this.HeaderMenuTemplateNode.querySelector(`.nav-container [data-link-title="${link_title}"]`).cloneNode(true);
            // const $nav = $($("#header-menu-template").html()).find(`.nav-container [data-link-title="${link_title}"]`).clone();
            $(".header-menu-popup-jelenew .nav_popup-container", container).append($(nav));
            // // 广告位插入
            // const first_href = $("a:first-child", nav).attr("href");
            _this.functions.appendPcMenuImg.call(_this, $(this).index());
          }, 200)
        );
        // 桌面末级菜单
        // $(container).on(
        //   "click mouseenter",
        //   ".header-menu-popup-jelenew .nav_popup-container a.nav-child-item",
        //   theme.debounce(function () {
        //     _this.functions.appendPcMenuImg.call(_this, $(this).index());
        //   }, 200)
        // );
        // 点击头部隐藏cart mini
        $(container).on("click", function () {
          // theme.removeAddedCartDrawer();
        });
        // 滑出菜单收起
        $(container).on("resize mouseleave", function () {
          $(".header-menu-popup-jelenew .PC_nav_close", container).trigger("click");
        });
        $(container).on("mouseenter", ".announcement-bar", function () {
          $(".header-menu-popup-jelenew .PC_nav_close", container).trigger("click");
        });
        // 桌面点击关闭菜单
        $(container).on("click", ".header-menu-popup-jelenew .PC_nav_close", function () {
          $(".navigation__link.active", container).removeClass("active");
          $(container).removeClass("show-menu");
          $("body").removeClass("show-nav-shade cc-popup-no-scroll");
        });
        // 移动端打开菜单浮层
        $(container).on("click", ".main-header .menu.mobile-only", function () {
          if ($(container).hasClass("show-search")) {
            $(container).removeClass("show-search");
            $(".header-search-layer-jelenew .jelenew_search_layer_wrap", container).removeClass("layer_has_show jelenew_search_layer_show");
          }
          if ($(container).hasClass("show-menu")) {
            // 关闭
            // $("body").removeClass("cc-popup-no-scroll");
            // $(container).removeClass("show-menu");
            // if ($("body").attr("data-page-type") == "index" &&
            //   $(window).scrollTop() == 0
            //  ){
            //   $(container).addClass("transparency-header");
            // }
          } else {
            $(container).removeClass("transparency-header");
            _this.functions.headerTemplateInit(container);
            const CONTENT = document.getElementById("header-menu-template").content.cloneNode(true);
            // 菜单插入
            if ($(".header-menu-popup-jelenew .nav_popup-container .nav-container", container).length == 0) {
              const $navContainer = $("<div class='nav-container'></div>");
              const currentMenuDOM = CONTENT.querySelectorAll(".nav-container>*");
              currentMenuDOM.forEach((item) => {
                // console.log(item)
                $navContainer.append(item.cloneNode(true));
              });

              $(".header-menu-popup-jelenew .nav_popup-container", container).empty();
              $(".header-menu-popup-jelenew .nav_popup-container", container).append($navContainer);
              // $(".header-menu-popup-jelenew .adv_popup-container", container).empty();
            }
            setTimeout(() => {
              $(container).addClass("show-menu");
              $("body").addClass("show-nav-shade cc-popup-no-scroll");
            }, 0);
          }
        });
        // pc端 点击关闭按钮  关闭菜单浮层
        $(container).on("click", ".pc-search-colse", function () {
          $(container).removeClass("show-search");
          $(".header-search-layer-jelenew .jelenew_search_layer_wrap", container).removeClass("layer_has_show jelenew_search_layer_show");
          // 关闭搜索
          // $("body").removeClass("cc-popup-no-scroll");
        });
        // 移动端关闭菜单浮层
        $(container).on("click", ".H5_nav_close", function () {
          // 关闭
          // $(".header-menu-popup-jelenew .navigation__link.has_dropdown.active .nav-child-list", container).css({
          //   opacity: 0,
          //   height: "0px",
          // });
          $(".header-menu-popup-jelenew .navigation__link.has_dropdown.active", container).removeClass("active");

          $(container).removeClass("show-menu");
          $("body").removeClass("show-nav-shade cc-popup-no-scroll");
          if ($("body").attr("data-page-type") == "index" && $(window).scrollTop() == 0) {
            $(container).addClass("transparency-header");
          }
          if ($(container).hasClass("show-search")) {
            _this.functions.closeSearch();
          }
        });
        // 移动端展开菜单项 -> 一级
        $(container).on("click", ".nav-container:not(.desktop-only) .has_dropdown", function (e) {
          if (e.target.tagName === "A" && e.target.getAttribute("href")) {
            return true;
          }
          if ($(this).hasClass("active")) {
            $(".nav-child-list", this).removeClass("active");
          } else {
            $(this).siblings(".active").removeClass("active").find(".has_dropdown").removeClass("active");
            $(".has_dropdown", this).eq(0).addClass("active");
            // $(".nav-child-list", this).each(function () {
            //   let height = 0;
            //   $(".nav-child-item", this).each(function () {
            //     height += $(this).height() + 1;
            //   });
            //   $(this).css({ "--max-height": height + "px" });
            // });
          }
          $(this).toggleClass("active");
          // 匹配图片
          // const CONTENT = document.getElementById("header-menu-template").content.cloneNode(true);
          // $(".nav-child-list>.nav-child-item", this).each(function () {
          //   if (!$(this).hasClass("img-init")) {
          //     const link_url = $(this).attr("href");
          //     const currentAdvDOMs = CONTENT.querySelector(`.link-container .header-adv-item[href="${link_url}"]`);
          //     if (currentAdvDOMs) {
          //       $(this)[0].append(currentAdvDOMs.cloneNode(true));
          //     }
          //     $(this).addClass("img-init");
          //   }
          // });
        });
        
        // 移动端展开菜单项 -> 二级
        // $(container).on("click init", ".nav-child-item.has_dropdown>.flex-center-spb", function () {
        //   $(this).parent().toggleClass("active");
        //   const $list = $(this).siblings(".nav-child-list");
        //   if (!$list.css("--max-height")) {
        //     // 写入最大高度
        //     let max_h = 0;
        //     $list.children().each(function () {
        //       max_h += $(this).height() + 20;
        //     });
        //     $list.css("--max-height", Math.round(max_h) + "px");
        //   }
        // });
        // 页面大小切换后，重置导航菜单
        $(window).on("resize", function () {
          if (window.innerWidth >= 768 && $(".header-menu-popup-jelenew .nav_popup-container .nav-container", container).length > 0) {
            // PC
            $(".header-menu-popup-jelenew .nav_popup-container", container).empty();
            $(container).removeClass("show-menu");
            $("body").removeClass("show-nav-shade cc-popup-no-scroll");
          } else if (window.innerWidth <= 767 && $(".header-menu-popup-jelenew .nav_popup-container>.nav-child-list", container).length > 0) {
            // H5
            $(".header-menu-popup-jelenew .nav_popup-container", container).empty();
            $(container).removeClass("show-menu");
            $("body").removeClass("show-nav-shade cc-popup-no-scroll");
            $(".desktop-only.nav-container>.active").removeClass("active");
          }
        });

        // 点击搜索按钮
        $(container).on("click", ".show-search-link__icon .search-icon, .desktop-search-trigger, .jelenew_search_layer_back", async function (e) {
          if (
            $(e.target).hasClass("search-icon") ||
            $(e.target).hasClass("desktop-search-trigger") ||
            $(e.target).hasClass("jelenew_search_layer_back")
          ) {
            if ($(e.target).hasClass("desktop-search-trigger")) {
              return $(".main-search__input", container).trigger("triggerSearch");
            }
          } else {
            return false;
          }
          if ($(container).hasClass("show-menu")) {
            if ($(".header-menu-popup-jelenew .PC_nav_close", container).css("display") == "none") {
              // H5
              $(".main-header .menu.mobile-only", container).trigger("click");
            } else {
              // PC
              $(".header-menu-popup-jelenew .PC_nav_close", container).trigger("click");
            }
          }
          _this.functions.headerTemplateInit(container);
          $(".header-search-layer-jelenew .jelenew_search_layer_wrap", container).toggleClass("layer_has_show jelenew_search_layer_show");
          if ($(container).toggleClass("show-search").hasClass("show-search")) {
            // 打开搜索
            $("body").addClass("cc-popup-no-scroll");
            // sensors.track("WebPageView", {
            //   web_page_name: "搜索中间页",
            // });
            // 初始化搜索浮层中的轮播图
            // if ($(".jelenew_search_products_col[jelenew-need-slick-init]", container).length > 0) {
            //   $(".jelenew_search_products_col", container).removeAttr("jelenew-need-slick-init");
            //   $(".jelenew_search_products").slick({
            //     lazyLoad: "ondemand",
            //     arrows: true,
            //     dots: true,
            //     dotsClass: "slick-dots",
            //     infinite: true,
            //     slidesToShow: 2,
            //     slidesToScroll: 2,
            //     prevArrow:
            //       '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            //     nextArrow:
            //       '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
            //   });
            // }
          } else {
            // 关闭搜索
            $("body").removeClass("cc-popup-no-scroll");
          }
          $(".jelenew_search_layer_wrap", container).css("top", $("#pageheader").height() + $("#pageheader")[0].getBoundingClientRect().top);
          // 热词接口调用 拼接模板配置
          if ($(".jelenew_search_keywords.loading").length > 0) {
            let search_res = [];
            try {
              search_res = await jelenewHttp.post("/api/mall/product/keyword/top");
            } catch (error) {}
            let queryWords = search_res?.result?.info?.keywords.map((item) => item.key) || [];
            let realWords = [
              ...new Set([
                ...window.jelenew.search,
                ...queryWords,
                "Bib Shorts",
                "Jersey",
                "Base Layer",
                "Tights",
                "Shorts",
                "Padded",
                "Top",
                "Bra",
                "Skorts",
                "Jacket",
              ]),
            ].splice(0, 10);
            $(".jelenew_search_keywords.loading>.jelenew_search_keyword").each(function (i, el) {
              $("a", el)
                .attr("href", $("a", el).attr("href").replace("&q=&", `&q=${realWords[i]}&`))
                .text(realWords[i]);
            });
            $(".jelenew_search_keywords.loading").removeClass("loading");
          }
        });
        // 触发搜索
        $(container).on("keyup triggerSearch", ".main-search__input", function (e) {
          if ($(this).val().length > 0) {
            // 显示输入清除按钮
            $(".input-clearn", container).show();
          } else {
            $(".input-clearn", container).hide();
          }
          if (e.keyCode == 13 && e.type == "keyup") {
            sensors.track("ClickSearchmiddleElement", {
              page_position: "搜索中间页",
              element_name: "搜索输入框",
              keyword: $(this).val(),
            });
            location.href = encodeURI(`${location.origin}${Shopify.routes.root}search?type=product&options[prefix]=last&q=${$(this).val()}`);
          }
        });
        $(container).on("click", ".header-search-icon", function () {
          var searchValue = $(".main-search__input", container).val();
          location.href = encodeURI(`${location.origin}${Shopify.routes.root}search?type=product&options[prefix]=last&q=${searchValue}`);
        });
        // 清除搜索框文字
        $(container).on("click", ".input-clearn", function () {
          $(".main-search__input", container).val("");
          $(".input-clearn", container).hide();
        });
        // 打开登录浮层
        // if ($("body").data("page-type") != "customers/login") {
        //   $(container).on("click", ".header-account-link[data-type=customer].customer-not-login", function (e) {
        //     $("#pageheader").removeClass("jelenew_sign_in_logo_tips_show");
        //     localStorage.setItem("jelenew_hide_sign_in_logo", 1);
        //     if ($("#shopify-section-jelenew-login-drawer").length == 0) {
        //       $("body")[0].appendChild(document.getElementById("jelenew-login-drawer-template").content.cloneNode(true));
        //     }
        //     $("body").addClass("show-jelenew-login-drawer");
        //     $(".page-shade").on("click", function (params) {
        //       $(".jelenew-login-drawer .drawer-header-close").trigger("click");
        //     });
        //   });
        // }

        // H5菜单栏中--地区切换
        // 打开下拉选项
        $(container).on("click", ".jelenew-country-selector .current_country", function () {
          $(this).closest(".jelenew-country-selector").addClass("on-focus");
          // sensors.track("ClickAnyElement", {
          //   element_name: "货币选择入口",
          // });
        });
        // 地区切换点击
        $(container).on("click", ".jelenew-country-selector .jelenew-select-option", function () {
          if ($(this).hasClass("jelenew-selected")) {
            $(this).closest(".jelenew-country-selector").removeClass("on-focus");
          } else {
            $(this).closest(".jelenew-country-selector").find(".jelenew-select-option.jelenew-selected").removeClass("jelenew-selected");
            $(this).addClass("jelenew-selected");
            $(this).closest(".jelenew-country-selector").find(".current_country span").text($(this).text().trim());
            $(this).closest(".jelenew-country-selector").removeClass("on-focus");
            var root_url = $(this).attr("root_url");
            var old_root_url = Shopify.routes.root;
            var href = location.href.replace(location.hostname + old_root_url.slice(0, old_root_url.length - 1), location.hostname + root_url).replaceAll(",", "%2C");
            const currency_cfg = {
              "/": "USD",
              "/fr-fr": "EUR",
              "/en-de": "EUR",
              "/en-au": "AUD",
              "/en-ca": "CAD",
              "/en-gb": "GBP",
            };
            sensors.setProfile({ currency: currency_cfg[root_url] || "USD" });
            // sensors.track("ClickCurrencySelect", {
            //   element_name: "用户选择的货币",
            //   currency: currency_cfg[root_url] || "USD",
            // });
            if(href.includes("/fr-eu/collections/") || old_root_url.includes("fr-eu")){
              window.location.href = href.split('?')[0];
            }else{
              window.location.href = href;
            }
          }
        });
        // 地区切换点击其他区域关闭
        $(container).on("click", ".jelenew-select-mask", function () {
          $(this).closest(".jelenew-country-selector").removeClass("on-focus");
        });
        // 页面准备完毕后插入DOM
        $(function () {
          _this.functions.headerScrollInit();
          // _this.functions.headerTemplateInit(container);
          _this.functions.jelenew_main_cart_drawer_dom_init();
          _this.functions.sensorsInit();
          _this.functions.setStickyHeaderHeight.call(_this);
          $(window).on("debouncedresize.jelenewHeaderSection", _this.functions.setStickyHeaderHeight.bind(_this));
        });
        // 向购物车中插入神策id
        // shopifyHttp.post("cart/update.js", {
        //   attributes: { __distinct_id: jelenew.functions.getDistinctId() },
        // });
        // 已有订阅邮箱存在，删除顶部滚动栏的订阅提示
        if (localStorage.getItem("jelenew_subscription_email")) {
          $(".announcement-bar-inner .bar-item.subscription-bar-item", container).remove();
        }
        // 顶部滚动横幅
        $(".announcement-bar-inner", container).slick({
          vertical: true,
          autoplay: true,
          draggable: false,
          infinite: true,
          autoplaySpeed: 5000,
          accessibility: false,
          arrows: false,
        });

        // wishlist 埋点
        $(container).on("click", ".wish-list-notification-bubble", function () {
          // sensors.track("ClickAnyElement", {
          //   element_name: "心愿单入口",
          // });
        });
      };
      this.onSectionUnload = function (container) {};
      this.functions = {
        headerScrollInit: function () {
          var oldScroll = 0;
          var $headerDOM = $("#pageheader");
          var $bar = $("#section-id-announcement-bar");
          var headerH = $headerDOM.height();
          var barH = $bar.height() || 0;
          var scrollTop = $(window).scrollTop();
          resetCss();
          window.addEventListener("resize", () => resetCss());
          window.addEventListener("throttled-scroll", (e) => resetCss(e));
          function resetCss(e) {
            if ($("#pageheader").hasClass("show-menu") || $("#pageheader").hasClass("show-search")) {
              return false;
            }
            headerH = $headerDOM.height();
            barH = $bar.height() || 0;
            scrollTop = $(window).scrollTop();
            // mobile
            let screen_type = "mobile";
            if (window.innerWidth >= 768) {
              // desktop
              screen_type = "desktop";
            }
            if (oldScroll < scrollTop) {
              // 向下滚动, 头部隐藏
              if (scrollTop >= barH + headerH) {
                $headerDOM.css({ top: -headerH });
                $(".jelenew_search_layer_wrap").css({ top: 0 });
                window.jelenewHeaderAnimateArr.forEach(({ target, screen, type, positionContainer }) => {
                  if (!target) return;
                  if (!screen || screen_type == screen) {
                    // 和当前视窗匹配
                    if ($(target).css("top").replace("px", "") != 0) {
                      if (type == "hidden") {
                        // 和头部显隐一致
                        $(target).css({ top: -target.scrollHeight });
                      } else {
                        // 一直存在，保持在头部下方
                        $(target).css({ top: 0 });
                      }
                    }
                  } else {
                    // 不和当前视窗匹配
                    $(target).css("position", "");
                  }
                  if (positionContainer && (!screen || screen_type == screen)) {
                    // 定位dom存在
                    if (scrollTop >= parseInt($(positionContainer).offset().top)) {
                      $(target).css("position", "fixed");
                    } else {
                      $(target).css("position", "");
                    }
                  }
                });
              }
            } else if (oldScroll > scrollTop) {
              // 向上滚动, 头部展示
              if (scrollTop <= barH) {
                if ($("body").data("page-type") == "index") {
                  $("#pageheader").addClass("transparency-header");
                }
                $headerDOM.removeClass("jelenewheader-fixed-style").addClass("jelenewheader-static-style");
                $headerDOM.css({ top: 0, transition: "color,box-shadow .3s, background .3s cubic-bezier(.39,.575,.565,1)", position: "relative" });
              } else {
                if (scrollTop > headerH) {
                  $headerDOM.removeClass("transparency-header");
                  $headerDOM.removeClass("jelenewheader-static-style").addClass("jelenewheader-fixed-style");
                  $headerDOM.css({ top: 0, transition: "all .3s cubic-bezier(.39,.575,.565,1)", position: "fixed" });
                }
              }
              let hiddenDomsHeight = 0;
              window.jelenewHeaderAnimateArr.forEach(({ target, screen, type, positionContainer }) => {
                if (!target) return;
                if (!screen || screen_type == screen) {
                  // 和当前视窗匹配
                  if (type == "hidden") {
                    if ($(target).css("top").replace("px", "") != headerH) {
                      $(target).css({ top: headerH });
                    }
                    hiddenDomsHeight += target.scrollHeight;
                  } else {
                    if ($(target).css("top").replace("px", "") != headerH + hiddenDomsHeight) {
                      $(target).css({ top: headerH + hiddenDomsHeight });
                    }
                  }
                } else {
                  // 不和当前视窗匹配
                  $(target).css("position", "");
                }
                if (positionContainer && (!screen || screen_type == screen)) {
                  // 定位dom存在
                  if (scrollTop <= parseInt($(positionContainer).offset().top - $(target).css("top").replace("px", "") * 1)) {
                    $(target).css("position", "");
                  } else {
                    $(target).css("position", "fixed");
                  }
                  if (scrollTop == 0) {
                    $(target).css("position", "");
                  }
                }
              });
            }
            oldScroll = scrollTop;
          }
        },
        // 头部组件所需DOM初始化
        headerTemplateInit: function headerTemplateInit(container) {
          const templates = [
            { template_name: "header-menu-popup-template", appendDOM: container },
            { template_name: "header-desktop-search-input-template", appendDOM: $("a.desktop-only.show-search-link__icon")[0] },
            { template_name: "header-search-layer-template", appendDOM: container },
          ];
          templates.forEach(({ template_name, appendDOM }) => {
            let current_class_name = "." + template_name.replace("-template", "-jelenew");
            if ($(current_class_name, container).length == 0) {
              appendDOM.appendChild(document.getElementById(template_name).content.cloneNode(true));
            }
          });
        },
        // 插入购物车浮层
        jelenew_main_cart_drawer_dom_init: () => {
          if ($("body>.jelenew-main-cart-drawer-container").length == 0) {
            if ($("body").attr("data-page-type") != "cart") {
              // 非cart页面 插入DOM，注册cart组件
              $("body")[0].appendChild(document.getElementById("jelenew-cart-drawer-template").content.cloneNode(true));
              theme.Sections.register("cart-template", theme.CartTemplateSection, { deferredLoad: false });
            }
            this.functions.jelenew_main_cart_action_init();
            $("body>.jelenew-main-cart-drawer-container [data-cc-animate]").addClass("-in");
          }
        },
        // 购物车补充事件初始化
        jelenew_main_cart_action_init: function jelenew_main_cart_action_init() {
          // 读取color和size的多语言文案
          var colorNameList = window.theme.strings.color_option_names.split(",");
          var isColorOption = function (colorText) {
            return colorNameList.some((text) => {
              return text == colorText;
            });
          };
          var sizeNameList = window.theme.strings.size_option_names.split(",");
          var isSizeOption = function (sizeText) {
            return sizeNameList.some((text) => {
              return text == sizeText;
            });
          };
          // 埋点公共属性
          var page_position = "购物车页";
          var is_cart_page = $("body").attr("data-page-type") == "cart" ? true : false;
          if (!is_cart_page) {
            // $(".jelenew-main-cart-drawer-container").css("display","");
            page_position = "购物车弹层页";
          }
          // 删除
          window.jelenewRemoveItemKey = [];
          $(".jelenew-main-cart").on("click", ".jelenew-remove-item", function () {
            if (!is_cart_page) {
              $(".jelenew_page_toast_wrap").css("top", $(".jelenew-main-cart-drawer-container").scrollTop());
              $(".jelenew-main-cart-drawer-container").css("overflow", "hidden");
            }
            var $cartItem = $(this).closest(".cart-item");
            if ($(this).hasClass("bundle-remove")) {
              const bundleId = $cartItem.data("bundle-id");
              $(`.cart-item[data-bundle-id="${bundleId}"]`).each(function () {
                jelenewRemoveItemKey.push($(this).data("line-item-key"));
              });
              $(".jelenew_page_toast_wrap .jelenew_page_toast").addClass("bundle");
            } else {
              jelenewRemoveItemKey = [$cartItem.data("line-item-key")];
              $(".jelenew_page_toast_wrap .jelenew_page_toast").removeClass("bundle");
            }
            $(".jelenew_page_toast_wrap").css("display", "block");
          });
          $(".jelenew_page_toast_btn_ok").on("click", function () {
            var $btn = $(this);
            $btn.addClass("disabled");
            let updates = {};
            window.jelenewRemoveItemKey.forEach((key) => {
              updates[key] = 0;
              const $dom = $(`.jelenew-main-cart .cart-item-list__body .cart-item[data-line-item-key='${key}']`);
              sensors.track("ClickRemoveConfirm", {
                page_position,
                product_name: getCartItemData($dom, "product_name"),
                product_id: getCartItemData($dom, "product_id"),
                original_price: getCartItemData($dom, "original_price"),
                sku_id: $dom.find(".cart-item_title .name").attr("data-sku"),
                skc_id: $dom.data("skc"),
                spu_id: $dom.data("spu"),
              });
            });
            // let updates = {
            //   794864053: 2,
            //   794864233: 3,
            // };
            // 删除商品时，进行标记。 让折扣码自动应用函数读取标记后跳过执行
            localStorage.setItem("jelenew_auto_use_discount_type", "remove");
            shopifyCartApi.update(updates).finally(() => {
              $(document).triggerHandler(cartChangedEvent());
              closeRemoveDrawer();
              $btn.removeClass("disabled");
            });

            // theme.CartTemplateSection.functions.updateCart.call(
            //   this,
            //   {
            //     id: jelenewRemoveItemKey,
            //     quantity: 0,
            //   },
            //   function () {
            //     closeRemoveDrawer();
            //     $btn.removeClass("disabled");
            //   },
            //   function () {
            //     closeRemoveDrawer();
            //     $btn.removeClass("disabled");
            //   }
            // );
          });
          $(".jelenew_page_toast_close_icon,.jelenew_page_toast_btn_no_inner,.jelenew_page_toast_back").on("click", closeRemoveDrawer);

          // loading
          $(".jelenew-real-cart").on("click", ".cart-loading-btn", function () {
            $(this).addClass("disabled");
            setTimeout(() => {
              $(this).removeClass("disabled");
            }, 5000);
          });
          // **************** main-cart-js **********************
          if (!is_cart_page) {
            // 非cart页面 ， 初始化购物车浮层的各个sku数据

            // cartDrawerDataInit();

            // open cart drawer
            $(document).on("jelenewCartDrawerShow jelenewCartDrawerHidden", function (e) {
              $(".jelenew-main-cart-drawer-container").css("display", "");
              if (e.type == "jelenewCartDrawerShow") {
                // 如果弹窗没有打开，上报埋点。已打开不上报
                if (!$("body").hasClass("jelenew-new-cart-drawer-shade")) {
                  let product_number = 0;
                  $(".cart-item-list__body .cart-item").each(function (params) {
                    product_number += $(this).find(".cart-item__quantity-input").val() * 1;
                  });
                  let original_price = "";
                  $(".jelenew-main-cart .checkout-subtotal-container__right .theme-money")
                    .text()
                    .split("")
                    .forEach((n) => {
                      if (parseFloat(n).toString() != "NaN") {
                        original_price += n;
                      }
                    });
                  if (original_price) {
                    original_price = original_price / 100;
                  } else {
                    original_price = 0;
                  }
                  // sensors.track("WebPageView", {
                  //   web_page_name: "购物车弹层页",
                  //   product_number,
                  //   original_price,
                  // });
                }
                $("body").addClass("jelenew-new-cart-drawer-shade");
                $(".jelenew-new-cart-drawer-shade .page-shade").on("click", function (e) {
                  $(".jelenew-new-cart-drawer-shade .page-shade").off("click");
                  $("body").removeClass("jelenew-new-cart-drawer-shade");
                  return false;
                });
              }
              if (e.type == "jelenewCartDrawerHidden") {
                $(".jelenew-new-cart-drawer-shade .page-shade").off("click");
                $("body").removeClass("jelenew-new-cart-drawer-shade");
                $(".anyflexbox.field--error").removeClass("field--error");
              }
            });

            $(".jelenew-main-cart-drawer-container").on("click", ".jelenew-main-cart-drawer-header-close", function () {
              let product_number = 0;
              $(".cart-item-list__body .cart-item").each(function (params) {
                product_number += $(this).find(".cart-item__quantity-input").val() * 1;
              });
              let original_price = "";
              $(".jelenew-main-cart .checkout-subtotal-container__right .theme-money")
                .text()
                .split("")
                .forEach((n) => {
                  if (parseFloat(n).toString() != "NaN") {
                    original_price += n;
                  }
                });
              if (original_price) {
                original_price = original_price / 100;
              } else {
                original_price = 0;
              }
              // sensors.track("ClickClose", {
              //   page_position: "购物车弹层页",
              //   product_number,
              //   original_price,
              // });
              document.dispatchEvent(new CustomEvent("jelenewCartDrawerHidden"));
            });
          }
          // cart页面 ， 打开sku切换浮层
          var $sku_drawer_item = null;
          var variation_selector_index = null;

          $("body").on("click", ".jelenew-real-cart .jelenew-cart-variation-selector", function () {
            return;
            const data_size_key_hidden = $(this).parents(".cart-item").hasClass("data_size_key_hidden");
            if (data_size_key_hidden) {
              $(".jelenew-main-cart-drawer").addClass("data_size_key_hidden");
            } else {
              $(".jelenew-main-cart-drawer").removeClass("data_size_key_hidden");
            }
            $(".jelenew-main-cart-drawer").attr(
              "data-variant_id",
              $(this).parents(".cart-item").find(".cart-item_title .name").attr("data-variant_id")
            );
            variation_selector_index = $(this).closest(".cart-item").index();
            if (!is_cart_page) {
              $(".jelenew-main-cart-drawer-container").css("overflow", "hidden");
              $(".jelenew-main-cart-drawer").css("top", $(".jelenew-main-cart-drawer-container").scrollTop());
            }
            let optionIndex = $(this).index(),
              selectedName = $(this).find(".selector-name").text().trim(),
              selectedVal = $(this).find(".cart-page-selector .selected-value").attr("data-select-key"),
              variantsData = window[$(this).closest(".cart-item").attr("data-item-data-key")],
              sameOtherSkuVariants = variantsDataFilter($(this), ".cart-page-selector"),
              $drawer = $(".jelenew-main-cart .jelenew-main-cart-drawer");
            $drawer.find(".header .option-name").text(selectedName);

            if (isColorOption(selectedName)) {
              selectedName = "Color";
            }
            if (isSizeOption(selectedName)) {
              selectedName = "Size";
            }
            if (isSizeOption(selectedName)) {
              var sku_country = $(this).find(".jelenew_country_span").text().replace(":", "").trim() || "DE";
              $(".jelenew-main-cart-drawer").addClass("jelenew-main-cart-drawer-size");
            } else {
              $(".jelenew-main-cart-drawer").removeClass("jelenew-main-cart-drawer-size");
            }
            if (isSizeOption(selectedName)) {
              $(".jelenew-cart-variation-selector", $drawer[0]).append(
                $(`<div data-base-dom="size-wrap" class="jelenew_sku_info">
                <div class="jelenew_sku_info_inner">
                  <div class="jelenew_sku_right">
                    <div class="jelenew_sku_item_inner"></div>
                  </div>
                </div>
              </div>`)
              );
            }
            sameOtherSkuVariants.forEach((variant, v_index) => {
              let $baseDOM = $(`
            <div data-base-dom="${selectedName}" class="sku-option-container">
              <div class="sku-option-item ${selectedRender()}"
                data-variant-id="${variant.id}" 
                data-variant_available="${variantAvailableRender()}"
                ${isSizeOption(selectedName) ? `data-index0=${v_index}` : ``}
              >
                ${isColorOption(selectedName) ? `<div class="sku-img-box"><img src="${variant.img}"/></div>` : ``}
                <div class="sku-name Futuran">
                  ${variant.options[optionIndex]}
                </div>
                <div class="sku-available" data-variant-available="${variantAvailableRender()}"></div>
              </div>
            </div>`);
              function variantAvailableRender() {
                let variant_available = "has_inventory_available";
                if (variant.inventory_quantity == 0) {
                  if (variant.available) {
                    variant_available = "no_inventory_available";
                  } else {
                    variant_available = "no_inventory_not_available";
                  }
                }
                return variant_available;
              }
              function selectedRender() {
                if (variant.options[optionIndex] == selectedVal) {
                  return "selected-value";
                } else {
                  return "";
                }
              }
              if (isSizeOption(selectedName)) {
                $(".jelenew-cart-variation-selector .jelenew_sku_item_inner", $drawer[0]).append($baseDOM);
              } else {
                $(".jelenew-cart-variation-selector", $drawer[0]).append($baseDOM);
              }
            });
            $("body").addClass("jelenew-main-cart-drawer-shade");
            $(".page-shade").on("click", closeSkuDrawer);
            $sku_drawer_item = $(this);
            // sensors.track("ClickDetailsElement", {
            //   element_name: isColorOption(selectedName) ? "颜色选择入口" : "尺寸选择入口",
            //   page_position,
            //   product_name: getCartItemData($(this), "product_name"),
            //   product_id: getCartItemData($(this), "product_id"),
            //   original_price: getCartItemData($(this), "original_price"),
            // });
          });
          // 关闭sku切换浮层
          $(".jelenew-main-cart-drawer .header-close").on("click", closeSkuDrawer);
          // 浮层内点击，选中新的variant
          $(".jelenew-main-cart-drawer").on("click", ".sku-option-item", function () {
            // sku未激活 || 已选中 -> return false
            if ($(this).find(".sku-available").attr("data-variant-available") == "no_inventory_not_available" || $(this).hasClass("selected-value")) {
              return;
            }
            ajaxUpdateDOM(this, [progressRemove, closeSkuDrawer], {});
            let sensorsParams = {
              element_name: "",
              page_position,
              product_name: getCartItemData($sku_drawer_item, "product_name"),
              product_id: getCartItemData($sku_drawer_item, "product_id"),
              original_price: getCartItemData($sku_drawer_item, "original_price"),
            };
            if (isColorOption($(this).closest(".jelenew-main-cart-drawer").find(".header .option-name").text().trim())) {
              Object.assign(sensorsParams, {
                element_name: "COLOUR",
                colour: $(this).find(".sku-name").text().trim(),
              });
            } else {
              Object.assign(sensorsParams, {
                element_name: "SIZE",
                size: $(this).find(".sku-name").text().trim(),
              });
            }
            // sensors.track("ClickDetailsElement", sensorsParams);
          });
          // 神策埋点
          $(".jelenew-main-cart").on("click", ".notabutton, .continue-shopping, .update-cart, .jelenew-view-item", function (e) {
            let product_number = 0;
            if ($(".cart-link__count").length > 0) {
              product_number = $(".cart-link__count").eq(0).text() * 1;
            }
            // 点击继续购物
            if ($(e.currentTarget).hasClass("continue-shopping")) {
              // 继续购物
              sensors.track("ClickContinueShopping", {
                page_position,
                product_number,
              });
            }
            // 加减
            if ($(e.currentTarget).hasClass("notabutton")) {
              let params = {
                page_position,
                product_name: getCartItemData($(e.currentTarget), "product_name"),
                product_id: getCartItemData($(e.currentTarget), "product_id"),
                original_price: getCartItemData($(e.currentTarget), "original_price"),
                sku_id: $(e.currentTarget).closest(".cart-item").data("sku"),
                skc_id: $(e.currentTarget).closest(".cart-item").data("skc"),
                spu_id: $(e.currentTarget).closest(".cart-item").data("spu"),
              };
              if ($(e.currentTarget).hasClass("quantity-up")) {
                // 加号
                sensors.track("ClickAddProduct", params);
              } else if ($(e.currentTarget).hasClass("quantity-down")) {
                // 减号
                sensors.track("ClickDeleteProduct", params);
              }
            }
            // checkout
            if ($(e.currentTarget).hasClass("update-cart")) {
              sensors.track("ClickCheckOut", makeSensorsCartParams());
            }
            // jelenew-view-item
            if ($(e.currentTarget).hasClass("jelenew-view-item")) {
              sensors.track("ClickVIewDetails", {
                page_position,
                product_name: getCartItemData($(e.currentTarget), "product_name"),
                product_id: getCartItemData($(e.currentTarget), "product_id"),
                original_price: getCartItemData($(e.currentTarget), "original_price"),
              });
            }
          });

          // **************** Function **********************
          // 点击新sku后更新数据，替换DOM
          theme.CartTemplateSection.skuAjaxLoad = false;
          async function ajaxUpdateDOM(_this, callbackList, properties) {
            if (theme.CartTemplateSection.skuAjaxLoad == true) {
              if ($("body").find(`.jelenew-tips-container`).length == 0) {
                theme.JelenewTips("The data is being updated, please wait for a moment", "warn", 3000);
              }
              return;
            }
            let old_vid = null;
            if (!properties && $(_this).hasClass("selected-value")) {
              return;
            }
            ajaxProgress();
            old_vid =
              $(".jelenew-main-cart-drawer").attr("data-variant_id") ||
              $(_this).closest(".jelenew-cart-variation-selector").find(".selected-value").attr("data-variant-id");
            current_num =
              $(`.cart-item-list__body .name[data-variant_id=${old_vid}]`).closest(".cart-item").find(".cart-item__quantity-input").val() * 1;
            $(_this).closest(".jelenew-cart-variation-selector").find(".selected-value").removeClass("selected-value");
            $(_this).addClass("selected-value");
            let new_vid = $(_this).attr("data-variant-id");
            let add_items = [];
            $(".cart-item-list__body .cart-item").each(function (i, el) {
              var variant = {
                id: $(el).data("line-item-id"),
                quantity: $(el).find(".cart-item__quantity-input").val(),
              };
              if ($(el).find(".line-item-property").length > 0) {
                variant.properties = {};
                // 保留变体的对应属性
                $(el)
                  .find(".line-item-property")
                  .each(function () {
                    var property_key = $(this).find(".first").text().trim();
                    var property_value = $(this).find(".last").text().trim();
                    variant.properties[`${property_key}`] = property_value;
                  });
              }
              if (old_vid == $(el).data("line-item-id") && variation_selector_index == i) {
                // 将新的variant-id替换旧variant-id
                variant.id = new_vid;
                if (properties) {
                  if (!variant.properties) {
                    variant.properties = {};
                  }
                  variant.properties[`${properties.key}`] = properties.value;
                }
              }

              add_items.push(variant);
            });
            await shopifyHttp.post("cart/clear.js");
            await shopifyHttp.post("cart/add.js", { items: add_items.reverse() }).finally(() => {
              $(document).triggerHandler(
                cartChangedEvent({
                  detail: {
                    jelenewCustomCallBack: () => {
                      if (callbackList) {
                        callbackList.forEach((callback) => {
                          callback.call();
                        });
                      }
                    },
                  },
                })
              );
            });
          }

          function ajaxProgress() {
            theme.CartTemplateSection.skuAjaxLoad = true;
            if ($(`#${window.jelenew_progress_id}`).length > 0) {
              $(`#${window.jelenew_progress_id}`).remove();
            }
            window.jelenew_progress_id = `${new Date().getTime()}-progress`;
            const $progress = $(`<div class='jelenew-ajax-progress' id="${window.jelenew_progress_id}">
            <style>
              .jelenew-ajax-progress{
                width: 100vw;
                height: 4px;
                position: fixed;
                top: 0px;
                left: 0px;
                right: 0px;
                z-index: 9999999;
              }
              .progress-bar{
                width: 0%;
                height: 100%;
                background: #616161;
                transition: width 2s ease-out;
                border-top-right-radius: 2px;
                border-bottom-right-radius: 2px;
              }
            </style>
            <div class="progress-bar"></div>
          </div>`);
            $("body").append($progress);
            setTimeout(() => {
              $progress.find(".progress-bar").css("width", "95%");
            }, 0);
          }
          function progressRemove() {
            $(`#${window.jelenew_progress_id} .progress-bar`).css({
              transition: "none",
              width: "100%",
            });
            $(`#${window.jelenew_progress_id} .progress-bar`).css({
              transition: "opacity .3s ease-out",
              opacity: 0,
            });
            setTimeout(() => {
              theme.CartTemplateSection.skuAjaxLoad = false;
              $(`#${window.jelenew_progress_id}`).remove();
              window.jelenew_progress_id = null;
            }, 300);
          }

          // 变体数据过滤
          function variantsDataFilter($variation_selector, selected_val_container) {
            let $item = $variation_selector.closest(".cart-item"),
              variants = window[$item.attr("data-item-data-key")],
              selectedVal = $variation_selector.find(selected_val_container + " .selected-value").attr("data-select-key"),
              otherSelectedValArr = [],
              sameOtherSkuVariants = [];
            $item.find(".jelenew-cart-variation-selector " + selected_val_container + " .selected-value").each(function () {
              if ($(this).attr("data-select-key") != selectedVal) {
                otherSelectedValArr.push($(this).attr("data-select-key"));
              }
            });
            variants.forEach((variant) => {
              const is_same = otherSelectedValArr.every((othSkuVal) => {
                return variant.options.some((optVal) => optVal == othSkuVal);
              });
              if (is_same) {
                sameOtherSkuVariants.push(variant);
              }
            });
            return sameOtherSkuVariants;
          }
          // 初始化购物车浮层的各个sku数据
          function cartDrawerDataInit() {
            $(".jelenew-main-cart-drawer-container .jelenew-real-cart .jelenew-cart-variation-selector").each(function () {
              let sameOtherSkuVariants = variantsDataFilter($(this), ".cart-drawer-selector"),
                selectedName = $(this).find(".selector-name").text().trim(),
                selectedVal = $(this).find(".cart-drawer-selector .selected-value").text().trim();
              $(this)
                .find(".cart-drawer-selector>span")
                .each(function () {
                  let val = $(this).text().trim();
                  let this_variant = sameOtherSkuVariants.find((variant) => {
                    return variant.options.some((sku_val) => sku_val == val);
                  });
                  $(this).attr("data-variant-id", this_variant.id);
                });
            });
          }
          // 浮层关闭, 重置数据
          function closeSkuDrawer() {
            $("body").removeClass("jelenew-main-cart-drawer-shade");
            if (!is_cart_page) {
              $(".jelenew-main-cart-drawer").css("top", "");
              $(".jelenew-main-cart-drawer-container").css("overflow", "");
            }
            $(".jelenew-main-cart-drawer .jelenew-cart-variation-selector").empty();
            $(".page-shade").off("click", closeSkuDrawer);
          }
          // 删除浮层关闭
          function closeRemoveDrawer() {
            window.jelenewRemoveItemKey = [];
            if (!is_cart_page) {
              $(".jelenew_page_toast_wrap").css("top", 0);
              $(".jelenew-main-cart-drawer-container").css("overflow", "");
            }
            $(".jelenew_page_toast_wrap").css("display", "none");
          }

          function getCartItemData($el, key) {
            if (key == "product_name") {
              return $el.closest(".cart-item").find(".cart-item_title .name").text().trim();
            }
            if (key == "product_id") {
              return $el.closest(".cart-item").find(".cart-item_title .name").data("product_id") + "";
            }
            if (key == "original_price") {
              return (
                theme.jelenew_money_to_number($el.closest(".cart-item").find(".cart-item__total .theme-money").text()) /
                $el.closest(".cart-item").find(".cart-item__quantity-input").val()
              );
              // return (
              //   $el
              //     .closest(".cart-item")
              //     .find(".cart-item__total .theme-money")
              //     .text()
              //     .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
              //     .replace(",", ".") / $el.closest(".cart-item").find(".cart-item__quantity-input").val()
              // );
            }
          }
        },
        // 神策埋点
        sensorsInit: (container) => {
          // H5菜单埋点
          $("#pageheader .main-header>.left>.menu").on("click", function () {
            // sensors.track("ClickAnyElement", { element_name: "Menu" });
          });
          // 一级导航埋点
          $("#pageheader").on("click", ".navigation__link, a[data-type=customer], a.mobile-only-flex[href='/cart']", function (e) {
            sensors.track("ClickFirstTab", {
              first_tab_name:
                $(".flex-center-spb .link_title", this).text().trim() || $(".nav_adv_title", this).text().trim() || $("span", this).text().trim(),
            });
          });
          // 二级、三级导航埋点
          $("#pageheader").on("click", ".nav-child-list > .nav-child-item", function (e) {
            e.stopPropagation();
            if ($(this).children("span").hasClass("last-child-title")) {
              sensors.track("ClickThirdTab", {
                first_tab_name: $(this).closest(".navigation__link").children(".flex-center-spb").text().trim(),
                second_tab_name: $(this).closest(".has_dropdown").find(".first-child-title").text().trim(),
                third_tab_name: $(this).children("span").text().trim(),
              });
            } else {
              sensors.track("ClickSecondTab", {
                first_tab_name:
                  $(this).closest(".second-nav-container").find(".navigation__link").text().trim() ||
                  $(this).closest(".nav-child-list").data("link-title"),
                second_tab_name: $(this).closest(".has_dropdown").find(".first-child-title").text().trim(),
              });
            }
          });
          $("#pageheader").on("click", ".header-adv-item", function () {
            sensors.track("ClickSPM", {
              spm_name: $(".nav_adv_title", this).text().trim(),
              spm_module: $(this).attr("href"),
              spm_position: "菜单",
            });
          });
          // Logo 点击
          $("#pageheader .main-header").on("click", ".mid.logo", function () {
            // sensors.track("ClickAnyElement", { element_name: "JELENEW" });
          });
          // 购物车 点击
          $("#pageheader .cart-link").on("click", function () {
            // sensors.track("ClickAnyElement", { element_name: "购物车" });
          });
          // 个人中心、登录 点击
          // $("#pageheader").on("click", ".header-account-link", function () {
          //   if ($(this).hasClass("jelenew_sign_in_logo_tips")) {
          //     // sensors.track("ClickAnyElement", { element_name: "会员导航栏入口" });
          //   } else {
          //     // sensors.track("ClickAnyElement", { element_name: "个人中心" });
          //     if ($(this).hasClass("customer-not-login")) {
          //       sensors.track("WebPageView",
          //       {
          //         web_page_name: "登陆页" ,
          //         forward_page_url:document.referrer,
          //         forward_page_path:document.referrer.split('?')[0]
          //       });
          //     }
          //   }
          // });
          // 搜索入口
          $("#pageheader").on("click", ".show-search-link__icon", function () {
            // sensors.track("ClickAnyElement", { element_name: "搜索入口" });
          });

          $("#pageheader").on("click", ".jelenew_search_keyword .jelenew_search_keyword_left", function () {
            sensors.track("ClickSearchmiddleElement", {
              page_position: "搜索中间页",
              element_name: "搜索热词",
              keyword: $(this).text(),
              ranking: $(this).parents(".jelenew_search_keyword").find(".jelenew_search_keyword_right").text(),
            });
          });
          $("#pageheader").on("click", ".jelenew_search_product .jelenew_search_product_img", function () {
            sensors.track("ClickProductList", {
              page_position: "搜索中间页",
              list_type: "推荐商品列表",
              list_name: "搜索中间页推荐商品列表",
              product_name: $(this).parents(".jelenew_search_product").find(".jelenew_search_pro_block_title").text().trim(),
              product_id: $(this).data("product-id"),
              spu_id: $(this).data("spu"),
              skc_id: $(this).data("skc"),
              sku_id: $(this).data("sku"),
              original_price: $(this).data("price"),
            });
          });
        },
        setStickyHeaderHeight: function setStickyHeaderHeight() {
          var header = document.querySelector(".section-header"),
            stickyHeaderHeight = 0;
          if (header && (getComputedStyle(header).position === "sticky" || getComputedStyle(header).position === "-webkit-sticky")) {
            stickyHeaderHeight = Math.ceil(header.clientHeight);
          }
          document.documentElement.style.setProperty("--theme-sticky-header-height", stickyHeaderHeight + "px");
        },
        // 关闭搜索
        closeSearch: function () {
          const container = $("#pageheader");
          if ($(container).hasClass("show-search")) {
            $(container).removeClass("show-search");
            $(".header-search-layer-jelenew .jelenew_search_layer_wrap", container).removeClass("layer_has_show jelenew_search_layer_show");
          }
        },
        // PC导航菜单插入广告图片
        appendPcMenuImg: function (index) {
          const { container, HeaderMenuTemplateNode } = this;
          $(`.header-menu-popup-jelenew .adv_popup-container .header-adv-item`, container).removeClass("active");
          $(`.header-menu-popup-jelenew .adv_popup-container .header-adv-item`, container).eq(index).addClass("active");

          // if ($(`.header-menu-popup-jelenew .adv_popup-container .header-adv-item[href="${href}"]`, container).length === 0) {
          //   const img_node = HeaderMenuTemplateNode.querySelector(`.link-container .header-adv-item[href="${href}"]`);
          //   if (img_node) {
          //     const $img = $(img_node.cloneNode(true)).addClass("active");
          //     $(".header-menu-popup-jelenew .adv_popup-container", container).append($img);
          //   }
          // } else {
          //   $(`.header-menu-popup-jelenew .adv_popup-container .header-adv-item.active`, container).removeClass("active");
          //   $(`.header-menu-popup-jelenew .adv_popup-container .header-adv-item[href="${href}"]`, container).addClass("active");
          // }
        },
      };
    })();

    theme.ImageWithTextOverlaySection = new (function () {
      var _ = this;

      _.checkForHeaderHeightSubtraction = function () {
        $(".section-image-with-text-overlay .height--full-minus-header-height").each(function () {
          var height = $(window).height() - $(".section-header").height();
          $(".rimage-outer-wrapper, .placeholder-image", this).height(height);
        });
      };

      this.onSectionLoad = function (container) {
        $(".height--full", container).each(function () {
          if ($(this).closest(".section-image-with-text-overlay").index() == 0) {
            $(this).addClass("height--full-minus-header-height");
            _.checkForHeaderHeightSubtraction();
            $(window)
              .off("debouncedresize.imageWithTextOverlaySection")
              .on("debouncedresize.imageWithTextOverlaySection", _.checkForHeaderHeightSubtraction);
          }
        });

        // Tidier typography
        $(".overlay-text__title, .overlay-text__rte", container).each(function () {
          theme.avoidUnecessaryOrphans(this);
        });
      };

      this.onSectionUnload = function (container) {
        $(window).off(".imageWithTextOverlaySection");
      };
    })();

    theme.ListCollectionsTemplateSection = new (function () {
      this.onSectionLoad = function (container) {
        theme.ProductBlockManager.loadImages(container);
      };

      this.onSectionUnload = function (container) {
        theme.ProductBlockManager.unloadImages(container);
      };
    })();
    theme.jelenewEventsSlide = new (function () {
      this.onSectionLoad = function (container) {
        $(".jelenew_events_slide", container).slick({
          arrows: true,
          dots: true,
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1.5,
              },
            },
          ],
        });
      };
    })();

    theme.ProductTemplateSection = new (function () {
      this.onSectionLoad = function (container) {
        //预售模版改标题字体颜色
        // var product_title = $(".product-form").find(".title").text();
        // var pre_order_str = "PRE-ORDER";
        // if (product_title.indexOf(pre_order_str) != -1) {
        // 	product_title = product_title.replace(pre_order_str, '<span class="pre-order-tips">PRE-ORDER</span>');
        // 	$(".product-form").find(".title").html(product_title);
        // }

        /// Init store availability if applicable
        if ($("[data-store-availability-container]", container).length) {
          this.storeAvailability = new theme.StoreAvailability($("[data-store-availability-container]", container)[0]);
        }

        /// Main product dropdown
        $(".product-form", container).trigger("load-product-form");

        theme.initProductGallery(container);

        theme.ProductBlockManager.loadImages(container);

        // click review rating under title
        $(".theme-product-reviews", container).on("click", "a", function () {
          $("html,body").animate(
            {
              scrollTop: $($(this).attr("href")).offset().top,
            },
            1000
          );
          return false;
        });

        //add to bag 和 buy it now 按钮悬浮逻辑处理
        // function showBuyButtons(){
        //   if(window.scrollY > $("div[data-section-type=main-product]").height()){
        //     $('.buy-buttons-row').addClass('buy-buttons-row-float')
        //   }else{
        //     $('.buy-buttons-row').removeClass('buy-buttons-row-float')
        //   }
        // }
        // showBuyButtons();
        // window.onscroll = function(){
        //   showBuyButtons();
        // }
      };

      this.onSectionUnload = function (container) {
        theme.ProductBlockManager.unloadImages(container);
        theme.destroyProductGallery(container);
        theme.OptionManager.unloadProductOptions($(".product-form", container));
        $(".theme-product-reviews", container).off("click");
        if (this.storeAvailability) {
          this.storeAvailability.onSectionUnload();
        }
      };
    })();
    theme.recruitAmbassadorsPage = new (function () {
      this.onSectionLoad = function (container) {
        var countryList = [];
        var provinceList = [];
        getCountryList();
        function getCountryList() {
          countryList = Object.keys(window.countryProvince);
          countryList.forEach((item, index) => {
            $('.recruit_ambassadors_input_input_select[name="country"]').append(
              $(`<option class="recruit_ambassadors_input_input_option" value="${item}">${item}</option>`)
            );
          });
        }
        function getProvince() {
          if ($('.recruit_ambassadors_input_input_select[name="country"]').val()) {
            var provinces = window.countryProvince[$('.recruit_ambassadors_input_input_select[name="country"]').val()].provinces;
            if (provinces) {
              provinceList = Object.keys(provinces);
              provinceList.forEach((item, index) => {
                $('.recruit_ambassadors_input_input_select[name="state"]').append(
                  $(`<option class="recruit_ambassadors_input_input_option" value="${item}">${item}</option>`)
                );
              });
              $('.recruit_ambassadors_input_input_select[name="state"]').parents(".recruit_ambassadors_input_wrap").show();
            } else {
              provinceList = [];
              $('.recruit_ambassadors_input_input_select[name="state"]').html(
                $(`<option class="recruit_ambassadors_input_input_option" value=""></option>`)
              );
              $('.recruit_ambassadors_input_input_select[name="state"]').parents(".recruit_ambassadors_input_wrap").hide();
            }
          } else {
            provinceList = [];
            $('.recruit_ambassadors_input_input_select[name="state"]').html(
              $(`<option class="recruit_ambassadors_input_input_option" value=""></option>`)
            );
            $('.recruit_ambassadors_input_input_select[name="state"]').parents(".recruit_ambassadors_input_wrap").show();
          }
        }
        $("body").on("change", '.recruit_ambassadors_input_input_select[name="country"]', function () {
          getProvince();
        });
        $("body").on("focus", ".recruit_ambassadors_input_must .recruit_ambassadors_input_input_inner", function () {
          $(this).parents(".recruit_ambassadors_input_must").removeClass("recruit_ambassadors_input_empty");
        });
        $("body").on("focus", ".recruit_ambassadors_input_check_email_error .recruit_ambassadors_input_input_inner", function () {
          $(this).parents(".recruit_ambassadors_input_check_email_error").removeClass("recruit_ambassadors_input_check_email_error");
        });
        $("body").on("input", ".jelenew_check_number", function () {
          if ($(this).val() && !isNaN(Number($(this).val()))) {
            $(this).val($(this).val().trim());
          } else {
            $(this).val($(this).val().trim().slice(0, -1));
          }
        });
        $("body").on("click", ".recruit_ambassadors_btn", function () {
          $(".recruit_ambassadors_input_must").each(function () {
            if (!$(this).find(".recruit_ambassadors_input_input_inner").val()) {
              if ($(this).attr("data-form-name") == "state") {
                if (provinceList.length > 0) {
                  $(this).addClass("recruit_ambassadors_input_empty");
                }
              } else {
                $(this).addClass("recruit_ambassadors_input_empty");
              }
            }
          });
          $(".recruit_ambassadors_input_check_email").each(function () {
            var val = $(this).find(".recruit_ambassadors_input_input_inner").val();
            if (val && /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(val)) {
            } else {
              if (!val) {
              } else {
                $(this).addClass("recruit_ambassadors_input_check_email_error");
              }
            }
          });
          if ($(".recruit_ambassadors_input_empty").length > 0 || $(".recruit_ambassadors_input_check_email_error").length > 0) {
            var scrollDom = ".recruit_ambassadors_input_empty";
            if ($(".recruit_ambassadors_input_empty").index() > -1 && $(".recruit_ambassadors_input_check_email_error") > -1) {
              if ($(".recruit_ambassadors_input_empty").index() > $(".recruit_ambassadors_input_check_email_error").index()) {
                scrollDom = ".recruit_ambassadors_input_check_email_error";
              } else {
                scrollDom = ".recruit_ambassadors_input_empty";
              }
            } else {
              if ($(".recruit_ambassadors_input_empty").index() > -1) {
                scrollDom = ".recruit_ambassadors_input_empty";
              } else {
                scrollDom = ".recruit_ambassadors_input_check_email_error";
              }
            }
            $("html").scrollTop($(scrollDom).eq(0).offset().top - 180);
            return;
          }
          $(this).addClass("btn--loading");
          var param = {
            firstName: $(container).find('.recruit_ambassadors_input_input_inner[name="firstName"]').val() || "",
            lastName: $(container).find('.recruit_ambassadors_input_input_inner[name="lastName"]').val() || "",
            email: $(container).find('.recruit_ambassadors_input_input_inner[name="email"]').val() || "",
            country: $(container).find('.recruit_ambassadors_input_input_inner[name="country"]').val() || "",
            state: $(container).find('.recruit_ambassadors_input_input_inner[name="state"]').val() || "",
            city: $(container).find('.recruit_ambassadors_input_input_inner[name="city"]').val() || "",
            cyclePerWeek: Number($(container).find('.recruit_ambassadors_input_input_inner[name="cyclePerWeek"]').val() || ""),
            purchasedBefore: $(container).find('.recruit_ambassadors_input_input_inner[name="purchasedBefore"]').val() == "YES",
            insHandle: $(container).find('.recruit_ambassadors_input_input_inner[name="insHandle"]').val() || "",
            stravaAccount: $(container).find('.recruit_ambassadors_input_input_inner[name="stravaAccount"]').val() || "",
            cyclingClubName: $(container).find('.recruit_ambassadors_input_input_inner[name="cyclingClubName"]').val() || "",
            roleInClub: $(container).find('.recruit_ambassadors_input_input_inner[name="roleInClub"]').val() || "",
            mbsInClub: $(container).find('.recruit_ambassadors_input_input_inner[name="mbsInClub"]').val() || "",
            frequencyInClub: $(container).find('.recruit_ambassadors_input_input_inner[name="frequencyInClub"]').val() || "",
            ambassadorReason: $(container).find('.recruit_ambassadors_input_input_inner[name="ambassadorReason"]').val() || "",
            roleInAmbassadorProgram: $(container).find('.recruit_ambassadors_input_input_inner[name="roleInAmbassadorProgram"]').val() || "",
          };
          jelenewHttp
            .post(`/api/shop/ambassador/recruit`, param)
            .then((res) => {
              $(this).removeClass("btn--loading");
              $(".jelenew_recruit_shade_popup").addClass("jelenew_recruit_shade_popup_show");
              $("body").css({
                overflow: "hidden",
              });
              $(".recruit_ambassadors_input_input_inner").each(function () {
                $(this).val("");
              });
            })
            .catch(() => {
              $(this).removeClass("btn--loading");
            });
        });
        $("body").on("click", ".jelenew_recruit_shade, .jelenew_recruit_popup_close", function () {
          $(this).parents(".jelenew_recruit_shade_popup").removeClass("jelenew_recruit_shade_popup_show");
          $("body").css({
            overflow: "auto",
          });
        });
      };
    })();

    theme.contactForm = new (function () {
      this.onSectionLoad = function (container) {
        const api = $(container).data("api");
        if (api) {
          $("form", container).attr("action", "");
          let hasInvalid = false;
          $("input, textarea", container).on("invalid change", function ({ type }) {
            if (type == "change") {
              hasInvalid = false;
            } else if (type == "invalid") {
              hasInvalid = true;
            }
          });
          $("form", container).on("submit", function () {
            return false;
          });
          $("[type=submit]", container).on("click submit", function (e) {
            // e.preventDefault();
            // e.stopPropagation();
            const arr = $("form", container).serializeArray().splice(2);
            setTimeout(() => {
              if (!hasInvalid) {
                let products_arr = [];
                let params = {
                  type: $(container).data("event_type") ? $(container).data("event_type") : 1,
                  actId: $(container).data("event_type") ? $(container).data("event_type") : "",
                  product: "",
                };
                arr.forEach((item) => {
                  if (item.name == "contact[style-of-interest]") {
                    products_arr.push(item.value);
                  } else if (item.name == "contact[first-name]") {
                    params.firstName = item.value;
                  } else if (item.name == "contact[last-name]") {
                    params.lastName = item.value;
                  } else if (item.name == "contact[email]") {
                    params.email = item.value;
                  }
                });
                params.product = products_arr.join(",");
                jelenewHttp
                  .post(api, params)
                  .then(() => {
                    theme.JelenewTips(
                      {
                        title: theme?.jsUse?.tips?.participation_title,
                        text: theme?.jsUse?.tips?.participation_thx,
                      },
                      "success"
                    );
                  })
                  .catch(() => {
                    theme.JelenewTips("NetWork Error, Please try again later.");
                  });
                return false;
              }
            }, 500);
            // return false;
          });
        }
      };
    })();

    // 赠品信息曝光弹窗
    theme.jelenewGiftDrawer = new (function () {
      this.onSectionLoad = function (container) {
        $("body").on("click", "a[href='#open_gifts_drawer']", function () {
          jelenewSectionAppendTemplate(".jelenew-main-product-gift-drawer-template", container);
          $("body").addClass("cc-popup-no-scroll");
          $(container).addClass("show");
          if ($("body").data("page-type") == "product") {
            // sensors.track("ClickDetailsElement", {
            //   element_name: "满赠详情页入口",
            //   page_position: theme.jelenew_web_page_name,
            //   product_name: $(".jelenew-product-name.title").text().trim(),
            //   product_id: $(".product-purchase-form").data("product-id"),
            //   original_price: theme.jelenew_money_to_number($(".jelenew-product-price .theme-money").text()),
            // });
          } else {
            // sensors.track("ClickDetailsElement", {
            //   element_name: "满赠跑马灯入口",
            //   page_position: theme.jelenew_web_page_name,
            // });
          }
        });
        $("body").on("click", ".jelenew-gift-drawer-close", function (e) {
          if ($(e.target).hasClass("jelenew-gift-drawer-close")) {
            $("body").removeClass("cc-popup-no-scroll");
            $(container).removeClass("show");
          }
        });
      };
    })();

    theme.jelenewShopNowDetail = new (function () {
      this.onSectionLoad = function (container) {
        $(document).on("click", ".jelenew-buy-buttons", function () {
          $("body").addClass("enable-mobile-shop-now-transition");
        });

        $(document).on("click", ".jelenew-shop-now-sku-popup-close", function () {
          $("body").removeClass("enable-mobile-shop-now-transition");
        });

        $(".product-form", container).trigger("load-product-form");
      };

      this.onSectionUnload = function (container) {};
    })();

    // theme.SearchTemplateSection = new (function () {
    //   this.onSectionLoad = function (container) {
    //     this.namespace = theme.namespaceFromSection(container);
    //     this.$container = $(container);

    //     this.filterer = new theme.LoadFilterer(this);
    //   };

    //   this.onSectionUnload = function () {
    //     this.filterer.destroy();
    //   };
    // })();

    theme.SlideshowSection = new (function () {
      var _ = this;

      _.checkForHeaderHeightSubtraction = function () {
        $(".section-slideshow .height--full-minus-header-height").each(function () {
          var height = $(window).height() - $(".section-header").height();
          $(".rimage-outer-wrapper, .placeholder-image", this).height(height);
        });
      };

      this.onSectionLoad = function (container) {
        $(".slideshow", container).each(function () {
          var slideshowSpeed = $(this).data("transition") === "instant" ? 0 : 800;
          var autoplaySpeed = $(this).data("autoplay-speed") * 1000;

          if ($(this).find(".height--full").length && $(this).closest(".section-slideshow").index() == 0) {
            $(this).addClass("height--full-minus-header-height");
            _.checkForHeaderHeightSubtraction();
            $(window).off("debouncedresize.slideshowSection").on("debouncedresize.slideshowSection", _.checkForHeaderHeightSubtraction);
          }
          $(this)
            .on("init", function () {
              $(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload");
            })
            .slick({
              autoplay: $(this).data("autoplay"),
              fade: $(this).data("transition") !== "slide",
              speed: slideshowSpeed,
              autoplaySpeed: autoplaySpeed,
              arrows: $(this).data("navigation") === "arrows",
              dots: $(this).data("navigation") === "dots",
              pauseOnHover: false,
              infinite: true,
              useTransform: true,
              prevArrow:
                '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
              nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
              customPaging: function customPaging(slider, i) {
                return (
                  '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0">' +
                  '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve">' +
                  '<circle class="circle-one" cx="15" cy="15" r="13" />' +
                  '<circle class="circle-two" cx="15" cy="15" r="13" style="animation-duration: '.concat(autoplaySpeed + slideshowSpeed, 'ms" />') +
                  "</svg>" +
                  "</button>"
                );
              },
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    arrows: false,
                    dots: $(this).data("navigation") !== "none",
                  },
                },
              ],
            })
            .on("beforeChange", function (event, slick, currentSlide) {
              if ($(this).data("transition") === "slide_fade" || $(this).data("transition") === "zoom") {
                var $outgoingSlide = $(slick.$slides.get(currentSlide));
                $outgoingSlide.addClass("slick--leaving");
              }
            })
            .on("afterChange", function (event, slick) {
              $(slick.$slides).filter(".slick--leaving").removeClass("slick--leaving");
            });

          $(".overlay-text__button", container).on("click", function () {
            sensors.track("ClickBanner", {
              element_name: "Banner",
              button_name: $(this).text().trim(),
              banner_location: $(this).attr("data-index"),
              position: "顶部轮播",
              jump_link: "https://www.jelenew.com" + $(this).attr("href"),
              page_position: "首页",
            });
          });
        });

        // Tidier typography
        $(".overlay-text__title, .overlay-text__rte", container).each(function () {
          theme.avoidUnecessaryOrphans(this);
        });
      };

      this.onSectionUnload = function (container) {
        $(".slick-slider", container).slick("unslick").off("init");
        $(window).off(".slideshowSection");
      };

      this.onBlockSelect = function (container) {
        $(container).closest(".slick-slider").slick("slickGoTo", $(container).data("slick-index")).slick("slickPause");
      };

      this.onBlockDeselect = function (container) {
        $(container).closest(".slick-slider").slick("slickPlay");
      };
    })();
    // theme.JelenewAutoSlickSection = new (function () {
    //   var _ = this;
    //   let JelenewSlickList = null;

    //   this.onSectionLoad = function (container) {
    //     // 初始化轮播图
    //     JelenewSlickList = $(".slick-container", container);
    //     JelenewSlickList.slick({
    //       dots: JelenewSlickList.data("desktop_has_dots"),
    //       infinite: true,
    //       adaptiveHeight: true,
    //       arrows: true,
    //       prevArrow: '<button type="button" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
    //       nextArrow: '<button type="button" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       responsive: [
    //         {
    //           breakpoint: 767,
    //           settings: {
    //             dots: JelenewSlickList.data("mobile_has_dots"),
    //           },
    //         },
    //       ],
    //     }).init(() => {
    //       // console.log("JelenewSlickList-init");
    //     });
    //   };
    //   this.onSectionUnLoad = function (container) {
    //     JelenewSlickList.slick("unSlick");
    //   };
    // })();

    // theme.TestimonialsSection = new (function () {
    //   this.onSectionLoad = function (container) {
    //     this.namespace = theme.namespaceFromSection(container);
    //     this.$testimonialContainer = $(".testimonial-list", container);

    //     this.$testimonialContainer
    //       .find(".testimonial-list__inner")
    //       .on("init", function () {
    //         $(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload");
    //       })
    //       .slick({
    //         fade: this.$testimonialContainer.hasClass("testimonial-list--with-images"),
    //         slidesToShow: this.$testimonialContainer.hasClass("testimonial-list--without-images") ? 2 : 1,
    //         autoplay: this.$testimonialContainer.data("autoplay"),
    //         autoplaySpeed: this.$testimonialContainer.data("autoplay-speed"),
    //         dots: false,
    //         arrows: true,
    //         appendArrows: this.$testimonialContainer.find(".testimonial-list__controls"),
    //         prevArrow:
    //           '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
    //         nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
    //         responsive: [
    //           {
    //             breakpoint: 768,
    //             settings: {
    //               fade: false,
    //               slidesToShow: 1,
    //             },
    //           },
    //         ],
    //       });
    //   };

    //   this.onSectionUnload = function (container) {
    //     $(".slick-slider", container).each(function () {
    //       $(this).slick("unslick").off("init");
    //     });
    //   };

    //   this.onBlockSelect = function (block) {
    //     var blockSlideIndex = $(block).data("slick-index");
    //     $(block)
    //       .closest(".slick-slider")
    //       .each(function () {
    //         $(this).slick("slickGoTo", blockSlideIndex);
    //       });
    //   };
    // })();
    theme.JelenewImgBigImg = new (function () {
      this.onSectionLoad = function (container) {
        //           var containerHtml = ''
        JelenewImgBigImg = $(".img_con_item", container);
        JelenewImgBigImg.click((e) => {
          var container = document.createElement("div");
          containerHtml =
            '<div class="img_big_img" style="display: flex;justify-content:center;align-items:center;width: 100%;height: 100%;position: fixed;top:0;left:0;z-index: 10000;background: rgba(0,0,0,0.8);"><div class="img_big_close_icon" style="position: absolute;top: 0;right:0;width:40px;height:40px;background: #FFF url(https://cdn.shopifycdn.net/s/files/1/0611/6275/0192/files/close.png?v=1647573206) no-repeat center center;background-size:50% 50%;z-index:100001;"></div>' +
            e.currentTarget.innerHTML +
            "</div>";

          container.innerHTML = containerHtml;
          document.body.appendChild(container);
          $(".img_big_img .rimage-outer-wrapper").css({
            width: "100%",
          });
          $(".img_big_img .img_big_close_icon").click(() => {
            document.body.removeChild(container);
          });
        });
      };
      this.onSectionUnLoad = function (container) {
        JelenewCollectionSlideSlideshow.slick("unSlick");
      };
    })();
    theme.JelenewCollectionSlide = new (function () {
      var JelenewCollectionSlideSlideshow = null;
      this.onSectionLoad = function (container) {
        JelenewCollectionSlideSlideshow = $(".jelenew_shop_coll_con", container);
        JelenewCollectionSlideSlideshow.slick({
          infinite: true,
          slidesToShow: 1,
          draggable: false,
          prevArrow:
            '<div class="icon_btn_left_black"><button type="button" class="slick-prev" aria-label="' +
            theme.strings.previous +
            '">' +
            theme.icons.chevronLeft +
            "</button></div>",
          nextArrow:
            '<div class="icon_btn_right_black"><button type="button" class="slick-next" aria-label="' +
            theme.strings.next +
            '">' +
            theme.icons.chevronRight +
            "</button></div>",
        });
        JelenewCollectionSlideSlideshow.css({
          height: "auto",
          overflow: "unset",
        });
      };
      this.onSectionUnLoad = function (container) {
        JelenewCollectionSlideSlideshow.slick("unSlick");
      };
    })();
    theme.jelenewSlideImg = new (function () {
      this.onSectionLoad = function (container) {
        var JelenewSlideshow = $(".jelenew_img_h5 .jelenew_img_inner", container);
        $(".jelenew_img_h5 .jelenew_img_inner", container) &&
          $(".jelenew_img_h5 .jelenew_img_inner", container).slick({
            centerMode: true,
            centerPadding: "20px",
            slidesToShow: 3,
            infinite: false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: "20px",
                  slidesToShow: 3,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: "20px",
                  slidesToShow: 1,
                },
              },
            ],
          });
        setTimeout(() => {
          JelenewSlideshow.css({
            height: "auto",
          });
        }, 500);
      };
      this.onSectionUnLoad = function (container) {};
    })();
    // theme.jelenewSlideProduct = new (function () {
    //   this.onSectionLoad = function (container) {
    //     var jelenewSlideProductshow = $("#" + container.id).find(".jelenew_img_h5 .jelenew_img_inner");
    //     jelenewSlideProductshow &&
    //       jelenewSlideProductshow.slick({
    //         infinite: false,
    //         slidesToShow: 1.3,
    //         slidesToScroll: 1,
    //       });
    //     setTimeout(() => {
    //       jelenewSlideProductshow.css({
    //         height: "auto",
    //       });
    //       $(".product_star_wrap", container).css({
    //         display: "block",
    //       });
    //     }, 500);
    //   };
    //   this.onSectionUnLoad = function (container) {};
    // })();
    theme.jelenewFoldBlock = new (function () {
      this.onSectionLoad = function (container) {
        var jelenew_fold_block_title_wrap = $(".jelenew_fold_block_title_wrap", container);
        var jelenew_fold_block_title_icon = $(".jelenew_fold_block_title_icon", container);
        var jelenew_fold_block_con_wrap = $(".jelenew_fold_block_con_wrap", container);
        var jelenew_fold_block_con_inner = $(".jelenew_fold_block_con_inner", container);
        $(".h5_video_box .video_suspend_wrap", container).on("click", function (e) {
          $(this).parents(".h5_video_box").find("video").trigger("pause");
          $(this).css({
            display: "none",
          });
          $(this).parents(".h5_video_box").find(".video_play_wrap").css({
            display: "block",
          });
        });
        $(".h5_video_box .video_play_wrap", container).on("click", function (e) {
          $(this).parents(".h5_video_box").find("video").trigger("play");
          $(this).css({
            display: "none",
          });
          $(this).parents(".h5_video_box").find(".video_suspend_wrap").css({
            display: "block",
          });
        });

        $(".h5_video_box .video_voice_close_wrap", container).on("click", function (e) {
          $(this).parents(".h5_video_box").find("video").prop("muted", false);
          $(this).css({
            display: "none",
          });
          $(this).parents(".h5_video_box").find(".video_voice_open_wrap").css({
            display: "block",
          });
        });
        if ($(container).find(".h5_video_box video").get(0)) {
          window.addEventListener("throttled-scroll", () => {
            if (
              $(window).scrollTop() > $(container).offset().top + $(container).height() ||
              $(window).scrollTop() < $(container).offset().top - $(window).height()
            ) {
              $(container).find("video").prop("muted", true);
              $(".h5_video_box .video_voice_open_wrap", container).css({
                display: "none",
              });
              $(".h5_video_box .video_voice_close_wrap", container).css({
                display: "block",
              });
            }
          });
        }
        $(".h5_video_box .video_voice_open_wrap", container).on("click", function (e) {
          $(this).parents(".h5_video_box").find("video").prop("muted", true);
          $(this).css({
            display: "none",
          });
          $(this).parents(".h5_video_box").find(".video_voice_close_wrap").css({
            display: "block",
          });
        });
        if ($(container).attr("data-default_open") == "true") {
          jelenew_fold_block_title_icon.addClass("jelenew_fold_block_title_icon_rotate");
          jelenew_fold_block_con_wrap.css({
            height: jelenew_fold_block_con_inner.get(0).offsetHeight + "px",
          });
          setTimeout(() => {
            jelenew_fold_block_con_wrap.css({
              height: "auto",
            });
          }, 300);
        }
        if ($(container).attr("data-can_open") == "false") {
          return;
        }

        jelenew_fold_block_title_wrap.unbind().click(function (e) {
          if (jelenew_fold_block_title_icon.hasClass("jelenew_fold_block_title_icon_rotate")) {
            jelenew_fold_block_con_wrap.css({
              height: jelenew_fold_block_con_inner.get(0).offsetHeight + "px",
            });
            setTimeout(() => {
              jelenew_fold_block_title_icon.removeClass("jelenew_fold_block_title_icon_rotate");
              jelenew_fold_block_con_wrap.css({
                height: 0,
              });
            }, 10);
          } else {
            if (location.pathname.split("/")[location.pathname.split("/").length - 2] == "products") {
              // sensors.track("ClickDetailsElement", {
              //   element_name: "描述项",
              //   page_position: "商品详情页",
              //   describe_type: e.target.innerText,
              //   product_name: $(".product-form").find(".title").text().trim(),
              //   product_id: $(".product-form").attr("data-product-id"),
              //   original_price: Number(
              //     document
              //       .querySelector(".section-main-product .current-price")
              //       .innerText.trim()
              //       .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
              //       .replace(",", ".")
              //   ),
              // });
            } else {
              // sensors.track("ClickActivityElement", {
              //   page_position: theme.jelenew_web_page_name,
              //   element_name: $(container).data("click_type"),
              //   button_name: $(this).find(".jelenew_fold_block_title").text().trim(),
              // });
            }
            jelenew_fold_block_title_icon.addClass("jelenew_fold_block_title_icon_rotate");
            jelenew_fold_block_con_wrap.css({
              height: jelenew_fold_block_con_inner.get(0).offsetHeight + "px",
            });
            setTimeout(() => {
              jelenew_fold_block_con_wrap.css({
                height: "auto",
              });
            }, 300);
          }
        });

        if (theme.jelenew_web_page_name == "首页") {
          $(".jelenew_fold_img a").on("click", function () {
            sensors.track("ClickHomeElement", {
              element_name: "PicResource",
              jump_link: "https://www.jelenew.com" + $(this).attr("href"),
              page_position: "首页",
            });
          });
        }
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewProductShowcase = new (function () {
      this.onSectionLoad = function (container) {
        const needSlickInit = !$(".jelenew-product-showcase-images-container", container).hasClass("jelenew-product-showcase-no-init");
        // 轮播图初始化
        $(".jelenew-product-showcase-images", container)
          .slick({
            dots: true,
            appendDots: $(".jelenew_product_bottom .slick-dots-container", container),
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true,
          })
          .init(() => {
            $(".jelenew-product-showcase-images", container).slick("slickFilter", slickFilterFn);
          });
        // 切换颜色
        $(".product_color_box", container).on("click", ".product_color_item", function (i, el) {
          // 颜色块选中样式切换
          $(this).siblings().removeClass("active");
          $(this).addClass("active");
          // 轮播图切换
          $(".jelenew-product-showcase-images", container).slick("slickUnfilter");
          $(".jelenew-product-showcase-images", container).slick("slickFilter", slickFilterFn);
        });
        $(".showcase-item", container).on("click", function () {
          sensors.track("ClickProductList", {
            page_position: window.theme.jelenew_web_page_name || "",
            list_type: "推荐商品列表",
            list_name: "推荐商品列表",
            product_name: $(this).parents(".jelenew-product-showcase-wrapper").find(".product_title").text().trim(),
            product_id: $(this).parents(".jelenew-product-showcase-container").data("product-id"),
            original_price:
              $(this)
                .parents(".jelenew-product-showcase-container")
                .find(".product_price")
                .text()
                .trim()
                .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                .replace(",", ".") * 1,
          });
        });
        $(".product_title", container).on("click", function () {
          sensors.track("ClickProductList", {
            page_position: window.theme.jelenew_web_page_name || "",
            list_type: "推荐商品列表",
            list_name: "推荐商品列表",
            product_name: $(this).parents(".jelenew-product-showcase-wrapper").find(".product_title").text().trim(),
            product_id: $(this).parents(".jelenew-product-showcase-container").data("product-id"),
            original_price:
              $(this)
                .parents(".jelenew-product-showcase-container")
                .find(".product_price")
                .text()
                .trim()
                .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                .replace(",", ".") * 1,
          });
        });
        // methods
        function slickFilterFn(i, el) {
          const color = $(".product_color_item.active", container).attr("title");
          if ($(el).data("position") == color) {
            return true;
          } else {
            return false;
          }
        }
      };
      this.onSectionUnLoad = function (container) {};
    })();

    theme.jelenewProductMesh = new (function () {
      var jelenewPc = null,
        jelenewH5 = null;
      this.onSectionLoad = function (container) {
        jelenewPc = $(".jelenew_pc .jelenew-product-mesh-container", container);
        jelenewPc.slick({
          infinite: false,
          arrows: true,
          dots: false,
          slidesToShow: 4,
          slidesToScroll: 4,
          draggable: false,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                touchThreshold: 2,
                arrows: false,
                dots: true,
              },
            },
          ],
        });
        jelenewPc.css("display", "block");
        jelenewPc.css("overflow", "revert");
        // 神策埋点
        if (theme.jelenew_web_page_name == "首页") {
          $(".jelenew-product-showcase-container").on("click", ".jelenew-product-showcase-wrapper", function () {
            var collection_type = $(this).parents(".jelenew-product-mesh-container").data("product-collection");
            var list_name;
            if (collection_type == "BEST SELLERS") {
              list_name = "首页推荐商品列表";
            } else if (collection_type == "Racing Collection") {
              list_name = "首页竞技商品列表";
            } else if (collection_type == "Comfort Collection") {
              list_name = "首页舒适商品列表";
            } else if (collection_type == "Jelenew x Rolland Series") {
              list_name = "首页高定商品列表";
            }
            var price = $(this).siblings(".product_price").text();
            sensors.track("ClickProductList", {
              page_position: "首页",
              list_type: "推荐商品列表",
              list_name: list_name,
              product_name: $(this).find(".product_title").text(),
              product_id: $(this).parents(".jelenew-product-showcase").attr("data-product-id"),
              original_price: Number(price ? price.trim().match(/\d+\.?\d*/)[0] : 0),
            });
          });

          $(".jelenew-product-showcase-color-select").on("click", ".product_color", function () {
            var collection_type = $(this).parents(".jelenew-product-mesh-container").data("product-collection");
            var list_name;
            if (collection_type == "BEST SELLERS") {
              list_name = "首页推荐商品列表";
            } else if (collection_type == "Racing Collection") {
              list_name = "首页竞技商品列表";
            } else if (collection_type == "Comfort Collection") {
              list_name = "首页舒适商品列表";
            } else if (collection_type == "Jelenew x Rolland Series") {
              list_name = "首页高定商品列表";
            }
            var price = $(this).parents(".jelenew-product-showcase-color-select").siblings(".product_price").text();
            sensors.track("ClickHomeElement", {
              page_position: "首页",
              element_name: "ColorPicker",
              button_name: $(this).attr("data-color-name"),
              list_type: "推荐商品列表",
              list_name: list_name,
              product_name: $(this)
                .parents(".jelenew-product-showcase-color-select")
                .siblings(".jelenew-product-showcase-wrapper")
                .find(".product_title")
                .text(),
              product_id: $(this).parents(".jelenew-product-showcase").attr("data-product-id"),
              original_price: Number(price ? price.trim().match(/\d+\.?\d*/)[0] : 0),
            });
          });
        }
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewProHotImgSlide = new (function () {
      this.onSectionLoad = function (container) {
        $(".pro_hot_img_slide_h5", container).slick({
          infinite: true,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          slidesToShow: 1,
          slidesToScroll: 1,
        });
        $(".pro_hot_img_slide_pc", container).slick({
          infinite: true,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          slidesToShow: 1,
          slidesToScroll: 1,
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewMainProThreeImg = new (function () {
      this.onSectionLoad = function (container) {
        if ($(container).data("use_slide")) {
          $(".block_img_list", container).slick({
            arrows: true,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            asNavFor: `#${container.id} .block_text_list`,
            adaptiveHeight: true,
          });
          $(".block_text_list", container)
            .slick({
              arrows: true,
              prevArrow:
                '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
              nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
              dots: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              asNavFor: `#${container.id} .block_img_list`,
              adaptiveHeight: true,
            })
            .on("afterChange", function () {
              // sensors.track("SlideProductPicture", {
              //   page_position: theme.jelenew_web_page_name,
              //   element_name: $(container).find(".section_title").text().trim(),
              //   product_name: $(".jelenew-main-product-detail .jelenew-product-name").text(),
              //   product_id: $(".jelenew-product-form-container.product-detail").attr("data-product-id") + "",
              //   original_price:
              //     $(".jelenew-main-product-detail .jelenew-product-price .theme-money")
              //       .text()
              //       .trim()
              //       .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
              //       .replace(",", ".") * 1,
              // });
            });
        }
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewProShopLook = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-pro-shop-look-template", container);
        // 存在bundle链接 =》 抓取数据
        const BundleURL = $(container).data("bundle-url");
        if (BundleURL) {
          shopifyHttp.get(BundleURL).then((res) => {
            const percent_discount = $(res).find(".jelenew-bundle-detail").attr("data-percent_discount");
            let all_origin_price = 0;
            let all_final_price = 0;
            let title_arr = [];
            $(".product_list .jelenew_pro_block_wrap_wrap", container).each(function (i) {
              const origin_price = theme.jelenew_money_to_number($(this).find(".jelenew_pro_block_price .theme-money").text());
              all_origin_price += origin_price;
              const final_price = (origin_price * (100 - percent_discount)) / 100;
              all_final_price += final_price;
              $(this)
                .find(".jelenew_pro_block_price")
                .empty()
                .append(
                  `<span class="theme-money Futuran">${theme.Shopify.formatMoney(
                    final_price * 100,
                    theme.money_format_with_cart_code_preference
                  )}</span><s style="margin-left: 5px;color: #ccc;font-family:Futuran;">${theme.Shopify.formatMoney(
                    origin_price * 100,
                    theme.money_format
                  )}</s>`
                );
              // let href = $("a", this).attr("href") + "#" + (i + 1) + "th";
              // $("a", this).attr("href", href);
              title_arr.push($(".pro_block_title", this).text());
            });
            $(".jelenew-import-bundle-text h2", container).text(title_arr.join(" + "));
            $(".jelenew-import-bundle-text .theme-money", container).text(
              theme.Shopify.formatMoney(all_final_price * 100, theme.money_format_with_cart_code_preference)
            );
            $(".jelenew-import-bundle-text div", container).eq(0).text(`Save ${percent_discount}% with this bundle.`);

            $(".pro_shop_btn.pro_shop_btn_href", container)
              .find(".bundle_price")
              .text(theme.Shopify.formatMoney(all_final_price * 100, theme.money_format));
            $(".pro_shop_btn.pro_shop_btn_href", container)
              .find(".origin_price")
              .text(theme.Shopify.formatMoney(all_origin_price * 100, theme.money_format));
          });
          $(".to-bundle").on("click", function () {
            // sensors.track("ClickDetailsElement", {
            //   element_name: "how to wear",
            //   page_position: theme.jelenew_web_page_name,
            //   product_name: $(".jelenew-product-name.title").text().trim(),
            //   product_id: $(".jelenew-product-form-container.product-detail.product-form").data("product-id"),
            //   original_price: theme.jelenew_money_to_number($(".jelenew-product-price>.current-price>.theme-money").text()),
            // });
          });
        } else {
          let title_arr = [];
          let all_price = 0;
          $(".product_list .jelenew-pro-block", container).each(function () {
            title_arr.push($(".pro_block_title", this).text());
            all_price += theme.jelenew_money_to_number($(".theme-money", this).text());
          });
          $(".jelenew-import-bundle-text h2", container).text(title_arr.join(" + "));
          $(".jelenew-import-bundle-text .theme-money", container).text(
            theme.Shopify.formatMoney(all_price * 100, theme.money_format_with_cart_code_preference)
          );
          // $(".jelenew-import-bundle-text div", container).eq(0).text(`Save ${percent_discount}% on ${title} with this bundle.`);
        }
        this.functions.actionInit(container);
      };
      this.onSectionUnLoad = function () {};
      this.functions = {
        actionInit: (container) => {
          if (!$(".product_list.product_list_h5", container).hasClass("dont-slick")) {
            $(".product_list.product_list_h5", container).slick({
              arrows: false,
              infinite: false,
              slidesToShow: 3.5,
              slidesToScroll: 1,
              responsive: [
                {
                  breakpoint: 1023,
                  settings: {
                    slidesToShow: 2.5,
                  },
                },
              ],
            });
          }
          //神策埋点
          $(".pro_shop_btn_href", container).on("click", function () {
            sensors.track(theme.jelenew_event_name, {
              page_position: theme.jelenew_web_page_name,
              element_name: "GO TO BUNDLE",
              // element_name: $(this).text().trim(0),
              product_name: $(".jelenew-main-product-detail .jelenew-product-name").text(),
              product_id: $(".jelenew-product-form-container.product-detail").attr("data-product-id") + "",
              original_price: $(".jelenew-main-product-detail .jelenew-product-price .theme-money")
                ? $(".jelenew-main-product-detail .jelenew-product-price .theme-money")
                    .text()
                    .trim()
                    .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                    .replace(",", ".") * 1
                : "",
            });
          });
          if ($("body").data("page-type") == "product") {
            $('div[data-section-type="jelenew-pro-shop-look"]').on("click", ".jelenew_wish", function () {
              var item = $(this).parents(".jelenew_pro_block_wrap_wrap");
              let href = $(this).closest("a").attr("href");
              $(this).closest("a").removeAttr("href");
              sensors.track("ClickWish", {
                page_position: "商品详情页",
                position: "Look推荐商品",
                product_name: item.find(".pro_block_title").text().trim(),
                product_id: item.data("product-id"),
                original_price: Number(
                  item
                    .find(".jelenew_pro_block_price")
                    .text()
                    .trim()
                    .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                    .replace(",", ".")
                ),
              });
              $(this).closest("a").attr("href", href);
            });
            $(container).on("click", ".jelenew_pro_block_wrap_wrap", function () {
              sensors.track("ClickProductList", {
                page_position: "商品详情页",
                list_type: "关联商品列表",
                list_name: "详情页Look商品列表",
                current_product_name: $(".jelenew-main-product-detail .jelenew-product-name").text(),
                current_product_id: $(".jelenew-product-form-container.product-detail").attr("data-product-id") + "",
                product_name: $(this).find(".pro_block_title").text().trim(),
                product_id: $(this).data("product-id"),
                original_price: Number(
                  $(this)
                    .find(".jelenew_pro_block_price")
                    .text()
                    .trim()
                    .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                    .replace(",", ".")
                ),
              });
            });
            // $('div[data-section-type="jelenew-pro-shop-look"]').on("click", ".jelenew_pro_block_img, .jelenew_pro_block_wrap_wrap>a", function () {
            //   var item = $(this).parents(".jelenew_pro_block_wrap_wrap");
            //   sensors.track("ClickProductList", {
            //     page_position: "商品详情页",
            //     list_type: "关联商品列表",
            //     list_name: "详情页Look商品列表",
            //     current_product_name: $(".jelenew-main-product-detail .jelenew-product-name").text(),
            //     current_product_id: $(".jelenew-product-form-container.product-detail").attr("data-product-id") + "",
            //     product_name: item.find(".pro_block_title").text().trim(),
            //     product_id: item.data("product-id"),
            //     original_price: Number(
            //       item
            //         .find(".jelenew_pro_block_price")
            //         .text()
            //         .trim()
            //         .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
            //         .replace(",", ".")
            //     ),
            //   });
            // });
            $('div[data-section-type="jelenew-pro-shop-look"]').on("click", ".pro_shop_btn.pro_shop_btn_add", function () {
              var items = $(this).siblings(".product_list").find(".jelenew_pro_block_wrap_wrap");
              var product_ids = [];
              var product_number = 0;
              items.each(function (index, item) {
                product_ids.push(String($(item).data("product-id")));
                product_number = product_number + 1;
              });
              // sensors.track("ClickDetailsElement", {
              //   element_name: $(this).text().trim(),
              //   page_position: "商品详情页",
              //   product_ids: product_ids,
              //   product_number: product_number,
              // });
            });
            if ($(".ajax-handler", container).length > 0) {
              $(container).on("click", ".ajax-handler", async function () {
                let href = $(this).closest("a").attr("href");
                $(this).closest("a").removeAttr("href");

                const $block = $(this).closest(".jelenew-pro-block");
                const product_handle = $block.data("product_handle");
                $block.addClass("jelenew-ajax-variants-selector-show");
                $("body").addClass("jelenew-ajax-variants-selector-show");
                await theme.CartTemplateSection.functions.fetchJelenewVariantsSelector($block, product_handle);
                $("body").off("click", "div[data-section-type=jelenew-ajax-variants-selector] .add-to-cart");
                $("body").on("click", "div[data-section-type=jelenew-ajax-variants-selector] .add-to-cart", function () {
                  const $this = $(this);
                  $this.addClass("disabled");
                  let addProduct = {
                    id: $(".jelenew-ajax-variants-selector .original-selector").val(),
                    quantity: 1,
                    properties: {
                      Country: $(".size_country_input").val() || "",
                    },
                  };
                  if ($(this).closest(".jelenew-ajax-variants-selector").data("product-type") == "Accessories") {
                    delete addProduct.properties.Country;
                  }
                  shopifyCartApi
                    .add({ items: [addProduct], sections: "cart-drawer" })
                    .then((data) => {
                      $(document).triggerHandler(cartChangedEvent());
                    })
                    .finally(() => {
                      $this.addClass("disabled");
                      $(".jelenew-ajax-variants-selector").remove();
                    });
                });
                sensors.track("ClickAddList", {
                  page_position: theme.jelenew_web_page_name + "快速加购",
                  product_name: $(this).closest(".jelenew-pro-block").find(".pro_block_title").text().trim(),
                  product_id: $(this).closest(".jelenew-pro-block").data("product-id"),
                  original_price: theme.jelenew_money_to_number($(this).closest(".jelenew-pro-block").find(".theme-money").text()),
                });
                $(this).closest("a").attr("href", href);
              });
              $("body").on("click", "div[data-section-type=jelenew-ajax-variants-selector] .jelenew-product-size-guide__button", function () {
                if ($("body").find(".jelenew-main-product-size-guide-drawer").length > 0) {
                  return false;
                }
              });
              $("body").on("submit", "div[data-section-type=jelenew-ajax-variants-selector] form.form", function () {
                return false;
              });
              $("body").on("click", "div[data-section-type=jelenew-ajax-variants-selector] .add-to-cart", function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).addClass("disabled");
                sensors.track("ClickAddToBag", {
                  page_position: "商品详情页",
                  colour: $(this).closest(".replace-element").find(".jelenew-product-option-selected").eq(0).text().trim(),
                  size: $(this).closest(".replace-element").find(".jelenew-product-option-values .size-item.active").text().trim(),
                  sku_id: $(this).closest(".replace-element").find(".original-selector option:selected").attr("sku-value"),
                  skc_id: $(this).closest(".replace-element").find(".original-selector option:selected").data("skc"),
                  spu_id: $(this).closest(".replace-element").find(".original-selector option:selected").data("spu"),
                  variant_id_string: $(this).closest(".replace-element").find(".original-selector").val() + "",
                  product_name: $(this).closest(".replace-element").find(".jelenew-product-name").text().trim(),
                  product_id: $(this).closest(".replace-element").find(".jelenew-product-options").data("product_id"),
                  original_price: theme.jelenew_money_to_number(
                    $(this).closest(".replace-element").find(".jelenew-product-price .theme-money").text()
                  ),
                });
                let addProduct = {
                  id: $(".jelenew-ajax-variants-selector .original-selector").val(),
                  quantity: 1,
                  properties: {
                    Country: $(".size_country_input").val() || "",
                  },
                };
                if ($(this).closest(".jelenew-ajax-variants-selector").data("product-type") == "Accessories") {
                  delete addProduct.properties.Country;
                }
                shopifyCartApi
                  .add({ items: [addProduct], sections: "cart-drawer" })
                  .then((data) => {
                    $(document).triggerHandler(cartChangedEvent());
                  })
                  .finally(() => $(".jelenew-ajax-variants-selector").remove());
              });
            }
            // sensors.track("EpModules", {
            //   page_position: theme.jelenew_web_page_name,
            //   ep_module: "详情页描述项",
            //   module_name: $(".block_title.Futuran", container).text().trim(),
            // });
          }
        },
      };
    })();
    theme.jelenewProShopLookToCart = new (function () {
      this.onSectionLoad = function (container) {
        $(".product_list.product_list_h5", container).slick({
          arrows: false,
          infinite: false,
          slidesToShow: 3.5,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2.5,
              },
            },
          ],
        });

        //添加购物车
        $(".pro_shop_btn", container).on("click", function () {
          if ($(this).hasClass("unable")) {
            return;
          }
          const items = [];
          $(".product_list", container)
            .find(".jelenew_pro_block_wrap")
            .each(function () {
              const variant_id = $(this).data("sku_id");
              if (variant_id) {
                items.push({
                  id: Number(variant_id),
                  quantity: 1,
                });
              }
            });

          $(this).addClass("unable");

          shopifyCartApi
            .add({ items, sections: "cart-drawer" })
            .then(function (res) {
              $(document).triggerHandler(cartChangedEvent());
              $(".pro_shop_btn", container).removeClass("unable");
            })
            .catch(function (err) {
              $(".pro_shop_btn", container).removeClass("unable");
            });
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewActiveLook = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-active-look-template", container);
        $(".jelenew_pro_block_img a", container).on("click", function name(params) {
          sensors.track("ClickProductPicture", {
            element_name: "商品图片",
            product_id: $(this).parents(".jelenew_pro_block_wrap_wrap").data("product-id"),
            product_name: $(this).parents(".jelenew_pro_block").find(".pro_block_title").text(),
            page_position: theme.jelenew_web_page_name || "",
            active_name: theme.jelenew_active_name,
          });
        });
        $(".product_list.product_list_h5", container).slick({
          arrows: false,
          infinite: false,
          slidesToShow: 3.5,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2.5,
              },
            },
          ],
        });
        //添加购物车
        $(".pro_shop_btn", container).on("click", function () {
          if ($(this).hasClass("unable")) {
            return;
          }
          var newFormData = "";
          var itemList = $(".product_list.product_list_h5", container).find(".jelenew_pro_block_wrap");
          var formData = {
            items: [],
          };
          itemList.each(function (index, item) {
            var variant_id = $(item).data("sku_id");
            if (variant_id) {
              formData.items.push({
                id: Number(variant_id),
                quantity: 1,
              });
            }
          });

          $(this).addClass("lazyload--placeholder");

          newFormData = JSON.parse(JSON.stringify(formData));
          shopifyCartApi
            .add({ items: newFormData.items, sections: "cart-drawer" })
            .then(function (res) {
              $(document).triggerHandler(cartChangedEvent());
              $(".pro_shop_btn", container).removeClass("lazyload--placeholder");
            })
            .catch(function (err) {
              $(".pro_shop_btn", container).removeClass("lazyload--placeholder");
            });
          var product_ids = [],
            sku_name = [],
            skc_ids = [],
            spu_ids = [],
            variant_ids = [];
          $(".product_list_h5 .jelenew_pro_block_wrap_wrap", container).each((index, item) => {
            product_ids.push($(item).data("product-id") + "");
            variant_ids.push($(item).data("variant-id") + "");
            sku_name.push($(item).data("sku") + "");
            skc_ids.push($(item).data("skc"));
            spu_ids.push($(item).data("spu"));
          });
          sensors.track("ClickAddToBag", {
            page_position: theme.jelenew_web_page_name,
            active_name: theme.jelenew_active_name,
            product_number: product_ids.length,
            product_ids: product_ids,
            sku_name: sku_name,
            skc_ids: skc_ids,
            spu_ids: spu_ids,
            variant_ids: variant_ids,
          });
        });
        theme.wishList();
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewValTabs = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-val-tabs-template", container);
        var $headerDOM = $("#pageheader"),
          bodyScrollTop = document.documentElement.scrollTop || document.body.scrollTop,
          oldScrollTop = document.documentElement.scrollTop || document.body.scrollTop,
          $container = $(container),
          jelenew_red_option_tabs = $container.find(".jelenew_red_option_tabs"),
          headerH = $headerDOM.height();
        window.jelenewHeaderAnimateArr.push({ target: $(".jelenew_red_option_tabs", container)[0] });
        var tabIds = [],
          selectIndex = -1;
        $container.find(".jelenew_red_tab").each((index, item) => {
          tabIds.push($(item).data("tab_id"));
        });
        setFixed();
        function setFixed() {
          bodyScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          if (oldScrollTop < bodyScrollTop) {
            // 下滚
            if (bodyScrollTop >= parseInt($container.offset().top)) {
              jelenew_red_option_tabs.addClass("jelenew_red_option_tabs_fixed");
            } else {
              jelenew_red_option_tabs.removeClass("jelenew_red_option_tabs_fixed");
            }
          } else {
            // 上滚
            if (bodyScrollTop >= parseInt($container.offset().top - headerH)) {
              jelenew_red_option_tabs.addClass("jelenew_red_option_tabs_fixed");
            } else {
              jelenew_red_option_tabs.removeClass("jelenew_red_option_tabs_fixed");
            }
          }

          if (bodyScrollTop < parseInt($("#" + tabIds[0]).offset().top)) {
            selectIndex = -1;
          }
          for (var ii = 0; ii < tabIds.length; ii++) {
            if (window.innerWidth < 768) {
              if (
                bodyScrollTop >=
                parseInt($("#" + tabIds[ii]).offset().top) - (Number($headerDOM.get(0).style.top.replace("px", "")) + headerH - 3) - 87
              ) {
                selectIndex = ii;
              }
            } else {
              if (
                bodyScrollTop >=
                parseInt($("#" + tabIds[ii]).offset().top) - (Number($headerDOM.get(0).style.top.replace("px", "")) + headerH - 3)
              ) {
                selectIndex = ii;
              }
            }
            oldScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          }
        }
        $(window).on("throttled-scroll", setFixed);
        var topTo = "";
        $(".jelenew_red_tab").on("click", function () {
          topTo = $("#" + $(this).data("tab_id")).offset().top;
          if (window.innerWidth > 768) {
            if ($(this).data("index0") > selectIndex) {
              window.scrollTo({
                top: topTo - 40,
                behavior: "smooth",
              });
            } else {
              window.scrollTo({
                top: topTo - 110 - 40,
                behavior: "smooth",
              });
            }
          } else {
            if ($(this).data("index0") > selectIndex) {
              window.scrollTo({
                top: topTo - 40,
                behavior: "smooth",
              });
            } else {
              window.scrollTo({
                top: topTo - 60 - 40,
                behavior: "smooth",
              });
            }
          }
          if ($("#content").find(".jelenew-section-loading").length > 0) {
            setTimeout(() => {
              topTo = $("#" + $(this).data("tab_id")).offset().top;
              if (window.innerWidth > 768) {
                if ($(this).data("index0") > selectIndex) {
                  window.scrollTo({
                    top: topTo - 40,
                    behavior: "smooth",
                  });
                } else {
                  window.scrollTo({
                    top: topTo - 110 - 40,
                    behavior: "smooth",
                  });
                }
              } else {
                if ($(this).data("index0") > selectIndex) {
                  window.scrollTo({
                    top: topTo - 40,
                    behavior: "smooth",
                  });
                } else {
                  window.scrollTo({
                    top: topTo - 60 - 40,
                    behavior: "smooth",
                  });
                }
              }
            }, 600);
          }
          // sensors.track("ClickDetailsElement", {
          //   element_name: $(this).text().trim(),
          //   page_position: theme.jelenew_web_page_name,
          //   active_name: theme.jelenew_active_name,
          // });
        });
      };
    })();
    theme.jelenewLookList = new (function () {
      function urlQuery(key, url) {
        let urls = location.search || location.hash;
        if (url) {
          urls = url;
        }
        var m = urls.match(new RegExp(`(\\?|&)(${key})=([^&$]*)`));
        return m ? m[3] : "";
      }
      this.onSectionLoad = function (container) {
        var dataList = $(container).data("list");
        var localDetailIndex = 0;

        var repeatList = {},
          updateCartList = {},
          newFormData = "";
        // ADD all to bag
        $(".product_item_shop .product_item_shop_inner", container).on("click", function () {
          if ($(".product_item_shop .product_item_shop_inner", container).hasClass("unable")) {
            return;
          }

          var product_items = $(".product_item", container);
          var formData = {
            items: [],
          };
          product_items.each(function (index, item) {
            var variant_id = $(item).find(".product_item_sku-value .selected").data("variant-id");
            if (variant_id) {
              formData.items.push({
                id: Number(variant_id),
                quantity: 1,
              });
            }
          });

          if (formData.items.length != product_items.length) {
            $(".select-size-warning", container).css("visibility", "visible");
            $(".select-size-warning .select-size-warning-title", container).text("Please select a size");
            return;
          } else {
            $(".select-size-warning", container).css("visibility", "hidden");
          }

          $(".product_item_shop .product_item_shop_inner", container).addClass("unable");

          shopifyCartApi
            .add({ items: formData.items, sections: "cart-drawer" })
            .then((res) => {
              $(document).triggerHandler(cartChangedEvent());
              $(".product_item_shop .product_item_shop_inner", container).removeClass("unable");
            })
            .catch((err) => {
              $(".product_item_shop .product_item_shop_inner", container).removeClass("unable");
            });
        });

        // 尺码选择
        $(".jelenew_look_detail", container).on("click", ".sku-value", function () {
          $(this).addClass("selected");
          $(this).siblings().removeClass("selected");
          $(".select-size-warning", container).css("visibility", "hidden");
        });
        // 删除商品
        $(".jelenew_look_detail", container).on("click", ".product_item_delete", function () {
          var item_num = $(".product_item", container).length;
          if (item_num > 1) {
            $(this).closest(".product_item").remove();
          } else {
            $(".select-size-warning", container).css("visibility", "visible");
            $(".select-size-warning .select-size-warning-title", container).text("Please add at least one item to cart");
          }
        });
        function getLookDetail(url) {
          if (!url) {
            url = window.location.pathname;
          }
          return url.split("/pages/")[1];
        }
        //埋点
        // 详情页-埋点
        if (
          document.querySelector('div[data-section-type="jelenew-look-list"]>div').getAttribute("data-path") !=
          document.querySelector('div[data-section-type="jelenew-look-list"]>div').getAttribute("data-setting-path")
        ) {
          $(".jelenew_look_detail .detail_img_list .detailBtn").on("click", function () {
            // sensors.track("ClickDetailsElement", {
            //   element_name: "主图",
            //   page_position: "LOOK详情页",
            //   position: getLookDetail($(this).attr("href")),
            // });
          });

          $(".detail_info_view").on("click", function () {
            // sensors.track("ClickDetailsElement", {
            //   element_name: "View all looks",
            //   page_position: "LOOK详情页",
            //   position: getLookDetail(),
            // });
          });

          $(".product_item_shop .product_item_shop_inner").on("click", function () {
            var product_ids = [];
            $(".detail_info_product_list .product_item").each(function () {
              product_ids.push($(this).data("product_id") + "");
            });
            // sensors.track("ClickDetailsElement", {
            //   element_name: $(this).text().trim(),
            //   page_position: "LOOK详情页",
            //   product_ids: product_ids,
            //   product_number: product_ids.length,
            // });
          });
          $(".product_item .sku-value").on("click", function () {
            // sensors.track("ClickDetailsElement", {
            //   element_name: "SIZE",
            //   page_position: window.theme.jelenew_web_page_name || "",
            //   look_id: location.pathname.split("/").pop(),
            //   size: $(this).text().trim(),
            //   product_name: $(this).parents(".product_item").data("title"),
            //   product_id: $(this).parents(".product_item").data("product_id"),
            //   original_price: Number(
            //     $(this)
            //       .parents(".product_item")
            //       .find(".product_item_price")
            //       .text()
            //       .trim()
            //       .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
            //       .replace(",", ".")
            //   ),
            // });
          });
        } else {
          // 列表页-埋点

          $(".jelenew_look_list .look_list .look_item .look_item_inner").on("click", function () {
            sensors.track("ClickLookList", {
              position: $(this).find(".look_item_title").text().trim(),
              pic_url: $(this).find("img").attr("src") || $(this).find(".rimage_image_url").text().trim(),
              look_list_name: location.pathname.split("/").pop(),
              page_position: window.theme.jelenew_web_page_name || "",
            });
          });
        }
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewOurLoved = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-our-loved-template", container);
        var centerMode = false,
          infinite = false,
          initialSlide = 1;
        if ($("body").data("page-type") == "product") {
          centerMode = true;
          infinite = true;
          initialSlide = 3;
        }
        $(".loved_list", container).slick({
          arrows: true,
          dots: true,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          slidesToScroll: 1,
          slidesToShow: 3,
          infinite: infinite,
          initialSlide: initialSlide,
          centerPadding: "0px",
          centerMode: centerMode,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                infinite: false,
                initialSlide: 0,
                centerPadding: "0px",
                centerMode: false,
                slidesToShow: 1.5,
              },
            },
          ],
        });

        var matchStr = location.pathname.match("[^/]+(?!.*/)");
        if (window.theme.jelenew_web_page_name == "商品详情页") {
          $(".jelenew_our_loved_a").on("click", function () {
            sensors.track("ClickHomeElement", {
              button_name: "pic",
              element_name: "PicResource",
              jump_link: "https://www.jelenew.com" + $(this).attr("href"),
              pic_url:
                $(this)
                  .find(".rimage-wrapper noscript")
                  .html()
                  .match(/src=[\"]?([^\"]*)[\"]?/i) &&
                ($(this)
                  .find(".rimage-wrapper noscript")
                  .html()
                  .match(/src=[\"]?([^\"]*)[\"]?/i)[1] ||
                  $(this)
                    .find(".rimage-wrapper noscript")
                    .html()
                    .match(/src=[\"]?([^\"]*)[\"]?/i)[0]),
              page_position: window.theme.jelenew_web_page_name || "",
              category_name: matchStr ? matchStr[0] : "",
            });
          });
        } else if (window.theme.jelenew_web_page_name == "分类列表页") {
          $(".jelenew_our_loved_a").on("click", function () {
            // sensors.track("ClickListElement", {
            //   button_name: "pic",
            //   element_name: "PicResource",
            //   jump_link: "https://www.jelenew.com" + $(this).attr("href"),
            //   pic_url:
            //     $(this)
            //       .find(".rimage-wrapper noscript")
            //       .html()
            //       .match(/src=[\"]?([^\"]*)[\"]?/i) &&
            //     ($(this)
            //       .find(".rimage-wrapper noscript")
            //       .html()
            //       .match(/src=[\"]?([^\"]*)[\"]?/i)[1] ||
            //       $(this)
            //         .find(".rimage-wrapper noscript")
            //         .html()
            //         .match(/src=[\"]?([^\"]*)[\"]?/i)[0]),
            //   page_position: window.theme.jelenew_web_page_name || "",
            //   category_name: matchStr ? matchStr[0] : "",
            // });
          });
        }
      };
      this.onSectionUnLoad = function (container) {};
    })();

    theme.jelenewImgProduct = new (function () {
      this.onSectionLoad = function (container) {
        $(".product_list", container).slick({
          arrows: true,
          dots: true,
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          touchMove: false,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2.25,
              },
            },
          ],
        });
        $(container).on("click", ".product_item_img", function () {
          var siblings = $(this).siblings();
          sensors.track("ClickCollectionList", {
            page_position: "首页",
            list_type: "首页推荐Collections",
            list_name: siblings.find(".product_item_title").text().trim(),
            jump_link: location.origin + $(this).find(".product_item_a").attr("href"),
          });
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewParisEventSlide = new (function () {
      this.onSectionLoad = function (container) {
        var slidesToShow = 1.5;
        $(".product_list", container).slick({
          arrows: true,
          dots: true,
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1.5,
              },
            },
          ],
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewProductImgs = new (function () {
      this.onSectionLoad = function (container) {
        //    $(".product_list", container).slick({
        //        arrows: true,
        //        dots: true,
        //        infinite: true,
        //        centerMode: true,
        //        centerPadding: '40%',
        //        slidesToShow: 1,
        //        prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
        // nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
        //        initialSlide: 0,
        //        responsive: [
        //          {
        //            breakpoint: 767,
        //            settings: {
        //              arrows: false,
        //              infinite: true,
        //              centerMode: true,
        //              centerPadding: '28%',
        //              slidesToShow: 1
        //            }
        //          }
        //        ]
        //    }).on("afterChange", function () {

        //    })
        $(".product_list", container).slick({
          arrows: true,
          dots: true,
          infinite: true,
          centerMode: false,
          slidesToShow: 4,
          slidesToScroll: 4,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          initialSlide: 0,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                arrows: false,
                infinite: true,
                centerMode: true,
                centerPadding: "28%",
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();

    theme.jelenewStravaImgsText = new (function () {
      this.onSectionLoad = function (container) {
        $(container)
          .find(".jelenew_strava_imgs")
          .slick({
            lazyLoad: "ondemand",
            arrows: true,
            dots: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  arrows: false,
                  infinite: false,
                  slidesToShow: 1.5,
                },
              },
            ],
          });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewStorySlide = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-story-slide-template", container);
        $(container)
          .find(".jelenew-story-blocks")
          .slick({
            lazyLoad: "ondemand",
            arrows: true,
            dots: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  arrows: false,
                  infinite: false,
                  slidesToShow: 1.5,
                },
              },
            ],
          });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewVideoImgsSection = new (function () {
      this.onSectionLoad = function (container) {
        var img_num = $(container).data("img_num"),
          img_before = $(container).data("img_before"),
          img_after = $(container).data("img_after");
        var canvasimg, video_imgs_container, video_imgs_container_wrap, selectIndex, container_height, oneScrollHeight, oldScrollTop, oldHasScrollTop;
        var jelenew_video_imgs_section = $(container).find(".jelenew_video_imgs_section").get(0);
        for (var i = 1; i < img_num; i++) {
          var image = new Image();
          image.src = img_before + i + img_after;
          jelenew_video_imgs_section.append(image);
        }
        window.addEventListener("resize", function () {
          setDom();
          domFun();
        });
        function setDom() {
          canvasimg = $(container).find(".canvasimg").get(0);
          video_imgs_container = $(container).find(".video_imgs_container").get(0);
          video_imgs_container_wrap = $(container).find(".video_imgs_container_wrap").get(0);
          canvasimg.src = img_before + "0" + img_after;
          selectIndex = 0;
          container_height = video_imgs_container.offsetHeight;
          oneScrollHeight = container_height / img_num;
          oldScrollTop = video_imgs_container_wrap.offsetTop;
          oldHasScrollTop = video_imgs_container_wrap.offsetHeight;
        }
        setDom();
        function domFun() {
          if (window.scrollY >= video_imgs_container_wrap.offsetTop) {
            // dom置顶
            if (window.scrollY >= video_imgs_container_wrap.offsetTop + container_height) {
              // 超过dom范围
              video_imgs_container.classList.remove("section_fixed");
              canvasimg.src = img_before + (img_num - 1) + img_after;
              video_imgs_container.style.transform = "translateY(100vh)";
            } else {
              // 在dom范围内
              video_imgs_container.classList.add("section_fixed");
              video_imgs_container.style.transform = "unset";
              selectIndex = Math.floor((window.scrollY - video_imgs_container_wrap.offsetTop) / oneScrollHeight);
              if (selectIndex > img_num - 1) {
                selectIndex = img_num - 1;
              }
              if (selectIndex < 0) {
                selectIndex = 0;
              }
              oldScrollTop = window.scrollY;
              canvasimg.src = img_before + selectIndex + img_after;
            }
          } else {
            // dom没达到置顶距离
            video_imgs_container.style.transform = "unset";
            video_imgs_container.classList.remove("section_fixed");
            selectIndex = 0;
            canvasimg.src = img_before + "0" + img_after;
          }
        }
        domFun();
        window.addEventListener("throttled-scroll", function (e) {
          domFun();
        });
      };
    })();
    theme.jelenewColLoadMore = new (function () {
      this.onSectionLoad = function (container) {
        var jelenew_product_items = $(".jelenew_product_item", container);
        function initSlick(jelenew_product_items) {
          jelenew_product_items.each(function () {
            var viewportTop = $(window).scrollTop(),
              viewportHeight = $(window).height();
            var itemTop = $(this).offset().top;
            var itemVisible = $(this).is(":visible");
            if (itemVisible) {
              //在可视区域内，初始化橱窗商品轮播
              if (itemTop >= viewportTop && itemTop < viewportTop + viewportHeight) {
                var jelenew_pro_block_img_list = $(this).find(".jelenew_pro_block_img_list");
                if (!jelenew_pro_block_img_list.hasClass("slick-initialized")) {
                  var _this = $(this);
                  jelenew_pro_block_img_list
                    .slick({
                      lazyLoad: "ondemand",
                      arrows: true,
                      dots: true,
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      prevArrow:
                        '<button type="button" class="slick-prev" aria-label="' +
                        theme.strings.previous +
                        '">' +
                        theme.icons.chevronLeft +
                        "</button>",
                      nextArrow:
                        '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                    })
                    .on("afterChange", function () {
                      initSlickSensors(_this);
                    });
                }
              }
            }
          });
        }
        function initSlickSensors(_this) {
          var page_path = $("html").data("path");
          var event_type = "";
          var sensors_param = {
            page_position: window.theme.jelenew_web_page_name || "活动页",
            element_name: "商品滑动",
            product_name: _this.find(".pro_block_title").text(),
            product_id: _this.find(".jelenew_pro_block_wrap_wrap").data("product-id"),
            active_name: page_path,
            category_name: page_path,
          };
          if ($("body").data("page-type") == "collection") {
            event_type = "ClickListElement";
            delete sensors_param.active_name;
          } else if ($("body").data("page-type") == "page") {
            event_type = "ClickActivityElement";
            delete sensors_param.category_name;
          }
          // sensors.track(event_type, sensors_param);
        }
        initSlick(jelenew_product_items);
        $(window).scroll(function () {
          initSlick(jelenew_product_items);
        });
        if (
          $("body").hasClass("template-suffix-rolland-leggings-shorts") ||
          $("body").hasClass("template-suffix-black-friday") ||
          $("body").hasClass("template-suffix-christmas")
        ) {
          $(".jelenew_show_details_btn", container).on("click", function () {
            sensors.track("ClickProductList", {
              page_position: window.theme.jelenew_web_page_name || "",
              active_name: window.theme.jelenew_active_name || "",
              list_type: "推荐商品列表",
              list_name: "推荐商品列表",
              product_name: $(this).parents(".jelenew_pro_block_wrap_wrap").find(".jelenew_new_product_showcase_a").data("title"),
              product_id: $(this).parents(".jelenew_pro_block_wrap_wrap").data("product-id"),
              original_price:
                $(this)
                  .parents(".jelenew_pro_block_wrap_wrap")
                  .find(".jelenew_pro_block_price")
                  .text()
                  .trim()
                  .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                  .replace(",", ".") * 1,
            });
          });
          $(".jelenew_new_product_showcase_a", container).on("click", function () {
            sensors.track("ClickProductList", {
              page_position: window.theme.jelenew_web_page_name || "",
              active_name: window.theme.jelenew_active_name || "",
              list_type: "推荐商品列表",
              list_name: "推荐商品列表",
              product_name: $(this).data("title"),
              product_id: $(this).parents(".jelenew_pro_block_wrap_wrap").data("product-id"),
              original_price:
                $(this)
                  .parents(".jelenew_pro_block_wrap_wrap")
                  .find(".jelenew_pro_block_price")
                  .text()
                  .trim()
                  .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                  .replace(",", ".") * 1,
            });
          });
        } else {
          $(".jelenew_new_product_showcase_a", container).on("click", function () {
            sensors.track("ClickProductList", {
              page_position: window.theme.jelenew_web_page_name || "",
              list_type: "分类列表",
              list_name: $(container).data("handle") || location.pathname.split("/").pop(),
              product_name: $(this).data("title"),
              product_id: $(this).parents(".jelenew_pro_block_wrap_wrap").data("product-id"),
              original_price:
                $(this)
                  .parents(".jelenew_pro_block_wrap_wrap")
                  .find(".jelenew_pro_block_price")
                  .text()
                  .trim()
                  .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                  .replace(",", ".") * 1,
            });
          });
        }
        // $(".jelenew-my-wish-product", container).on("click", function () {
        //   sensors.track("ClickWish", {
        //     page_position: window.theme.jelenew_web_page_name || "",
        //     category_name: $(container).data("handle") || location.pathname.split("/").pop(),
        //     product_id: $(this).parents(".jelenew_pro_block_wrap_wrap").data("product-id"),
        //     original_price:
        //       $(this)
        //         .parents(".jelenew_pro_block_wrap_wrap")
        //         .find(".jelenew_pro_block_price")
        //         .text()
        //         .trim()
        //         .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
        //         .replace(",", ".") * 1,
        //   });
        // });
        $(".collection_btn", container).on("click", function () {
          jelenew_product_items.each(function () {
            if ($(this).css("display") == "none") {
              _this = $(this);
              $(this).css({ display: "block" });
              $(this)
                .find(".jelenew_pro_block_img_list")
                .slick({
                  lazyLoad: "ondemand",
                  arrows: true,
                  dots: true,
                  infinite: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  prevArrow:
                    '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                  nextArrow:
                    '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                })
                .on("afterChange", function () {
                  initSlickSensors(_this);
                });
            }
          });
          $(this).parents(".collection_btn_wrap").css({ display: "none" });
          var matchStr = location.pathname.match("[^/]+(?!.*/)");
          // sensors.track("ClickListElement", {
          //   page_position: "分类列表页",
          //   category_name: matchStr ? matchStr[0] : "",
          //   element_name: $(this).text().trim(),
          // });
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewFoldSection = new (function () {
      this.onSectionLoad = function (container) {
        var $container = $(container);
        $container.on("click", ".jelenew_spec_title", function () {
          $container.toggleClass("open_fold");
          sensors.track(theme.jelenew_event_name, {
            element_name: "展开折叠项",
            choose_type: $(container).hasClass("open_fold") ? "展开" : "折叠",
            choose_title: $(this).text().trim(),
            page_position: theme.jelenew_web_page_name,
            product_name: $(".jelenew-main-product-detail .jelenew-product-name").text().trim(),
            product_id: $(".jelenew-product-form-container.product-detail").attr("data-product-id") + "",
            original_price:
              $(".jelenew-main-product-detail .jelenew-product-price .theme-money")
                .text()
                .trim()
                .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                .replace(",", ".") * 1,
          });
        });
      };
    })();
    theme.jelenewStoryText = new (function () {
      this.onSectionLoad = function (container) {
        $(".text_see_more_all", container).on("click", function () {
          if ($(container).find(".section_inner").hasClass("jelenew_see_more_text_show")) {
            $(this).text("See More");
            $(container).find(".section_inner").removeClass("jelenew_see_more_text_show");
            $(".section_inner", container).height("200px");
          } else {
            $(this).text("See Less");
            $(container).find(".section_inner").addClass("jelenew_see_more_text_show");
            $(".section_inner", container).height($(container).find(".section_inner .section_inner_inner").height() + "px");
          }
        });
        $(".text_see_more_text", container).on("click", function () {
          // sensors.track("ClickActivityElement", {
          //   button_name:
          //     $(this)
          //       .parents(".jelenew_story_text_text_wrap")
          //       .prev(".jelenew_story_text_title_wrap")
          //       .find(".jelenew_story_text_title:nth-child(1)")
          //       .text()
          //       .trim() || "",
          //   element_name: $(this).text().trim(),
          //   page_position: window.theme.jelenew_web_page_name || "",
          //   active_name: window.theme.jelenew_active_name || "",
          // });
          if ($(this).parents(".jelenew_story_text_text_wrap").hasClass("jelenew_story_text_text_show")) {
            $(this).text("See More");
            $(this).parents(".jelenew_story_text_text_wrap").removeClass("jelenew_story_text_text_show");
            $(this).parents(".jelenew_story_text_text_wrap").find(".jelenew_story_text_text_inner").height("60px");
          } else {
            $(this).text("See Less");
            $(this).parents(".jelenew_story_text_text_wrap").addClass("jelenew_story_text_text_show");
            $(this)
              .parents(".jelenew_story_text_text_wrap")
              .find(".jelenew_story_text_text_inner")
              .height($(this).parents(".jelenew_story_text_text_wrap").find(".jelenew_story_text_text_con").height() + "px");
          }
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();

    theme.jelenewTextSeeMore = new (function () {
      this.onSectionLoad = function (container) {
        $(document).ready(function () {
          var text_see_more_text_wrap = $(".text_see_more_text_wrap", container),
            text_see_more_text_inner = $(".text_see_more_text_inner", container),
            text_see_more_text = $(".text_see_more_text", container),
            spiderConfig = {
              element_name: "See More",
              category_name: location.pathname.split("/").pop(),
              page_position: theme.jelenew_web_page_name,
            },
            line = $(container).data("line") || 2;
          const desktop_line = $(container).data("desktop_line") || 2;
          function lineFormat() {
            if (window.innerWidth >= 768) {
              return desktop_line;
            } else {
              return line;
            }
          }
          function initSeeMore() {
            if (text_see_more_text_wrap.hasClass("text_see_more_text_wrap_open")) {
              return;
            }
            text_see_more_text_wrap.attr("class", "text_see_more_text_wrap");
            if (text_see_more_text_inner.height() > 24 * lineFormat()) {
              text_see_more_text_wrap.addClass("text_see_more_text_wrap_close");
              text_see_more_text.height(24 * lineFormat() + "px");
            } else {
              text_see_more_text_wrap.addClass("text_see_more_text_wrap_none");
            }
          }
          // text_see_more_text_wrap.attr("class", "text_see_more_text_wrap");
          // if (text_see_more_text_inner.height() > 24 * lineFormat()) {
          //   text_see_more_text_wrap.addClass("text_see_more_text_wrap_close");
          //   text_see_more_text.height(24 * lineFormat() + "px");
          // } else {
          //   text_see_more_text_wrap.addClass("text_see_more_text_wrap_none");
          // }
          initSeeMore();
          window.addEventListener("resize", initSeeMore, true);
          $(".text_see_more", container).on("click", function () {
            if (text_see_more_text_wrap.hasClass("text_see_more_text_wrap_open")) {
              spiderConfig.element_name = "See Less";
              $(this).text("See More");
              text_see_more_text_wrap.removeClass("text_see_more_text_wrap_open");
              text_see_more_text.height(24 * lineFormat() + "px");
            } else {
              $(this).text("See Less");
              text_see_more_text_wrap.addClass("text_see_more_text_wrap_open");
              text_see_more_text.height(text_see_more_text_inner.height() + "px");
              setTimeout(() => {
                text_see_more_text.height(text_see_more_text_inner.height() + "px");
              }, 350);
            }
            const module_name =
              $(this).closest(".jelenew_detail_left_inner").find(".product_details_title").text().trim() ||
              $(this).closest(".jelenew_main_product_desc").find(".product_description_title").text().trim() ||
              $(this).parents(".jelenew_cottom_text").find(".jelenew_bottom_title").text().trim() ||
              "顶部";
            sensors.track(theme.jelenew_event_name, {
              ...spiderConfig,
              module_name,
            });
          });
          if (
            window.location.hash == "#product-details" &&
            $(".text_see_more", container).closest(".jelenew_detail_left_inner").find(".product_details_title").length > 0
          ) {
            $(".text_see_more", container).trigger("click");
          } else if (
            window.location.hash == "#why-we-made-this" &&
            $(".text_see_more", container).closest(".jelenew_main_product_desc").find(".product_description_title").length > 0
          ) {
            $(".text_see_more", container).trigger("click");
          }
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewAppVlogProduct = new (function () {
      this.onSectionLoad = function (container) {
        $(".product_item_a", container).on("click", function () {
          sensors.track("ClickPic", {
            page_position: "APPVlog详情页",
            vlog_details_id: $("body").data("vlog_id"),
          });
        });
        $(".product_list", container).slick({
          infinite: false,
          slidesToShow: 2.5,
          slidesToScroll: 1,
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewAppVlogName = new (function () {
      this.onSectionLoad = function (container) {
        // sensors.track("WebPageView", {
        //   vlog_details_title: $(container).data("vlog_title"),
        //   vlog_details_id: $(container).data("vlog_id"),
        //   web_page_name: "APPVlog详情页",
        // });
        var data = {
          context: {},
          params: {
            key: $(container).data("vlog_id"),
            keyType: 2,
          },
        };
        var httpUrl = "https://dev-api.jelenew.com/api/home/likes/counts";
        if (Shopify.theme.role == "main") {
          httpUrl = "https://api.jelenew.com/api/home/likes/counts";
        }
        fetch(httpUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            return response.json();
          })
          .then((res) => {
            if (res.status && res.status.code == 0 && res.result && res.result.info) {
              $(container).find(".vlog_right_inner").text(res.result.info.likes);
            } else {
              $(container).find(".vlog_right_inner").text(0);
            }
          });
        var clickLock = false;
        $(".vlog_right", container).on("click", function () {
          if ($(this).hasClass("vlog_right_select") || clickLock) {
            return;
          }
          sensors.track("ClickLike", {
            vlog_details_id: $(container).data("vlog_id"),
            video_url: $("body .jelenew_fold_video .video-container").data("video-url"),
            page_position: "APPVlog详情页",
          });
          clickLock = true;
          var httpHandleUrl = "https://dev-api.jelenew.com/api/home/likes/handle";
          if (Shopify.theme.role == "main") {
            httpHandleUrl = "https://api.jelenew.com/api/home/likes/handle";
          }

          fetch(httpHandleUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => {
              return response.json();
            })
            .then((res) => {
              clickLock = false;
              if (res.status && res.status.code == 0) {
                $(container)
                  .find(".vlog_right_inner")
                  .text(Number($(container).find(".vlog_right_inner").text()) + 1);
                $(this).find(".vlog_right_icon").css({
                  transform: "rotate(-20deg)",
                });
                $(this).addClass("vlog_right_select");
                setTimeout(() => {
                  $(this).find(".vlog_right_icon").css({
                    transform: "rotate(0deg)",
                  });
                }, 300);
              } else {
                theme.JelenewTips((res.status && res.status.desc) || "");
              }
            });
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewAppVlogList = new (function () {
      this.onSectionLoad = function (container) {
        // var vlog_con_time
        var vlog_con = $(".vlog_list_con .vlog_con", container);
        for (var i = 0; i < vlog_con.length; i++) {
          setVideoTime($(vlog_con[i]).data("video_src"), i);
        }
        var layerContainer = "";
        $(".vlog_con", container).on("click", function () {
          layerContainer = `<div class="vlog_layer_wrap">
              <div class="vlog_layer">
                <div class="vlog_layer_video">
                </div>
                <div class="layer_con">
                  <div class="layer_frame Futuran">${$(this).data("layer_frame")}</div>
                  <div class="layer_shot Futuran">${$(this).data("layer_shot")}</div>
                </div>
              </div>
            </div>`;
          $("body").append(layerContainer);
          if ($(this).data("video_src")) {
            // 当前是视频
            $(".vlog_layer_video").append($(this).find(".vlog_con_video_wrap").html());
            $(".vlog_layer_video .vlog_layer_video_inner").get(0).oncanplay = function () {
              $(this)
                .parents(".vlog_layer_video")
                .css({
                  "padding-top": `min(${($(this)[0].videoHeight / $(this)[0].videoWidth) * 100}%, 70vh)`,
                });
              $(".vlog_layer_video .vlog_layer_video_inner").css({
                height: `min(100%, 70vh)`,
              });
            };
            $(".vlog_layer_video .vlog_layer_video_inner")
              .get(0)
              .addEventListener("play", function (e) {
                // sensors.track("ClickVideoPlaying", {
                //   vlog_details_id: $("body").data("vlog_id"),
                //   video_url: $(this)[0].src,
                //   page_position: "APPVlog详情页",
                // });
              });
            $(".vlog_layer_video .vlog_layer_video_inner")
              .get(0)
              .addEventListener("pause", function (e) {
                // sensors.track("VideoEnd", {
                //   vlog_details_id: $("body").data("vlog_id"),
                //   video_duration: $(this)[0].currentTime,
                //   video_url: $(this)[0].src,
                //   page_position: "APPVlog详情页",
                // });
              });
            $(".vlog_layer_video .vlog_layer_video_inner").trigger("play");
          } else {
            // 当前是图片
            $(".vlog_layer_video").addClass("vlog_layer_video_img").append($(this).find(".rimage-outer-wrapper").html());
            $(".vlog_layer_video").css("padding-top", "0");
          }
          $(".vlog_layer_wrap")
            .unbind()
            .on("click", function () {
              $(this).remove();
            });
          $(".vlog_layer_wrap .vlog_layer")
            .unbind()
            .on("click", function (e) {
              e.stopPropagation();
            });
        });

        function setTime(e) {
          var t = Math.floor(e / 1e3 / 60),
            n = Math.floor(e / 1e3 - 60 * t),
            i = "";
          return t.toString(), t < 10 && (t = "0" + t), (i += t + ":"), n.toString(), n < 10 && (n = "0" + n), (i += n);
        }
        function setVideoTime(videoSrc, videoIndex) {
          var videoDiv = document.createElement("video");
          videoDiv.src = videoSrc;
          videoDiv.width = 0;
          videoDiv.height = 0;
          document.body.appendChild(videoDiv);
          videoDiv.oncanplay = () => {
            $(vlog_con[videoIndex])
              .find(".vlog_con_time")
              .text(setTime(videoDiv.duration * 1000))
              .show();
            document.body.removeChild(videoDiv);
          };
        }
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewRollProSlide = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-roll-pro-slide-template", container);
        $(".jelenew_roll_pro_slide_list", container)
          .slick({
            arrows: true,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: $(container).data("autoplay"),
            autoplaySpeed: 5000,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          })
          .init(function () {
            $(".jelenew_roll_pro_slide_list", container).css("overflow", "unset");
          });
        $(".jelenew_roll_pro_slide_btn", container).on("click", function () {
          // sensors.track("ClickActivityElement", {
          //   page_position: theme.jelenew_web_page_name || "",
          //   active_name: theme.jelenew_active_name || "",
          //   element_name: $(this).text().trim(),
          // });
          window.location.href = $(container).find(".slick-active").data("href");
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewRollOccSilde = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-roll-occ-silde-template", container);

        $(".jelenew_roll_occ_silde_list", container).slick({
          arrows: false,
          dots: false,
          slidesToScroll: 1,
          slidesToShow: 3,
          infinite: false,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          responsive: [
            {
              breakpoint: 767,
              settings: {
                arrows: true,
                dots: false,
                slidesToScroll: 1,
                slidesToShow: 1.136,
              },
            },
          ],
        });
        $(".jelenew_roll_occ_silde_item_inner", container).on("click", function () {
          // sensors.track("ClickActivityElement", {
          //   button_name: "pic",
          //   element_name: "PicResource",
          //   jump_link: $(this).attr("href"),
          //   page_position: window.theme.jelenew_web_page_name || "",
          //   pic_url:
          //     $(this)
          //       .find(".rimage-wrapper noscript")
          //       .html()
          //       .match(/src=[\"]?([^\"]*)[\"]?/i) &&
          //     ($(this)
          //       .find(".rimage-wrapper noscript")
          //       .html()
          //       .match(/src=[\"]?([^\"]*)[\"]?/i)[1] ||
          //       $(this)
          //         .find(".rimage-wrapper noscript")
          //         .html()
          //         .match(/src=[\"]?([^\"]*)[\"]?/i)[0]),
          //   active_name: window.theme.jelenew_active_name || "",
          // });
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewParisSlide = new (function () {
      this.onSectionLoad = function (container) {
        $(".index_video_h5 .jelenew_paris_slide_img_wrap", container)
          .slick({
            arrows: false,
            dots: true,
            infinite: false,
            centerMode: true,
            centerPadding: "25%",
            slidesToShow: 1,
          })
          .init(function () {
            $(".index_video_h5 .jelenew_paris_slide_title_item", container).addClass("jelenew_paris_slide_title_item_hidden");
            $(container)
              .find('.index_video_h5 .jelenew_paris_slide_title_item[data-index0="' + $(".slick-current", container).data("index0") + '"]')
              .removeClass("jelenew_paris_slide_title_item_hidden");
          })
          .on("afterChange", function () {
            $(".index_video_h5 .jelenew_paris_slide_title_item", container).addClass("jelenew_paris_slide_title_item_hidden");
            $(container)
              .find('.index_video_h5 .jelenew_paris_slide_title_item[data-index0="' + $(".slick-current", container).data("index0") + '"]')
              .removeClass("jelenew_paris_slide_title_item_hidden");
          });
        $(".index_video_pc .jelenew_paris_slide_item", container).mouseover(function () {
          $(".index_video_pc .jelenew_paris_slide_item", container).addClass("jelenew_paris_slide_item_hidden");
          $(this).removeClass("jelenew_paris_slide_item_hidden");
          $(this).css({
            "z-index": "3",
          });
          $(".index_video_pc .jelenew_paris_slide_title_item", container).addClass("jelenew_paris_slide_title_item_hidden");
          $(container)
            .find('.index_video_pc .jelenew_paris_slide_title_item[data-index0="' + $(this).data("index0") + '"]')
            .removeClass("jelenew_paris_slide_title_item_hidden");
          $(".index_video_pc .jelenew_paris_slide_titles", container).addClass("jelenew_paris_slide_titles_show");
        });
        $(".index_video_pc .jelenew_paris_slide_img_wrap", container).mouseleave(function () {
          $(".index_video_pc .jelenew_paris_slide_item", container).removeClass("jelenew_paris_slide_item_hidden");
          $(".index_video_pc .jelenew_paris_slide_title_item", container).addClass("jelenew_paris_slide_title_item_hidden");
          $(".index_video_pc .jelenew_paris_slide_titles", container).removeClass("jelenew_paris_slide_titles_show");
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewRedOptionLook = new (function () {
      this.onSectionLoad = function (container) {
        var dataList = $(container).data("list"),
          localDetailIndex = 0;
        $(".jelenew_look_detail .detail_img_list", container)
          .slick({
            lazyLoad: "ondemand",
            arrows: true,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            unslick: false,
            initialSlide: 0,
          })
          .on("afterChange", function () {
            localDetailIndex = $(".jelenew_look_detail .detail_img_list", container).slick("slickCurrentSlide");
            setProductInfo();
          });
        $(".jelenew_look_list .look_list .look_item .look_item_inner", container).on("click", function () {
          localDetailIndex = $(this).data("index0");
          $(".jelenew_look_detail .detail_img_list", container).slick("slickGoTo", localDetailIndex);
          setProductInfo();
          $(".jelenew_look_detail_wrap", container).addClass("jelenew_look_detail_wrap_show");
        });
        $(".jelenew_look_detail_icon", container).on("click", function () {
          $(".jelenew_look_detail_wrap", container).removeClass("jelenew_look_detail_wrap_show");
        });
        $(".jelenew_look_detail .detail_info_next", container).on("click", function () {
          $(".jelenew_look_detail .detail_img_list", container).slick("slickNext");
        });
        var newFormData = "";
        $(".product_item_shop .product_item_shop_inner", container).on("click", function () {
          if ($(this).hasClass("unable")) {
            return;
          }
          $(this).addClass("unable");
          newFormData = "";
          newFormData = JSON.parse(JSON.stringify(dataList[localDetailIndex].formData));
          shopifyCartApi
            .add({ items: newFormData.items, sections: "cart-drawer" })
            .then((res) => {
              $(document).triggerHandler(cartChangedEvent());
              $(".product_item_shop .product_item_shop_inner", container).removeClass("unable");
            })
            .catch((err) => {
              $(".product_item_shop .product_item_shop_inner", container).removeClass("unable");
            });
        });
        function urlQuery(key, url) {
          let urls = location.search || location.hash;
          if (url) {
            urls = url;
          }
          var m = urls.match(new RegExp(`(\\?|&)(${key})=([^&$]*)`));
          return m ? m[3] : "";
        }
        //埋点
        $(".detail_info_view").on("click", function () {
          // sensors.track("ClickDetailsElement", {
          //   element_name: "View all looks",
          //   page_position: "LOOK详情页",
          //   position: urlQuery("detailIndex") || urlQuery("detailId"),
          // });
        });

        $(".product_item_shop .product_item_shop_inner").on("click", function () {
          var product_ids = ($(this).data("sku_list") + "").split("_");
          // sensors.track("ClickDetailsElement", {
          //   element_name: $(this).text().trim(),
          //   page_position: "LOOK详情页",
          //   product_ids: product_ids,
          //   product_number: product_ids.length,
          // });
        });

        $(".detail_info_product_list").on("click", ".product_item", function () {
          sensors.track("ClickProductList", {
            page_position: "LOOK详情页",
            list_type: "推荐列表",
            list_name: "推荐列表",
            product_name: $(this).find(".product_item_title").text().trim(),
            product_id: $(this).data("product_id"),
            original_price: Number(
              $(this)
                .find(".product_item_price")
                .text()
                .trim()
                .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                .replace(",", ".")
            ),
          });
        });
        function setProductInfo() {
          // 修改title
          $(".jelenew_look_detail .detail_info_title").text(dataList[localDetailIndex].title);
          // 修改加车标签的data
          $(".product_item_shop .product_item_shop_inner").attr("data-sku_list", dataList[localDetailIndex].skuIdList.join("_"));
          // 修改商品list
          var listHtml = "";

          $(".detail_info_product_list").html("");
          dataList[localDetailIndex].productList.forEach((item, index) => {
            listHtml += `<div class="product_item" data-product_id="${item.id}" data-title="${item.title}">
                            <div class="product_item_left">
                              <a href="${item.selectSkuInfo.url}">
                                <img src="${item.selectSkuInfo.featured_image.jelenewSrc}"/>
                              </a>
                            </div>
                            <div class="product_item_right">
                             <div class="product_item_title">${item.title}</div>
                              <div class="product_item_price">${item.selectSkuInfo.jelenewPrice}</div>
                              <div class="product_item_view"><a href="${item.selectSkuInfo.url}">View product</a></div>
                            </div>
                          </div>`;
          });
          $(".jelenew_look_detail .detail_info_product_list").html(listHtml);
        }
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewParisSlide = new (function () {
      this.onSectionLoad = function (container) {
        $(".index_video_h5 .jelenew_paris_slide_img_wrap", container)
          .slick({
            arrows: false,
            dots: true,
            infinite: false,
            centerMode: true,
            centerPadding: "25%",
            slidesToShow: 1,
          })
          .init(function () {
            $(".index_video_h5 .jelenew_paris_slide_title_item", container).addClass("jelenew_paris_slide_title_item_hidden");
            $(container)
              .find('.index_video_h5 .jelenew_paris_slide_title_item[data-index0="' + $(".slick-current", container).data("index0") + '"]')
              .removeClass("jelenew_paris_slide_title_item_hidden");
          })
          .on("afterChange", function () {
            $(".index_video_h5 .jelenew_paris_slide_title_item", container).addClass("jelenew_paris_slide_title_item_hidden");
            $(container)
              .find('.index_video_h5 .jelenew_paris_slide_title_item[data-index0="' + $(".slick-current", container).data("index0") + '"]')
              .removeClass("jelenew_paris_slide_title_item_hidden");
          });
        $(".index_video_pc .jelenew_paris_slide_item", container).mouseover(function () {
          $(".index_video_pc .jelenew_paris_slide_item", container).addClass("jelenew_paris_slide_item_hidden");
          $(this).removeClass("jelenew_paris_slide_item_hidden");
          $(this).css({
            "z-index": "3",
          });
          $(".index_video_pc .jelenew_paris_slide_title_item", container).addClass("jelenew_paris_slide_title_item_hidden");
          $(container)
            .find('.index_video_pc .jelenew_paris_slide_title_item[data-index0="' + $(this).data("index0") + '"]')
            .removeClass("jelenew_paris_slide_title_item_hidden");
          $(".index_video_pc .jelenew_paris_slide_titles", container).addClass("jelenew_paris_slide_titles_show");
        });
        $(".index_video_pc .jelenew_paris_slide_img_wrap", container).mouseleave(function () {
          $(".index_video_pc .jelenew_paris_slide_item", container).removeClass("jelenew_paris_slide_item_hidden");
          $(".index_video_pc .jelenew_paris_slide_title_item", container).addClass("jelenew_paris_slide_title_item_hidden");
          $(".index_video_pc .jelenew_paris_slide_titles", container).removeClass("jelenew_paris_slide_titles_show");
        });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.jelenewIndexNewArrival = new (function () {
      this.onSectionLoad = function (container) {
        var slideIndex = "";
        $(".jelenew_paris_slide_item", container).on("click", function () {
          sensors.track("ClickProductPicture", {
            page_position: theme.jelenew_web_page_name,
            element_name: "See New Arrivals",
            product_name: $(this).find(".jelenew_product_title").text().trim(),
            product_id: $(this).data("product-id"),
          });
        });
        $(".jelenew_paris_slide_img_wrap", container)
          .slick({
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: "20%",
            slidesToShow: 3,
            draggable: false,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  arrows: false,
                  dots: true,
                  centerMode: true,
                  centerPadding: "20%",
                  slidesToShow: 1,
                  draggable: true,
                },
              },
            ],
          })
          .on("beforeChange", function (evt, slick, current) {
            slideIndex = current;
          })
          .on("afterChange", function (evt, slick, current) {
            if (current !== slideIndex) {
              // sensors.track("SlideProductPicture", {
              //   page_position: theme.jelenew_web_page_name,
              //   element_name: "See New Arrivals",
              // });
            }
          })
          .init(() => {
            $(".jelenew_paris_slide_img_wrap", container).css({
              overflow: "unset",
            });
          });
      };
      this.onSectionUnLoad = function (container) {};
    })();
    theme.loadJelenewMainSearchFilterer = function (section) {
      this.$container = section.$container;
      this.namespace = section.namespace;
      this.registerEventListener = section.registerEventListener;
      this.active_dom = "";

      this.functions = {
        initFiltersEtc: function initFiltersEtc() {
          $(".filter-container", this.$container).addClass("filter-container--mobile-initialised");

          // append query vars onto sort urls (e.g. filters, vendor collection)
          if (location.href.indexOf("?") >= 0) {
            $("#sort-dropdown-options .link-dropdown__link", this.$container).each(function () {
              var queryTerms = location.href.split("?")[1].split("&");
              var newHref = $(this).attr("href");
              queryTerms.forEach(function (term) {
                if (term.indexOf("sort_by=") === -1) {
                  newHref += "&" + term;
                }
              });
              $(this).attr("href", newHref);
            });
          }

          theme.ProductBlockManager.loadImages(this.$container);
        },

        switchGridLayout: function switchGridLayout(evt) {
          evt.preventDefault();
          if ($(evt.currentTarget).hasClass("layout-switch--one-column")) {
            this.$container.find(".product-list").addClass("product-list--one-column-mobile");
          } else {
            this.$container.find(".product-list").removeClass("product-list--one-column-mobile");
          }
          $(evt.currentTarget).addClass("layout-switch--active").siblings().removeClass("layout-switch--active");
        },

        checkStickyScroll: function checkStickyScroll() {
          var utilityBarOffsetY = $(".utility-bar").offset().top;
          if ($(window).width() < 768 && this.previousScrollTop > window.scrollY && window.scrollY > utilityBarOffsetY) {
            $("body").addClass("utility-bar-sticky-mobile-copy-reveal");
          } else {
            $("body.utility-bar-sticky-mobile-copy-reveal").removeClass("utility-bar-sticky-mobile-copy-reveal");
          }
          this.previousScrollTop = window.scrollY;
        },

        ajaxLoadLink: function ajaxLoadLink(evt) {
          evt.preventDefault();
          this.active_dom = $(evt.target);
          this.functions.ajaxLoadUrl.call(this, $(evt.currentTarget).attr("href"));
        },

        ajaxLoadForm: function ajaxLoadForm(evt) {
          if (evt.type === "submit") {
            evt.preventDefault();
          }
          this.active_dom = $(evt.target);
          $("#CollectionFilterForm").addClass("jelenew_collection_filter_list_open");
          var queryVals = [];
          evt.currentTarget.querySelectorAll("input, select").forEach(function (input) {
            if (
              ((input.type !== "checkbox" && input.type !== "radio") || input.checked) && // is an active input value
              input.value !== "" // has a value
            ) {
              queryVals.push([input.name, encodeURIComponent(input.value)]);
            }
          });
          // new url
          var newUrl = location.pathname;
          queryVals.forEach(function (value) {
            newUrl += "&".concat(value[0], "=").concat(value[1]);
          });
          newUrl = newUrl.replace("&", "?");
          // load
          this.functions.ajaxLoadUrl.call(this, newUrl);
        },

        ajaxPopState: function ajaxPopState(event) {
          this.active_dom = $(event.target);
          this.functions.ajaxLoadUrl.call(this, document.location.href);
        },

        ajaxLoadUrl: function ajaxLoadUrl(url) {
          // update url history
          var fullUrl = url;
          if (fullUrl.slice(0, 1) === "/") {
            fullUrl = window.location.protocol + "//" + window.location.host + fullUrl;
          }
          window.history.pushState({ path: fullUrl }, "", fullUrl);

          // start fetching URL
          var refreshContainerSelector = "[data-ajax-container]",
            $ajaxContainers = this.$container.find(refreshContainerSelector);

          // loading state
          $ajaxContainers.addClass("ajax-loading");

          // fetch content
          if (this.currentAjaxLoadUrlFetch) {
            this.currentAjaxLoadUrlFetch.abort();
          }
          this.currentAjaxLoadUrlFetch = $.get(
            url,
            function (data) {
              this.currentAjaxLoadUrlFetch = null;

              // save active element
              if (document.activeElement) {
                this.activeElementId = document.activeElement.id;
              }

              // unload content
              theme.ProductBlockManager.unloadImages(this.$container);

              // replace contents
              var $newAjaxContainers = $("<div>".concat(data, "</div>")).find(refreshContainerSelector);
              $newAjaxContainers.each(function (index) {
                $($ajaxContainers[index]).html($(this).html());
              });

              // init js
              this.functions.initFiltersEtc.call(this);

              // init theme components
              var $componentHaver = this.$container.closest("[data-components]");
              if ($componentHaver.length) {
                var components = $componentHaver.data("components").split(",");
                components.forEach(
                  function (component) {
                    $(document).trigger("cc:component:load", [component, $componentHaver[0]]);
                  }.bind(this)
                );
              }

              // remove loading state
              $ajaxContainers.removeClass("ajax-loading");

              $(".jelenew_searh_filter_btn").on("click", function () {
                $("#CollectionFilterForm").addClass("jelenew_CollectionFilterForm_show");
                $("body").css({
                  overflow: "hidden",
                });
              });
              $(".jelenew_search_filter_title_right").on("click", function () {
                $("#CollectionFilterForm").removeClass("jelenew_CollectionFilterForm_show");
                $("body").css({
                  overflow: "auto",
                });
              });
              $("#CollectionFilterForm").removeClass("jelenew_collection_filter_list_open");
              if (
                this.active_dom &&
                this.active_dom.parents(".filter-group__items_wrap") &&
                this.active_dom.parents(".filter-group__items_wrap").length > 0
              ) {
              } else {
                $("#CollectionFilterForm").addClass("jelenew_CollectionFilterForm_show");
              }
              $(".jelenew_pro_block_img_list", this.$container).slick({
                arrows: true,
                dots: true,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow:
                  '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                nextArrow:
                  '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
              });

              // init scroll animations
              theme.initAnimateOnScroll();

              // restore active element
              if (this.activeElementId) {
                var el = document.getElementById(this.activeElementId);
                if (el) {
                  el.focus();
                }
              }
            }.bind(this)
          );
        },
      };

      // ajax filter & sort
      if (this.$container.data("ajax-filtering")) {
        // ajax load on link click
        this.$container.on(
          "click" + this.namespace,
          ".link-dropdown__link, .filter-group__applied-item, .filter-group__clear-link, .pagination a",
          this.functions.ajaxLoadLink.bind(this)
        );
        // ajax load form submission
        this.$container.on(
          "change" + this.namespace + " submit" + this.namespace,
          "#CollectionFilterForm",
          theme.debounce(this.functions.ajaxLoadForm.bind(this), 700)
        );
        // handle back button
        this.registerEventListener(window, "popstate", this.functions.ajaxPopState.bind(this));
      } else {
        this.$container.on("change" + this.namespace, "#CollectionFilterForm", function () {
          $(this).submit();
        });
      }

      // sort dropdown: open
      this.$container.on("click" + this.namespace, ".link-dropdown__button", theme.toggleLinkDropdownButton.bind(this));

      // sort dropdown: click anywhere else in page to close
      $(document).on("click" + this.namespace, function () {
        $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
      });

      if (document.querySelector(".utility-bar")) {
        // duplicate utility bar for mobile
        var $utilBarClone = $(".utility-bar")
          .clone()
          .addClass("utility-bar--sticky-mobile-copy")
          .removeAttr("data-ajax-container")
          .insertAfter(".utility-bar");
        // ensure unique ids
        theme.suffixIds($utilBarClone[0], "dupe");

        this.previousScrollTop = window.scrollY;
        $(window).on("throttled-scroll" + this.namespace, this.functions.checkStickyScroll.bind(this));

        // filter visibility
        this.$container.on(
          "click" + this.namespace,
          "[data-toggle-filters]",
          function (evt) {
            var isNowVisible = $(".filter-container", this.$container)
              .toggleClass("filter-container--show-filters-desktop filter-container--show-filters-mobile")
              .hasClass("filter-container--show-filters-desktop");
            $(".toggle-btn[data-toggle-filters]", this.$container).toggleClass("toggle-btn--revealed-desktop", isNowVisible);
            // handle resized collection grid
            theme.ProductBlockManager.afterImagesResized();
            $(".slick-slider", this.$container).each(function () {
              $(this).slick("setPosition");
            });
            return false;
          }.bind(this)
        );

        // layout switcher
        this.$container.on("click" + this.namespace, ".layout-switch", this.functions.switchGridLayout.bind(this));
      }

      // init things that may need re-initialising on ajax load
      this.functions.initFiltersEtc.call(this);

      this.destroy = function () {
        theme.ProductBlockManager.unloadImages(this.$container);
        theme.destroyProductGallery(this.$container);
        this.$container.off(this.namespace);
        $(window).off(this.namespace);
        $(document).off(this.namespace);
      }.bind(this);
    };
    // theme.jelenewMainSearch = new (function () {
    //   this.onSectionLoad = function (container) {
    //     this.namespace = theme.namespaceFromSection(container);
    //     this.$container = $(container);
    //     this.filterer = new theme.loadJelenewMainSearchFilterer(this);
    //     $(".jelenew_searh_filter_btn").on("click", function () {
    //       $("#CollectionFilterForm").addClass("jelenew_CollectionFilterForm_show");
    //       $("body").css({
    //         overflow: "hidden",
    //       });
    //     });
    //     $(".jelenew_search_filter_title_right").on("click", function () {
    //       $("#CollectionFilterForm").removeClass("jelenew_CollectionFilterForm_show");
    //       $("body").css({
    //         overflow: "auto",
    //       });
    //     });
    //     $(".jelenew_pro_block_img_list", container).slick({
    //       arrows: true,
    //       dots: true,
    //       infinite: false,
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
    //       nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
    //     });

    //     $("#content .jelenew_new_product_showcase_a").on("click", function () {
    //       sensors.track("ClickProductList", {
    //         page_position: "搜索结果页",
    //         keyword: $(".section-search-template").find(".main-search__input").val(),
    //         product_number: $(".jelenew_main_search .section_collection_list").children().length,
    //         search_type: urlQuery("jn_search_type") == "hot" ? "热词搜索" : urlQuery("jn_search_type") == "history" ? "历史搜索" : "默认搜索",
    //         floor: Math.ceil(($(this).parents(".jelenew_product_item").index() + 1) / 2),
    //         list_type: "搜索列表",
    //         list_name: "搜索商品列表",
    //         product_name: $(this).parents(".jelenew_product_item").find(".pro_block_title").text().trim(),
    //         product_id: $(this).data("product-id"),
    //         original_price: Number(
    //           $(this)
    //             .parents(".jelenew_product_item")
    //             .find(".jelenew_pro_block_price")
    //             .text()
    //             .trim()
    //             .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
    //             .replace(",", ".")
    //         ),
    //       });
    //     });
    //   };

    //   this.onSectionUnload = function () {
    //     this.filterer.destroy();
    //   };
    // })();
    theme.jelenewSizeGuide = new (function () {
      this.onSectionLoad = function (container) {
        var $container = $(container),
          $document = $(document);
        this.container = container;
        $container.on("click", ".jelenew-product-size-guide__button", this.functions.openSizeguide.bind(this));
        $document.on("click", ".jelenew-main-product-page-shade .page-shade,.jelenew-main-product-size-guide-drawer .header-close", function () {
          $(".jelenew-main-product-size-guide-drawer").removeAttr("data-drawer");
          $("body").removeClass("jelenew-main-product-page-shade");
        });
        $(document).on("theme:jelenewsizeguide.open", this.functions.openSizeguide.bind(this));
        // $(document).on("theme:cartchanged.cartTemplateSection", this.functions.refreshCartDependentContent.bind(this));
      };
      this.onSectionUnload = function (container) {};
      this.functions = {
        openSizeguide: function (event, tags) {
          var $container = $(this.container),
            $document = $(document);
          var drawer_name = "SizeGuide";
          // 存在template && 没有插入过size-guide
          if ($container.find(".jelenew-size-guide-container").html() && $("body .jelenew-main-product-size-guide-drawer").length == 0) {
            $("body").append($($container.find(".jelenew-size-guide-container")).html());
            $container.find(".jelenew-size-guide-container").remove();
            shopifyHttp.get("pages/size-guide?sections=jelenew-size-guide").then((res) => {
              var newDom = $(res["jelenew-size-guide"]).find(".jelenew-size-guide_wrap");
              $(".jelenew-main-product-size-guide-drawer .sku-option-list").html(newDom);

              const productTags = tags || $container.data("product-tags");
              var selectIndex = 0;
              if (productTags.indexOf("all bra") > -1) {
                selectIndex = 0;
              } else if (productTags.indexOf("Tops") > -1) {
                selectIndex = 1;
              } else if (productTags.indexOf("Bottoms") > -1) {
                // selectIndex = 2;
                selectIndex = 1; // Tops Bottoms合并采用Tops尺码表
              } else if (productTags.indexOf("accessories") > -1) {
                selectIndex = 2;
              }
              $(".jelenew-main-product-size-guide-drawer .jelenew-new-size-guide__type .size-guide-item-type").removeClass("selected");
              $(".jelenew-main-product-size-guide-drawer .jelenew-new-size-guide__type .size-guide-item-type").eq(selectIndex).addClass("selected");
              $(".jelenew-main-product-size-guide-drawer .jelenew-new-size-guide .jelenew-new-size-guide__unit").css("display", "none");
              $(".jelenew-main-product-size-guide-drawer .jelenew-new-size-guide .jelenew-new-size-guide__unit")
                .eq(selectIndex)
                .css("display", "block");
              $(".jelenew_size_guide_recommend_wrap").append('<div class="jelenew_size_guide_recommend"></div>');
              if ($(".jelenew-main-product-length-example-img").length > 0) {
                $(".jelenew-main-product-size-guide-drawer .jelenew-new-size-guide .jelenew-new-size-guide__unit")
                  .eq(1)
                  .find(".jelenew-new-tabs")
                  .eq(0)
                  .after($(".jelenew-main-product-length-example-img"));
                $(".jelenew-main-product-length-example-img").css("display", "block");
              }
              !(function () {
                var e = null;
                if ((window.eyefituShopifyOptions && (e = window.eyefituShopifyOptions), !e || !1 !== e.isWidgetEnabled)) {
                  (window.eyefituCalls = []),
                    n("store", Shopify.shop),
                    ["interactive", "complete"].includes(document.readyState)
                      ? n("init", void 0, e)
                      : document.addEventListener("DOMContentLoaded", function () {
                          window.eyefitu ? window.eyefitu("init", void 0, e) : n("init", void 0, e);
                        }),
                    (window.ga && "function" == typeof window.ga) ||
                      (window.ga = function () {
                        (window.ga.q = window.ga.q || []).push(arguments);
                      });
                  var i = document.createElement("script");
                  (i.id = "efu-sdk"),
                    (i.type = "text/javascript"),
                    (i.async = !0),
                    (i.src = "".concat($(".jelenew_size_guide_recommend_wrap").attr("data-request-url")));
                  var t = document.getElementsByTagName("script")[0];
                  t.parentNode.insertBefore(i, t);
                }
                function n() {
                  for (var e = arguments.length, i = new Array(e), t = 0; t < e; t++) i[t] = arguments[t];
                  window.eyefituCalls.push(i);
                }
              })();
              $(".jelenew-main-product-size-guide-drawer .sku-option-list").removeClass("lazyload--placeholder");
            });
          }
          setTimeout(() => {
            $(".jelenew-main-product-size-guide-drawer").attr("data-drawer", drawer_name);
            $("body").addClass("jelenew-main-product-page-shade");
          });
          if ($("body").data("page-type") == "cart") {
            // sensors.track("ClickDetailsElement", {
            //   element_name: "Size Guide",
            //   page_position: "购物车加购弹层页",
            //   product_name: $(this).closest(".replace-element").find(".jelenew-product-name").text().trim(),
            //   product_id: $(this).closest(".replace-element").find(".jelenew-product-options").data("product_id"),
            //   original_price: theme.jelenew_money_to_number($(this).closest(".replace-element").find(".jelenew-product-price .theme-money").text()),
            // });
          } else {
            // sensors.track("ClickDetailsElement", {
            //   element_name: "Size Guide",
            //   page_position: "商品详情页",
            //   product_name: $(".jelenew-main-product-detail .jelenew-product-name").text(),
            //   product_id: $(".jelenew-product-form-container.product-detail").attr("data-product-id") + "",
            //   original_price:
            //     $(".jelenew-main-product-detail .jelenew-product-price .theme-money")
            //       .text()
            //       .trim()
            //       .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
            //       .replace(",", ".") * 1,
            // });
          }
        },
      };
    })();
    theme.jelenewRedPopMain = new (function () {
      this.onSectionLoad = function (container) {
        function setReviewInfo(id, img, title) {
          $(".jelenew_red_pop_review").attr("data-product-id", id);
          $(".jelenew_red_pop_review .drawer-product-img img").attr("src", img);
          $(".jelenew_red_pop_review .drawer-product-title").text(title);
        }
        setReviewInfo(
          $(".jelenew_red_pop_main_tab", container)[0].getAttribute("data-product-id"),
          $(".jelenew_red_pop_main_tab", container)[0].getAttribute("data-product-img"),
          $(".jelenew_red_pop_main_tab", container)[0].getAttribute("data-product-title")
        );
        window.resetReviews($(".jelenew_red_pop_main_tab", container)[0].getAttribute("data-product-id"));
        $(".jelenew_red_pop_main_tab", container).on("click", function () {
          // sensors.track("ClickActivityElement", {
          //   web_page_name: theme.jelenew_web_page_name || "",
          //   active_name: theme.jelenew_active_name || "",
          //   element_name: $(this).text().trim(),
          // });
          $(".jelenew_red_pop_main_tab.jelenew_red_pop_main_active", container).removeClass("jelenew_red_pop_main_active");
          $(".jelenew_red_pop_main_con.jelenew_red_pop_main_active", container).removeClass("jelenew_red_pop_main_active");
          $(".jelenew_red_pop_look.jelenew_red_pop_main_active").removeClass("jelenew_red_pop_main_active");
          $(".jelenew_red_pop_care_img_wrap.jelenew_red_pop_main_active").removeClass("jelenew_red_pop_main_active");
          $(this).addClass("jelenew_red_pop_main_active");
          $(".jelenew_red_pop_main_con[data-index0=" + $(this).data("index0") + "]", container).addClass("jelenew_red_pop_main_active");
          $(".jelenew_red_pop_look[data-index0=" + $(this).data("index0") + "]").addClass("jelenew_red_pop_main_active");
          $(".jelenew_red_pop_care_img_wrap[data-index0=" + $(this).data("index0") + "]").addClass("jelenew_red_pop_main_active");
          setReviewInfo($(this).data("product-id"), $(this).data("product-img"), $(this).data("product-title"));
          window.resetReviews($(this).data("product-id"), true);
        });

        $(".pro_shop_btn", container).on("click", function () {
          // sensors.track("ClickActivityElement", {
          //   web_page_name: theme.jelenew_web_page_name || "",
          //   active_name: theme.jelenew_active_name || "",
          //   element_name: $(this).text().trim(),
          // });
        });
        $(".jelenew_pop_jelenew_vs_rapha_img", container).on("click", function () {
          // sensors.track("ClickActivityElement", {
          //   web_page_name: theme.jelenew_web_page_name || "",
          //   active_name: theme.jelenew_active_name || "",
          //   element_name: "SHOP NOW",
          // });
        });
        $(".product_list_item_a", container).on("click", function () {
          sensors.track("ClickProductList", {
            page_position: window.theme.jelenew_web_page_name || "",
            active_name: window.theme.jelenew_active_name || "",
            list_type: "look商品列表",
            list_name: "look商品列表",
            product_name: $(this).data("title"),
            product_id: $(this).data("product-id"),
            original_price:
              $(this)
                .find(".jelenew_pro_block_price")
                .text()
                .trim()
                .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                .replace(",", ".") * 1,
          });
        });
      };
      this.onSectionUnload = function (container) {};
    })();

    theme.jelenewCartDonation = new (function () {
      const _this = this;
      this.onSectionLoad = function (container) {
        _this.fn.reinitDonationInputAction();
        // 初始化校验
        _this.fn.checkDonationProduct("close");
      };
      this.onSectionUnload = function (container) {};
      this.fn = {
        checkDonationProduct: (open_drawer = true) => {
          const should_num = $("div[data-section-type=jelenew-cart-donation] .pointe.active").data("num") * 1 || 0;
          const donation_num = $("div[data-section-type=jelenew-cart-donation] .donation_num").text().trim() * 1 || 0;
          if (should_num != donation_num) {
            shopifyHttp
              .post("cart/update.js", {
                updates: {
                  43644210446576: should_num,
                },
                attributes: {
                  _donation_ratio: $("div[data-section-type=jelenew-cart-donation] .range-input").val(),
                },
              })
              .then(() => {
                $(document).triggerHandler(
                  cartChangedEvent({
                    detail: { open_drawer },
                  })
                );
              });
          }
        },
        changeDonationInput: function (params) {
          $(this).attr("value", `${params.target.value}`);
          $(this).closest(".range-box").find(".pointe").removeClass("active");
          $(this).closest(".range-box").find(`.pointe[data-pasent=${params.target.value}]`).addClass("active");
          const num = $(this).closest(".range-box").find(".pointe.active").data("num");
          shopifyHttp
            .post("cart/update.js", {
              updates: {
                43644210446576: num,
              },
              attributes: {
                _donation_ratio: params.target.value,
              },
            })
            .then(() => {
              $(document).triggerHandler(
                cartChangedEvent({
                  detail: {
                    jelenewCustomCallBack: () => {
                      var other_num = 0;
                      $(".cart-item-list__body .cart-item").each(function (params) {
                        if ($(this).data("line-item-id") != "43644210446576") {
                          other_num += $(this).find(".cart-item__quantity-input").val() * 1;
                        }
                      });
                      sensors.track("ClickDonationSet", {
                        discount_amount: ($(".donation-section-container .info-box .discount").data("difference-discount") * 1) / 100,
                        trees_donated: $(".donation-section-container .info-box .donation_num").text().trim() * 1,
                        product_number: other_num,
                        page_position: $("body").data("page-type") == "cart" ? "购物车页" : "购物车弹层页",
                      });
                    },
                  },
                })
              );
            });
        },
        reinitDonationInputAction: () => {
          if (document.querySelector("div[data-section-type=cart-template] .range-input")) {
            document.querySelector("div[data-section-type=cart-template] .range-input").removeEventListener("change", this.fn.changeDonationInput);
            document.querySelector("div[data-section-type=cart-template] .range-input").addEventListener("change", this.fn.changeDonationInput);
          }
        },
      };
    })();
    theme.jelenewVideoItem = new (function () {
      this.onSectionLoad = function (container) {
        $(document).ready(function () {
          $(".jelenew_video_play_btn", container).on("click", function () {
            $("video", container).attr("src", $(container).data("video_link"));
            $("video", container).get(0).play();
            $(".jelenew_video_img", container).remove();
          });
        });
      };
    })();
    theme.jelenewKlarnaPayClickFun = function () {
      var payLock = false;
      $(document).on("click", ".jelenew_klarna_icon", function (e) {
        e.stopPropagation();
        if (payLock) {
          $(".jelenew_klarna_pay_wrap").addClass("jelenew_klarna_pay_wrap_show");
        } else {
          payLock = true;
          var containerDiv = `<div class="jelenew_klarna_pay_wrap">
                              <div class="jelenew_klarna_pay_layer"></div>
                              <div class="jelenew_klarna_pay_content">
                                <div class="jelenew_klarna_pay_header">
                                  <span class="option-name Futuran"></span>
                                    <span class="header-close jelenew-main-product-transition">
                                      <svg class="jelenew-icon close-icon  feather feather-x" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                                          <line x1="20" y1="4" x2="4" y2="20"></line><line x1="4" y1="4" x2="20" y2="20"></line>
                                      </svg>
                                    </span>
                                </div>
                                <div class="jelenew_klarna_pay_con lazyload--placeholder"></div>
                              </div>
                            </div>`;
          $("body").append(containerDiv);
          setTimeout(() => {
            $(".jelenew_klarna_pay_wrap").addClass("jelenew_klarna_pay_wrap_show");
          });
          shopifyHttp.get("pages/interest-free_installments").then((res) => {
            var shippingDom = $('<div class="aaaaa">' + res + "</div>").find("#content .container.cf");
            $(".jelenew_klarna_pay_con").append(shippingDom);
            $(".jelenew_klarna_pay_con").removeClass("lazyload--placeholder");
          });
        }
      });
      $(document).on("click", ".jelenew_klarna_pay_wrap .jelenew_klarna_pay_layer", function () {
        $(".jelenew_klarna_pay_wrap").removeClass("jelenew_klarna_pay_wrap_show");
      });
      $(document).on("click", ".jelenew_klarna_pay_wrap .header-close", function () {
        $(".jelenew_klarna_pay_wrap").removeClass("jelenew_klarna_pay_wrap_show");
      });
    };
    theme.jelenewKlarnaPayClickFun();

    theme.jelenewBundlesCollection = new (function () {
      this.onSectionLoad = function (container) {
        if ($(".jelenew-bundles-collection-template", container).length > 0) {
          jelenewSectionAppendTemplate(".jelenew-bundles-collection-template", container);
        }
        if ($(container).hasClass("jelenew-import-bundles")) {
          $(container).on("click", ".jelenew-import-bundle-item a", function () {
            let params = {
              page_position: window.theme.jelenew_web_page_name,
              category_name: $("body").data("page-type") === "collection" ? $("html").data("path") : "",
            };
            if ($(this).hasClass("jelenew-import-bundle-product")) {
              const $item = $(this).closest(".jelenew-import-bundle-product");
              Object.assign(params, {
                module_name: "BUNDLE单品",
                product_id: $item.data("product_id"),
                product_name: $item.find("h2").text().trim(),
                sku_id: $item.data("sku_name"),
                skc_id: $item.data("skc"),
                spu_id: $item.data("spu"),
              });
            } else {
              const $item = $(this).closest(".jelenew-import-bundle-item");
              Object.assign(params, {
                module_name: "BUNDLE整体",
                bundle_price: theme.jelenew_money_to_number($item.find(".jelenew-import-bundle-text .theme-money").text().trim()),
                bundle_off: $item.data("bundle_off"),
                product_name: $item.find("h2").text(),
                product_number: $item.find(".jelenew-import-bundle-product").length * 1,
                sku_name: $item.data("sku_name").split(","),
              });
            }
            // sensors.track("ClickListElement", params);
          });
        } else {
          $(".bundle-item .bundle-images", container)
            .slick({
              lazyLoad: "ondemand",
              adaptiveHeight: true,
              dots: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              prevArrow:
                '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
              nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
              infinite: false,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    arrows: false,
                  },
                },
              ],
            })
            .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
              // console.log(event, slick, currentSlide, nextSlide);
            });
          // sensors.track("WebPageView", {
          //   web_page_name: "组合购列表页",
          //   category_name: window.location.pathname.replace("/pages/", "")
          // });
          $(container).on("click", ".bundle-item a", function () {
            var $item = $(this).closest(".bundle-item");
            sensors.track("ClickBundleList", {
              page_position: "组合购列表页",
              category_name: window.location.pathname.replace("/pages/", ""),
              product_name: $item.find(".bundle-title").text().trim(),
              product_ids: $item.find(".bundle-title").data("product_ids").split(","),
              product_number: $item.find(".bundle-title").data("product_ids").split(",").length,
              sku_name: $item.find(".bundle-title").data("sku_name").split(","),
              variant_ids: $item.find(".bundle-title").data("variant_ids").split(","),
              bundle_price: theme.jelenew_money_to_number($item.find(".bundle-total .theme-money").text()),
              bundle_off: $item.find(".bundle-total").data("save_percent") / 100,
            });
          });
        }
      };
      this.onSectionUnload = function (container) {};
    })();

    // 组合购买详情
    theme.jelenewBundleDetail = new (function () {
      this.onSectionLoad = function (container) {
        // sensors.track("WebPageView", {
        //   web_page_name: "组合购详情页",
        //   category_name: window.location.pathname.replace("/pages/", ""),
        //   product_ids: $(container).attr("data-product_ids").split(","),
        //   product_number: $(container).attr("data-product_ids").split(",").length,
        //   sku_name: $(container).attr("data-sku_name").split(","),
        //   variant_ids: $(container).attr("data-variant_ids").split(","),
        //   product_names: $(container).find(".jelenew-product-name.title").text(),
        //   bundle_price: theme.jelenew_money_to_number($(".bundle-total .theme-money", container).text()),
        //   bundle_off: $(container).attr("data-percent_discount") / 100,
        // });
        $(".jelenew-bundle-main-product", container).each((i, el) => {
          this.functions.bundle_product_init(el);
        });
        // 组合购买点击事件
        $(".jelenew-bundle-main-product-add-btn", container).on("click", function () {
          let $btn = $(this);
          $btn.addClass("disabled");
          let add_items = [];
          $(".original-selector", container).each(function (i, el) {
            if (!$(el).val()) {
              $(".size-selector-container", container).eq(i).addClass("size-warning");

              $(".size-selector-container", container).eq(i)[0].scrollIntoView({
                behavior: "smooth", // 平滑过渡
                block: "center", //居中
              });
              $btn.removeClass("disabled");
              $(".bundle-add-bar button").removeAttr("disabled");
              return false;
            } else {
              $(".size-selector-container", container).eq(i).removeClass("size-warning");

              add_items.push({
                id: $(el).val(),
                quantity: 1,
                properties: {},
              });
            }
          });
          if (add_items.length == $(".original-selector", container).length) {
            // 都选中了size，加购
            shopifyCartApi
              .add({ items: add_items, sections: "cart-drawer" })
              .then((data) => {
                $(document).triggerHandler(cartChangedEvent());
              })
              .finally(() => {
                $btn.removeClass("disabled");
                $(".bundle-add-bar button").removeAttr("disabled");
              });

            add_items;
            let all_variant_ids = $(container).attr("data-variant_ids").split(",");
            let all_sku_name = $(container).attr("data-sku_name").split(",");
            let sku_name_arr = [],
              skc_ids = [],
              spu_ids = [];
            let variant_ids_arr = [];
            all_variant_ids.forEach((v_id, i) => {
              add_items.forEach((item) => {
                if (item.id == v_id) {
                  sku_name_arr.push(all_sku_name[i]);
                  variant_ids_arr.push(v_id);
                }
              });
            });
            sensors.track("ClickAddToBag", {
              page_position: "组合购详情页",
              category_name: window.location.pathname.replace("/pages/", ""),
              product_ids: $(container).attr("data-product_ids").split(","),
              product_number: $(container).attr("data-product_ids").split(",").length,
              sku_name: sku_name_arr,
              skc_ids,
              spu_ids,
              sku_name_bundle: sku_name_arr.join("+"),
              variant_ids: variant_ids_arr,
              bundle_price: theme.jelenew_money_to_number($(".bundle-total .theme-money", container).text()),
              bundle_off: $(container).attr("data-percent_discount") / 100,
            });
          } else {
            sensors.track("ClickBundleDetailElement", {
              element_name: "加车缺少尺寸",
              page_position: "组合购详情页",
              category_name: window.location.pathname.replace("/pages/", ""),
              product_ids: $(container).attr("data-product_ids").split(","),
              product_number: $(container).attr("data-product_ids").split(",").length,
              bundle_price: theme.jelenew_money_to_number($(".bundle-total .theme-money", container).text()),
              bundle_off: $(container).attr("data-percent_discount") / 100,
            });
          }
        });
        // H5 吸底横幅
        $(".bundle-add-bar button", container).on("click", function () {
          $(this).attr("disabled", "true");
          $(".jelenew-bundle-main-product-add-btn", container).trigger("click");
        });
        //初始化组合购买详情下面的轮播
        $(".bundles-product-picture-list", container).slick({
          arrows: false,
          dots: true,
        });

        // $(".jelenew-bundles-product-desc", container).on(
        //   "click",
        //   ".bundles-product-desc-more",
        //   function () {
        //     var siblings = $(this).siblings(
        //       ".bundles-product-desc-block-wrapper"
        //     );
        //     siblings.toggleClass("bundles-product-desc-block-wrapper-close");
        //     if (siblings.hasClass("bundles-product-desc-block-wrapper-close")) {
        //       $(this).text("See More");
        //     } else {
        //       $(this).text("See Less");
        //     }
        //   }
        // );

        $(".jelenew-main-product-detail", container).on("click", ".jelenew-size-guide-desc-ope", function () {
          $(this).parent().toggleClass("jelenew-size-guide-desc-auto");
        });
      };
      this.onSectionUnload = function (container) {};
      this.functions = {
        bundle_product_init: (container) => {
          // init Add to Bag
          var $form = $(".jelenew-main-product .product-form", container),
            window_inner_width_type,
            old_window_inner_width_type;
          // 读取color和size的多语言文案
          var colorNameList = $(".jelenew-main-product", container).data("color-name-list").split(",");
          var isColorOption = function (colorText) {
            return colorNameList.some((text) => {
              return text == colorText;
            });
          };
          var sizeNameList = $(".jelenew-main-product", container).data("size-name-list").split(",");
          var isSizeOption = function (sizeText) {
            return sizeNameList.some((text) => {
              return text == sizeText;
            });
          };
          // 读取商品数据
          // 读取商品数据
          const product_all_data = JSON.parse($(".jelenew-main-product-current-product-data-json", container).text().trim());
          const product_full_data = [];

          product_all_data.forEach((product) => {
            product.variants.forEach((variant) => {
              variant.url = "/products/" + product.handle;
              variant.product_id = product.id;
              product_full_data.push(variant);
            });
          });
          if (window.innerWidth >= 48 * 16) {
            window_inner_width_type = "PC";
            old_window_inner_width_type = "PC";
          } else {
            window_inner_width_type = "H5";
            old_window_inner_width_type = "H5";
          }

          // 主逻辑初始化
          jelenewMainProductPageInit();

          /******************** Actions *********************/
          // sku select
          $(".jelenew-main-product-drawer", container).on("click", ".sku-option-item", function (e) {
            // 重复点击 或 无库存商品
            if ($(this).find(".sku-unavailable").length > 0) {
              return;
            }
            var jelenew_size_span = $(this).parents(".jelenew-bundle-main-product").find(".jelenew_size_span");
            $(this).parents(".product-drawer-section").find(".sku-option-item.sku-selected").removeClass("sku-selected");
            $(this).addClass("sku-selected");
            if (
              $(this).parents(".product-drawer-section").find(".jelenew_sku_item_inner .sku-option-item.sku-selected").find(".sku-preorder").length >
              0
            ) {
              // SKU为预售，开启预售文案
              $(this).parents(".jelenew-bundle-main-product").find(".jelenew-next-incoming-text").css("display", "block");
            } else {
              // 关闭预售文案
              $(this).parents(".jelenew-bundle-main-product").find(".jelenew-next-incoming-text").css("display", "none");
            }
            if ($(this).closest(".product-drawer-section").data("option-name") == "Size") {
              jelenew_size_span.text(
                $(this).parents(".product-drawer-section").find(".jelenew_sku_item_inner .sku-option-item.sku-selected .sku-name").text()
              );
              jelenew_size_span.closest(".jelenew-selected").find(".country-code").removeClass("hidden");
            }
            // 切换轮播图
            var currentData = changeSlideShow();

            // 替换 地址栏链接 和 主页展示的 价格、sku选项、 地址栏链接
            if (currentData) {
              changeSkuDetail(currentData, $(this).closest(".product-drawer-section").data("option-name"));
            }

            // 关闭弹窗
            $(".jelenew-main-product-drawer .header-close", container).trigger("click");

            //神策埋点
            var selectSkuType = $(this).parents(".sku-option-list").siblings().find(".option-name").text().trim();
            var param = {
              element_name: "",
              category_name: window.location.pathname.replace("/pages/", ""),
              page_position: "组合购详情选择弹层页",
              product_name: $(this).closest(".jelenew-bundle-main-product").find(".jelenew-main-product-detail .jelenew-product-name").text(),
              product_id: $(".jelenew-bundle-detail").data("product_ids").split(",")[$(this).closest(".jelenew-bundle-main-product").index()],
            };
            if (isColorOption(selectSkuType)) {
              param.element_name = "COLOUR";
              param["colour"] = $(this).find(".sku-name").text().trim();
            } else if (isSizeOption(selectSkuType)) {
              param.element_name = "SIZE";
              param["size"] = $(this).find(".sku-name").text().trim();
            }
            sensors.track("ClickBundleDetailElement", param);
            // bundle 吸底按钮文案改变
            let selected_all = true;
            $(".original-selector").each(function () {
              if (!$(this).val()) {
                selected_all = false;
              }
            });
            if (selected_all) {
              $(".bundle-add-bar button").text("Add to bag");
            }
          });

          // open sku select drawer
          $(".jelenew-main-product-detail", container).on("click", ".jelenew-product-variation-selector", function () {
            var _this = $(this);
            var drawer_name = $(this).find(".selector-name").text().trim();
            if (isColorOption(drawer_name)) {
              drawer_name = "Color";
            }
            if (isSizeOption(drawer_name)) {
              drawer_name = "Size";
            }
            $(".jelenew-main-product-drawer", container).attr("data-drawer", drawer_name);
            $("body").addClass("jelenew-main-product-page-shade");
            $(".jelenew-main-product-page-shade .page-shade").on("click", function () {
              $(".jelenew-main-product-drawer .header-close").trigger("click");
              return false;
            });
            var element_name;
            if (isColorOption(drawer_name)) {
              element_name = "颜色选择入口";
            } else if (isSizeOption(drawer_name)) {
              element_name = "尺寸选择入口";
            }
            sensors.track("ClickBundleDetailElement", {
              element_name: element_name,
              category_name: window.location.pathname.replace("/pages/", ""),
              page_position: "组合购详情页",
              product_name: $(this).closest(".jelenew-bundle-main-product").find(".jelenew-main-product-detail .jelenew-product-name").text(),
              product_id: $(".jelenew-bundle-detail").attr("data-product_ids").split(",")[$(this).closest(".jelenew-bundle-main-product").index()],
            });
          });
          // open size guide
          $(".jelenew-main-product-detail", container).on("click", ".jelenew-product-size-guide__button", function () {
            // var drawer_name = $(this).find(".selector-name").text().trim();
            var drawer_name = "SizeGuide";
            $(".jelenew-main-product-size-guide-drawer", container).attr("data-drawer", drawer_name);
            $("body").addClass("jelenew-main-product-page-shade");
            $(".jelenew-main-product-page-shade .page-shade").on("click", function () {
              $(".jelenew-main-product-size-guide-drawer .header-close").trigger("click");
              return false;
            });
            sensors.track("ClickBundleDetailElement", {
              element_name: "Size Guide",
              category_name: window.location.pathname.replace("/pages/", ""),
              page_position: "组合购详情页",
              product_name: $(this).closest(".jelenew-bundle-main-product").find(".jelenew-main-product-detail .jelenew-product-name").text(),
              product_id: $(".jelenew-bundle-detail").attr("data-product_ids").split(",")[$(this).closest(".jelenew-bundle-main-product").index()],
            });
          });
          // close drawer
          $(".jelenew-main-product-drawer .header-close, .jelenew-main-product-size-guide-drawer .header-close", container).on("click", function () {
            $(".jelenew-main-product-drawer", container).removeAttr("data-drawer");
            $(".jelenew-main-product-size-guide-drawer", container).removeAttr("data-drawer");
            $(".jelenew-main-product-page-shade .page-shade").off("click");
            $("body").removeClass("jelenew-main-product-page-shade");
          });
          /******************** Functions *********************/
          // 主逻辑
          function jelenewMainProductPageInit() {
            Promise.all([mainSlickInitPromise()]).then(() => {
              // slideshow init
              $(".jelenew-element-hidden-init", container).removeClass("jelenew-element-hidden-init");
              $(".jelenew-main-product-slideshow-dots", container).css("display", "block");
              sensorsInit();
            });
          }
          // 主轮播初始化
          function mainSlickInitPromise() {
            return new Promise((resolve, reject) => {
              $(".jelenew-main-product-slideshow", container)
                .slick({
                  prevArrow:
                    '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                  nextArrow:
                    '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                  arrows: true,
                  infinite: false,
                  dots: true,
                  dotsClass: "jelenew-main-product-slideshow-dots",
                  // appendDots: $(".jelenew-main-product-slideshow-dots", container),
                  adaptiveHeight: false,
                  customPaging: function (slider, i) {
                    return i + 1 + "/" + slider.slideCount;
                  },
                })
                .init(() => {
                  var slickNum = 0;
                  $(".jelenew-main-product-slideshow", container).slick("slickFilter", function (i, el) {
                    if ($(el).data("color") == $(".jelenew-main-product-sku-select .selected-name", container).eq(0).text().trim()) {
                      return true;
                    } else {
                      return false;
                    }
                  });
                  $(".jelenew-main-product-slideshow", container).on("beforeChange", mainSlickSensor);
                  resolve(true);
                });
            });
          }
          function calcOpacity() {
            var shade_coefficient = 1; // 遮罩层透明度渐变系数
            var n = $(window).scrollTop() / $(".jelenew-main-product-slideshow", container).height();
            if (n / shade_coefficient > 0.75) {
              return 0.8;
            } else if (n / shade_coefficient < 0.2) {
              return 0.2;
            } else {
              return n / shade_coefficient;
            }
          }
          // 改变轮播图的展现数据
          function changeSlideShow() {
            var selectedArr = [],
              variantData;
            // 获取当前选中的sku选项数组
            $(".jelenew-main-product-drawer .sku-selected .sku-name", container).each(function (index, item) {
              selectedArr.push($(this).text().trim());
            });
            selectedArr.sort();
            // 查询对应的变体，获取变体数据，修改表单中的的值
            if (selectedArr.length == 1) {
              variantData = product_full_data.find((variant) => {
                return variant.option1 == selectedArr[0] || variant.option2 == selectedArr[0];
              });
            } else {
              for (let i = 0; i < product_full_data.length; i++) {
                let variant = product_full_data[i];
                // 深克隆 防止源数据顺序改变
                let variantOptClone = JSON.parse(JSON.stringify(variant.options)).sort();
                if (JSON.stringify(variantOptClone) == JSON.stringify(selectedArr)) {
                  variantData = variant;
                  break;
                }
              }
            }
            $(".jelenew-main-product-slideshow", container).slick("slickUnfilter");
            var slickNum = 0;
            $(".jelenew-main-product-slideshow", container).slick("slickFilter", function (i, el) {
              if ($(el).data("color") == variantData.option1) {
                return true;
              } else {
                return false;
              }
            });
            var src =
              $(".jelenew-main-product-slideshow", container).find(".slick-active img").attr("src") ||
              $(".jelenew-main-product-slideshow", container).find(".slick-active img").attr("data-lazy");
            var index = $(".jelenew-main-product-slideshow", container).closest(".jelenew-bundle-main-product").index();
            $(".jelenew-bundle-detail .desktop-img-container img").eq(index).attr("src", src);
            return variantData;
          }
          // 修改商品详细信息和浏览器地址
          function changeSkuDetail(variant, optionName) {
            // 替换链接
            const old_href = $(".jelenew-product-name", container).attr("href");
            if (old_href != variant.url) {
              $("[data-section-type=jelenew-bundle-detail] a").each(function () {
                if ($(this).attr("href") && $(this).attr("href").includes(old_href)) {
                  const new_href = $(this).attr("href").replace(old_href, variant.url);
                  $(this).attr("href", new_href);
                }
              });
              // 替换productid
              $(container).attr("data-product-id", variant.product_id);
              let product_ids = $(".jelenew-bundle-detail").attr("data-product_ids").split(",");
              product_ids[$(container).index()] = variant.product_id;
              $(".jelenew-bundle-detail").attr("data-product_ids", product_ids.join(","));
              // 替换sku variantsId
              const old_product = product_all_data.find(
                (p) => p.handle == $(".jelenew-product-name", container).attr("href").replace("/products/", "")
              );
              const current_product = product_all_data.find((p) => p.id == variant.product_id);
              const new_sku_name = $(".jelenew-bundle-detail")
                .attr("data-sku_name")
                .replace(old_product.variants.map((v) => v.sku).join(","), current_product.variants.map((v) => v.sku).join(","));
              const new_variant_ids = $(".jelenew-bundle-detail")
                .attr("data-variant_ids")
                .replace(old_product.variants.map((v) => v.id).join(","), current_product.variants.map((v) => v.id).join(","));

              $(".jelenew-bundle-detail").attr("data-sku_name", new_sku_name);
              $(".jelenew-bundle-detail").attr("data-variant_ids", new_variant_ids);
            }

            // sku
            $(".jelenew-main-product-detail .jelenew-selected", container).each(function (i, el) {
              // if ($(el).find(".selected-name").text().trim() != "" || isSizeOption(optionName)) {
              //   $(el).find(".selected-name").text(variant.options[i]);
              // }
              if ($(el).find("span[data-swatch]").length > 0) {
                const old_color = $(el).find("span[data-swatch]").attr("data-swatch");
                const new_color = variant.options[i]
                  .toLocaleLowerCase()
                  .split("+")
                  .map((str) => str.trim())
                  .join("-")
                  .replace(" ", "-");
                $(el).find("span[data-swatch]").removeClass(old_color).addClass(new_color);
                $(el).find("span[data-swatch]").attr("data-swatch", new_color).data("swatch", new_color);
                // $(el).find("span[data-swatch]").data("swatch", new_color);
              }
            });
            if (isSizeOption(optionName)) {
              $(".size-selector-container", container).removeClass("size-warning");
            }
            // 如果颜色和尺码都存在则选中变体id
            var changeSelect = true;
            $(".jelenew-main-product-detail .jelenew-selected .selected-name", container).each(function () {
              if (!$(this).text().trim()) changeSelect = false;
            });
            if (changeSelect) {
              $(".original-selector", container).val(variant.id);
            }
          }

          //神策埋点
          function sensorsInit() {
            try {
              $(".jelenew-main-product-detail")
                .off("click", ".jelenew-my-wish-product")
                .on("click", ".jelenew-my-wish-product", function () {
                  sensors.track("ClickWish", {
                    category_name: $(this).parents(".jelenew-bundle-main-product").attr("data-path").split("/").pop(),
                    page_position: "组合购详情页",
                    product_name: $(this).parents(".jelenew-product-head").find(".jelenew-product-name").text().trim(),
                    product_id: $(this).parents(".jelenew-bundle-main-product").attr("data-product-id"),
                  });
                });
              $(".jelenew-main-product-detail")
                .off("click", ".jelenew-social-sharing")
                .on("click", ".jelenew-social-sharing", function () {
                  sensors.track("ClickShare", {
                    category_name: $(this).parents(".jelenew-bundle-main-product").attr("data-path").split("/").pop(),
                    page_position: "组合购详情页",
                    product_name: $(this).parents(".jelenew-product-head").find(".jelenew-product-name").text().trim(),
                    product_id: $(this).parents(".jelenew-bundle-main-product").attr("data-product-id"),
                  });
                });

              // 加车
              $(".jelenew-main-product").on("click", ".add-to-cart", function () {
                var sensorsParam = {
                  page_position: "商品详情页",
                  size: $(".jelenew-main-product-sku-select").find('ul li[data-sku-type="Size"]').find(".selected-name").text().trim(),
                  colour: $(".jelenew-main-product-sku-select").find('ul li[data-sku-type="Color"]').find(".selected-name").data("swatch"),
                  product_name: $(".jelenew-main-product-detail .jelenew-product-name").text(),
                  product_id: $(".jelenew-product-form-container.product-detail").attr("data-product-id") + "",
                  sku_id: $(".jelenew-main-product-detail").find("option:selected").attr("sku-value"),
                  variant_id_string: $(".jelenew-main-product-detail .original-selector").val(),
                  original_price:
                    $(".jelenew-main-product-detail .jelenew-product-price .theme-money")
                      .text()
                      .trim()
                      .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                      .replace(",", ".") * 1,
                  is_booking: false,
                };
                if (sensorsParam.size || $(".jelenew-product-variation-selector").length == 1) {
                  sensors.track("ClickAddToBag", sensorsParam);
                } else {
                  delete sensorsParam["size"];
                  // sensors.track("ClickDetailsElement", sensorsParam);
                }
              });
            } catch (error) {
              sensors.track("ServeException", {
                exception_type: "前端错误",
                exception_level: "p0",
                exception_modle: "神策埋点报错sensorsInit",
                exception_from: "前端",
                exception_reason: JSON.stringify(error),
                exception_modle_sub: "系统报错",
                $url: window.location.href,
              });
              throw new Error("main-product-sensors-init-failed");
            }
          }

          function mainSlickSensor(event, slick, currentSlide) {
            sensors.track("ClickBundleDetailElement", {
              element_name: "主图",
              category_name: window.location.pathname.replace("/pages/", ""),
              page_position: "组合购详情页",
              position: currentSlide + "",
              product_name: $(this).closest(".jelenew-bundle-main-product").find(".jelenew-main-product-detail .jelenew-product-name").text(),
              product_id: $(".jelenew-bundle-detail").attr("data-product_ids").split(",")[$(this).closest(".jelenew-bundle-main-product").index()],
            });
          }
        },
      };
    })();

    theme.jelenewInsListIndexSection = new (function () {
      var containerWrap = "";
      this.onSectionLoad = function (container) {
        containerWrap = container;
        if ($(container).data("is-ins")) {
          this.functions.setDom($(container).find(".lazyload--placeholder[data-selected-ids]")[0]);
        } else {
          $(".jelenew_ins_list", container).slick({
            arrows: true,
            dots: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1.5,
                },
              },
            ],
          });
        }
      };
      this.functions = {
        setDom: (container) => {
          const insUrl = "pages/inspiration";
          shopifyHttp
            .get(insUrl)
            .then((res) => {
              let $page = $(`<div>${res}</div>`);
              const selected_ids = $(container).data("selected-ids").split(",");
              const idset = new Set(selected_ids);
              // 插入css
              $page.find(".jelenew-ins-list-css").each(function () {
                $(container).append($(this));
              });
              $page.find("[data-section-type=jelenew-ins-list]").each(function () {
                $(container).find("[data-section-type=jelenew-ins-list]").addClass($(this).attr("class"));
                $(this)
                  .find(".jelenew_ins_list .jelenew_ins_list_item")
                  .each(function () {
                    if (idset.has($(this).attr("id"))) {
                      $(".jelenew_ins_list", container).append($(this));
                    }
                  });
                let templateNodes = $(this).find(".jelenew-ins-list-template")[0].content.cloneNode(true);
                const items = templateNodes.querySelectorAll(".jelenew_ins_list_item");
                items.forEach((item) => {
                  const id = $(item).attr("id");
                  if (idset.has(id)) {
                    $(".jelenew_ins_list", container).append($(item));
                  }
                });
              });

              // 取消loading
              $(container).removeClass("lazyload--placeholder");
              if ($("body").data("page-type") == "index") {
                $(".jelenew_ins_list_item", containerWrap).on("click", function () {
                  sensors.track("ClickInfluencerWall", {
                    page_position: theme.jelenew_web_page_name,
                    pic_url:
                      $(this).find(".jelenew_ins_list_image_wrap .rimage_image_url").eq(0).text().trim() ||
                      $(this).find(".first-screen-picture img").eq(0).get(0).src,
                  });
                  location.href = $(containerWrap).data("href") + "?insId=" + $(this).attr("id");
                });
                $(".jelenew_ins_list_item", containerWrap).hover(
                  function () {
                    if (window.innerWidth > 767) {
                      sensors.track("HoverInfluencerWall", {
                        page_position: theme.jelenew_web_page_name,
                        pic_url:
                          $(this).find(".jelenew_ins_list_image_wrap .rimage_image_url").eq(0).text().trim() ||
                          $(this).find(".first-screen-picture img").eq(0).get(0).src,
                        element_name: "网红墙照片",
                      });
                    }
                  },
                  function () {
                    if (window.innerWidth > 767) {
                    }
                  }
                );
              }
              if ($(containerWrap).data("use_slide")) {
                $(".jelenew_ins_list", container)
                  .slick({
                    arrows: true,
                    dots: true,
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    prevArrow:
                      '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                    nextArrow:
                      '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                    responsive: [
                      {
                        breakpoint: 767,
                        settings: {
                          slidesToShow: 1.5,
                        },
                      },
                    ],
                  })
                  .on("afterChange", function () {
                    // sensors.track("SlideProductPicture", {
                    //   element_name: "网红墙",
                    //   product_name: $(".jelenew-main-product-detail .jelenew-product-name").text(),
                    //   product_id: $(".jelenew-product-form-container.product-detail").attr("data-product-id") + "",
                    //   original_price:
                    //     $(".jelenew-main-product-detail .jelenew-product-price .theme-money")
                    //       .text()
                    //       .trim()
                    //       .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                    //       .replace(",", ".") * 1,
                    // });
                  });
              }
            })
            .catch(() => {
              $(container).remove();
            });
          $(".jelenew_ins_btn", container)
            .unbind("click")
            .click(function () {
              sensors.track("ClickHomeElement", {
                element_name: "See More",
                module_name: "网红墙",
                page_position: window.theme.jelenew_web_page_name || "",
              });
            });
        },
      };
    })();

    theme.jelenewInsListSection = new (function () {
      this.onSectionLoad = function (container) {
        const $insContainer = $(container);
        $insContainer.on("click", ".insta_image_info_product", function () {
          sensors.track(theme.jelenew_event_name, {
            page_position: window.theme.jelenew_web_page_name || "",
            element_name: ">",
            influencer_name: $(this).parents(".jelenew_ins_list_item").find(".jelenew_ins_list_item_name").text().trim(),
            product_name: $(this).find(".pro_block_title").text().trim(),
            product_id: $(this).find(".jelenew_pro_block_wrap_wrap").data("product-id"),
          });
          window.location.href = $(this).data("href");
        });
        $insContainer.on("click", ".read_more", function () {
          if ($(this).parents(".jelenew_ins_list_item_content").hasClass("jelenew_ins_list_item_content_show")) {
            $(this).parents(".jelenew_ins_list_item_content").removeClass("jelenew_ins_list_item_content_show");
            $(this)
              .parents(".jelenew_ins_list_item_content")
              .find(".jelenew_ins_list_item_content_inner")
              .text($(this).parents(".jelenew_ins_list_item_content").data("content20"));
            sensors.track(theme.jelenew_event_name, {
              element_name: "Read Less",
              influencer_name: $(this).parents(".jelenew_ins_list_item").find(".jelenew_ins_list_item_name").text().trim(),
              page_position: window.theme.jelenew_web_page_name || "",
            });
          } else {
            $(this).parents(".jelenew_ins_list_item_content").addClass("jelenew_ins_list_item_content_show");
            $(this)
              .parents(".jelenew_ins_list_item_content")
              .find(".jelenew_ins_list_item_content_inner")
              .text($(this).parents(".jelenew_ins_list_item_content").data("content"));
            sensors.track(theme.jelenew_event_name, {
              element_name: "Read More",
              influencer_name: $(this).parents(".jelenew_ins_list_item").find(".jelenew_ins_list_item_name").text().trim(),
              page_position: window.theme.jelenew_web_page_name || "",
            });
          }
        });
        $insContainer.on("click", ".insta_image_info_icon", function (event) {
          event.stopPropagation();
          if ($(this).parents(".insta_image_info").hasClass("insta_image_info_show")) {
            $(this).parents(".insta_image_info").removeClass("insta_image_info_opacity");
            $(this).removeClass("insta_image_info_icon_show");
            setTimeout(() => {
              $(this).parents(".insta_image_info").removeClass("insta_image_info_show");
            }, 300);
          } else {
            if ($(this).parents(".insta_image_info").find(".insta-image-info-product-template").length > 0) {
              $(this).parents(".insta_image_info").append($(this).parents(".insta_image_info").find(".insta-image-info-product-template").html());
              $(this).parents(".insta_image_info").find(".insta-image-info-product-template").remove();
            }
            sensors.track(theme.jelenew_event_name, {
              element_name: "+",
              influencer_name: $(this).parents(".jelenew_ins_list_item").find(".jelenew_ins_list_item_name").text().trim(),
              product_name: $(this).parents(".insta_image_info").find(".pro_block_title").text().trim(),
              product_id: $(this).parents(".insta_image_info").find(".jelenew_pro_block_wrap_wrap").data("product-id"),
              page_position: window.theme.jelenew_web_page_name || "",
            });
            $(this)
              .parents(".jelenew_ins_list")
              .find(".insta_image_info_show")
              .removeClass("insta_image_info_opacity")
              .removeClass("insta_image_info_show");
            $(this).parents(".jelenew_ins_list").find(".insta_image_info_icon").removeClass("insta_image_info_icon_show");
            if ($(this).offset().left > $("body").width() / 2) {
              $(this).parents(".insta_image_info").addClass("insta_image_info_right");
            } else {
              $(this).parents(".insta_image_info").removeClass("insta_image_info_right");
            }
            $(this).parents(".insta_image_info").addClass("insta_image_info_show");
            $(this).addClass("insta_image_info_icon_show");
            setTimeout(() => {
              $(this).parents(".insta_image_info").addClass("insta_image_info_opacity");
            });
          }
        });
        if ($insContainer.find(".jelenew_ins_list").data("blocks_size") > 6 && $("body").hasClass("template-suffix-inspiration")) {
          function setDom() {
            if (
              $insContainer.find(".jelenew-ins-list-template").length &&
              $insContainer.find(".jelenew-ins-list-template").offset().top < $(window).height() + $(window).scrollTop()
            ) {
              $(window).off("scroll", setDom);
              $insContainer.find(".jelenew_ins_list").append($insContainer.find(".jelenew-ins-list-template").html());
              $insContainer.find(".jelenew-ins-list-template").remove();
            }
          }
          setDom();
          $(window).on("scroll", setDom);
        }
        var insId = urlQuery("insId");
        if (insId) {
          if ($("#" + insId).length) {
            window.scrollTo({
              top: $("#" + insId).offset().top,
              behavior: "smooth",
            });
          } else {
            $insContainer.find(".jelenew_ins_list").append($insContainer.find(".jelenew-ins-list-template").html());
            $insContainer.find(".jelenew-ins-list-template").remove();
            setTimeout(() => {
              window.scrollTo({
                top: $("#" + insId).offset().top,
                behavior: "smooth",
              });
            }, 300);
          }
        }
      };
    })();
    theme.jelenewIndexNews = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-index-news-template", container);
        var $container = $(container);
        $container.find(".jelenew_news.jelenew_pc").slick({
          arrows: true,
          dots: true,
          infinite: false,
          slidesToShow: 3.2,
          slidesToScroll: 1,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
        });
        $container.on("click", ".jelenew_index_span", function () {
          sensors.track(theme.jelenew_event_name, {
            page_position: window.theme.jelenew_web_page_name || "",
            button_name: $(this).text().trim(),
            element_name: $container.find(".jelenew_index_title_inner").text().trim(),
            jump_link: $(this).attr("href").indexOf("www.jelenew.com") > -1 ? $(this).attr("href") : "https://www.jelenew.com" + $(this).attr("href"),
          });
        });
        $container.on("click", ".jelenew_new_item", function () {
          sensors.track(theme.jelenew_event_name, {
            page_position: window.theme.jelenew_web_page_name || "",
            button_name: $(this).find(".jelenew_new_title").text().trim(),
            element_name: $container.find(".jelenew_index_title_inner").text().trim(),
            jump_link: $(this).attr("href").indexOf("www.jelenew.com") > -1 ? $(this).attr("href") : "https://www.jelenew.com" + $(this).attr("href"),
          });
        });
      };
      this.onSectionUnload = function (container) {};
    })();

    theme.jelenewActiveSlide = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-active-slide-template", container);
        var slideDom = $(".jelenew_active_slide_img_list", container);
        const h5_slidesToShow = $(container).attr("data-h5_slidesToShow") * 1,
          pc_slidesToShow = $(container).attr("data-pc_slidesToShow") * 1;
        slideDom
          .slick({
            infinite: true,
            arrows: true,
            dots: true,
            slidesToShow: pc_slidesToShow,
            slidesToScroll: 1,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: pc_slidesToShow,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  arrows: false,
                  slidesToShow: h5_slidesToShow,
                },
              },
            ],
          })
          .on("afterChange", function (evt, slick, current) {
            $(".slide_title_active", container).removeClass("slide_title_active");
            $(".jelenew_active_slide_title", container).eq(current).addClass("slide_title_active");
          });
        $(".jelenew_active_slide_title", container).on("click", function () {
          slideDom.slick("slickGoTo", $(this).data("index0"));
        });
      };
    })();

    theme.jelenewParisTextBack = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-paris-text-back-template", container);
      };
    })();
    theme.jelenewFeaturedContentImages = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".featured-content-images-template", container);
      };
    })();
    theme.imageBanner = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".image-banner-template", container);
      };
    })();
    theme.jelenewImageWithTextSection = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-image-with-text-section-template", container);

        $("a", container).on("click", function (params) {
          sensors.track("ClickHomeElement", {
            page_position: theme.jelenew_web_page_name,
            button_name: "Discover the collection",
            element_name: "PicResource",
            jump_link: window.origin + $(this).attr("href"),
          });
        });
      };
    })();
    theme.jelenewCollectionList = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-collection-list-template", container);
        $(".jelenew-collection-item", container).on("click", function () {
          sensors.track("ClickCollectionList", {
            list_name: theme.jelenew_web_page_name + "推荐Collections",
            list_type: $(this).find("h3").text().trim(),
            page_position: theme.jelenew_web_page_name,
            jump_link: window.origin + $(this).attr("href"),
          });
        });
      };
    })();

    theme.jelenewBanner = new (function () {
      this.onSectionLoad = function (container) {
        const _this = this;
        if (container.dataset.loading === "lazy") {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  observer.disconnect();
                  jelenewSectionAppendTemplate(".jelenew-banner-template", container);
                  _this.functions.init(container);
                }
              });
            },
            {
              root: null,
              rootMargin: "500px",
              threshold: 0,
            }
          );
          observer.observe(container);
        } else {
          _this.functions.init(container);
        }
      };
      this.functions = {
        init: function (container) {
          $(container).on("click", ".copy-btn", function () {
            sensors.track(theme.jelenew_event_name, {
              element_name: $(this).text().trim(),
              page_position: theme.jelenew_web_page_name,
              active_name: theme.jelenew_active_name,
            });
            jelenew?.functions?.copyText($(this).data("code"));
          });
          $(container).on("click", ".product-item .handle", function () {
            $(this).closest(".product-item").toggleClass("active");
          });
          if (container.dataset.fixedBg === "yes") {
            const observer = new IntersectionObserver((entries) => {
              entries.forEach(
                (entry) => {
                  if (entry.isIntersecting) {
                    $(".jelenew-image-container-inner", container).css({ opacity: 1 });
                  } else {
                    $(".jelenew-image-container-inner", container).css({ opacity: 0 });
                  }
                },
                {
                  root: null,
                  rootMargin: "100px",
                  threshold: 0,
                }
              );
            });
            observer.observe(container);
          }
          // if (container.dataset.fixedBg === "yes") {
          //   $(window).on("scroll", function () {
          //     const { top, height } = $(".jelenew-image-container", container)[0].getBoundingClientRect();
          //     $(".jelenew-image-container-inner", container).css({
          //       backgroundPosition: `center ${-(top + height / 2 - window.innerHeight / 2)}px`,
          //     });
          //   });
          // };
        },
      };
    })();

    theme.jelenewSubscription = new (function () {
      this.onSectionLoad = function (container) {
        $(".jelenew-signup-form__email .signup-form__email", container).on("click", function () {
          // sensors.track("ClickAnyElement", {
          //   element_name: "EnterEmail",
          // });
        });
        $(".jelenew-signup-form__email .signup-form__button", container).on("click", function () {
          sessionStorage.getItem("openPopupType", "click");
          var email = $(this).siblings().val();
          emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          if (email && emailReg.test(email)) {
            $("[data-section-type=newsletter-popup]")[0].popup_strategy = "点击触发";
            let sensorsParam = {
              element_name: "底部订阅",
              email_input: email,
              popup_type: "bottom",
              popup_strategy: $("[data-section-type=newsletter-popup]")[0].popup_strategy,
              popup_name: "订阅弹层",
            };
            localStorage.setItem("jelenew_subscription_email", email);
            sensors.track("ClickLayerSubmit", sensorsParam);
            sensors.setProfile({ subscribe_email: email });
            fbq("track", "Subscribe");
          }
        });
      };
    })();

    theme.jelenewSlickAndText = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-slick-and-text-template", container);
        if ($(".image-slick", container).length > 0 && $(".image-slick>a", container).length > 1) {
          $(".image-slick", container).slick({
            dots: false,
            arrows: false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1.5,
                  dots: true,
                },
              },
            ],
          });
        }
      };
    })();
    theme.jelenewMemberBenefits = new (function () {
      this.onSectionLoad = function (container) {
        var $container = $(container);
        $("body").on("click", ".jelenew_member_benefits_wrap .jelenew_member_benefits_btn_lock", function (e) {
          e.stopPropagation();
          // $('.jelenew_member_benefit_detail_show').removeClass('jelenew_member_benefit_detail_show')
          $(".jelenew_member_birth_wrap_wrap .jelenew_member_birth_wrap").addClass("jelenew_member_birth_show");
          $(".jelenew_member_birth_wrap_wrap .jelenew_account_shade").addClass("jelenew_account_shade_show");
          // sensors.track("WebPageView", {
          //   web_page_name: "会员福利解锁页",
          //   is_login: $("body").data("is_login"),
          //   email_address: $("body").data("customer_email")
          // });
          sensors.track("ClickMemberElement", {
            web_page_name: $(this).parents(".jelenew_member_benefit_detail").length ? "会员权益详情页" : "会员权益列表页",
            module_name: $(this).text(),
            details_title: $(this).parents(".jelenew_member_benefit_detail").find(".jelenew_member_benefit_detail_title").text().trim() || "",
            is_login: $("body").data("is_login"),
            email_address: $("body").data("customer_email"),
          });
        });
        $("body").on("click", ".jelenew_member_benefits_wrap .jelenew_member_benefit_item", function (e) {
          e.stopPropagation();
          var $this = $(this);
          $this.find(".jelenew_member_benefit_detail").addClass("jelenew_member_benefit_detail_show");
          $(".jelenew_member_benefits_wrap .jelenew_account_shade").addClass("jelenew_account_shade_show");
          // sensors.track("WebPageView", {
          //   web_page_name: theme.jelenew_web_page_name,
          //   details_title: $this.find(".jelenew_member_benefit_image_title").text().trim(),
          //   is_login: $("body").data("is_login"),
          //   email_address: $("body").data("customer_email")
          // });
        });
        $("body").on(
          "click",
          ".jelenew_member_benefits_wrap .jelenew_account_shade_show, .jelenew_member_benefits_wrap .jelenew_member_benefit_detail_close",
          function (e) {
            e.stopPropagation();
            $(".jelenew_member_benefits_wrap .jelenew_account_shade_show").removeClass("jelenew_account_shade_show");
            $(".jelenew_member_benefits_wrap .jelenew_member_benefit_detail_show").removeClass("jelenew_member_benefit_detail_show");
            // $('.jelenew_member_benefits_wrap .jelenew_member_birth_show').removeClass('jelenew_member_birth_show')
          }
        );
      };
    })();
    theme.jelenewMemberPopup = new (function () {
      this.onSectionLoad = function (container) {
        // $("body").on("click", ".jelenew_show_member_tips", function () {
        //   if ($(".jelenew-member-popup-template").length) {
        //     jelenewSectionAppendTemplate(".jelenew-member-popup-template", container);
        //   }
        //   setTimeout(() => {
        //     $(container).addClass("jelenew-member-popup-template-wrap_show");
        //     $("body").addClass("cc-popup-no-scroll");
        //   });
        //   if ($("body").attr("data-page-type") == "product") {
        //     // sensors.track("ClickDetailsElement", {
        //     //   element_name: "会员详情页入口",
        //     //   page_position: "商品详情页",
        //     //   product_name: $(".jelenew-main-product-detail .jelenew-product-name").text().trim(),
        //     //   product_id: $(".jelenew-product-form-container.product-detail").attr("data-product-id") + "",
        //     //   original_price:
        //     //     $(".jelenew-main-product-detail .jelenew-product-price .theme-money")
        //     //       .text()
        //     //       .trim()
        //     //       .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
        //     //       .replace(",", ".") * 1,
        //     // });
        //   }
        // });
        $(container).on("click", ".jelenew-member-popup_shade, .jelenew-member-popup_close", function () {
          $(container).removeClass("jelenew-member-popup-template-wrap_show");
          $("body").removeClass("cc-popup-no-scroll");
        });
        $(container).on("click", ".jelenew-member-popup_item", function (e) {
          e.stopPropagation();
          var $this = $(this);
          $this.find(".jelenew-member-popup_detail").addClass("jelenew-member-popup_detail_show");
          $(".jelenew-member-popup .jelenew_account_shade").addClass("jelenew_account_shade_show");
        });
        $(container).on("click", ".jelenew-member-popup .jelenew_account_shade_show, .jelenew-member-popup_detail_close", function (e) {
          e.stopPropagation();
          $(".jelenew-member-popup .jelenew_account_shade_show").removeClass("jelenew_account_shade_show");
          $(".jelenew-member-popup_detail_show").removeClass("jelenew-member-popup_detail_show");
        });
      };
    })();
    theme.jelenewAccountUpdateInfo = new (function () {
      this.onSectionLoad = function (container) {
        function is29Days(year) {
          return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
        }
        function is31Days(month) {
          return month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12;
        }
        $(".jelenew_sex").on("change", function () {
          if ($(this).val() && $(this).find(".jelenew_birth_year_item_null").length) {
            $(this).find(".jelenew_birth_year_item_null").remove();
          }
        });
        function initBirthYear() {
          var currentYear = new Date().getFullYear();
          var jelenew_birth_year = $(".jelenew_birth_year");
          var jelenew_birth_month = $(".jelenew_birth_month");
          var jelenew_birth_date = $(".jelenew_birth_date");
          // jelenew_birth_year.on("click", function () {
          //   sensors.track("WebPageView", {
          //     web_page_name: "会员福利解锁页",
          //     element_name: "Year选择框",
          //     is_login: $("body").data("is_login"),
          //     email_address: $("body").data("customer_email"),
          //   });
          // });
          // jelenew_birth_month.on("click", function () {
          //   sensors.track("WebPageView", {
          //     web_page_name: "会员福利解锁页",
          //     element_name: "Month选择框",
          //     is_login: $("body").data("is_login"),
          //     email_address: $("body").data("customer_email"),
          //   });
          // });
          // $("#first_name").on("click", function () {
          //   sensors.track("WebPageView", {
          //     web_page_name: "会员福利解锁页",
          //     element_name: "FIRSTNAME输入框",
          //     is_login: $("body").data("is_login"),
          //     email_address: $("body").data("customer_email")
          //   });
          // });
          // $("#last_name").on("click", function () {
          //   sensors.track("WebPageView", {
          //     web_page_name: "会员福利解锁页",
          //     element_name: "LASTNAME输入框",
          //     is_login: $("body").data("is_login"),
          //     email_address: $("body").data("customer_email")
          //   });
          // });
          // jelenew_birth_month.on("click", function () {
          //   sensors.track("WebPageView", {
          //     web_page_name: "会员福利解锁页",
          //     element_name: "Day选择框",
          //     is_login: $("body").data("is_login"),
          //     email_address: $("body").data("customer_email")
          //   });
          // });

          jelenew_birth_year.html("");
          jelenew_birth_month.html("");
          jelenew_birth_date.html("");

          jelenew_birth_month.append('<option class="jelenew_birth_month_item" selected="selected">Month</option>');
          jelenew_birth_date.append('<option class="jelenew_birth_date_item" selected="selected">Day</option>');

          for (var i = currentYear - 100; i <= currentYear; i++) {
            jelenew_birth_year.prepend(`<option class="jelenew_birth_year_item" value="${i}">${i}</option>`);
          }
          jelenew_birth_year.prepend('<option class="jelenew_birth_year_item" selected="selected">Year</option>');
          for (var i = 1; i < 13; i++) {
            if (i < 10) {
              jelenew_birth_month.append(`<option class="jelenew_birth_month_item" value="0${i}">0${i}</option>`);
            } else {
              jelenew_birth_month.append(`<option class="jelenew_birth_month_item" value="${i}">${i}</option>`);
            }
          }
          jelenew_birth_year.on("change", function () {
            var maxDay = 30;
            if (jelenew_birth_year.val() > 0 && jelenew_birth_month.val() > 0) {
              if (is31Days(jelenew_birth_month.val())) {
                maxDay = 31;
              } else if (jelenew_birth_month.val() == 2) {
                if (is29Days(jelenew_birth_year.val())) {
                  maxDay = 29;
                } else {
                  maxDay = 28;
                }
              }
              initBirthDate(maxDay);
            }
          });
          jelenew_birth_month.on("change", function () {
            var maxDay = 30;
            if (jelenew_birth_year.val() > 0 && jelenew_birth_month.val() > 0) {
              if (is31Days(jelenew_birth_month.val())) {
                maxDay = 31;
              } else if (jelenew_birth_month.val() == 2) {
                if (is29Days(jelenew_birth_year.val())) {
                  maxDay = 29;
                } else {
                  maxDay = 28;
                }
              }
              initBirthDate(maxDay);
            }
          });
          function initBirthDate(maxDay) {
            jelenew_birth_date.html("");
            jelenew_birth_date.append('<option class="jelenew_birth_date_item" selected="selected">Day</option>');
            var maxDays = 31;
            if (maxDay) {
              maxDays = maxDay;
            }
            for (var i = 1; i <= maxDays; i++) {
              if (i < 10) {
                jelenew_birth_date.append(`<option class="jelenew_birth_date_item" value="0${i}">0${i}</option>`);
              } else {
                jelenew_birth_date.append(`<option class="jelenew_birth_date_item" value="${i}">${i}</option>`);
              }
            }
          }
          initBirthDate();
        }
        initBirthYear();
        function checkContent() {
          var jelenew_birth_year = $(".jelenew_birth_year");
          var jelenew_birth_month = $(".jelenew_birth_month");
          var jelenew_birth_date = $(".jelenew_birth_date");
          var jelenew_sex = $(".jelenew_sex");
          var first_name = $("#first_name");
          var last_name = $("#last_name");
          var lock = true;
          if (!(jelenew_birth_year.val() > 0)) {
            jelenew_birth_year.css("border-color", "#C53929");
            jelenew_birth_year.parents(".jelenew_update_item").find(".error-msg").remove();
            jelenew_birth_year.parents(".jelenew_update_item").append("<div class='error-msg'>Please enter a valid year</div>");
            lock = false;
          } else {
            jelenew_birth_year.css("border-color", "#c7c3c3");
            jelenew_birth_year.parents(".jelenew_update_item").find(".error-msg").remove();
          }
          if (!(jelenew_birth_month.val() > 0)) {
            jelenew_birth_month.css("border-color", "#C53929");
            jelenew_birth_month.parents(".jelenew_update_item").find(".error-msg").remove();
            jelenew_birth_month.parents(".jelenew_update_item").append("<div class='error-msg'>Please enter a valid month</div>");
            lock = false;
          } else {
            jelenew_birth_month.css("border-color", "#c7c3c3");
            jelenew_birth_month.parents(".jelenew_update_item").find(".error-msg").remove();
          }
          if (!(jelenew_birth_date.val() > 0)) {
            jelenew_birth_date.css("border-color", "#C53929");
            jelenew_birth_date.parents(".jelenew_update_item").find(".error-msg").remove();
            jelenew_birth_date.parents(".jelenew_update_item").append("<div class='error-msg'>Please enter a valid date</div>");
            lock = false;
          } else {
            jelenew_birth_date.css("border-color", "#c7c3c3");
            jelenew_birth_date.parents(".jelenew_update_item").find(".error-msg").remove();
          }
          if (!first_name.val()) {
            first_name.css("border-color", "#C53929");
            first_name.parents(".jelenew_update_item").find(".error-msg").remove();
            first_name.parents(".jelenew_update_item").append("<div class='error-msg'>Please enter a name</div>");
            lock = false;
          } else {
            first_name.css("border-color", "#c7c3c3");
            first_name.parents(".jelenew_update_item").find(".error-msg").remove();
          }
          if (!last_name.val()) {
            last_name.css("border-color", "#C53929");
            last_name.parents(".jelenew_update_item").find(".error-msg").remove();
            last_name.parents(".jelenew_update_item").append("<div class='error-msg'>Please enter a name</div>");
            lock = false;
          } else {
            last_name.css("border-color", "#c7c3c3");
            last_name.parents(".jelenew_update_item").find(".error-msg").remove();
          }
          if (!jelenew_sex.val()) {
            jelenew_sex.css("border-color", "#C53929");
            jelenew_sex.parents(".jelenew_update_item").find(".error-msg").remove();
            jelenew_sex.parents(".jelenew_update_item").append("<div class='error-msg'>Please select gender</div>");
            lock = false;
          } else {
            jelenew_sex.css("border-color", "#c7c3c3");
            jelenew_sex.parents(".jelenew_update_item").find(".error-msg").remove();
          }
          return lock;
        }
        $("body").on("click", ".jelenew_member_birth_update", function () {
          // sensors.track("WebPageView", {
          //   web_page_name: "会员福利解锁页",
          //   element_name: $(this).text().trim(),
          //   is_login: $("body").data("is_login"),
          //   email_address: $("body").data("customer_email")
          // });
          if (!checkContent()) {
            return false;
          }
          var $this = $(this);
          jelenewHttp
            .post("/api/user/modifyProfile", {
              firstName: $("#first_name").val() || "",
              lastName: $("#last_name").val() || "",
              gender: $(".jelenew_sex").val() || "",
              birthDate: $(".jelenew_birth_year").val() + "-" + $(".jelenew_birth_month").val() + "-" + $(".jelenew_birth_date").val(),
            })
            .then(() => {
              localStorage.setItem("accountFrom", "updata_info");
              window.location.href = $this.data("success-href");
            })
            .catch((err) => {
              theme.JelenewTips(err.status.desc);
            });
        });
        $("body").on(
          "click",
          ".jelenew_member_birth_wrap_wrap .jelenew_account_shade_show, .jelenew_member_birth_wrap_wrap .jelenew_member_birth_close",
          function (e) {
            e.stopPropagation();
            $(".jelenew_member_birth_wrap_wrap .jelenew_account_shade_show").removeClass("jelenew_account_shade_show");
            $(".jelenew_member_birth_wrap_wrap .jelenew_member_birth_show").removeClass("jelenew_member_birth_show");
          }
        );
      };
    })();

    theme.jelenewImgSlide = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-img-slide-template", container);
        if ($(".jelenew_active_slide_img_list", container).attr("data-slick")) {
          $(".jelenew_active_slide_img_list", container).slick();
        } else {
          $(".jelenew_active_slide_img_list", container).slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          });
        }
      };
    })();
    theme.jelenewBrandConceptNew = new (function () {
      this.onSectionLoad = function (container) {
        var jelenew_brand_concept_time = 0;
        var _jelenew_brand_concept_timer = setInterval(() => {
          jelenew_brand_concept_time++;
          $(".jelenew_brand_con_inner .jelenew_brand_con_item.active", container).removeClass("active");
          $($(".jelenew_brand_con_inner .jelenew_brand_con_item", container).get(jelenew_brand_concept_time)).addClass("active");
          if (jelenew_brand_concept_time >= 2) {
            jelenew_brand_concept_time = -1;
          }
        }, 4000);
        $(".jelenew_brand_con_inner .jelenew_brand_con_item", container).on("click", function () {
          clearInterval(_jelenew_brand_concept_timer);
          $(this).siblings().removeClass("active");
          $(this).addClass("active");
          // sensors.track("ClickActivityElement", {
          //   page_position: window.theme.jelenew_web_page_name || "",
          //   element_name: $(this).find(".jelenew_brand_con_item_title").text(),
          //   module_name: "WHY JELENEW",
          // });
        });
      };
    })();

    theme.jelenewImgWaterfall = new (function () {
      this.onSectionLoad = function (container) {
        // 加载更多
        $(".waterfall-load-more").on("click", function () {
          $willShowList = $(".waterfall-container .waterfall-hidden").splice(0, 14);
          $willShowList.forEach((el) => {
            $(el).removeClass("waterfall-hidden");
          });
          if ($(".waterfall-container .waterfall-hidden").length == 0) {
            return $(".waterfall-load-more").addClass("waterfall-hidden");
          }
        });
        // 设置基础变量
        let $baseItem = null,
          $dataDom = null,
          dataSource = [];
        // 点击唤起弹窗
        $(".waterfall-item-button").on("click", function () {
          // 初始化
          $baseItem = null;
          $dataDom = null;
          dataSource = [];
          // 销毁之前的dom
          $(".waterfall-dialog-products").empty();
          $(".waterfall-tag").remove();
          // 修改基础变量
          $baseItem = $(this).closest(".waterfall-item");
          $dataDom = $baseItem.find(".waterfall-item-data");

          // 打开弹窗
          $(".waterfall-dialog-bg").addClass("waterfall-show-dialog");

          // 弹窗左侧图片处理 -- 更改img-src
          let imgsrc = $baseItem.find("img").attr("src");
          $(".waterfall-dialog-img").attr("src", imgsrc);
          if ($dataDom.data("title") || $dataDom.data("sub_title")) {
            $(".waterfall-dialog-container .waterfall-item-img_text").show();
            $(".waterfall-dialog-container .waterfall-item-img_title").text($dataDom.data("title"));
            $(".waterfall-dialog-container .waterfall-item-img_sub_title").text($dataDom.data("sub_title"));
          } else {
            $(".waterfall-dialog-container .waterfall-item-img_text").hide();
            $(".waterfall-dialog-container .waterfall-item-img_title").text("");
            $(".waterfall-dialog-container .waterfall-item-img_sub_title").text("");
          }

          // 获取img alt注入标题
          let alt = $baseItem.find(".waterfall-item-img-container img").attr("alt");
          $(".waterfall-dialog-header-title").text(alt);

          // 组装数据源
          for (let i = 1; i < 4; i++) {
            if ($dataDom.data(`product-${i}-variants`)) {
              // 如果数据存在  variants数据舍弃最后一个；
              let product_variants = $dataDom.data(`product-${i}-variants`).slice(0, -1).split(";");
              let product_options = $dataDom.data(`product-${i}-options`).split(";");

              // 数据存在 -- 处理数据 写入数据源
              let product_data = {
                variants: [],
                options: [],
                tag_position: "",
              };
              product_variants.forEach((str) => {
                const arr = str.split(",");
                const price = "$" + arr[3].slice(0, -2) + "." + arr[3].slice(-2);
                product_data.variants.push({
                  variant_title: arr[0],
                  id: arr[1],
                  img: arr[2],
                  price,
                  product_title: arr[4],
                  variant_url: arr[5],
                  available: arr[6], // 是否有库存
                });
              });
              product_options.forEach((str) => {
                let brr = str.split(":");
                product_data.options.push({
                  option_name: brr[0],
                  option_list: brr[1].split(","),
                });
              });
              product_data.tag_position = $dataDom.data(`tag-${i}-position`);
              dataSource.push(product_data);
            }
          }
          dataSource.forEach((data, index) => {
            // 根据产品创建 product-container
            makeProductContainer(data, index);
          });
          // 重置tag交互脚本
          taghover();
        });
        // 关闭弹窗 ==》 销毁dom
        $(".waterfall-dialog-close").on("click", () => {
          $(".waterfall-dialog-bg").removeClass("waterfall-show-dialog");
          $(".waterfall-dialog-products").empty();
          $(".waterfall-tag").remove();
        });

        // 创建商品容器并插入右侧dom
        function makeProductContainer(data, index) {
          // 插入商品
          let $container = `
          <div class="waterfall-dialog-product-container" data-product-index="${index}">
              <img class="waterfall-dialog-product-img" src="${data.variants[0].img}"/>
              <div class="waterfall-dialog-product-price">${data.variants[0].price}</div>
              <div class="waterfall-dialog-product-title">${data.variants[0].product_title}</div>
              <div class="waterfall-dialog-product-button">ADD TO CART</div>
          </div>`;
          $(".waterfall-dialog-products").append($container);
          // 插入标记
          let tag = `
              <a class="waterfall-tag" data-product-index="${index}" style="${data.tag_position}" href="${data.variants[0].variant_url}">
                  <div class="waterfall-tag-nth">${index + 1}</div>
                  <div class="waterfall-overlink-text">       
                      <div class="waterfall-arrow-up"></div>       
                      <div class="waterfall-overlink-product-name">
                          ${data.variants[0].product_title}
                      </div>
                  </div>
              </a>
          `;
          $(".waterfall-dialog-img-container").append(tag);
        }
        // 划入划出交互脚本
        function taghover() {
          $(".waterfall-tag-nth").on("mouseenter", function () {
            $(this).closest(".waterfall-tag").addClass("waterfall-tag-active");
          });
          $(".waterfall-tag").on("mouseleave", function () {
            $(this).removeClass("waterfall-tag-active");
          });

          $(".waterfall-dialog-product-container").on("mouseenter", function () {
            const index = $(this).data("product-index");
            const currentTag = $(".waterfall-tag").filter(`[data-product-index=${index}]`);
            currentTag.addClass("waterfall-tag-active");
          });
          $(".waterfall-dialog-product-container").on("mouseleave", function () {
            const index = $(this).data("product-index");
            const currentTag = $(".waterfall-tag").filter(`[data-product-index=${index}]`);
            currentTag.removeClass("waterfall-tag-active");
          });
        }
        let currentProductData = null;
        // waterfall-dialog容器中点击 add to cart
        $(".waterfall-dialog").on("click", ".waterfall-dialog-product-button", function () {
          $(".waterfall-product-detail").removeClass("show-add-to-bag");
          // 点击 添加商品
          $(".waterfall-dialog-bg").addClass("show-product-detail");
          // 通过DataSource获取数据
          currentProductData = dataSource[$(this).closest(".waterfall-dialog-product-container").data("product-index") * 1];
          // 先删除sku容器中的dom
          $(".waterfall-product-detail-sku").empty();
          // 插入sku选择器
          currentProductData.options.forEach((item) => {
            let liststr = '<div class="option-list">';
            item.option_list.forEach((l, i) => {
              if (i === 0) {
                liststr += `<div class="option-item selected">${l.split("-#")[0]}</div>`;
              } else {
                liststr += `<div class="option-item">${l.split("-#")[0]}</div>`;
              }
            });
            $(".waterfall-product-detail-sku").append(
              `<div class="option-row"><div class="option-name">${item.option_name}</div>${liststr}</div></div>`
            );
          });
          // 插入图片
          checkSelectedShowImg(currentProductData.variants);
        });
        // sku 点击
        $(".waterfall-product-detail-sku").on("click", ".option-item", function () {
          $(this).closest(".option-list").find(".option-item").removeClass("selected");
          $(this).addClass("selected");
          checkSelectedShowImg(currentProductData.variants);
        });
        //对比选中项--筛查出对应数据，修改currentId
        function checkSelectedShowImg(variants) {
          let selectedList = [];
          $(".selected").each(function () {
            selectedList.push($(this).text());
          });
          let newTitleList = [];
          variants.forEach((v) => {
            let t = v.variant_title.split(" / ");
            let newTitle = new Set();
            t.forEach((str) => newTitle.add(str.split("-#")[0]));
            newTitleList.push(newTitle);
          });
          let index = checkSelectedIndex(selectedList, newTitleList);
          $("#waterfall-form-container #waterfall-form-id-input").attr("value", variants[index].id);
          $(".waterfall-product-detail-img").attr("src", variants[index].img);

          // 查看是否有库存，无库存禁用submit，有库存开启submit
          if (variants[index].available == "true") {
            // 有库存
            $("#waterfall-form-submit-btn").removeAttr("disabled");
            $("#waterfall-form-submit-btn").css("cursor", "pointer");
          } else {
            // 无库存
            $("#waterfall-form-submit-btn").attr("disabled", "disabled");
            $("#waterfall-form-submit-btn").css("cursor", "no-drop");
          }
        }
        //对比选中项和数据源，查找index
        function checkSelectedIndex(selectedList, newTitleList) {
          let index = 0;
          newTitleList.forEach((itemSet, i) => {
            let is_this = selectedList.every((selected) => itemSet.has(selected));
            if (is_this) {
              index = i;
            }
          });
          return index;
        }
        // 加入购物车
        theme.applyAjaxToProductForm($("#waterfall-form-container"));
        //加购提示--在theme.js中调用
        theme.jelenewImgWaterfallShowAddToBagPrompt = function (title, image, money) {
          if ($(".waterfall-product-detail").length === 0) return;
          $(".waterfall-product-detail").addClass("show-add-to-bag");
          $(".waterfall-add-to-bag-detail-text").text(`${title.split("-#")[0]}（${money}）`);
          $(".waterfall-add-to-bag-detail-img img").attr("src", image);

          let num = $(".cart-link__count").text() * 1 + 1;
          $(".waterfall-add-to-bag-detail-num span").text(num);
        };
        // 关闭商详
        $(".waterfall-product-detail-cancel").on("click", function () {
          $(".waterfall-dialog-bg").removeClass("show-product-detail");
          $(".waterfall-add-to-bag-detail-img img").attr("src", "");
          $(".waterfall-product-detail").removeClass("show-add-to-bag");
        });
        setTimeout(() => {
          $(".waterfall-dialog-bg").css({
            transition: "transform .3s",
          });
        }, 3000);
      };
    })();

    theme.jelenewIndexLoadGif = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-index-load-gif-template", container);
        var $container = $(container);
        $container.on("click", ".video_main_btn_wrap,.video_url_wrap", function () {
          sensors.track(theme.jelenew_event_name, {
            button_name: $container.find(".index_video_pc .video_main_btn_wrap").text().trim(),
            element_name: "PicResource",
            jump_link: $(this).attr("href").indexOf("www.jelenew.com") > -1 ? $(this).attr("href") : "https://www.jelenew.com" + $(this).attr("href"),
            page_position: window.theme.jelenew_web_page_name || "",
          });
        });
      };
      this.onSectionUnload = function (container) {};
    })();
    theme.jelenewCommonTitle = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-common-title-template", container);
      };
    })();

    theme.jelenewRollandAf = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-rolland-af-template", container);
        $(".jelenew_rolland_af_content_btn", container).on("click", function () {
          // sensors.track("ClickActivityElement", {
          //   web_page_name: theme.jelenew_web_page_name || "",
          //   active_name: theme.jelenew_active_name || "",
          //   element_name: $(this).text().trim(),
          // });
        });
      };
    })();

    theme.JelenewSwiperSection = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-swiper-template", container);
        function jelenewSwiper() {
          var _timer = setInterval(() => {
            if (window.Swiper) {
              clearInterval(_timer);
              let galleryThumbs = new Swiper(".gallery-thumbs", {
                spaceBetween: 10,
                slidesPerView: "auto",
                grabCursor: true,
                loopedSlides: 5, //looped slides should be the same
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                on: {
                  resize: function () {
                    this.update(); //窗口变化时，更新Swiper的一些属性，如宽高等
                  },
                  slideChange: function () {
                    //console.log('改变了，activeIndex为'+this.activeIndex);
                    // sensors.track("ClickActivityElement", {
                    //   element_name: "切换图片",
                    //   position: "ALL PHOTOS",
                    //   list_name: "活动页罗兰推荐列表",
                    //   page_position: "活动页",
                    // });
                  },
                },
              });
              let galleryTop = new Swiper(".gallery-top", {
                spaceBetween: 10,
                grabCursor: true,
                loopedSlides: 5, //looped slides should be the same
                navigation: {
                  nextEl: ".swiper-button-next-top",
                  prevEl: ".swiper-button-prev-top",
                },
                pagination: {
                  el: "#gallery-top-pagination",
                  type: "fraction",
                },
                thumbs: {
                  swiper: galleryThumbs,
                },
                on: {
                  resize: function () {
                    this.update(); //窗口变化时，更新Swiper的一些属性，如宽高等
                  },
                  slideChange: function () {
                    $(".gallery-top .swiper-slide").css("transform", "scale(1)");
                    //console.log('改变了，activeIndex为'+this.activeIndex);
                    // sensors.track("ClickActivityElement", {
                    //   element_name: "切换图片",
                    //   position: "ALL PHOTOS",
                    //   list_name: "活动页罗兰推荐列表",
                    //   page_position: "活动页",
                    // });
                  },
                },
              });
              let base_swiper = new Swiper(".swiper-container-base", {
                slidesPerView: "auto",
                grabCursor: true,
                spaceBetween: 10,
                freeMode: true,
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                },
                // 如果需要前进后退按钮
                navigation: {
                  nextEl: ".swiper-button-next-base",
                  prevEl: ".swiper-button-prev-base",
                },
                on: {
                  resize: function () {
                    this.update(); //窗口变化时，更新Swiper的一些属性，如宽高等
                  },
                  slideChange: function () {
                    // sensors.track("ClickActivityElement", {
                    //   element_name: "切换图片",
                    //   position: "ALL PHOTOS",
                    //   list_name: "活动页罗兰推荐列表",
                    //   page_position: "活动页",
                    // });
                  },
                },
              });
              base_swiper.controller.control = galleryTop; //Swiper2控制Swiper1，需要初始化Swiper1之后
              galleryTop.controller.control = base_swiper;
              $(".swiper-container-base").on("click", ".swiper-slide", function () {
                $(".jelenew-full-size-drawer").addClass("show-jelenew-full-size-drawer");
              });
              $(".jelenew-full-size-drawer .close-drawer-btn").on("click", function () {
                $(".jelenew-full-size-drawer").removeClass("show-jelenew-full-size-drawer");
              });
              let scaleNum = 1;
              $(".jelenew-full-size-drawer .fangda-img").on("click", function () {
                if (3 > scaleNum) {
                  scaleNum += 0.5;
                }
                $(".gallery-top .swiper-slide-active").css("transform", "scale(" + scaleNum + ")");
              });
              $(".jelenew-full-size-drawer .suoxiao-img").on("click", function () {
                if (scaleNum > 0.5) {
                  scaleNum -= 0.2;
                }
                $(".gallery-top .swiper-slide-active").css("transform", "scale(" + scaleNum + ")");
              });
              $(".copy-img-url-btn").on("click", function () {
                let src = $(".swiper-container-base .swiper-slide-active").find("img").attr("src");
                navigator && navigator.clipboard && navigator.clipboard.writeText("https:" + src);
              });
              $("#fullScreen").on("click", ".quanping-dakai, .quanping-guanbi", function () {
                if ($(this).hasClass("quanping-dakai")) {
                  $(this).parent().addClass("show-quanping-guanbi");
                  if (document.documentElement.RequestFullScreen) {
                    document.documentElement.RequestFullScreen();
                  }
                  //兼容火狐
                  if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                  }
                  //兼容谷歌等可以webkitRequestFullScreen也可以webkitRequestFullscreen
                  if (document.documentElement.webkitRequestFullScreen) {
                    document.documentElement.webkitRequestFullScreen();
                  }
                  //兼容IE,只能写msRequestFullscreen
                  if (document.documentElement.msRequestFullscreen) {
                    document.documentElement.msRequestFullscreen();
                  }
                } else {
                  $(this).parent().removeClass("show-quanping-guanbi");

                  if (document.exitFullScreen) {
                    document.exitFullscreen();
                  }
                  //兼容火狐
                  if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                  }
                  //兼容谷歌等
                  if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                  }
                  //兼容IE
                  if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                  }
                }
              });
            }
          }, 500);
        }
        jelenewSwiper();
      };
    })();

    theme.jelenewAmbVideo = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-amb-video-template", container);
        $(document).ready(function () {
          $(".jelenew_video_play_btn", container).on("click", function () {
            // $("video", container).attr("src", $(container).find('div[data-section-type="jelenew-video-item"]').data("video_link"));
            $("video", container).get(0).play();
            $(".jelenew_video_img", container).remove();
          });
        });
      };
    })();
    theme.jelenewHoverImage = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-hover-image-template", container);
        $(".image-container", container).on("click, mouseover", function () {
          const index = $(this).index();
          $(".bg-imgs-container img.active", container).removeClass("active");
          $(".bg-imgs-container img", container).eq(index).addClass("active");
          $(".position-text .text_inner.active", container).removeClass("active");
          $(".position-text .text_inner", container).eq(index).addClass("active");
        });
      };
    })();

    theme.jelenewIndexGifSkewing = new (function () {
      this.onSectionLoad = function (container) {
        $(".section-jelenew-index-gif .video_main_btn_wrap").on("click", function () {
          sensors.track("ClickHomeElement", {
            button_name: $(this).text().trim(),
            element_name: "PicResource",
            jump_link: $(this).attr("href").indexOf("www.jelenew.com") > -1 ? $(this).attr("href") : "https://www.jelenew.com" + $(this).attr("href"),
            page_position: window.theme.jelenew_web_page_name || "",
          });
        });
        $(".section-jelenew-index-gif .video_url_wrap").on("click", function () {
          sensors.track("ClickHomeElement", {
            button_name: "pic",
            element_name: "PicResource",
            jump_link: $(this).attr("href").indexOf("www.jelenew.com") > -1 ? $(this).attr("href") : "https://www.jelenew.com" + $(this).attr("href"),
            page_position: window.theme.jelenew_web_page_name || "",
          });
        });
        $(".section-jelenew-index-gif .jelenew_index_gif_btn").on("click", function () {
          // sensors.track(theme.jelenew_event_name || "ClickListElement", {
          //   page_position: theme.jelenew_web_page_name,
          //   category_name: location.pathname.split("/").pop(),
          //   element_name: $(this).text().trim(),
          // });
        });
      };
    })();

    theme.jelenewIndexGif = new (function () {
      this.onSectionLoad = function (container) {
        $(".section-jelenew-index-gif .video_main_btn_wrap").on("click", function () {
          sensors.track("ClickHomeElement", {
            button_name: $(this).text().trim(),
            element_name: "PicResource",
            jump_link: $(this).attr("href").indexOf("www.jelenew.com") > -1 ? $(this).attr("href") : "https://www.jelenew.com" + $(this).attr("href"),
            page_position: window.theme.jelenew_web_page_name || "",
          });
        });
        $(".section-jelenew-index-gif .video_url_wrap").on("click", function () {
          sensors.track("ClickHomeElement", {
            button_name: "pic",
            element_name: "PicResource",
            jump_link: $(this).attr("href").indexOf("www.jelenew.com") > -1 ? $(this).attr("href") : "https://www.jelenew.com" + $(this).attr("href"),
            page_position: window.theme.jelenew_web_page_name || "",
          });
        });
        $(".section-jelenew-index-gif .jelenew_index_gif_btn").on("click", function () {
          // sensors.track(theme.jelenew_event_name || "ClickListElement", {
          //   page_position: theme.jelenew_web_page_name,
          //   category_name: location.pathname.split("/").pop(),
          //   element_name: $(this).text().trim(),
          // });
        });
      };
    })();

    theme.jelenewIndexImage = new (function () {
      this.onSectionLoad = function (container) {
        $(".section-jelenew-index-image .video_main_btn_wrap").on("click", function () {
          sensors.track("ClickHomeElement", {
            button_name: $(this).text().trim(),
            element_name: "PicResource",
            jump_link: $(this).attr("href").indexOf("www.jelenew.com") > -1 ? $(this).attr("href") : "https://www.jelenew.com" + $(this).attr("href"),
            page_position: window.theme.jelenew_web_page_name || "",
          });
        });
        $(".section-jelenew-index-image .video_sub_btn_wrap").on("click", function () {
          sensors.track("ClickHomeElement", {
            button_name: $(this).text().trim(),
            element_name: "PicResource",
            jump_link: $(this).attr("href").indexOf("www.jelenew.com") > -1 ? $(this).attr("href") : "https://www.jelenew.com" + $(this).attr("href"),
            page_position: window.theme.jelenew_web_page_name || "",
          });
        });
        $(".section-jelenew-index-image .video_url_wrap").on("click", function () {
          sensors.track("ClickHomeElement", {
            button_name: "pic",
            element_name: "PicResource",
            jump_link: $(this).attr("href").indexOf("www.jelenew.com") > -1 ? $(this).attr("href") : "https://www.jelenew.com" + $(this).attr("href"),
            page_position: window.theme.jelenew_web_page_name || "",
          });
        });
      };
    })();

    theme.jelenewIndexList = new (function () {
      this.onSectionLoad = function (container) {
        $(".section-jelenew-index-list .jelenew_index_item_btn_text").on("click", function () {
          // sensors.track("ClickActivityElement", {
          //   element_name: $(this).text().trim(),
          //   page_position: window.theme.jelenew_web_page_name || "",
          // });
        });

        $(".section-jelenew-index-list .jelenew_index_list").slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1.5,
              },
            },
          ],
        });
      };
    })();

    theme.jelenewOurBelief = new (function () {
      this.onSectionLoad = function (container) {
        var mian = document.querySelector(".jelenew_our_belief_wrap");
        var jelenew_our_item_length = $(".jelenew_our_belief_wrap .jelenew_our_belief:nth-child(1) .jelenew_our_item:nth-child(1)").width();
        $(".jelenew_our_item").css({
          width: jelenew_our_item_length + "px",
        });
        var jelenew_our_belief_length = jelenew_our_item_length * $(".jelenew_our_belief_wrap").data("blocks_size");
        $(".jelenew_our_belief").css({
          width: jelenew_our_belief_length + "px",
        });
        $(".jelenew_our_belief_wrap").css({
          width: jelenew_our_belief_length * 2 + "px",
        });
        // 移动的距离
        let num = -1;
        // 跑马灯效果
        let timer = setInterval(function () {
          mian.style.transform = "translateX(" + num + "px)";
          num -= 1;
          if (num <= -jelenew_our_belief_length) {
            num = -1;
          }
        }, 30);
        window.addEventListener("resize", function () {
          jelenew_our_item_length = $(".jelenew-our-belief").width() / 4;
          $(".jelenew_our_item").css({
            width: jelenew_our_item_length + "px",
          });
          jelenew_our_belief_length = jelenew_our_item_length * $(".jelenew_our_belief_wrap").data("blocks_size");
          $(".jelenew_our_belief").css({
            width: jelenew_our_belief_length + "px",
          });
          $(".jelenew_our_belief_wrap").css({
            width: jelenew_our_belief_length * 2 + "px",
          });
        });
      };
    })();

    theme.jelenewRecommend = new (function () {
      this.onSectionLoad = function (container) {
        if (theme.jelenew_web_page_name == "首页") {
          $(".recommend-product-list .product-link").on("click", function () {
            sensors.track("ClickProductList", {
              page_position: "首页",
              list_type: "推荐商品列表",
              list_name: "首页推荐商品列表",
              product_name: $(this).parents(".product-block").find(".product-block__title").text().trim(),
              product_id: $(this).parents(".product-block").attr("data-product-id"),
              original_price: Number(
                (
                  $(this).parents(".product-block").find(".product-price__compare").text().trim() ||
                  $(this).parents(".product-block").find(".product-price__amount").text().trim()
                )
                  .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                  .replace(",", ".")
              ),
            });
          });
        }
        if (theme.jelenew_active_name == "刘地列表") {
          $(".recommend-product-list").on("click", ".product-link", function () {
            sensors.track("ClickProductList", {
              page_position: "活动页",
              list_type: "刘地商品列表",
              list_name: "活动页刘地推荐列表",
              product_name: $(this).parents(".product-block").find(".product-block__title").text().trim(),
              product_id: $(this).parents(".product-block").attr("data-product-id"),
              original_price: Number(
                (
                  $(this).parents(".product-block").find(".product-price__compare").text().trim() ||
                  $(this).parents(".product-block").find(".product-price__amount").text().trim()
                )
                  .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                  .replace(",", ".")
              ),
            });
          });
          $(".jelenew-recommend-btnbox a").on("click", function () {
            // sensors.track("ClickActivityElement", {
            //   element_name: $(this).text().trim(),
            //   jump_link: "https://www.jelenew.com" + $(this).attr("href"),
            //   page_position: "活动页",
            // });
          });
        }
        if (theme.jelenew_web_page_name == "1+1落地页") {
          $(".recommend-product-list").on("click", ".product-link", function () {
            sensors.track("ClickProductList", {
              page_position: theme.jelenew_web_page_name,
              list_type: "1+1落地页商品列表",
              list_name: "11列表2",
              product_name: $(this).parents(".product-block").find(".product-block__title").text().trim(),
              product_id: $(this).parents(".product-block").attr("data-product-id"),
              original_price: Number(
                (
                  $(this).parents(".product-block").find(".product-price__compare").text().trim() ||
                  $(this).parents(".product-block").find(".product-price__amount").text().trim()
                )
                  .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                  .replace(",", ".")
              ),
            });
          });
        }
        if (theme.jelenew_active_name == "罗兰列表") {
          $(".recommend-product-list").on("click", ".product-link", function () {
            sensors.track("ClickProductList", {
              page_position: "活动页",
              list_type: "罗兰商品列表",
              list_name: "活动页罗兰推荐列表",
              product_name: $(this).parents(".product-block").find(".product-block__title").text().trim(),
              product_id: $(this).parents(".product-block").attr("data-product-id"),
              original_price: Number(
                (
                  $(this).parents(".product-block").find(".product-price__compare").text().trim() ||
                  $(this).parents(".product-block").find(".product-price__amount").text().trim()
                )
                  .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
                  .replace(",", ".")
              ),
            });
          });
        }
      };
    })();

    theme.jelenewRedPopAf = new (function () {
      this.onSectionLoad = function (container) {
        $(".jelenew_rolland_af_content_btn", container).on("click", function () {
          // sensors.track("ClickActivityElement", {
          //   web_page_name: theme.jelenew_web_page_name || "",
          //   active_name: theme.jelenew_active_name || "",
          //   element_name: $(this).text().trim(),
          // });
        });
      };
    })();

    theme.jelenewRedPopTop = new (function () {
      this.onSectionLoad = function (container) {
        $(".section-jelenew-red-pop-top .jelenew_index_gif_btn").on("click", function () {
          sensors.track(theme.jelenew_event_name, {
            button_name: $(this).text().trim(),
            element_name: $(this).text().trim(),
            page_position: window.theme.jelenew_web_page_name || "",
            active_name: theme.jelenew_active_name || "",
          });
          if (!$(this).data("href")) {
            var offset = $($(this).data("section_id")).offset();
            window.scrollTo({
              top: offset.top,
              behavior: "smooth",
            });
          }
        });
        $(".section-jelenew-red-pop-top .video_main_btn_wrap").on("click", function () {
          sensors.track("ClickHomeElement", {
            button_name: $(this).text().trim(),
            element_name: "PicResource",
            jump_link: $(this).attr("href").indexOf("www.jelenew.com") > -1 ? $(this).attr("href") : "https://www.jelenew.com" + $(this).attr("href"),
            page_position: window.theme.jelenew_web_page_name || "",
          });
        });
        $(".section-jelenew-red-pop-top .video_url_wrap").on("click", function () {
          sensors.track("ClickHomeElement", {
            button_name: "pic",
            element_name: "PicResource",
            jump_link: $(this).attr("href").indexOf("www.jelenew.com") > -1 ? $(this).attr("href") : "https://www.jelenew.com" + $(this).attr("href"),
            page_position: window.theme.jelenew_web_page_name || "",
          });
        });
      };
    })();

    theme.jelenewKeywordsBanner = new (function () {
      this.onSectionLoad = function (container) {
        $(".jelenew-keywords-contianer a", container).on("click", function () {
          // sensors.track("ClickActivityElement", {
          //   element_name: $(this).text().trim(),
          //   button_name: "Keywords",
          //   active_name: window.theme.jelenew_active_name || "",
          //   page_position: window.theme.jelenew_web_page_name || "",
          // });
        });
      };
    })();
    theme.jelenewMediaAndText = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-media-and-text-template", container);
        const slides_show = $(container).data("slides_show") * 1;
        if ($(".jelenew-media-and-text-comment-style").length == 0) {
          const styleTag = $(".jelenew-media-and-text-comment-style-template", container)[0].content.cloneNode(true);
          container.appendChild(styleTag);
          $(".jelenew-media-and-text-comment-style-template").remove();
        }
        this.functions.actionInit(container);
        if ($("main>.section-layout.flex", container).length > 2 || $(container).data("h5_slick")) {
          // 轮播图初始化
          if (window.innerWidth < 768) {
            $(".jelenew-media-and-text-element>main", container).slick({
              dots: true,
              infinite: false,
              slidesToShow: slides_show,
              slidesToScroll: 1,
            });
          }
          $(window).on("resize", function () {
            if (window.innerWidth < 768 && !$(".jelenew-media-and-text-element>main", container).hasClass("slick-initialized")) {
              $(".jelenew-media-and-text-element>main", container).slick({
                dots: true,
                infinite: false,
                slidesToShow: slides_show,
                slidesToScroll: 1,
              });
            } else if (window.innerWidth >= 768 && $(".jelenew-media-and-text-element>main", container).hasClass("slick-initialized")) {
              $(".jelenew-media-and-text-element>main", container).slick("unslick");
            }
          });
        }
        // 视频在可视范围内 播放 不在暂停
        function isInViewport() {
          if($(".section-item video", container).length>0){
            var elementTop = $(".section-item video", container).offset().top;
            var elementBottom = elementTop + $(".section-item video", container).outerHeight();
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();
            return elementBottom > viewportTop && elementTop < viewportBottom;
          }
        }
        function setFixed() {
          if($(".item-media.visible_controls", container).length>0){
              if (isInViewport()) {
                $(".section-item video", container).trigger("play");
              } else {
                $(".section-item video", container).trigger("pause");
              }
          }
        }
        $(window).on("throttled-scroll", setFixed);
      };
      this.functions = {
        actionInit: (container) => {
          if ($("[data-item-type=Text]", container).length > 0 || $("[data-item-type=ImageText]", container).length > 0) {
            $(".main-text>p", container).each(function () {
              if ($(this).prop("scrollHeight") > $(this).closest(".main-text").height()) {
                $(this).closest(".section-item").find(".collapse-handler").removeClass("hidden");
              } else {
                $(this).closest(".section-item").find(".main-text").removeClass("collapse-container");
              }
            });
            $(container).on("click", ".collapse-handler:not(.hidden)", function () {
              const TextSection = $(this).closest(".section-item[data-item-type]")[0];
              let element_name = "See More";
              if ($(TextSection).toggleClass("open-collapse").hasClass("open-collapse")) {
                // 打开
                $(".main-text", TextSection).css("max-height", $(".main-text>p", TextSection).prop("scrollHeight"));
              } else {
                // 关闭
                $(".main-text", TextSection).css("max-height", "");
                element_name = "See Less";
              }
              // sensors.track("ClickActivityElement", {
              //   element_name,
              //   button_name:
              //     $(this).closest(".section-item").find(".brandstory-title").text().trim() ||
              //     $(this).closest(".section-item").find(".collection-item-title").text().trim(),
              //   active_name: window.theme.jelenew_active_name || "",
              //   page_position: window.theme.jelenew_web_page_name || "",
              // });
            });
          }
          if ($("[data-item-type=Slide]", container).length > 0) {
            $("[data-item-type=Slide]", container).slick({
              dots: false,
              infinite: false,
              arrow: false,
              slidesToShow: 3,
              slidesToScroll: 1,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
          }
          if ($("[data-item-type=Collection]", container).length > 0) {
            $(container).on("click", "[data-item-type=Collection] a", function () {
              // sensors.track("ClickActivityElement", {
              //   list_name: $(this).find(".image-title").text().trim(),
              //   list_type: "推荐商品列表",
              //   active_name: window.theme.jelenew_active_name || "",
              //   page_position: window.theme.jelenew_web_page_name || "",
              // });
            });
          }
        },
      };
    })();

    theme.collectionFooterSeo = new (function () {
      this.onSectionLoad = function (container) {
        // 存在blogs链接
        $("#blogs .blog-item", container).each(function () {
          const $this = $(this);
          shopifyHttp.get($this.attr("href") + "?view=jelenew-article-simple&sections=jelenew-article-simple").then((html) => {
            $this.append($(html["jelenew-article-simple"]));
          });
        });
      };
    })();

    theme.jelenewZoomImg = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-zoom-img-template", container);
        const _this = this;
        _this.functions.zoomInit(container);
        $(window).on("debouncedresize.jelenewZoomImg", function () {
          _this.functions.zoomInit(container);
        });
        $(".zoom-container", container).on("mousemove", function (e) {
          let X = e.clientX || e.touches[0].clientX;
          let Y = e.clientY || e.touches[0].clientY;
          let top = Y - $(this)[0].getBoundingClientRect().top - $(".zoom", this).height() / 2;
          let left = X - $(this)[0].getBoundingClientRect().left - $(".zoom", this).width() / 2;
          if (top < 0) top = 0;
          if (top > $(this).height() - $(".zoom", this).height()) top = $(this).height() - $(".zoom", this).height();
          if (left < 0) left = 0;
          if (left > $(this).width() - $(".zoom", this).width()) left = $(this).width() - $(".zoom", this).width();
          $(".zoom", this).css({
            top,
            left,
            backgroundPosition: `-${left * 1.2}px -${top * 1.2}px`,
          });
        });
      };
      this.functions = {
        zoomInit: function (container) {
          $(".zoom", container).css({
            backgroundSize: $(".zoom-container", container).width() * 1.2,
            backgroundPosition: `-${$(".zoom-container", container).width() * 0.1}px -${$(".zoom-container", container).height() * 0.1}px`,
          });
        },
      };
    })();

    theme.jelenewSlickRow = new (function () {
      this.onSectionLoad = function (container) {
        const slickCfg = {
          dots: true,
          infinite: true,
          arrow: true,
          slidesToShow: 3.5,
          slidesToScroll: 1,
          centerMode: false,
          appendArrows: $(".slick-control", container),
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
          appendDots: $(".slick-control .dots", container),
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3.5,
                slidesToScroll: 1,
                centerMode: false,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: "25vw",
                dots: false,
                arrow: false,
              },
            },
          ],
        };
        $(".list", container).slick(slickCfg);
        this.functions.sensorsInit(container);
      };
      this.functions = {
        sensorsInit: function (container) {
          $(container).on("click", "a", function () {
            // sensors.track("ClickAnyElement", {
            //   page_position: theme.jelenew_web_page_name,
            //   element_name: "RECENT STORES",
            //   button_name: $(this).closest(".item").find("p").text().trim(),
            //   jump_link: $(this).attr("href"),
            // });
          });
        },
      };
    })();

    theme.mainPage = new (function () {
      this.onSectionLoad = function () {
        const continueMap = new Set([
          Shopify.routes.root + "pages/about-us",
          Shopify.routes.root + "pages/faqs",
          Shopify.routes.root + "pages/payment-method",
          Shopify.routes.root + "pages/installment_agreement",
        ]);
        if (!continueMap.has(location.pathname)) {
          sensors.track("ServeException", {
            exception_type: "前端错误",
            exception_level: "p0",
            exception_modle: "空页面被访问",
            exception_from: "前端",
            exception_reason: "默认页面模板被使用",
            exception_modle_sub: "系统报错",
            $url: window.location.href,
          });
        }
      };
    })();

    theme.jelenewTimeout = new (function () {
      this.onSectionLoad = function (container) {
        const timeStr = $(container).data("timeout_date");
        if (!timeStr) return;
        window.jelenewHeaderAnimateArr.push({
          target: $(".jelenew-timeout-container", container)[0],
          // type: "show",
        });
        const timestamp = new Date(timeStr).getTime();
        // 当前时间剩余倒计时秒数
        let timeout_seconds = timestamp - new Date().getTime();
        timeout_seconds = Math.floor(timeout_seconds / 1000);
        let setTimer = setInterval(() => {
          // 当前时间 > 约定倒计时开始时间 -> 开始倒计时
          if (timeout_seconds > 0) {
            timeout_seconds--;
            let s, m, h;
            h = Math.floor(timeout_seconds / (60 * 60));
            m = Math.floor((timeout_seconds - h * 60 * 60) / 60);
            s = timeout_seconds - h * 60 * 60 - m * 60;
            $(".time-out-container", container).text(`${jelenewPrefixZero(h)}: ${jelenewPrefixZero(m)}: ${jelenewPrefixZero(s)}`);
            if (timeout_seconds < 0) {
              clearInterval(setTimer);
              $(".time-out-container", container).text(`-- : -- : --`);
            }
          }
        }, 1000);
        $(window).on("throttled-scroll", function () {
          if ($(container)[0].getBoundingClientRect().top < 0) {
            $(".jelenew-timeout-container", container).addClass("fixed");
          } else {
            $(".jelenew-timeout-container", container).removeClass("fixed");
          }
        });
      };
    })();

    theme.jelenewFridayImgs = new (function () {
      this.onSectionLoad = function (container) {
        $("a", container).on("click", function () {
          sensors.track(theme.jelenew_event_name, {
            element_name: $(this).find(".jelenew_friday_imgs_item_con").text().trim(),
            page_position: theme.jelenew_web_page_name,
            active_name: theme.jelenew_active_name,
          });
        });
      };
    })();
    theme.jelenewFixedNav = new (function () {
      this.onSectionLoad = function (container) {
        $("a", container).on("click", function () {
          sensors.track("ClickHomeElement", {
            element_name: "导航快捷入口",
            page_position: "首页",
            button_name: $(this).text().trim(),
          });
        });
      };
    })();
    theme.jelenewImageGrid = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-image-grid-template", container);
      };
    })();
    theme.jelenewSocialImgText = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-social-img-text-template", container);
      };
    })();
    theme.jelenewLocalParnter = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-local-parnter-template", container);
      };
    })();
    theme.jelenewKatiaDella = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-katia-della-template", container);
      };
    })();
    theme.jelenewStoryBanner = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-story-banner-template", container);
      };
    })();
    theme.jelenewImageSortText = new (function () {
      this.onSectionLoad = function (container) {
        jelenewSectionAppendTemplate(".jelenew-image-sort-text-template", container);
      };
    })();
    theme.jelenewProductBubble = new (function () {
      this.onSectionLoad = function (container) {
        $(".handle", container).on("click", function () {
          if ($(container).hasClass("active")) {
            $(".product-bubble-box", container).css("transform", `scale(0)`);
            $(container).removeClass("active");
            $(container).trigger("close");
            return false;
          }
          $(container).trigger("open");
          $("body [data-section-type='jelenew-product-bubble'].active").each(function () {
            $(this).removeClass("active");
            $(".product-bubble-box", this).css("transform", `scale(0)`);
          });
          $(container).toggleClass("active");
          const left_p =
            window.innerWidth >= 768
              ? $(container).attr("style").split(";")[0].split(":")[1].replace("%", "").trim() * 1
              : $(container).attr("style").split(";")[2].split(":")[1].replace("%", "").trim() * 1;
          const top_p =
            window.innerWidth >= 768
              ? $(container).attr("style").split(";")[1].split(":")[1].replace("%", "").trim() * 1
              : $(container).attr("style").split(";")[3].split(":")[1].replace("%", "").trim() * 1;

          let left = 30;
          if (
            // left_p > 50 ||
            // window.innerWidth - container.getBoundingClientRect().left - container.offsetWidth < $(".product-bubble-box", container).width() + 40
            $(container).parent().parent().width() - $(container).parent()[0].offsetLeft - container.offsetLeft <
            $(".product-bubble-box", container).width()
          ) {
            left = -$(".product-bubble-box", container).width() - 10;
          }
          const top = -(($(".product-bubble-box", container).height() * (top_p + 5)) / 100);
          $(".product-bubble-box", container).css({
            transform: `scale(1)`,
            "transform-origin": `${-left}px ${-top}px`,
            top: `${top}px`,
            left: `${left}px`,
          });
        });
        $(".actions a", container).on("click", function (e) {
          if ($("body").data("page-type") == "product" && window.location.href.includes($(this).attr("href"))) {
            e.preventDefault();
            e.stopPropagation();
            $("jelenew-product-variant-picker")[0].submitForm();
            return false;
          }
        });
        $(".actions svg", container).on("click", function () {
          $(this).closest(".actions").find("a").trigger("click");
        });
      };
      this.functions = {};
    })();
    // 发送邮件信息
    theme.jelenewSendMail = new (function () {
      this.onSectionLoad = function (container) {
        const _this = this;
        const links = ["/pages/meet-marjorie-rossetti", "/pages/jelenew-100-with-marjorie-rossetti", "/pages/2025-pre-tour-de-france-ride"];
        const root = Shopify.routes.root == "/" ? "" : Shopify.routes.root;
        if (!links.includes(root + location.pathname)) {
          if (window.jelenew.customer.email) {
            // 如果存在邮箱信息, 隐藏
            // $(container).hide(); // 活动期间全体展示
          }
        }
        $(container).on("click", ".jelenew-send-mail-close", function () {
          $(".jelenew-send-mail-content", container).hide();
        });
        $(container).on("click", ".jelenew-send-mail-icon", function () {
          if ($(this).find(".jelenew-send-mail-link").length == 0) {
            $(".jelenew-send-mail-content", container).show();
          }
        });
        // 保存地址
        $(container).on("click", ".send-mail", function (e) {
          const $btn = $(this);
          e.stopPropagation(), e.preventDefault();
          // 获取表单元素
          const form = $(".send-mail-form form", container)[0];
          // 使用 FormData 对象将表单数据序列化
          const formData = new URLSearchParams();
          formData.append("form_type", "contact");
          formData.append("utf8", "✓");
          formData.append("contact[email]", $("input[name='contact[email]']", form).val());
          formData.append("contact[name]", $("input[name='contact[name]']", form).val());
          formData.append("contact[request-type]", $("select[name='contact[request-type]']", form).val());
          formData.append("contact[body]", $("textarea[name='contact[body]']", form).val());
          const mediaList = Array.from(_this.mediaMap.values());
          formData.append("contact[media-list]", mediaList.join(","));
          // if ($("input[name='id']", form).val()) {
          //   formData.append("_method", "put");
          // }
          var email = $("input[name='contact[email]']", form).val();
          var emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          if (!email || !emailReg.test(email)) {
            theme.JelenewTips(theme?.jsUse?.tips?.check_email);
            return;
          }
          if ($("input[name='contact[name]']", form).val() == "") {
            theme.JelenewTips("enter one user name");
            return;
          }
          if ($("textarea[name='contact[body]']", form).val() == "") {
            theme.JelenewTips("Please enter a problem description");
            return;
          }

          let url = "/contact";
          fetch(url, {
            // 替换为你的服务器地址
            method: "POST", // 这里依然使用 POST 方法
            headers: {
              "Content-Type": "application/x-www-form-urlencoded", // 设置表单格式
            },
            redirect: "manual", // 手动处理重定向
            body: formData.toString(), // 将表单数据序列化为字符串
          })
            .then((response) => {
              if (response.status === 302) {
              } else {
                // 处理正常响应
                theme.JelenewTips(
                  {
                    title: "Send Successfully",
                  },
                  "success"
                );
              }
            })
            .finally(() => {
              $(".jelenew-send-mail-content", container).hide();
              sensors.track("SubmitMessage", {
                page_position: theme.jelenew_web_page_name,
                model: "ContactUsViaEmail",
                user_name: $("input[name='contact[name]']", form).val(),
                email: $("input[name='contact[email]']", form).val(),
                subject: $("select[name='contact[request-type]']", form).val(),
                message: $("textarea[name='contact[body]']", form).val(),
              });
            });
          return false;
        });
        window.jelenew.functions.uploadImgAction(container, _this);
      };
      this.functions = {};
    })();
    theme.jelenewSharePopup = new (function () {
      this.onSectionLoad = function (container) {
        const _this = this;
        const act_id = "act-share-friends";
        this.container = container;
        $(document).on("click", "a[href='#jelenew-share-popup-open']", function (e) {
          console.log("click share", e);
          e.preventDefault();
          e.stopPropagation();
          theme.jelenewSharePopup.open();
        });
        $(container).on("click", ".jelenew-share-popup-container-close", function (e) {
          e.preventDefault();
          e.stopPropagation();
          theme.jelenewSharePopup.close();
        });

        // 分享
        $(".share-email-input", container).on("blur", function () { 
          const email = $(this).val();
          var emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          if (!email || !emailReg.test(email)) {
            $(".email.form-item .tip", container).hide();
            $(".email.form-item .warn", container).show();
            return false;
          } else {
            $(".email.form-item .tip", container).show();
            $(".email.form-item .warn", container).hide();
          }
        });
        $(container).on("click", ".get-share-link-btn", function (e) {
          const $btn = $(this);
          $btn.attr("disabled", true);
          e.stopPropagation(), e.preventDefault();
          const email = $(".share-email-input", container).val();
          var emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          if (!email || !emailReg.test(email)) {
            $btn.removeAttr("disabled");
            $(".email.form-item .tip", container).hide();
            $(".email.form-item .warn", container).show();
            return;
          }
          jelenewHttp
            .post("/api/shop/ambassador/activity", {
              diffUser: true,
              actId: act_id,
              actTitle: act_id,
              type: act_id,
              email,
              name: $(".your-name-input", container).val(),
            })
            .then(({ result }) => {
              $(".email.form-item .tip", container).show();
              $(".email.form-item .warn", container).hide();
              const replaceLink = `${location.origin + location.pathname}?actId=${act_id}&ownerCode=${result.info.ownerCode}`;
              const replaceText = `You’re Invited to Ride with Jelenew! 🚴
 Join the ride with me and enjoy 20% off your first order. It’s simple: use my link to shop, claim your discount, and start your journey with Jelenew. Every ride begins with the right gear—don’t miss it! ✨`;
              $(".jelenew-share-popup-success-list-item", container).each(function () { 
                const href = $(this).attr("href").replace("replaceLink", encodeURIComponent(replaceLink)).replace("replaceText", encodeURIComponent(replaceText));
                $(this).attr("href", href);
              });
              $(".jelenew-share-popup-form-success-link", container).val(replaceLink);
              $(".jelenew-share-popup-form-success", container).show();
              $(".jelenew-share-popup-form", container).hide();
              $(".jelenew-share-popup-discount", container).hide();
            })
            .finally(() => {
              $btn.removeAttr("disabled");
            });
        });
        // 复制
        $(container).on("click", ".jelenew-share-popup-form-success-link-container .icon-box", function () {
          window?.jelenew?.functions?.copyText($(".jelenew-share-popup-form-success-link", container).val());
        });
        $(container).on("click", ".jelenew-share-popup-discount-code-btn", function () {
          const code = $(this).find(".code").text().trim();
          window?.jelenew?.functions?.copyText(code);
        });
        // 发送折扣码邮件
        $(container).on("click", ".send-discount-code-btn", function (e) {
          const email = $(".jelenew-share-popup-discount-email-input", container).val().trim();
          var emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          if (!email || !emailReg.test(email)) {
            theme.JelenewTips("Please fill in the correct email address");
            return false;
          }
          const discountCode = $(".jelenew-share-popup-discount-code-btn .code", container).text().trim();
          jelenewHttp.post("/api/shop/ambassador/activity/saveCode", { email, discountCode }).then(() => {
            theme.JelenewTips(
              {
                title: "The discount code has been sent to your email",
              },
              "success"
            );
          });
        });

        function getQueryParam(name) {
          const url = new URL(window.location.href);
          return url.searchParams.get(name);
        }
        const actId = getQueryParam("actId");
        const ownerCode = getQueryParam("ownerCode");
        if (actId && ownerCode && actId == act_id) {
          jelenewHttp.post("/api/shop/ambassador/activity/exchangeCode", { actId, ownerCode }).then(({ result }) => {
            if (result && result.info && result.info.discountCode) {
              $(container).find(".jelenew-share-popup-discount-code-btn .code").text(result.info.discountCode);
              $(".discount-time", container).text(result.info.expireTime);
              $(".jelenew-share-popup-form", container).hide();
              $(".jelenew-share-popup-form-success", container).hide();
              $(".jelenew-share-popup-discount", container).show();
              theme.jelenewSharePopup.open();
            }
          });
        } else if (location.hash == "#jelenew-share-popup-open") {
          theme.jelenewSharePopup.open();
        }
      };
      this.open = function () {
        const _this = this;
        $(".jelenew-share-popup-container", _this.container).addClass("show");
      };
      this.close = function () {
        const _this = this;
        $(".jelenew-share-popup-container", _this.container).removeClass("show");
        setTimeout(() => {
          $(".jelenew-share-popup-form", _this.container).show();
          $(".jelenew-share-popup-form-success", _this.container).hide();
          $(".jelenew-share-popup-discount", _this.container).hide();
        }, 300);
      };
    })();
    theme.Sections.register("jelenew-share-popup", theme.jelenewSharePopup, { deferredLoad: false });
    // lzq -- 2022.05.30 -- 公共函数

    theme.JelenewTips = function (data, type = "warn", timeout = 4000) {
      let time_key = new Date().getTime();
      let typeIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
            <path d="M512 0C229.222 0 0 229.222 0 512s229.222 512 512 512 512-229.222 512-512S794.778 0 512 0zm0 238.95c18.842 0 34.15 15.258 34.15 34.1V614.4a34.15 34.15 0 0 1-68.3 0V273.05c0-18.842 15.308-34.1 34.15-34.1zM512 768a34.15 34.15 0 1 0 0-68.25 34.15 34.15 0 0 0 0 68.25zm0 192a448 448 0 1 1 0-896 448 448 0 0 1 0 896z"/>
        </svg>`;
      if (type == "success") {
        typeIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <path d="M730.675 329.114l-298.7 298.7-138.599-138.7a31.232 31.232 0 0 0-44.186 44.185l156.98 156.98c1.024 1.535 1.69 3.225 3.072 4.607 6.246 6.247 14.54 9.216 22.835 8.96a31.078 31.078 0 0 0 22.835-9.01c1.382-1.332 2.048-3.073 3.072-4.609L774.912 373.3a31.232 31.232 0 0 0-44.186-44.185zM512 0C229.222 0 0 229.222 0 512s229.222 512 512 512 512-229.222 512-512S794.778 0 512 0zm0 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896z"/>
          </svg>`;
      }
      let $jelenewTips = $(`<div class="jelenew-tips" id="jelenew-tip-id-${time_key}">
          <div class="jelenew-tips-icon-container">
              ${typeIcon}
          </div>
          <div class="jelenew-tips-text-container">
              <h6 class="jelenew-tips-title Futuran" style="margin-bottom: 0px;color: inherit;"></h6>
              <p class="jelenew-tips-text" style="margin-bottom: 0px;"></p>
          </div>
      	</div>`);
      if (typeof data === "string") {
        $jelenewTips.find(".jelenew-tips-text").text(data);
        $jelenewTips.find("svg[data-tips-type=warn]").addClass("jelenew-tips-show-icon");
      } else {
        if (data.title) {
          $jelenewTips.find(".jelenew-tips-title").text(data.title);
        }
        $jelenewTips.find(".jelenew-tips-text").text(data.text);
        $jelenewTips.find("svg[data-tips-type=" + type + "]").addClass("jelenew-tips-show-icon");
      }

      let $tipsContainer = $(".jelenew-tips-container");
      if ($tipsContainer.length == 0) {
        $tipsContainer = $(`<div class="jelenew-tips-container"></div>`);
        $tipsContainer.append($jelenewTips);
        $("body").append($tipsContainer);
        $jelenewTips.css({
          opacity: 1,
          display: "flex",
          transform: "translateY(200%)",
        });
        setTimeout(() => {
          $("body").find(`#jelenew-tip-id-${time_key}`).remove();
          if ($tipsContainer.find(".jelenew-tips").length == 0) {
            $("body").find(`.jelenew-tips-container`).remove();
          }
        }, timeout);
        return `#jelenew-tip-id-${time_key}`;
      }
    };
    // lzq -- 2022.05.30 -- 公共函数

    theme.wishList = function () {
      //心愿单处理逻辑
      var wishList = JSON.parse(localStorage.getItem("jelenewWishList"));
      if (wishList && wishList.length) {
        $(".jelenew-my-wish-product").each(function () {
          _this = $(this);
          var productId = $(this).data("product-id");
          wishList.forEach(function (item) {
            if (item.productId == productId) {
              _this.find(".jelenew-wish-hollow").hide();
              _this.find(".jelenew-wish-solid").show();
            }
          });
        });
        //bubble展示
        showWishListNotificationBubble();
      }
      // 接触时间重复绑定
      $(".jelenew-my-wish-product").off("click", ".jelenew-wish-hollow");
      $(".jelenew-my-wish-product").off("click", ".jelenew-wish-solid");
      // 添加收藏
      $(".jelenew-my-wish-product").on("click", ".jelenew-wish-hollow", function () {
        $(this).hide();
        $(this).siblings().show();
        var wishList = JSON.parse(localStorage.getItem("jelenewWishList"));
        var product = {
          productId: $(this).parent().data("product-id"),
          productPrice: $(this).parent().data("product-price"),
          productTitle: $(this).parent().data("product-title"),
          productImage: $(this).parent().data("product-image"),
          productHandle: $(this).parent().data("product-handle"),
        };
        if (wishList) {
          var productIds = [];
          wishList.forEach(function (item) {
            productIds.push(item.productId);
          });
          if (productIds.indexOf(product.productId) == -1) {
            wishList.push(product);
            //wish添加成功提示
            addWishTips(product.productImage);
          }
        } else {
          wishList = [];
          wishList.push(product);
          //wish添加成功提示
          addWishTips(product.productImage);
          //bubble展示
          showWishListNotificationBubble();
        }
        localStorage.setItem("jelenewWishList", JSON.stringify(wishList));
        let matchStr = location.pathname.match("[^/]+(?!.*/)");
        let $item = $(this).closest(".jelenew-my-wish-product");
        sensors.track("ClickWish", {
          page_position: theme.jelenew_web_page_name,
          category_name: matchStr ? matchStr[0] : "",
          element_name: "",
          original_price: theme.jelenew_money_to_number($item.data("product-price")),
          product_id: $item.data("product-id"),
          product_name: $item.data("product-title"),
          sku_id: $item.data("sku"),
          skc_id: $item.data("skc"),
          spu_id: $item.data("spu"),
        });
      });
      // 取消收藏
      $(".jelenew-my-wish-product").on("click", ".jelenew-wish-solid", function () {
        $(this).hide();
        $(this).siblings().show();
        var wishList = JSON.parse(localStorage.getItem("jelenewWishList"));
        var product = {
          productId: $(this).parent().data("product-id"),
          productPrice: $(this).parent().data("product-price"),
          productTitle: $(this).parent().data("product-title"),
          productImage: $(this).parent().data("product-image"),
          productHandle: $(this).parent().data("product-handle"),
        };
        if (wishList.length > 0) {
          wishList.forEach(function (item, index) {
            if (item.productId == product.productId) {
              wishList.splice(index, 1);
            }
          });
        }
        addWishTips(product.productImage, "remove");
        localStorage.setItem("jelenewWishList", JSON.stringify(wishList));
        //神策埋点
        let matchStr = location.pathname.match("[^/]+(?!.*/)");
        sensors.track("ClickDeleteWishProducts", {
          page_position: theme.jelenew_web_page_name,
          category_name: matchStr ? matchStr[0] : "",
          product_name: product.productTitle,
          product_id: product.productId,
          original_price: theme.jelenew_money_to_number(product.productPrice),
          sku_id: $(this).parent().data("sku"),
          skc_id: $(this).parent().data("skc"),
          spu_id: $(this).parent().data("spu"),
        });
      });

      function addWishTips(image, type = "add") {
        var tipsStr = "This product has been added to your wishlist";
        if (type != "add") {
          tipsStr = "This product has been removed from your wishlist";
        }
        //删除上次的插入dom
        $(".jelenew-add-wish-tips").remove();
        var index = image.lastIndexOf(".");
        var suffixName = image.substr(index);
        var imagePath = image.substr(0, index);
        var wishHtml =
          `<div class="jelenew-add-wish-tips">
                    <div class="wish-product-image lazyload--placeholder">
                      <img class="lazyload fade-in"
                        data-src="${imagePath}_{width}x${suffixName}"
                        data-widths="[180, 220, 300, 360, 460, 540, 750, 900, 1080, 1296, 1512, 1728, 2048]"
                        data-aspectratio="1.0"
                        data-sizes="auto"
                      >
                    </div>
                    <div class="wish-product-tips">
                      <div>` +
          tipsStr +
          `</div>
                      <a class="access-wish-list" href="${Shopify.routes.root}pages/wishlist">Access your wishlist</a>
                    </div>
                </div>`;
        $("body").append(wishHtml);
        $("body").addClass("reveal-wish-layer");
        setTimeout(function () {
          $("body").removeClass("reveal-wish-layer");
          $(".jelenew-add-wish-tips").fadeOut();
        }, 2000);
      }

      function showWishListNotificationBubble() {
        if (!$(".wish-list-notification-bubble").hasClass("show-wish-list-notification-bubble")) {
          $(".wish-list-notification-bubble").addClass("show-wish-list-notification-bubble");
        }
      }
    };

    // dom ready
    $(function ($) {
      var $ = $; // keep this ref local

      theme.wishList();

      //size guide处理逻辑
      $(document).on("click", ".jelenew-detail-size-guide", function () {
        $("body").addClass("jelenew-size-guide-popup-show");
        $(".page-shade").css("z-index", 7000);
      });
      $(document).on("click", ".jelenew-size-guide-popup-close", function () {
        $("body").removeClass("jelenew-size-guide-popup-show");
        $(".page-shade").css("z-index", "");
      });
      $(document).on("click", ".jelenew-size-guide-radio", function () {
        var self = $(this).text().trim();
        var siblings = $(this).siblings().text().trim();
        $(this).find(".jelenew-size-guide-radio-icon").addClass("jelenew-size-guide-radio-selected");
        $(this).siblings().find(".jelenew-size-guide-radio-icon").removeClass("jelenew-size-guide-radio-selected");

        $(".jelenew-size-guide-table-" + self).show();
        $(".jelenew-size-guide-table-" + siblings).hide();
      });

      //新版size guide处理逻辑
      $(document).on("click", ".jelenew-new-size-guide .size-guide-item-type", function () {
        $(this).addClass("selected");
        $(this).siblings().removeClass("selected");
        var parent = $(this).parent();
        var index = $(this).index();
        var jelenew_new_size_guide__unit = parent.siblings(".jelenew-new-size-guide__unit").eq(index);
        jelenew_new_size_guide__unit.show();
        jelenew_new_size_guide__unit.siblings(".jelenew-new-size-guide__unit").hide();
        if (index == 3) {
          $(".jelenew_size_guide_recommend_wrap").css({ display: "none" });
        } else {
          $(".jelenew_size_guide_recommend_wrap").css({ display: "block" });
        }
        //埋点
        // sensors.track("ClickDetailsElement", {
        //   tab_name: $(this).text(),
        //   position: parent
        //     .siblings(".jelenew-new-size-guide-country")
        //     .find(".jelenew-new-size-guide-current-country .current-country-full-name")
        //     .text(),
        //   page_position: $(this).parents(".jelenew-new-size-guide").data("source") == "product_detail" ? "商品详情页" : "SIZEGUIDE弹层页",
        //   product_id: $(this).closest(".jelenew-new-size-guide").data("product-id")
        //     ? $(this).closest(".jelenew-new-size-guide").data("product-id")
        //     : "",
        // });
      });

      // $(document).on("click", ".jelenew-new-size-guide .jelenew-new-size-guide-country", function () {
      //   if ($(this).hasClass("jelenew-new-size-guide-country-show")) {
      //     $(this).removeClass("jelenew-new-size-guide-country-show");
      //   } else {
      //     $(this).addClass("jelenew-new-size-guide-country-show");
      //   }
      // });
      // $(document).on("click", ".jelenew-new-size-guide .country-list-detail", function (event, source) {
      //   event.stopPropagation();
      //   var child = $(this).children().clone();
      //   var parent = $(this).parent();
      //   parent.siblings().empty().append(child);
      //   var country_abbr = parent.siblings().find(".current-country-abbr").text();
      //   $(".general-size-chart-country").hide();
      //   $(".general-size-chart-" + country_abbr).show();
      //   $(".jelenew-new-size-guide .jelenew-new-size-guide-country").removeClass("jelenew-new-size-guide-country-show");
      //   //区分国家切换尺码单位
      //   // var unit_conversion = $(".jelenew-new-size-guide .unit-conversion");
      //   // if (country_abbr == "US" || country_abbr == "UK") {
      //   //   unit_conversion.each(function (index, item) {
      //   //     if (!$(item).hasClass("unit-conversion-right")) {
      //   //       $(item).trigger("init", ["auto-trigger"]);
      //   //     }
      //   //   });
      //   // } else {
      //   //   unit_conversion.each(function (index, item) {
      //   //     if ($(item).hasClass("unit-conversion-right")) {
      //   //       $(item).trigger("init", ["auto-trigger"]);
      //   //     }
      //   //   });
      //   // }
      //   //埋点
      //   if (source != "auto-trigger") {
      //     sensors.track("ClickDetailsElement", {
      //       choose_type: $(this).find(".current-country-full-name").text(),
      //       page_position: $(this).parents(".jelenew-new-size-guide").data("source") == "product_detail" ? "商品详情页" : "SIZEGUIDE弹层页",
      //       product_id: $(this).closest(".jelenew-new-size-guide").data("product-id")
      //         ? $(this).closest(".jelenew-new-size-guide").data("product-id")
      //         : "",
      //     });
      //   }
      // });

      $(document).on("click init", ".jelenew-new-size-guide .jelenew-unit-conversion .unit", function (event, source) {
        if ($(this).hasClass("active")) {
          return;
        }
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        const unit = $(this).data("unit");
        let jelenew_new_size_guide_td = $(this).parents(".jelenew-new-tabs").find("td[data-in]");

        jelenew_new_size_guide_td.each(function (index, item) {
          var size_guide_in = $(item).data(unit);
          $(item).text(size_guide_in);
        });
        //埋点
        if (source != "auto-trigger") {
          // sensors.track("ClickDetailsElement", {
          //   element_name: unit,
          //   tab_name: $(this).closest(".jelenew-new-size-guide").find(".size-guide-item-type.selected").text(),
          //   position: $(this).closest(".jelenew-new-size-guide").find(".jelenew-new-size-guide-current-country .current-country-full-name").text(),
          //   page_position: $(this).parents(".jelenew-new-size-guide").data("source") == "product_detail" ? "商品详情页" : "SIZEGUIDE弹层页",
          //   product_id: $(this).closest(".jelenew-new-size-guide").data("product-id")
          //     ? $(this).closest(".jelenew-new-size-guide").data("product-id")
          //     : "",
          // });
        }
      });

      //buy it now 按钮添加loading
      $(document).on("click", ".shopify-payment-button__button", function () {
        $(this).wrap("<div></div>");
        $(this).parent().css("position", "relative");
        $(this).css("color", "#1e0e0e");
        $(this).append('<div class="loading-layer"><div class="jelenew-loading-spinner"></div></div>');
      });
      //checkout 结算按钮添加loading
      $(document).on("click", "input[value='CHECKOUT']", function () {
        $(this).addClass("btnlazyload");
        $(this).parent().addClass("btnlazyload");
        //          $(this).wrap("<div></div>");
        //          $(this).parent().css('position', 'relative')
        //          $(this).css('color','#1e0e0e')
        //          console.log($(this).css("color"))
        // $(this).parent().append('<div class="loading-layer"><div class="jelenew-loading-spinner"></div></div>');
      });

      $(document).on("keyup.themeTabCheck", function (evt) {
        if (evt.keyCode === 9) {
          $("body").addClass("tab-used");
          $(document).off("keyup.themeTabCheck");
        }
      });

      /// Reusable function to expand/contract a div
      // $(document).on("click", "a[data-toggle-target]", function (e) {
      //   e.preventDefault();
      //   var $toggler = $(this),
      //     $target = $($(this).data("toggle-target")),
      //     $transCont = $target.find(".toggle-target-container"),
      //     doCollapse = !$target.hasClass("toggle-target--hidden");
      //   var transitionDuration =
      //     $target.css("transition-duration").indexOf("ms") >= 0
      //       ? parseInt($target.css("transition-duration"))
      //       : parseFloat($target.css("transition-duration")) * 1000;
      //   if (!$target.data("toggle-in-progress")) {
      //     $target.data("toggle-in-progress", true);
      //     if (doCollapse) {
      //       $toggler.addClass("toggle-target-toggler--is-hidden");
      //       $target.css({
      //         height: $transCont.outerHeight() + "px",
      //         opacity: 1,
      //       });

      //       setTimeout(function () {
      //         $target.css({
      //           height: 0,
      //           opacity: 0,
      //         });

      //         setTimeout(function () {
      //           $target.addClass("toggle-target--hidden");
      //           $target.css({
      //             height: "",
      //             opacity: "",
      //           });

      //           $target.data("toggle-in-progress", false);
      //         }, transitionDuration);
      //       }, 10);
      //     } else {
      //       $toggler.removeClass("toggle-target-toggler--is-hidden");
      //       $target.css({
      //         height: 0,
      //         opacity: 0,
      //         display: "block",
      //       });

      //       setTimeout(function () {
      //         $target.css({
      //           height: $transCont.outerHeight() + "px",
      //           opacity: 1,
      //         });

      //         setTimeout(function () {
      //           $target.removeClass("toggle-target--hidden");
      //           $target.css({
      //             height: "",
      //             opacity: "",
      //             display: "",
      //           });

      //           $target.data("toggle-in-progress", false);
      //         }, transitionDuration);
      //       }, 10);
      //     }
      //   }
      // });

      //Redirect dropdowns
      $(document).on("change", "select.navdrop", function () {
        window.location = $(this).val();
      });

      /// Mobile nav
      var bodyScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      window.addEventListener("throttled-scroll", function () {
        bodyScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      });
      $(document).on("click", ".mobile-nav-toggle", function (e) {
        e.preventDefault();
        if ($("body").hasClass("enable-mobile-nav-transition")) {
          $("body").removeClass("reveal-mobile-nav");
          setTimeout(function () {
            $("body").removeClass("enable-mobile-nav-transition");
          }, 750);
        } else {
          $("body").addClass("enable-mobile-nav-transition");
          // 新增逻辑-->关闭搜索浮层
          $("body").removeClass("show-search");
          // 新增逻辑 --> 检测header距顶部距离，设置定位top
          let pageHeaderTop = $("#pageheader")[0].getBoundingClientRect().top;
          $(".mobile-navigation-drawer").css("top", pageHeaderTop + $("#pageheader").height());

          // --------------------------------------
          setTimeout(function () {
            $("body").addClass("reveal-mobile-nav");

            // on reveal, set up internal transition values
            $(".mobile-navigation-drawer .disclosure").each(function () {
              var $list = $(".disclosure-list", this),
                listHeight = 0;
              $list.children().each(function () {
                listHeight += $(this).height();
              });
              $(".disclosure-list", this).css("height", listHeight + "px");
            });

            // on reveal, load product carousel
            $(".mobile-navigation-drawer .product-list").each(function () {
              theme.ProductBlockManager.loadImages($(this));
            });
          }, 10);
        }

        //自定义样式处理
        $(".mobile-navigation-drawer").css({
          background: "#fff",
          transition: "all .5s",
        });
      });

      /// General window shade
      $('<a href="#" class="page-shade" aria-label="' + theme.strings.general_navigation_menu_toggle_aria_label + '"></a>')
        .on("click", function () {
          $("body").removeClass("reveal-mobile-nav show-search");
          $("body").removeClass("enable-mobile-shop-now-transition");
          setTimeout(function () {
            $("body").removeClass("enable-mobile-nav-transition");
          }, 750);
          return false;
        })
        .appendTo("body");

      if (theme.settings.quickbuy_style != "off") {
        theme.loadQuickbuy();
      }

      /// Event for initialising options
      $(document).on("load-product-form", ".product-form", function (e) {
        if ($(this).data("product-id") === "") {
          return;
        }

        // events on option change
        $(this).on("variantChanged", function (evt, variant) {
          var $labelCont = $(this).closest(".product-detail").find(".product-label-container");
          $labelCont.find(".product-label").remove();
          $labelCont.append($("#variant-label-" + variant.id).html());
        });

        theme.OptionManager.initProductOptions($(this));

        // If we have clicky boxes, add the disabled-state to options that have no valid variants
        if ($(this).find(".option-selector__btns").length) {
          // product form may have changed height. If in quick buy, resize container
          $(this).closest(".quickbuy-container").trigger("changedsize");

          var productData = theme.OptionManager.getProductData($(this));

          // each option
          for (var optionIndex = 0; optionIndex < productData.options.length; optionIndex++) {
            // list each value for this option
            var optionValues = {};
            for (var variantIndex = 0; variantIndex < productData.variants.length; variantIndex++) {
              var variant = productData.variants[variantIndex];
              if (typeof optionValues[variant.options[optionIndex]] === "undefined") {
                optionValues[variant.options[optionIndex]] = false;
              }
              // mark true if an option is available
              if (variant.available) {
                optionValues[variant.options[optionIndex]] = true;
              }
            }
            // mark any completely unavailable options
            for (var key in optionValues) {
              if (!optionValues[key]) {
                $(".option-selector:eq(" + optionIndex + ") .opt-btn", this)
                  .filter(function () {
                    return $(this).val() == key;
                  })
                  .addClass("is-unavailable");
              }
            }
          }
        }
      });

      /// Galleries (inc. product page)

      // when variant changes, and the variant has an image
      $(document).on("variantImageSelected", ".gallery", function (e, data) {
        // get image src
        var mediaId = data.featured_media.id;

        // locate matching thumbnail
        $(this)
          .find('.thumbnails a[data-media-id="' + mediaId + '"]:first')
          .trigger("select");
      });

      // click main product image (launch gallery)
      $(document).on("click", ".product-detail .gallery .main-image a.show-gallery", function () {
        var images = [];

        var $thumbs = $(this).closest(".gallery").find(".thumbnails .thumbnail--media-image");
        let currentIndex = localStorage.getItem("thumbnailIndex") || 0;
        if ($thumbs.length) {
          $thumbs.each(function () {
            var $imgThumb = $(this).find(".rimage-outer-wrapper").clone();
            $imgThumb.find(".lazyloaded").removeClass("lazyloaded").addClass("lazyload").parent().addClass("lazyload--placeholder");
            images.push({
              thumbTag: $imgThumb,
              zoomUrl: $(this).attr("href"),
            });
          });
        } else {
          var $imgThumb = $(this).find(".rimage-outer-wrapper").clone();
          $imgThumb.find(".lazyloaded").removeClass("lazyloaded").addClass("lazyload").parent().addClass("lazyload--placeholder");
          images.push({
            thumbTag: $imgThumb,
            zoomUrl: $(this).attr("href"),
          });
        }
        theme.buildGalleryViewer({
          images: images,
          current: currentIndex,
          prev: theme.icons.chevronLeft,
          next: theme.icons.chevronRight,
          close: theme.icons.close,
        });

        return false;
      });

      // load any images that aren't inside a section
      var $nonSectionedProductLists = $(".product-list, .collection-listing").filter(function () {
        return $(this).closest("[data-section-type]").length == 0;
      });
      if ($nonSectionedProductLists.length) {
        theme.ProductBlockManager.loadImages($nonSectionedProductLists);
      }
      $(window).on("debouncedresize", function () {
        setTimeout(function () {
          theme.ProductBlockManager.afterImagesResized(); // empty param req
        }, 100); // after third party stuff
      });

      // forms don't all have correct label attributes
      $("#template label").each(function () {
        var $sibinputs = $(this).siblings('input:not([type="submit"]), textarea');
        if ($sibinputs.length == 1 && $sibinputs.attr("id").length > 0) {
          $(this).attr("for", $sibinputs.attr("id"));
        }
      });

      $(document).on("click", ".quantity-wrapper [data-quantity]", function () {
        var adj = $(this).data("quantity") == "up" ? 1 : -1;
        var $qty = $(this).closest(".quantity-wrapper").find("[name=quantity]");
        if ($qty.attr("step")) {
          adj *= parseInt($qty.attr("step"));
        }
        $qty.val(Math.max(1, parseInt($qty.val()) + adj)).trigger("change");
        return false;
      });

      /// Responsive tables
      $(".responsive-table").on("click", ".responsive-table__cell-head", function (e) {
        if ($(window).width() < 768) {
          if (e.currentTarget.tagName.toUpperCase() == "A" || $("a", e.currentTarget).length > 0) {
          } else {
            $(this).closest("tr").toggleClass("expanded");
          }
          // return false;
        }
      });

      // Enhance video sections for overlays
      if (typeof cc !== "undefined" && cc.sections) {
        for (var sectionKey in cc.sections) {
          var ccSection = cc.sections[sectionKey];
          if (ccSection.name === "video") {
            var t = ccSection.section.onSectionLoad;
            ccSection.section.onSectionLoad = function (container) {
              // Tidier typography
              $(".overlay-text__title, .overlay-text__rte", container).each(function () {
                theme.avoidUnecessaryOrphans(this);
              });
              t.call(this);
            };
          }
        }
      }

      /// Register all sections
      theme.Sections.init();
      theme.Sections.register("slideshow", theme.SlideshowSection);
      theme.Sections.register("gallery", theme.GallerySection);
      // theme.Sections.register("testimonials", theme.TestimonialsSection);
      theme.Sections.register("image-with-text-overlay", theme.ImageWithTextOverlaySection);
      theme.Sections.register("map", theme.MapSection);
      theme.Sections.register("background-video", theme.VideoManager, {
        deferredLoadViewportExcess: 800,
      });
      theme.Sections.register("jelenew-index-video", theme.jelenewIndexVideo, {
        deferredLoadViewportExcess: 800,
      });
      theme.Sections.register("custom-row", theme.CustomRowSection);
      // theme.Sections.register("featured-product", theme.FeaturedProductSection);
      theme.Sections.register("jelenew-header", theme.JelenewHeaderSection, {
        deferredLoad: false,
      });
      theme.Sections.register("header", theme.HeaderSection, {
        deferredLoad: false,
      });
      theme.Sections.register("announcement-bar", theme.AnnouncementBarSection, {
        deferredLoad: false,
      });
      theme.Sections.register("footer", theme.FooterSection, { deferredLoad: false });
      theme.Sections.register("main-product", theme.ProductTemplateSection, {
        deferredLoad: false,
      });

      // theme.Sections.register("collection-template", theme.CollectionTemplateSection, { deferredLoad: false });
      // theme.Sections.register("search-template", theme.SearchTemplateSection, {
      //   deferredLoad: false,
      // });
      theme.Sections.register("blog-template", theme.BlogTemplateSection, {
        deferredLoad: false,
      });
      theme.Sections.register("cart-template", theme.CartTemplateSection, {
        deferredLoad: false,
      });

      // 商品评论
      theme.Sections.register("jelenew-product-review", theme.jelenewProductReview, { deferredLoad: false });

      theme.Sections.register("list-collections-template", theme.ListCollectionsTemplateSection, { deferredLoad: false });
      theme.Sections.register("page-list-collections-template", theme.ListCollectionsTemplateSection, { deferredLoad: false });
      // theme.Sections.register("jelenew-auto-slick", theme.JelenewAutoSlickSection, { deferredLoad: true });

      theme.Sections.register("jelenew-shop-now-detail", theme.jelenewShopNowDetail, { deferredLoad: false });

      theme.Sections.register("jelenew-collection-slide", theme.JelenewCollectionSlide, { deferredLoad: false });
      theme.Sections.register("jelenew-img-big-img", theme.JelenewImgBigImg, {
        deferredLoad: false,
      });
      theme.Sections.register("jelenew-fold-block", theme.jelenewFoldBlock, {
        deferredLoad: false,
      });
      theme.Sections.register("jelenew-slide-img", theme.jelenewSlideImg, {
        deferredLoad: false,
      });
      // theme.Sections.register("jelenew-slide-product", theme.jelenewSlideProduct, { deferredLoad: false });
      theme.Sections.register("jelenew-product-showcase", theme.jelenewProductShowcase, { deferredLoad: true });
      theme.Sections.register("jelenew-product-mesh", theme.jelenewProductMesh, {
        deferredLoad: false,
      });
      theme.Sections.register("jelenew-pro-hot-img-slide", theme.jelenewProHotImgSlide, { deferredLoad: false });
      theme.Sections.register("jelenew-main-pro-three-img", theme.jelenewMainProThreeImg, { deferredLoad: true });
      theme.Sections.register("jelenew-pro-shop-look", theme.jelenewProShopLook, { deferredLoad: true });
      theme.Sections.register("jelenew-pro-shop-look-to-cart", theme.jelenewProShopLookToCart, { deferredLoad: false });
      theme.Sections.register("jelenew-active-look", theme.jelenewActiveLook, { deferredLoad: true });
      theme.Sections.register("jelenew-val-tabs", theme.jelenewValTabs, { deferredLoad: true });
      theme.Sections.register("jelenew-look-list", theme.jelenewLookList, {
        deferredLoad: false,
      });
      theme.Sections.register("jelenew-our-loved", theme.jelenewOurLoved, { deferredLoad: true });
      theme.Sections.register("jelenew-img-product", theme.jelenewImgProduct, { deferredLoad: true });
      theme.Sections.register("jelenew-paris-event-slide", theme.jelenewParisEventSlide, { deferredLoad: false });
      theme.Sections.register("jelenew-product-imgs", theme.jelenewProductImgs, {
        deferredLoad: false,
      });
      theme.Sections.register("jelenew-col-load-more", theme.jelenewColLoadMore, {
        deferredLoad: true,
      });
      theme.Sections.register("jelenew-video-imgs-section", theme.jelenewVideoImgsSection, {
        deferredLoad: false,
      });
      theme.Sections.register("jelenew-text-see-more", theme.jelenewTextSeeMore, {
        deferredLoad: false,
      });

      theme.Sections.register("jelenew-app-vlog-product", theme.jelenewAppVlogProduct, { deferredLoad: false });
      theme.Sections.register("jelenew-app-vlog-name", theme.jelenewAppVlogName, {
        deferredLoad: false,
      });
      theme.Sections.register("jelenew-app-vlog-list", theme.jelenewAppVlogList, {
        deferredLoad: false,
      });
      theme.Sections.register("jelenew-roll-pro-slide", theme.jelenewRollProSlide, { deferredLoad: true });
      theme.Sections.register("jelenew-roll-occ-silde", theme.jelenewRollOccSilde, { deferredLoad: true });
      theme.Sections.register("jelenew-paris-slide", theme.jelenewParisSlide, {
        deferredLoad: false,
      });
      theme.Sections.register("jelenew-red-option-look", theme.jelenewRedOptionLook, { deferredLoad: false });
      theme.Sections.register("jelenew-index-new-arrival", theme.jelenewIndexNewArrival, { deferredLoad: true });
      theme.Sections.register("jelenew_filter_product_list", theme.jelenewFilterProductList, { deferredLoad: false });
      // theme.Sections.register("jelenew-main-search", theme.jelenewMainSearch, {
      //   deferredLoad: false,
      // });
      theme.Sections.register("jelenew-red-pop-main", theme.jelenewRedPopMain, {
        deferredLoad: false,
      });
      theme.Sections.register("jelenew-story-text", theme.jelenewStoryText, {
        deferredLoad: false,
      });
      //捐赠模块
      //theme.Sections.register("jelenew-cart-donation", theme.jelenewCartDonation, { deferredLoad: false });
      // 组合购买列表
      theme.Sections.register("jelenew-bundles-collection", theme.jelenewBundlesCollection, { deferredLoad: true });

      // 组合购买详情
      theme.Sections.register("jelenew-bundle-detail", theme.jelenewBundleDetail, { deferredLoad: false });
      theme.Sections.register("jelenew-strava-imgs-text", theme.jelenewStravaImgsText, { deferredLoad: true });
      theme.Sections.register("jelenew-story-slide", theme.jelenewStorySlide, { deferredLoad: true });
      theme.Sections.register("jelenew-video-item", theme.jelenewVideoItem, { deferredLoad: false });
      // theme.Sections.register("jelenew-filter-collection", theme.jelenewFilterCollection, { deferredLoad: false });
      theme.Sections.register("jelenew-size-guide", theme.jelenewSizeGuide, { deferredLoad: true });
      theme.Sections.register("jelenew-fold-section", theme.jelenewFoldSection, { deferredLoad: true });
      // jelenew-ins-list-index
      theme.Sections.register("jelenew-ins-list-index", theme.jelenewInsListIndexSection, { deferredLoad: true });
      theme.Sections.register("jelenew-ins-list", theme.jelenewInsListSection, { deferredLoad: true });
      theme.Sections.register("jelenew-index-news", theme.jelenewIndexNews, { deferredLoad: true });
      theme.Sections.register("jelenew-index-load-gif", theme.jelenewIndexLoadGif, { deferredLoad: true });

      // {% javascript %}合并至theme.js
      theme.Sections.register("jelenew-brand-concept-new", theme.jelenewBrandConceptNew, { deferredLoad: true });
      theme.Sections.register("jelenew-img-waterfall", theme.jelenewImgWaterfall, { deferredLoad: true });
      theme.Sections.register("jelenew-index-gif", theme.jelenewIndexGif, { deferredLoad: true });
      theme.Sections.register("jelenew-index-gif-skewing", theme.jelenewIndexGifSkewing, { deferredLoad: true });
      theme.Sections.register("jelenew-index-image", theme.jelenewIndexImage, { deferredLoad: true });
      theme.Sections.register("jelenew-index-list", theme.jelenewIndexList, { deferredLoad: true });
      theme.Sections.register("jelenew-our-belief", theme.jelenewOurBelief, { deferredLoad: true });
      theme.Sections.register("jelenew-recommend", theme.jelenewRecommend, { deferredLoad: true });
      theme.Sections.register("jelenew-red-pop-af", theme.jelenewRedPopAf, { deferredLoad: true });
      theme.Sections.register("jelenew-red-pop-top", theme.jelenewRedPopTop, { deferredLoad: true });

      theme.Sections.register("jelenew-common-title", theme.jelenewCommonTitle, { deferredLoad: true });

      // bandstory 图文组件
      theme.Sections.register("jelenew-media-and-text", theme.jelenewMediaAndText, { deferredLoad: true });
      theme.Sections.register("jelenew-amb-video", theme.jelenewAmbVideo, { deferredLoad: true });
      theme.Sections.register("jelenew-keywords-banner", theme.jelenewKeywordsBanner, { deferredLoad: true });

      // 大使页，鼠标划入交互效果组件
      theme.Sections.register("jelenew-hover-image", theme.jelenewHoverImage, { deferredLoad: true });
      theme.Sections.register("jelenew-active-slide", theme.jelenewActiveSlide, { deferredLoad: true });

      // 罗兰页组件
      theme.Sections.register("jelenew-rolland-af", theme.jelenewRollandAf, { deferredLoad: true });

      // 罗兰页组件 尾部轮播组件，带放大功能
      theme.Sections.register("jelenew-swiper", theme.JelenewSwiperSection, { deferredLoadViewportExcess: 800 });
      theme.Sections.register("jelenew-img-slide", theme.jelenewImgSlide, { deferredLoad: true });
      theme.Sections.register("jelenew-paris-text-back", theme.jelenewParisTextBack, { deferredLoad: true });

      // 2023/03/28首页组件
      theme.Sections.register("jelenew-image-with-text", theme.jelenewImageWithTextSection, { deferredLoad: true });
      // theme.Sections.register("jelenew-whats-new", theme.jelenewWhatsNewSection, { deferredLoad: true });
      theme.Sections.register("jelenew-collection-list", theme.jelenewCollectionList, { deferredLoad: true });
      theme.Sections.register("jelenew-subscription", theme.jelenewSubscription, { deferredLoad: true });
      theme.Sections.register("jelenew-member-benefits", theme.jelenewMemberBenefits, { deferredLoad: true });
      theme.Sections.register("jelenew-account-update-info", theme.jelenewAccountUpdateInfo, { deferredLoad: false });
      theme.Sections.register("jelenew-slick-and-text", theme.jelenewSlickAndText, { deferredLoadViewportExcess: 800 });
      theme.Sections.register("recruit-ambassadors-page", theme.recruitAmbassadorsPage, { deferredLoadViewportExcess: 800 });
      theme.Sections.register("jelenew-member-popup", theme.jelenewMemberPopup, { deferredLoad: false });
      theme.Sections.register("jelenew-events-slide", theme.jelenewEventsSlide, { deferredLoadViewportExcess: 800 });

      // 2023/08/24 contact-form
      theme.Sections.register("contact-form", theme.contactForm, { deferredLoad: true });

      theme.Sections.register("jelenew-gift-drawer", theme.jelenewGiftDrawer, { deferredLoad: false });
      // 2023/10/16 collection-footer-seo
      theme.Sections.register("collection-footer-seo", theme.collectionFooterSeo, { deferredLoad: false });

      theme.Sections.register("jelenew-zoom-img", theme.jelenewZoomImg, { deferredLoad: true });

      theme.Sections.register("jelenew-slick-row", theme.jelenewSlickRow, { deferredLoad: true });
      // 2023-11-15 默认页面模板访问报警
      theme.Sections.register("main-page", theme.mainPage, { deferredLoad: false });
      // 2023-11-17
      theme.Sections.register("jelenew-timeout", theme.jelenewTimeout, { deferredLoad: false });
      theme.Sections.register("jelenew-friday-imgs", theme.jelenewFridayImgs, { deferredLoad: true });
      theme.Sections.register("fixed-nav", theme.jelenewFixedNav, { deferredLoad: true });

      theme.Sections.register("jelenew-image-grid", theme.jelenewImageGrid, { deferredLoad: true });
      theme.Sections.register("jelenew-story-banner", theme.jelenewStoryBanner, { deferredLoad: true });
      theme.Sections.register("jelenew-image-sort-text", theme.jelenewImageSortText, { deferredLoad: true });
      theme.Sections.register("jelenew-social-img-text", theme.jelenewSocialImgText, { deferredLoad: true });
      theme.Sections.register("jelenew-product-bubble", theme.jelenewProductBubble, { deferredLoad: false });
      theme.Sections.register("jelenew-local-parnter", theme.jelenewLocalParnter, { deferredLoad: true });
      theme.Sections.register("jelenew-katia-della", theme.jelenewKatiaDella, { deferredLoad: true });

      theme.Sections.register("jelenew-send-mail", theme.jelenewSendMail, { deferredLoad: false });

      theme.Sections.register("jelenew-banner", theme.jelenewBanner, { deferredLoad: false });
      theme.Sections.register("image-banner", theme.imageBanner, { deferredLoad: false });
      theme.Sections.register("featured-content-images", theme.jelenewFeaturedContentImages, { deferredLoad: true });
      theme.Sections.register("jelenew-cart-discount-list-popup", theme.jelenewCartDiscountListPopup, { deferredLoad: false });

    });

    //Register dynamically pulled in sections
    $(function ($) {
      if (cc.sections.length) {
        cc.sections.forEach(function (section) {
          try {
            var data = {};
            if (typeof section.deferredLoad !== "undefined") {
              data.deferredLoad = section.deferredLoad;
            }
            if (typeof section.deferredLoadViewportExcess !== "undefined") {
              data.deferredLoadViewportExcess = section.deferredLoadViewportExcess;
            }
            theme.Sections.register(section.name, section.section, data);
          } catch (err) {
            console.error("Unable to register section ".concat(section.name, "."), err);
          }
        });
      } else {
        console.warn("Barry: No common sections have been registered.");
      }
    });

    //神策埋点
    $(function ($) {
      try {
        //公共元素埋点
        $(".jelenew_text a").on("click", function () {
          sensors.track("ClickHomeElement", {
            element_name: $(this).text().trim(),
            jump_link: "https://www.jelenew.com" + $(this).attr("href"),
            page_position: "首页",
          });
        });
      } catch (error) {
        sensors.track("ServeException", {
          exception_type: "前端错误",
          exception_level: "p2",
          exception_modle: "埋点错误",
          exception_from: "前端",
          exception_reason: JSON.stringify(error),
          exception_modle_sub: "系统报错",
          $url: window.location.href,
        });
      }
    });
  })(theme.jQuery);

  //custom.js
  (function ($) {
    var $ = (jQuery = $);
    $("body").on("click", "a", function (event) {
      const href = $(this).attr("href");
      if (href) {
        if (href.includes("/checkout")) {
          // GTM电子商务数据上报
          let params = {
            event: "begin_checkout",
            ecommerce: {
              currency: window.Shopify.currency.active,
              value: theme.jelenew_money_to_number($(".checkout-subtotal-container__right .total .theme-money").text()),
              coupon: $(".reduction-code__text").text(),
              items: [],
            },
          };
          $(".cart-item-list__body .cart-item").each(function () {
            params.ecommerce.items.push({
              item_id: $(".name", this).data("product_id") || $(this).closest(".cart-item").data("product_id"),
              item_name: $(".name", this).text().trim() || $(".cart-item_title", this).text().trim(),
              item_brand: "JELENEW",
              item_category: $(this).data("product-type"),
              item_variant: $(".name", this).data("variant_id") || $(this).closest(".cart-item").data("line-item-id"),
              price: theme.jelenew_money_to_number($(".theme-money", this).text()),
              quantity: $(".cart-item__quantity-input", this).val() * 1,
              discount: $(this).hasClass("jelenew-cart-item-gift")
                ? theme.jelenew_money_to_number($(".struck-out-price", this).text())
                : theme.jelenew_money_to_number($(".item_save_price", this).text()),
            });
          });
          dataLayer?.push({ ecommerce: null }); // Clear the previous ecommerce object.
          dataLayer?.push(params);
        }
        // 跳转
        window.localStorage.jelenew_page_timestamp = new Date().getTime();
        window.localStorage.jelenew_referrer_link = window.location.origin + $(this).attr("href");

        if (Shopify.routes.root !== "/" && !href.includes("/checkout")) {
          if (href.startsWith("/pages") || href.startsWith("/collections") || href.startsWith("/products")) {
            event.preventDefault(); // 阻止默认跳转行为
            let originalHref = $(this).attr("href"); // 获取原始链接
            // 动态修改并执行跳转
            window.location.href = `${Shopify.routes.root.slice(0, -1)}${originalHref}`;
          }
        }
      }
      // // 锚点
      // if (href.startsWith("#") && href.length > 1 && $(`a[name=${href.substr(1)}]`).length > 0) {
      //   $("html, body").animate({ scrollTop: $(`a[name=${href.substr(1)}]`).offset().top + "px" }, 500);
      //   return false;
      // } else if (href) {
      //   // 跳转
      //   window.localStorage.jelenew_page_timestamp = new Date().getTime();
      //   window.localStorage.jelenew_referrer_link = window.location.origin + $(this).attr("href");
      // }
    });

    // 神策统一埋点
    $("body").on("click", ".sensors-handler", function () {
      $(this).data("sensors-action");
      sensors.track($(this).data("sensors-action"), Object.assign({ page_position: theme.jelenew_web_page_name }, $(this).data("sensors-json")));
    });
    // window.addEventListener(
    //   "error",
    //   (error) => {
    //     sensors.track("allServeException", {
    //       exception_type: "报错全监控",
    //       exception_level: "p2",
    //       exception_modle: (error.target && error.target.outerHTML) || "",
    //       exception_from: "前端",
    //       exception_reason: JSON.stringify(error),
    //       exception_url: window.location.href,
    //       $url: window.location.href,
    //     });
    //     console.error(error);
    //     return true;
    //   },
    //   true
    // );
    // 点击统一预警
    (function clickForewarning() {
      $("body").on("click", function (e) {
        const data = makeForewarnData("jelenew_click_list", {
          selector: getDomSelector(e.target),
          timestamp: new Date().getTime(),
        });
        if (data.length < 3) return;
        // 1s内点击3次，触发预警
        if (
          data[data.length - 1].selector == data[data.length - 2].selector &&
          data[data.length - 1].selector == data[data.length - 3].selector &&
          data[data.length - 1].timestamp - data[data.length - 3].timestamp < 1000
        ) {
          sensors.track("ServeException", {
            exception_from: "前端监控",
            exception_type: "行为异常",
            exception_level: "p1",
            exception_modle: $("body").data("page-type"),
            exception_modle_sub: "重复点击",
            exception_reason: JSON.stringify(data),
          });
        }
      });
    })();
    // 页面重复访问统一预警
    (function pageReloadForewarning() {
      const data = makeForewarnData("jelenew_page_view_list", {
        url: window.location.href,
        timestamp: new Date().getTime(),
      });
      if (data.length < 3) return;
      if (
        data[data.length - 1].url == data[data.length - 2].url &&
        data[data.length - 1].url == data[data.length - 3].url &&
        data[data.length - 1].timestamp - data[data.length - 3].timestamp < 60000
      ) {
        // 最近3次访问相同地址，且间隔小于1min。发出预警
        sensors.track("ServeException", {
          exception_from: "前端监控",
          exception_type: "行为异常",
          exception_level: "p1",
          exception_modle: $("body").data("page-type"),
          exception_modle_sub: "同页面刷新",
          exception_reason: JSON.stringify(data),
        });
      }
    })();
    // 检查媒体资源大小
    // (function observerVideoSize() {
    //   try {
    //     // img, video 初始化检查
    //     $("img").on("load", function (e) {
    //       checkMediaSize(getImgUrl(e.target), "img");
    //     });
    //     $("video").each(function () {
    //       checkMediaSize($(this).attr("src"));
    //     });
    //     // img, video 动态插入检查
    //     const observer = new MutationObserver(function (mutationsList, observer) {
    //       for (let mutation of mutationsList) {
    //         if (mutation.type == "childList" && mutation.addedNodes.length > 0) {
    //           mutation.addedNodes.forEach((node) => {
    //             if (node.tagName == "VIDEO") {
    //               // 插入<video/>
    //               checkMediaSize(node.src);
    //             } else if ($(node).find("video").length > 0) {
    //               // 插入包含<video/>的dom结构
    //               checkMediaSize($(node).find("video").attr("src"));
    //             } else if (node.tagName == "IMG") {
    //               // 插入<img/>
    //               checkMediaSize(getImgUrl(node), "img");
    //             } else if ($(node).find("img").length > 0) {
    //               // 插入包含<img/>的dom结构
    //               $(node)
    //                 .find("img")
    //                 .each(function () {
    //                   checkMediaSize(getImgUrl(this), "img");
    //                 });
    //             }
    //           });
    //         }
    //         if (mutation.type == "attributes" && (mutation.attributeName == "src" || mutation.attributeName == "srcset")) {
    //           if (mutation.target.tagName == "VIDEO") {
    //             checkMediaSize(mutation.target.src);
    //           } else if (mutation.target.tagName == "IMG") {
    //             checkMediaSize(getImgUrl(mutation.target), "img");
    //           }
    //         }
    //       }
    //     });
    //     observer.observe($("body")[0], { attributes: true, childList: true, subtree: true });
    //     // 离开前销毁监控
    //     window.addEventListener("beforeunload", function () {
    //       observer.disconnect();
    //     });
    //     // Method
    //     const checkTypeMap = new Map();
    //     checkTypeMap.set("img", { maxSize: 307200, minSize: 0, name: "图片" });
    //     checkTypeMap.set("video", { maxSize: 5242880, minSize: 0, name: "视频" });
    //     function checkMediaSize(src, type = "video") {
    //       if (!src || typeof src !== "string") return false;
    //       let xhr = new XMLHttpRequest();
    //       // 设置onreadystatechange回调函数，以便在接收响应时读取Content-Length标头xhr.onreadvstatechange
    //       xhr.onreadystatechange = function () {
    //         if (xhr.getResponseHeader("Content-Length")) {
    //           const fileSize = xhr.getResponseHeader("Content-Length"); // 单位改为b
    //           // const fileSize = (xhr.getResponseHeader("Content-Length") / 1024 / 1024).toFixed(2) * 1 || 0;
    //           // console.log(`${xhr.getResponseHeader("Content-Length")}体积:${fileSize}MB,链接:${src}`);
    //           if (fileSize && (fileSize > checkTypeMap.get(type).maxSize || fileSize < checkTypeMap.get(type).minSize)) {
    //             sensors.track("ServeException", {
    //               exception_from: "前端监控",
    //               exception_type: "资源异常",
    //               exception_level: "p1",
    //               exception_modle: $("body").data("page-type"),
    //               exception_modle_sub: `${checkTypeMap.get(type).name}资源异常`,
    //               exception_reason: `${src}`,
    //               exception_size: fileSize,
    //             });
    //             // console.error(`存在${fileSize}MB的${checkTypeMap.get(type).name}(${src}), 请及时检查`);
    //           }
    //         }
    //         xhr.abort();
    //       };
    //       xhr.open("GET", src, true);
    //       xhr.send();
    //     }
    //     function getImgUrl(node) {
    //       let img_url = "";
    //       if (node.getAttribute("aria-hidden") === "true") {
    //         return "";
    //       }
    //       if (node.getAttribute("srcset")) {
    //         img_url = node.getAttribute("srcset").split(", ").pop().split(" ")[0];
    //       } else if (node.getAttribute("src")) {
    //         img_url = node.getAttribute("src");
    //       }
    //       return img_url;
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   }
    // })();
    // 视频完播率
    (function videoCompletionRate() {
      const page_type = $("body").data("page-type");
      const ob_pages = ["index", "product"];
      if (ob_pages.every((pt) => pt != page_type) || $("video").length == 0) return;
      const $video = $("video").eq(0);
      // video开始 =》 分母数据
      $video.one("timeupdate.videoCompletionRate", function () {
        // sensors.track("ClickVideoPlaying", {
        //   page_position: theme.jelenew_web_page_name,
        //   product_name: page_type == "product" ? $(".jelenew-product-name.title").text() : "",
        //   video_url: $(this).attr("src") || $(this).data("src") || $(this).data("video_url"),
        // });
      });
      // video不在可视区域 =》 分子数据
      let interval = setInterval(() => {
        if (
          $video[0].getBoundingClientRect().left < 0 ||
          $video[0].getBoundingClientRect().bottom < 0 ||
          $video.css("visibility") == "hidden" ||
          $("body").css("overflow") == "hidden"
        ) {
          let trigger_condition = "";
          if ($video[0].getBoundingClientRect().left < 0 || ($video.css("visibility") == "hidden" && $("body").data("page-type") == "index")) {
            trigger_condition = "左右滑动";
          } else if (
            $video[0].getBoundingClientRect().bottom < 0 ||
            ($video.css("visibility") == "hidden" && $("body").data("page-type") == "product")
          ) {
            trigger_condition = "上下滑动";
          } else if ($("body").css("overflow") == "hidden") {
            trigger_condition = "浮层遮罩";
          }
          sensorsVideoEnd($video[0].currentTime, $video[0].duration, trigger_condition);
          $video.off("timeupdate.videoCompletionRateB");
          clearInterval(interval);
        }
      }, 500);
      // video播放完毕 =》 分子数据
      $video.on("timeupdate.videoCompletionRateB", function () {
        const { duration, currentTime } = this;
        if (duration - currentTime < 0.3 && !$video.hasClass("video-sensors-done")) {
          sensorsVideoEnd(currentTime, duration, "播放完毕");
          clearInterval(interval);
          $video.off("timeupdate.videoCompletionRateB");
        }
      });
      // 页面离开 =》 分子数据
      $(window).on("visibilitychange.videoCompletionRate", function () {
        sensorsVideoEnd($video[0].currentTime, $video[0].duration, "页面离开");
      });
      function sensorsVideoEnd(currentTime = 0, duration = 0, trigger_condition) {
        if (!$video.hasClass("video-sensors-done")) {
          if (isNaN(currentTime)) currentTime = 0;
          if (isNaN(duration)) duration = 0;
          // sensors.track("VideoEnd", {
          //   page_position: theme.jelenew_web_page_name,
          //   product_name: page_type == "product" ? $(".jelenew-product-name.title").text() : "",
          //   video_url: $video.attr("src") || $video.data("src") || $video.data("video_url"),
          //   currentTime,
          //   duration,
          //   play_schedule: !duration ? 0 : Number(currentTime / duration).toFixed(2) * 1,
          //   trigger_condition,
          // });
          $video.addClass("video-sensors-done");
        }
      }
    })();
    function aftershipObtest() {
      const targetNode = $("body")[0];
      const config = { childList: true, subtree: true };
      const callback = function (mutationsList, observer) {
        for (let mutation of mutationsList) {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach((item) => {
              if ($(item).parents(".r-1awozwy").length) {
                setAftership();
              }
            });
          }
        }
      };
      function setAftership() {
        var changeDom = $(
          ".css-1rynq56.r-8akbws.r-krxsd3.r-dnmrzs.r-1udh08x.r-1udbk01.r-rqu6wu.r-13awgt0.r-167b84g.r-1b43r93.r-13uqrnb.r-b88u0q.r-3ucsff.r-135wba7"
        );
        var changeDomText = changeDom.text().split(" - ")[0];
        if (changeDom.text().split(" - ")[1]) {
          changeDom.text(changeDomText);
        }
      }
      if (window.location.pathname.indexOf("/apps/aftership") > -1) {
        setAftership();
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
      }
    }
    aftershipObtest();

    //商品模块统一曝光埋点
    (function productExposure() {
      const exposureProductIds = new Set([]);
      const productBlockName = ".product-exposure"; // 目标商品模块classname
      const intersectionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              // 在可视区域内
              $(e.target).attr("time", new Date().getTime());
            } else {
              // 不在可视区域内
              // sensorsTrack(e.target);
              // 记录曝光商品id
              recordProduct(e.target);
            }
            $(e.target).attr("isIntersecting", e.isIntersecting);
          });
        },
        { rootMargin: window.jelenew.exposureRootMargin, threshold: [0] } // 缩小触发边界
      );
      // 初始商品监听
      $(productBlockName).each((i, el) => exposureInit(el));
      // 异步商品监听
      const mutationObserver = new MutationObserver(function (mutationsList, observer) {
        // Use traditional 'for loops' for IE 11
        for (let mutation of mutationsList) {
          // 点击后识别选中商品数量
          if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
              if ($(node).hasClass("product-exposure")) {
                $(node).each((i, el) => exposureInit(el));
              }
              if ($(node).find(productBlockName).length > 0) {
                $(productBlockName, node).each((i, el) => exposureInit(el));
              }
            });
          }
        }
      });
      // 以上述配置开始观察目标节点
      mutationObserver.observe(document.body, { childList: true, subtree: true });
      $(window).on("visibilitychange beforeunload", function (e) {
        // if (e.type == "visibilitychange") {
        //   if (document.visibilityState == "hidden") {
        //     // 可视区域曝光上报
        //     $(`${productBlockName}[isIntersecting=true]`).each((i, el) => sensorsTrack(el));
        //   } else {
        //     // 重新计时
        //     $(`${productBlockName}[isIntersecting=true]`).each((i, el) => $(el).attr("time", new Date().getTime()));
        //   }
        // }
        // 可视区域曝光上报
        // $(`${productBlockName}[isIntersecting=true]`).each((i, el) => sensorsTrack(el));
        $(`${productBlockName}[isIntersecting=true]`).each((i, el) => recordProduct(el));
        const product_ids = splitArray([...exposureProductIds]);
        function splitArray(array, chunkSize = 50) {
          const result = [];
          for (let i = 0; i < array.length; i += chunkSize) {
            result.push(array.slice(i, i + chunkSize));
          }
          return result;
        }
        if (product_ids.length > 0) {
          if (document.visibilityState === 'hidden') {
            product_ids.forEach((ids) => {
              sensors.track("EpProducts", {
                page_position: theme.jelenew_web_page_name,
                product_id: ids.join(","),
              });
            });
          }
        }
      });

      // 记录曝光商品id
      function recordProduct(target) {
        exposureProductIds.add(`${$(target).data("product-id")}`);
      }
      // 防止重复加载
      function exposureInit(element) {
        if (!$(element).hasClass("exposure-init")) {
          intersectionObserver.observe(element);
          $(element).addClass("exposure-init");
        }
      }
      // 大于1s-上报
      function sensorsTrack(target) {
        const exposure_time = (new Date().getTime() - $(target).attr("time")) / 1000;
        if (exposure_time > 2) {
          sensors.track("EpProducts", {
            page_position: theme.jelenew_web_page_name,
            exposure_time,
            list_type: $(target).closest(".shopify-section").index(), // section-index
            list_name: $(target).closest("[data-section-type]").data("section-type"), // section-name
            product_name: $(target).data("title"),
            product_id: $(target).data("product-id"),
            original_price: $(target).data("price"),
            sku_id: $(target).data("sku"),
            spu_id: $(target).data("spu"),
            skc_id: $(target).data("skc"),
            // ep_module_id: $(target).data("slick-index") + "",
          });
        }
      }
    })();

    // 图片、视频统一曝光埋点
    // (function mediaExposure() {
    //   if ($("body").data("page-type") != "product" || $("a[name=jelenew-product-kit]").length == 0) return;
    //   // 选择目标节点
    //   // var targetNode = document.getElementById("content");
    //   var targetNode = $("a[name=jelenew-product-kit]").parent()[0];

    //   // 创建一个观察者对象
    //   var observer = new MutationObserver(function (mutations) {
    //     mutations.forEach(function (mutation) {
    //       if (mutation.type === "childList") {
    //         var imgAddObj = $("img:visible:not(.product_image)", mutation.target);
    //         var videoAddObj = $("video:visible", mutation.target);
    //         if (imgAddObj.length > 0) {
    //           imgAddObj.each(function (m, imgelement) {
    //             if (!$(imgelement).attr("data-add-load")) {
    //               $(imgelement).attr("data-add-load", true);
    //               operationTypeExpose($(imgelement), "image");
    //             }
    //           });
    //         }
    //         if (videoAddObj.length > 0) {
    //           videoAddObj.each(function (v, videoelement) {
    //             if (!$(videoelement).attr("data-add-load")) {
    //               $(videoelement).attr("data-add-load", true);
    //               operationTypeExpose($(videoelement), "video");
    //             }
    //           });
    //         }
    //       }
    //     });
    //   });

    //   // 观察者的配置（观察目标节点的子节点的变化）
    //   var config = { childList: true, subtree: true };

    //   // 传入目标节点和观察选项并开始观察
    //   observer.observe(targetNode, config);

    //   const imgSelectorStr = "img:visible:not(.product_image)";
    //   const videoSelectorStr = "video:visible";
    //   // 获取页面的图片
    //   var imagesObj = $(imgSelectorStr, targetNode);
    //   operationTypeExpose(imagesObj, "image");
    //   // 获取页面的视频信息
    //   var videosObj = $(videoSelectorStr, targetNode);
    //   operationTypeExpose(videosObj, "video");

    //   //全局曝光添加时间属性
    //   function operationTypeExpose(objList, type) {
    //     // 精准曝光
    //     function intersectionCallback(entries) {
    //       if (entries.length > 0) {
    //         entries.forEach((e, i) => {
    //           if (e.isIntersecting) {
    //             // 在可视区域内
    //             $(e.target).attr("time", new Date().getTime());
    //           } else {
    //             // 不在可视区域内
    //             sensorsTrack_Operation(e.target, type, "OperationExpose");
    //           }
    //           $(e.target).attr("isIntersecting", e.isIntersecting);
    //           $(e.target).attr("data-add-load", true);
    //         });
    //       }
    //     }
    //     const intersectionObserver = new IntersectionObserver(intersectionCallback, {
    //       rootMargin: window.jelenew.exposureRootMargin,
    //       threshold: [0],
    //     });
    //     objList.each((i, el) => {
    //       intersectionObserver.observe(el);
    //     });
    //   }
    //   // 图片滑动监控
    //   $(window).on("visibilitychange beforeunload", function (e) {
    //     if (e.type == "visibilitychange") {
    //       if (document.visibilityState == "hidden") {
    //         // 可视区域曝光上报
    //         $(imgSelectorStr + "[isIntersecting=true]").each((i, el) => sensorsTrack_Operation(el, "image", "OperationExpose"));
    //         $(videoSelectorStr + "[isIntersecting=true]").each((i, el) => sensorsTrack_Operation(el, "video", "OperationExpose"));
    //       } else {
    //         // 重新计时
    //         $(imgSelectorStr + "[isIntersecting=true]").each((i, el) => $(el).attr("time", new Date().getTime()));
    //         $(videoSelectorStr + "[isIntersecting=true]").each((i, el) => $(el).attr("time", new Date().getTime()));
    //       }
    //     }
    //     if (e.type == "beforeunload") {
    //       // 可视区域曝光上报
    //       $(imgSelectorStr + "[isIntersecting=true]").each((i, el) => sensorsTrack_Operation(el, "image", "OperationExpose"));
    //       $(videoSelectorStr + "[isIntersecting=true]").each((i, el) => sensorsTrack_Operation(el, "video", "OperationExpose"));
    //     }
    //   });

    //   // 图片点击上报
    //   $("body").on("click", imgSelectorStr, function (e) {
    //     sensorsTrack_Operation(e.target, "image", "OperationClick");
    //   });
    //   // 视频点击上报
    //   $("body").on("click", videoSelectorStr, function (e) {
    //     sensorsTrack_Operation(e.target, "video", "OperationClick");
    //   });
    //   // 图片视屏曝光上报方法
    //   // target 曝光对象 type：image图片  video 视频  eventName：上报事件名称
    //   function sensorsTrack_Operation(target, type, eventName) {
    //     const exposure_time = (new Date().getTime() - $(target).attr("time")) / 1000;
    //     // 有效曝光 => 曝光时长>1s, 曝光面积百分比>50%
    //     if (exposure_time > 1) {
    //       // 获取图片所在的组件名称
    //       var parentsList = $(target).parents();
    //       var module_content = type=="image" ? "jelenew-image" : "jelenew-video"; //组件名称
    //       parentsList.each(function (index, element) {
    //         if ($(element).attr("data-section-type")) {
    //           module_content = $(element).attr("data-section-type");
    //           return false;
    //         }
    //       });
    //       // 获取图片和视屏地址
    //       var creative_url = "";
    //       if (type == "image") {
    //         creative_url = $(target).attr("src") ? $(target).attr("src") : $(target).attr("srcset").split(",")[0];
    //       }
    //       if (type == "video") {
    //         if($(target).attr("src")){
    //           creative_url = $(target).attr("src")
    //         }else{
    //           if($("source",target).length===1){
    //             creative_url =$("source",target).attr("src")
    //           }
    //           if($("source",target).length===2){
    //             if (window.innerWidth > 767) {
    //               creative_url =  $("source.desktop-only",target).attr("src");
    //             } else {
    //               creative_url = $("source.mobile-only", target).attr("src");
    //             }
    //           }
    //         }    
    //       }
    //       //获取图片外的a标签
    //       var alist = $(target).parents("a");
    //       // var goto_page_position="" //素材落地页面名称
    //       var goto_page_url = ""; //素材落地URL
    //       var goto_page_path = ""; //素材落地path
    //       if (alist.length > 0) {
    //         goto_page_url = Shopify.routes.root === "/" ? alist.eq(0).attr("href") : alist.eq(0).attr("href").replace(Shopify.routes.root, "");
    //         goto_page_path = goto_page_url.split("?")[0];
    //       }
    //       var operation_index = -1;
    //       const $mediaList =
    //         type === "video" ? $(target).closest(".shopify-section").find("video") : $(target).closest(".shopify-section").find("img");
    //       $mediaList.each(function (index, element) {
    //         if (element === target) {
    //           operation_index = index;
    //         }
    //       });
    //       sensors.track(eventName, {
    //         page_position: theme.jelenew_web_page_name,
    //         exposure_time,
    //         path: window.location.pathname,
    //         module_content: module_content, //模块内容/组件名称
    //         operation_section: `$('#content>.container>.shopify-section').eq(${$(target).closest(".shopify-section").index()})`, //模块位置
    //         operation_index: operation_index, //资源位ID/坑位ID
    //         creative_type: type,
    //         creative_url: creative_url, //展示素材地址
    //         // goto_page_position: "",//素材落地页面名称
    //         goto_page_url: goto_page_url!=""? window.origin + goto_page_url : goto_page_url, //素材落地URL
    //         goto_page_path: goto_page_path, //素材落地path
    //       });
    //     }
    //   }
    // })();

    window.addEventListener("load", () => {
      // if (window.lcp_duration > 0) {
      //   sensors.track("RenderingFirstScreen", {
      //     lcp_duration: window.lcp_duration,
      //     page_position: theme.jelenew_web_page_name,
      //     $url_path: location.origin + location.pathname,
      //   });
      // }
      // const removeTidioPageTypeList = ["cart", "customers/login", "customers/register"]
      // if (removeTidioPageTypeList.every((pageType) => pageType != $("body").data("page-type"))) {
      //   setTimeout(function () {
      //     var tidioScript = document.createElement("script");
      //     tidioScript.src = "//code.tidio.co/y1rndj3eb9qmbgwlxkjayq3me5v0lwzh.js";
      //     document.body.appendChild(tidioScript);
      //   }, 15 * 1000);
      // }
      // ip地址查询
      try {
        const jelenew_ip_data = localStorage.getItem("jelenew-ip-data") ? localStorage.getItem("jelenew-ip-data") : "";
        if (
          !jelenew_ip_data ||
          jelenew_ip_data.distinct_id !== jelenew.functions.getDistinctId() ||
          Number(jelenew_ip_data.timestamp) < new Date().getTime()
        ) {
          jelenewHttp.post("/api/shop/customer/getAddr").then((res) => {
            if (res && res.result && "info" in res.result) {
              const { country, city } = res.result.info;
              let newDate = {
                distinct_id: jelenew.functions.getDistinctId(),
                timestamp: new Date().getTime() + 1000 * 60 * 60 * 24 * 30,
                country,
                city,
              };
              localStorage.setItem("jelenew-ip-data", JSON.stringify(newDate));
              sensors.registerPage({ jelenew_country: country, jelenew_city: city });
            }
          });
        }
      } catch (err) {
        console.error(err);
      }
      //app兼容脚本逻辑
      if (isNative() && isVersion()) {
        //注入app_jsbridge脚本
        var app_script = document.createElement("script");
        app_script.src = "https://cdn.shopify.com/s/files/1/0611/6275/0192/t/183/assets/app_jsbridge.js?v=0.1";
        app_script.defer = true;
        app_script.async = false;
        document.body.append(app_script);
        document.querySelector("#jelenew_app_addresses_css").setAttribute("href", '{{ "jelenew_app_addresses.css" | asset_url }}');
      }
    });
  })(theme.jQuery);
  
})();